const pincodeData = [
  
{ pincode: 110001, min_days: 2, max_days: 3 },
{ pincode: 110002, min_days: 2, max_days: 3 },
{ pincode: 110003, min_days: 2, max_days: 3 },
{ pincode: 110004, min_days: 2, max_days: 3 },
{ pincode: 110005, min_days: 2, max_days: 3 },
{ pincode: 110006, min_days: 2, max_days: 3 },
{ pincode: 110007, min_days: 2, max_days: 3 },
{ pincode: 110008, min_days: 2, max_days: 3 },
{ pincode: 110009, min_days: 2, max_days: 3 },
{ pincode: 110010, min_days: 2, max_days: 3 },
{ pincode: 110011, min_days: 2, max_days: 3 },
{ pincode: 110012, min_days: 2, max_days: 3 },
{ pincode: 110013, min_days: 2, max_days: 3 },
{ pincode: 110014, min_days: 2, max_days: 3 },
{ pincode: 110015, min_days: 2, max_days: 3 },
{ pincode: 110016, min_days: 2, max_days: 3 },
{ pincode: 110017, min_days: 2, max_days: 3 },
{ pincode: 110018, min_days: 2, max_days: 3 },
{ pincode: 110019, min_days: 2, max_days: 3 },
{ pincode: 110020, min_days: 2, max_days: 3 },
{ pincode: 110021, min_days: 2, max_days: 3 },
{ pincode: 110022, min_days: 2, max_days: 3 },
{ pincode: 110023, min_days: 2, max_days: 3 },
{ pincode: 110024, min_days: 2, max_days: 3 },
{ pincode: 110025, min_days: 2, max_days: 3 },
{ pincode: 110026, min_days: 2, max_days: 3 },
{ pincode: 110027, min_days: 2, max_days: 3 },
{ pincode: 110028, min_days: 2, max_days: 3 },
{ pincode: 110029, min_days: 2, max_days: 3 },
{ pincode: 110030, min_days: 2, max_days: 3 },
{ pincode: 110031, min_days: 2, max_days: 3 },
{ pincode: 110032, min_days: 2, max_days: 3 },
{ pincode: 110033, min_days: 2, max_days: 3 },
{ pincode: 110034, min_days: 2, max_days: 3 },
{ pincode: 110035, min_days: 2, max_days: 3 },
{ pincode: 110036, min_days: 2, max_days: 3 },
{ pincode: 110037, min_days: 2, max_days: 3 },
{ pincode: 110038, min_days: 2, max_days: 3 },
{ pincode: 110039, min_days: 2, max_days: 3 },
{ pincode: 110040, min_days: 2, max_days: 3 },
{ pincode: 110041, min_days: 2, max_days: 3 },
{ pincode: 110042, min_days: 2, max_days: 3 },
{ pincode: 110043, min_days: 2, max_days: 3 },
{ pincode: 110044, min_days: 2, max_days: 3 },
{ pincode: 110045, min_days: 2, max_days: 3 },
{ pincode: 110046, min_days: 2, max_days: 3 },
{ pincode: 110047, min_days: 2, max_days: 3 },
{ pincode: 110048, min_days: 2, max_days: 3 },
{ pincode: 110049, min_days: 2, max_days: 3 },
{ pincode: 110050, min_days: 2, max_days: 3 },
{ pincode: 110051, min_days: 2, max_days: 3 },
{ pincode: 110052, min_days: 2, max_days: 3 },
{ pincode: 110053, min_days: 2, max_days: 3 },
{ pincode: 110054, min_days: 2, max_days: 3 },
{ pincode: 110055, min_days: 2, max_days: 3 },
{ pincode: 110056, min_days: 2, max_days: 3 },
{ pincode: 110057, min_days: 2, max_days: 3 },
{ pincode: 110058, min_days: 2, max_days: 3 },
{ pincode: 110059, min_days: 2, max_days: 3 },
{ pincode: 110060, min_days: 2, max_days: 3 },
{ pincode: 110061, min_days: 2, max_days: 3 },
{ pincode: 110062, min_days: 2, max_days: 3 },
{ pincode: 110063, min_days: 2, max_days: 3 },
{ pincode: 110064, min_days: 2, max_days: 3 },
{ pincode: 110065, min_days: 2, max_days: 3 },
{ pincode: 110066, min_days: 2, max_days: 3 },
{ pincode: 110067, min_days: 2, max_days: 3 },
{ pincode: 110068, min_days: 2, max_days: 3 },
{ pincode: 110069, min_days: 2, max_days: 3 },
{ pincode: 110070, min_days: 2, max_days: 3 },
{ pincode: 110071, min_days: 2, max_days: 3 },
{ pincode: 110072, min_days: 2, max_days: 3 },
{ pincode: 110073, min_days: 2, max_days: 3 },
{ pincode: 110074, min_days: 2, max_days: 3 },
{ pincode: 110075, min_days: 2, max_days: 3 },
{ pincode: 110076, min_days: 2, max_days: 3 },
{ pincode: 110077, min_days: 2, max_days: 3 },
{ pincode: 110078, min_days: 2, max_days: 3 },
{ pincode: 110080, min_days: 2, max_days: 3 },
{ pincode: 110081, min_days: 2, max_days: 3 },
{ pincode: 110082, min_days: 2, max_days: 3 },
{ pincode: 110083, min_days: 2, max_days: 3 },
{ pincode: 110084, min_days: 2, max_days: 3 },
{ pincode: 110085, min_days: 2, max_days: 3 },
{ pincode: 110086, min_days: 2, max_days: 3 },
{ pincode: 110087, min_days: 2, max_days: 3 },
{ pincode: 110088, min_days: 2, max_days: 3 },
{ pincode: 110089, min_days: 2, max_days: 3 },
{ pincode: 110090, min_days: 2, max_days: 3 },
{ pincode: 110091, min_days: 2, max_days: 3 },
{ pincode: 110092, min_days: 2, max_days: 3 },
{ pincode: 110093, min_days: 2, max_days: 3 },
{ pincode: 110094, min_days: 2, max_days: 3 },
{ pincode: 110095, min_days: 2, max_days: 3 },
{ pincode: 110096, min_days: 2, max_days: 3 },
{ pincode: 110097, min_days: 2, max_days: 3 },
{ pincode: 110098, min_days: 2, max_days: 3 },
{ pincode: 110100, min_days: 2, max_days: 3 },
{ pincode: 110101, min_days: 2, max_days: 3 },
{ pincode: 110103, min_days: 2, max_days: 3 },
{ pincode: 110104, min_days: 2, max_days: 3 },
{ pincode: 110105, min_days: 2, max_days: 3 },
{ pincode: 110106, min_days: 2, max_days: 3 },
{ pincode: 110107, min_days: 2, max_days: 3 },
{ pincode: 110108, min_days: 2, max_days: 3 },
{ pincode: 110109, min_days: 2, max_days: 3 },
{ pincode: 110110, min_days: 2, max_days: 3 },
{ pincode: 110112, min_days: 2, max_days: 3 },
{ pincode: 110113, min_days: 2, max_days: 3 },
{ pincode: 110114, min_days: 2, max_days: 3 },
{ pincode: 110115, min_days: 2, max_days: 3 },
{ pincode: 110116, min_days: 2, max_days: 3 },
{ pincode: 110117, min_days: 2, max_days: 3 },
{ pincode: 110118, min_days: 2, max_days: 3 },
{ pincode: 110119, min_days: 2, max_days: 3 },
{ pincode: 110120, min_days: 2, max_days: 3 },
{ pincode: 110122, min_days: 2, max_days: 3 },
{ pincode: 110124, min_days: 2, max_days: 3 },
{ pincode: 110125, min_days: 2, max_days: 3 },
{ pincode: 110301, min_days: 2, max_days: 3 },
{ pincode: 110302, min_days: 2, max_days: 3 },
{ pincode: 110501, min_days: 2, max_days: 3 },
{ pincode: 110502, min_days: 2, max_days: 3 },
{ pincode: 110503, min_days: 2, max_days: 3 },
{ pincode: 110504, min_days: 2, max_days: 3 },
{ pincode: 110505, min_days: 2, max_days: 3 },
{ pincode: 110510, min_days: 2, max_days: 3 },
{ pincode: 110511, min_days: 2, max_days: 3 },
{ pincode: 110512, min_days: 2, max_days: 3 },
{ pincode: 110601, min_days: 2, max_days: 3 },
{ pincode: 110602, min_days: 2, max_days: 3 },
{ pincode: 110603, min_days: 2, max_days: 3 },
{ pincode: 110604, min_days: 2, max_days: 3 },
{ pincode: 110605, min_days: 2, max_days: 3 },
{ pincode: 110606, min_days: 2, max_days: 3 },
{ pincode: 110607, min_days: 2, max_days: 3 },
{ pincode: 110608, min_days: 2, max_days: 3 },
{ pincode: 110609, min_days: 2, max_days: 3 },
{ pincode: 111105, min_days: 2, max_days: 3 },
{ pincode: 111111, min_days: 2, max_days: 3 },
{ pincode: 111112, min_days: 2, max_days: 3 },
{ pincode: 111113, min_days: 2, max_days: 3 },
{ pincode: 111114, min_days: 2, max_days: 3 },
{ pincode: 111115, min_days: 2, max_days: 3 },
{ pincode: 111116, min_days: 2, max_days: 3 },
{ pincode: 111117, min_days: 2, max_days: 3 },
{ pincode: 111118, min_days: 2, max_days: 3 },
{ pincode: 111119, min_days: 2, max_days: 3 },
{ pincode: 111122, min_days: 3, max_days: 4 },
{ pincode: 111123, min_days: 2, max_days: 3 },
{ pincode: 114145, min_days: 4, max_days: 5 },
{ pincode: 121000, min_days: 2, max_days: 3 },
{ pincode: 121001, min_days: 2, max_days: 3 },
{ pincode: 121002, min_days: 2, max_days: 3 },
{ pincode: 121003, min_days: 2, max_days: 3 },
{ pincode: 121004, min_days: 2, max_days: 3 },
{ pincode: 121005, min_days: 2, max_days: 3 },
{ pincode: 121006, min_days: 2, max_days: 3 },
{ pincode: 121007, min_days: 2, max_days: 3 },
{ pincode: 121008, min_days: 2, max_days: 3 },
{ pincode: 121009, min_days: 2, max_days: 3 },
{ pincode: 121010, min_days: 2, max_days: 3 },
{ pincode: 121012, min_days: 2, max_days: 3 },
{ pincode: 121013, min_days: 2, max_days: 3 },
{ pincode: 121014, min_days: 2, max_days: 3 },
{ pincode: 121015, min_days: 2, max_days: 3 },
{ pincode: 121101, min_days: 2, max_days: 3 },
{ pincode: 121102, min_days: 2, max_days: 3 },
{ pincode: 121103, min_days: 2, max_days: 3 },
{ pincode: 121105, min_days: 2, max_days: 3 },
{ pincode: 121106, min_days: 2, max_days: 3 },
{ pincode: 121107, min_days: 2, max_days: 3 },
{ pincode: 121206, min_days: 2, max_days: 3 },
{ pincode: 122001, min_days: 2, max_days: 3 },
{ pincode: 122002, min_days: 2, max_days: 3 },
{ pincode: 122003, min_days: 2, max_days: 3 },
{ pincode: 122004, min_days: 2, max_days: 3 },
{ pincode: 122005, min_days: 2, max_days: 3 },
{ pincode: 122006, min_days: 2, max_days: 3 },
{ pincode: 122007, min_days: 2, max_days: 3 },
{ pincode: 122008, min_days: 2, max_days: 3 },
{ pincode: 122009, min_days: 2, max_days: 3 },
{ pincode: 122010, min_days: 2, max_days: 3 },
{ pincode: 122011, min_days: 2, max_days: 3 },
{ pincode: 122012, min_days: 2, max_days: 3 },
{ pincode: 122015, min_days: 2, max_days: 3 },
{ pincode: 122016, min_days: 2, max_days: 3 },
{ pincode: 122017, min_days: 2, max_days: 3 },
{ pincode: 122018, min_days: 2, max_days: 3 },
{ pincode: 122019, min_days: 2, max_days: 3 },
{ pincode: 122022, min_days: 2, max_days: 3 },
{ pincode: 122050, min_days: 2, max_days: 3 },
{ pincode: 122051, min_days: 2, max_days: 3 },
{ pincode: 122052, min_days: 2, max_days: 3 },
{ pincode: 122098, min_days: 2, max_days: 3 },
{ pincode: 122100, min_days: 2, max_days: 3 },
{ pincode: 122101, min_days: 2, max_days: 3 },
{ pincode: 122102, min_days: 2, max_days: 3 },
{ pincode: 122103, min_days: 2, max_days: 3 },
{ pincode: 122104, min_days: 2, max_days: 3 },
{ pincode: 122105, min_days: 2, max_days: 3 },
{ pincode: 122106, min_days: 2, max_days: 3 },
{ pincode: 122107, min_days: 2, max_days: 3 },
{ pincode: 122222, min_days: 2, max_days: 3 },
{ pincode: 122413, min_days: 2, max_days: 3 },
{ pincode: 122503, min_days: 2, max_days: 3 },
{ pincode: 122504, min_days: 2, max_days: 3 },
{ pincode: 122505, min_days: 2, max_days: 3 },
{ pincode: 122506, min_days: 2, max_days: 3 },
{ pincode: 123001, min_days: 2, max_days: 3 },
{ pincode: 123003, min_days: 2, max_days: 3 },
{ pincode: 123021, min_days: 3, max_days: 4 },
{ pincode: 123023, min_days: 3, max_days: 4 },
{ pincode: 123024, min_days: 3, max_days: 4 },
{ pincode: 123027, min_days: 4, max_days: 5 },
{ pincode: 123028, min_days: 4, max_days: 5 },
{ pincode: 123029, min_days: 3, max_days: 4 },
{ pincode: 123034, min_days: 4, max_days: 5 },
{ pincode: 123103, min_days: 2, max_days: 3 },
{ pincode: 123106, min_days: 2, max_days: 3 },
{ pincode: 123110, min_days: 2, max_days: 3 },
{ pincode: 123301, min_days: 3, max_days: 4 },
{ pincode: 123303, min_days: 4, max_days: 5 },
{ pincode: 123401, min_days: 2, max_days: 3 },
{ pincode: 123411, min_days: 4, max_days: 5 },
{ pincode: 123412, min_days: 2, max_days: 3 },
{ pincode: 123413, min_days: 2, max_days: 3 },
{ pincode: 123414, min_days: 2, max_days: 3 },
{ pincode: 123501, min_days: 2, max_days: 3 },
{ pincode: 123504, min_days: 2, max_days: 3 },
{ pincode: 123505, min_days: 2, max_days: 3 },
{ pincode: 123506, min_days: 2, max_days: 3 },
{ pincode: 124001, min_days: 2, max_days: 3 },
{ pincode: 124010, min_days: 2, max_days: 3 },
{ pincode: 124021, min_days: 2, max_days: 3 },
{ pincode: 124102, min_days: 3, max_days: 4 },
{ pincode: 124103, min_days: 3, max_days: 4 },
{ pincode: 124104, min_days: 3, max_days: 4 },
{ pincode: 124105, min_days: 3, max_days: 4 },
{ pincode: 124106, min_days: 3, max_days: 4 },
{ pincode: 124107, min_days: 3, max_days: 4 },
{ pincode: 124108, min_days: 3, max_days: 4 },
{ pincode: 124109, min_days: 3, max_days: 4 },
{ pincode: 124111, min_days: 2, max_days: 3 },
{ pincode: 124112, min_days: 2, max_days: 3 },
{ pincode: 124146, min_days: 3, max_days: 4 },
{ pincode: 124201, min_days: 3, max_days: 4 },
{ pincode: 124303, min_days: 2, max_days: 3 },
{ pincode: 124401, min_days: 2, max_days: 3 },
{ pincode: 124412, min_days: 2, max_days: 3 },
{ pincode: 124501, min_days: 2, max_days: 3 },
{ pincode: 124505, min_days: 2, max_days: 3 },
{ pincode: 124506, min_days: 2, max_days: 3 },
{ pincode: 124507, min_days: 2, max_days: 3 },
{ pincode: 124508, min_days: 2, max_days: 3 },
{ pincode: 124512, min_days: 2, max_days: 3 },
{ pincode: 124514, min_days: 2, max_days: 3 },
{ pincode: 124517, min_days: 2, max_days: 3 },
{ pincode: 125001, min_days: 3, max_days: 4 },
{ pincode: 125002, min_days: 3, max_days: 4 },
{ pincode: 125003, min_days: 3, max_days: 4 },
{ pincode: 125004, min_days: 3, max_days: 4 },
{ pincode: 125005, min_days: 3, max_days: 4 },
{ pincode: 125006, min_days: 3, max_days: 4 },
{ pincode: 125007, min_days: 3, max_days: 4 },
{ pincode: 125011, min_days: 3, max_days: 4 },
{ pincode: 125033, min_days: 3, max_days: 4 },
{ pincode: 125034, min_days: 3, max_days: 4 },
{ pincode: 125039, min_days: 3, max_days: 4 },
{ pincode: 125042, min_days: 2, max_days: 3 },
{ pincode: 125044, min_days: 3, max_days: 4 },
{ pincode: 125047, min_days: 3, max_days: 4 },
{ pincode: 125048, min_days: 3, max_days: 4 },
{ pincode: 125049, min_days: 3, max_days: 4 },
{ pincode: 125050, min_days: 3, max_days: 4 },
{ pincode: 125051, min_days: 4, max_days: 5 },
{ pincode: 125052, min_days: 3, max_days: 4 },
{ pincode: 125055, min_days: 3, max_days: 4 },
{ pincode: 125058, min_days: 3, max_days: 4 },
{ pincode: 125060, min_days: 3, max_days: 4 },
{ pincode: 125075, min_days: 4, max_days: 5 },
{ pincode: 125076, min_days: 4, max_days: 5 },
{ pincode: 125077, min_days: 4, max_days: 5 },
{ pincode: 125101, min_days: 4, max_days: 5 },
{ pincode: 125102, min_days: 4, max_days: 5 },
{ pincode: 125103, min_days: 4, max_days: 5 },
{ pincode: 125104, min_days: 4, max_days: 5 },
{ pincode: 125111, min_days: 3, max_days: 4 },
{ pincode: 125112, min_days: 3, max_days: 4 },
{ pincode: 125113, min_days: 3, max_days: 4 },
{ pincode: 125120, min_days: 4, max_days: 5 },
{ pincode: 125121, min_days: 3, max_days: 4 },
{ pincode: 125122, min_days: 3, max_days: 4 },
{ pincode: 125133, min_days: 4, max_days: 5 },
{ pincode: 125201, min_days: 3, max_days: 4 },
{ pincode: 126001, min_days: 4, max_days: 5 },
{ pincode: 126101, min_days: 3, max_days: 4 },
{ pincode: 126102, min_days: 3, max_days: 4 },
{ pincode: 126110, min_days: 3, max_days: 4 },
{ pincode: 126111, min_days: 3, max_days: 4 },
{ pincode: 126112, min_days: 4, max_days: 5 },
{ pincode: 126113, min_days: 3, max_days: 4 },
{ pincode: 126114, min_days: 3, max_days: 4 },
{ pincode: 126115, min_days: 3, max_days: 4 },
{ pincode: 126116, min_days: 3, max_days: 4 },
{ pincode: 126125, min_days: 3, max_days: 4 },
{ pincode: 126126, min_days: 3, max_days: 4 },
{ pincode: 126127, min_days: 3, max_days: 4 },
{ pincode: 126128, min_days: 3, max_days: 4 },
{ pincode: 126152, min_days: 3, max_days: 4 },
{ pincode: 127020, min_days: 3, max_days: 4 },
{ pincode: 127021, min_days: 3, max_days: 4 },
{ pincode: 127022, min_days: 3, max_days: 4 },
{ pincode: 127025, min_days: 3, max_days: 4 },
{ pincode: 127026, min_days: 3, max_days: 4 },
{ pincode: 127027, min_days: 3, max_days: 4 },
{ pincode: 127031, min_days: 3, max_days: 4 },
{ pincode: 127032, min_days: 3, max_days: 4 },
{ pincode: 127040, min_days: 3, max_days: 4 },
{ pincode: 127041, min_days: 2, max_days: 3 },
{ pincode: 127043, min_days: 3, max_days: 4 },
{ pincode: 127045, min_days: 4, max_days: 5 },
{ pincode: 127046, min_days: 4, max_days: 5 },
{ pincode: 127111, min_days: 3, max_days: 4 },
{ pincode: 127201, min_days: 3, max_days: 4 },
{ pincode: 127306, min_days: 3, max_days: 4 },
{ pincode: 127308, min_days: 3, max_days: 4 },
{ pincode: 127309, min_days: 3, max_days: 4 },
{ pincode: 127310, min_days: 3, max_days: 4 },
{ pincode: 131001, min_days: 2, max_days: 3 },
{ pincode: 131021, min_days: 2, max_days: 3 },
{ pincode: 131027, min_days: 2, max_days: 3 },
{ pincode: 131028, min_days: 2, max_days: 3 },
{ pincode: 131029, min_days: 2, max_days: 3 },
{ pincode: 131030, min_days: 2, max_days: 3 },
{ pincode: 131039, min_days: 2, max_days: 3 },
{ pincode: 131101, min_days: 2, max_days: 3 },
{ pincode: 131102, min_days: 2, max_days: 3 },
{ pincode: 131103, min_days: 2, max_days: 3 },
{ pincode: 131301, min_days: 3, max_days: 4 },
{ pincode: 131305, min_days: 3, max_days: 4 },
{ pincode: 132001, min_days: 3, max_days: 4 },
{ pincode: 132022, min_days: 3, max_days: 4 },
{ pincode: 132037, min_days: 3, max_days: 4 },
{ pincode: 132039, min_days: 4, max_days: 5 },
{ pincode: 132046, min_days: 4, max_days: 5 },
{ pincode: 132054, min_days: 3, max_days: 4 },
{ pincode: 132101, min_days: 3, max_days: 4 },
{ pincode: 132102, min_days: 3, max_days: 4 },
{ pincode: 132103, min_days: 2, max_days: 3 },
{ pincode: 132104, min_days: 2, max_days: 3 },
{ pincode: 132105, min_days: 2, max_days: 3 },
{ pincode: 132106, min_days: 2, max_days: 3 },
{ pincode: 132107, min_days: 3, max_days: 4 },
{ pincode: 132108, min_days: 2, max_days: 3 },
{ pincode: 132110, min_days: 2, max_days: 3 },
{ pincode: 132113, min_days: 4, max_days: 5 },
{ pincode: 132114, min_days: 3, max_days: 4 },
{ pincode: 132115, min_days: 3, max_days: 4 },
{ pincode: 132116, min_days: 3, max_days: 4 },
{ pincode: 132117, min_days: 3, max_days: 4 },
{ pincode: 132122, min_days: 3, max_days: 4 },
{ pincode: 132132, min_days: 2, max_days: 3 },
{ pincode: 132140, min_days: 3, max_days: 4 },
{ pincode: 132145, min_days: 2, max_days: 3 },
{ pincode: 132151, min_days: 2, max_days: 3 },
{ pincode: 132157, min_days: 3, max_days: 4 },
{ pincode: 133001, min_days: 3, max_days: 4 },
{ pincode: 133003, min_days: 3, max_days: 4 },
{ pincode: 133004, min_days: 3, max_days: 4 },
{ pincode: 133005, min_days: 3, max_days: 4 },
{ pincode: 133006, min_days: 3, max_days: 4 },
{ pincode: 133007, min_days: 3, max_days: 4 },
{ pincode: 133008, min_days: 3, max_days: 4 },
{ pincode: 133010, min_days: 3, max_days: 4 },
{ pincode: 133021, min_days: 3, max_days: 4 },
{ pincode: 133101, min_days: 3, max_days: 4 },
{ pincode: 133102, min_days: 3, max_days: 4 },
{ pincode: 133103, min_days: 3, max_days: 4 },
{ pincode: 133104, min_days: 3, max_days: 4 },
{ pincode: 133201, min_days: 3, max_days: 4 },
{ pincode: 133202, min_days: 3, max_days: 4 },
{ pincode: 133203, min_days: 3, max_days: 4 },
{ pincode: 133204, min_days: 3, max_days: 4 },
{ pincode: 133205, min_days: 3, max_days: 4 },
{ pincode: 133206, min_days: 3, max_days: 4 },
{ pincode: 133207, min_days: 3, max_days: 4 },
{ pincode: 133301, min_days: 3, max_days: 4 },
{ pincode: 133302, min_days: 3, max_days: 4 },
{ pincode: 134001, min_days: 3, max_days: 4 },
{ pincode: 134002, min_days: 3, max_days: 4 },
{ pincode: 134003, min_days: 3, max_days: 4 },
{ pincode: 134004, min_days: 3, max_days: 4 },
{ pincode: 134005, min_days: 3, max_days: 4 },
{ pincode: 134006, min_days: 3, max_days: 4 },
{ pincode: 134007, min_days: 3, max_days: 4 },
{ pincode: 134008, min_days: 3, max_days: 4 },
{ pincode: 134101, min_days: 3, max_days: 4 },
{ pincode: 134102, min_days: 3, max_days: 4 },
{ pincode: 134103, min_days: 3, max_days: 4 },
{ pincode: 134104, min_days: 3, max_days: 4 },
{ pincode: 134105, min_days: 3, max_days: 4 },
{ pincode: 134107, min_days: 3, max_days: 4 },
{ pincode: 134108, min_days: 3, max_days: 4 },
{ pincode: 134109, min_days: 3, max_days: 4 },
{ pincode: 134112, min_days: 3, max_days: 4 },
{ pincode: 134113, min_days: 3, max_days: 4 },
{ pincode: 134114, min_days: 3, max_days: 4 },
{ pincode: 134115, min_days: 3, max_days: 4 },
{ pincode: 134116, min_days: 3, max_days: 4 },
{ pincode: 134117, min_days: 3, max_days: 4 },
{ pincode: 134118, min_days: 3, max_days: 4 },
{ pincode: 134201, min_days: 3, max_days: 4 },
{ pincode: 134202, min_days: 3, max_days: 4 },
{ pincode: 134203, min_days: 3, max_days: 4 },
{ pincode: 134204, min_days: 3, max_days: 4 },
{ pincode: 134205, min_days: 3, max_days: 4 },
{ pincode: 135001, min_days: 3, max_days: 4 },
{ pincode: 135002, min_days: 3, max_days: 4 },
{ pincode: 135003, min_days: 3, max_days: 4 },
{ pincode: 135004, min_days: 3, max_days: 4 },
{ pincode: 135021, min_days: 3, max_days: 4 },
{ pincode: 135101, min_days: 3, max_days: 4 },
{ pincode: 135102, min_days: 3, max_days: 4 },
{ pincode: 135103, min_days: 3, max_days: 4 },
{ pincode: 135106, min_days: 3, max_days: 4 },
{ pincode: 135133, min_days: 3, max_days: 4 },
{ pincode: 136020, min_days: 3, max_days: 4 },
{ pincode: 136021, min_days: 3, max_days: 4 },
{ pincode: 136026, min_days: 3, max_days: 4 },
{ pincode: 136027, min_days: 3, max_days: 4 },
{ pincode: 136030, min_days: 3, max_days: 4 },
{ pincode: 136033, min_days: 3, max_days: 4 },
{ pincode: 136034, min_days: 3, max_days: 4 },
{ pincode: 136035, min_days: 3, max_days: 4 },
{ pincode: 136038, min_days: 3, max_days: 4 },
{ pincode: 136042, min_days: 3, max_days: 4 },
{ pincode: 136043, min_days: 3, max_days: 4 },
{ pincode: 136044, min_days: 3, max_days: 4 },
{ pincode: 136118, min_days: 3, max_days: 4 },
{ pincode: 136119, min_days: 3, max_days: 4 },
{ pincode: 136128, min_days: 3, max_days: 4 },
{ pincode: 136129, min_days: 3, max_days: 4 },
{ pincode: 136130, min_days: 3, max_days: 4 },
{ pincode: 136131, min_days: 3, max_days: 4 },
{ pincode: 136132, min_days: 3, max_days: 4 },
{ pincode: 136135, min_days: 3, max_days: 4 },
{ pincode: 136136, min_days: 3, max_days: 4 },
{ pincode: 136156, min_days: 3, max_days: 4 },
{ pincode: 140001, min_days: 3, max_days: 4 },
{ pincode: 140101, min_days: 3, max_days: 4 },
{ pincode: 140102, min_days: 5, max_days: 6 },
{ pincode: 140103, min_days: 3, max_days: 4 },
{ pincode: 140105, min_days: 3, max_days: 4 },
{ pincode: 140108, min_days: 3, max_days: 4 },
{ pincode: 140109, min_days: 3, max_days: 4 },
{ pincode: 140110, min_days: 3, max_days: 4 },
{ pincode: 140111, min_days: 5, max_days: 6 },
{ pincode: 140112, min_days: 5, max_days: 6 },
{ pincode: 140113, min_days: 3, max_days: 4 },
{ pincode: 140114, min_days: 3, max_days: 4 },
{ pincode: 140115, min_days: 3, max_days: 4 },
{ pincode: 140116, min_days: 3, max_days: 4 },
{ pincode: 140117, min_days: 3, max_days: 4 },
{ pincode: 140118, min_days: 3, max_days: 4 },
{ pincode: 140119, min_days: 3, max_days: 4 },
{ pincode: 140123, min_days: 3, max_days: 4 },
{ pincode: 140124, min_days: 3, max_days: 4 },
{ pincode: 140125, min_days: 3, max_days: 4 },
{ pincode: 140126, min_days: 3, max_days: 4 },
{ pincode: 140133, min_days: 3, max_days: 4 },
{ pincode: 140201, min_days: 3, max_days: 4 },
{ pincode: 140306, min_days: 3, max_days: 4 },
{ pincode: 140308, min_days: 3, max_days: 4 },
{ pincode: 140401, min_days: 3, max_days: 4 },
{ pincode: 140402, min_days: 3, max_days: 4 },
{ pincode: 140406, min_days: 3, max_days: 4 },
{ pincode: 140407, min_days: 3, max_days: 4 },
{ pincode: 140408, min_days: 3, max_days: 4 },
{ pincode: 140412, min_days: 3, max_days: 4 },
{ pincode: 140417, min_days: 3, max_days: 4 },
{ pincode: 140501, min_days: 3, max_days: 4 },
{ pincode: 140506, min_days: 3, max_days: 4 },
{ pincode: 140507, min_days: 3, max_days: 4 },
{ pincode: 140601, min_days: 3, max_days: 4 },
{ pincode: 140602, min_days: 3, max_days: 4 },
{ pincode: 140603, min_days: 3, max_days: 4 },
{ pincode: 140604, min_days: 3, max_days: 4 },
{ pincode: 140701, min_days: 3, max_days: 4 },
{ pincode: 140802, min_days: 3, max_days: 4 },
{ pincode: 140901, min_days: 3, max_days: 4 },
{ pincode: 141001, min_days: 3, max_days: 4 },
{ pincode: 141002, min_days: 3, max_days: 4 },
{ pincode: 141003, min_days: 3, max_days: 4 },
{ pincode: 141004, min_days: 3, max_days: 4 },
{ pincode: 141005, min_days: 3, max_days: 4 },
{ pincode: 141006, min_days: 3, max_days: 4 },
{ pincode: 141007, min_days: 3, max_days: 4 },
{ pincode: 141008, min_days: 3, max_days: 4 },
{ pincode: 141009, min_days: 3, max_days: 4 },
{ pincode: 141010, min_days: 3, max_days: 4 },
{ pincode: 141011, min_days: 3, max_days: 4 },
{ pincode: 141012, min_days: 3, max_days: 4 },
{ pincode: 141013, min_days: 3, max_days: 4 },
{ pincode: 141014, min_days: 3, max_days: 4 },
{ pincode: 141015, min_days: 3, max_days: 4 },
{ pincode: 141016, min_days: 3, max_days: 4 },
{ pincode: 141017, min_days: 3, max_days: 4 },
{ pincode: 141020, min_days: 3, max_days: 4 },
{ pincode: 141101, min_days: 3, max_days: 4 },
{ pincode: 141104, min_days: 3, max_days: 4 },
{ pincode: 141106, min_days: 3, max_days: 4 },
{ pincode: 141110, min_days: 3, max_days: 4 },
{ pincode: 141113, min_days: 3, max_days: 4 },
{ pincode: 141114, min_days: 4, max_days: 5 },
{ pincode: 141115, min_days: 4, max_days: 5 },
{ pincode: 141116, min_days: 3, max_days: 4 },
{ pincode: 141117, min_days: 3, max_days: 4 },
{ pincode: 141120, min_days: 3, max_days: 4 },
{ pincode: 141121, min_days: 4, max_days: 5 },
{ pincode: 141122, min_days: 3, max_days: 4 },
{ pincode: 141123, min_days: 3, max_days: 4 },
{ pincode: 141304, min_days: 3, max_days: 4 },
{ pincode: 141309, min_days: 3, max_days: 4 },
{ pincode: 141310, min_days: 3, max_days: 4 },
{ pincode: 141401, min_days: 3, max_days: 4 },
{ pincode: 141402, min_days: 3, max_days: 4 },
{ pincode: 141411, min_days: 3, max_days: 4 },
{ pincode: 141416, min_days: 3, max_days: 4 },
{ pincode: 141421, min_days: 3, max_days: 4 },
{ pincode: 141422, min_days: 3, max_days: 4 },
{ pincode: 141801, min_days: 5, max_days: 6 },
{ pincode: 142001, min_days: 4, max_days: 5 },
{ pincode: 142003, min_days: 4, max_days: 5 },
{ pincode: 142021, min_days: 3, max_days: 4 },
{ pincode: 142022, min_days: 3, max_days: 4 },
{ pincode: 142026, min_days: 4, max_days: 5 },
{ pincode: 142027, min_days: 3, max_days: 4 },
{ pincode: 142037, min_days: 4, max_days: 5 },
{ pincode: 142038, min_days: 4, max_days: 5 },
{ pincode: 142039, min_days: 4, max_days: 5 },
{ pincode: 142042, min_days: 4, max_days: 5 },
{ pincode: 142043, min_days: 4, max_days: 5 },
{ pincode: 142044, min_days: 4, max_days: 5 },
{ pincode: 142045, min_days: 4, max_days: 5 },
{ pincode: 142047, min_days: 4, max_days: 5 },
{ pincode: 142048, min_days: 4, max_days: 5 },
{ pincode: 142049, min_days: 4, max_days: 5 },
{ pincode: 142050, min_days: 4, max_days: 5 },
{ pincode: 142052, min_days: 4, max_days: 5 },
{ pincode: 142053, min_days: 4, max_days: 5 },
{ pincode: 142055, min_days: 4, max_days: 5 },
{ pincode: 142057, min_days: 4, max_days: 5 },
{ pincode: 142058, min_days: 4, max_days: 5 },
{ pincode: 142060, min_days: 4, max_days: 5 },
{ pincode: 143001, min_days: 3, max_days: 4 },
{ pincode: 143002, min_days: 3, max_days: 4 },
{ pincode: 143003, min_days: 3, max_days: 4 },
{ pincode: 143004, min_days: 3, max_days: 4 },
{ pincode: 143005, min_days: 3, max_days: 4 },
{ pincode: 143006, min_days: 3, max_days: 4 },
{ pincode: 143008, min_days: 3, max_days: 4 },
{ pincode: 143010, min_days: 3, max_days: 4 },
{ pincode: 143021, min_days: 3, max_days: 4 },
{ pincode: 143022, min_days: 3, max_days: 4 },
{ pincode: 143101, min_days: 3, max_days: 4 },
{ pincode: 143102, min_days: 4, max_days: 5 },
{ pincode: 143104, min_days: 3, max_days: 4 },
{ pincode: 143105, min_days: 3, max_days: 4 },
{ pincode: 143106, min_days: 3, max_days: 4 },
{ pincode: 143107, min_days: 3, max_days: 4 },
{ pincode: 143112, min_days: 3, max_days: 4 },
{ pincode: 143115, min_days: 3, max_days: 4 },
{ pincode: 143201, min_days: 3, max_days: 4 },
{ pincode: 143202, min_days: 3, max_days: 4 },
{ pincode: 143204, min_days: 3, max_days: 4 },
{ pincode: 143301, min_days: 4, max_days: 5 },
{ pincode: 143303, min_days: 4, max_days: 5 },
{ pincode: 143305, min_days: 4, max_days: 5 },
{ pincode: 143401, min_days: 4, max_days: 5 },
{ pincode: 143412, min_days: 4, max_days: 5 },
{ pincode: 143416, min_days: 4, max_days: 5 },
{ pincode: 143419, min_days: 4, max_days: 5 },
{ pincode: 143501, min_days: 3, max_days: 4 },
{ pincode: 143505, min_days: 4, max_days: 5 },
{ pincode: 143521, min_days: 4, max_days: 5 },
{ pincode: 143531, min_days: 5, max_days: 6 },
{ pincode: 143601, min_days: 4, max_days: 5 },
{ pincode: 144001, min_days: 3, max_days: 4 },
{ pincode: 144002, min_days: 3, max_days: 4 },
{ pincode: 144003, min_days: 3, max_days: 4 },
{ pincode: 144004, min_days: 3, max_days: 4 },
{ pincode: 144005, min_days: 3, max_days: 4 },
{ pincode: 144006, min_days: 3, max_days: 4 },
{ pincode: 144007, min_days: 3, max_days: 4 },
{ pincode: 144008, min_days: 3, max_days: 4 },
{ pincode: 144009, min_days: 3, max_days: 4 },
{ pincode: 144010, min_days: 3, max_days: 4 },
{ pincode: 144011, min_days: 3, max_days: 4 },
{ pincode: 144012, min_days: 3, max_days: 4 },
{ pincode: 144013, min_days: 3, max_days: 4 },
{ pincode: 144014, min_days: 3, max_days: 4 },
{ pincode: 144015, min_days: 3, max_days: 4 },
{ pincode: 144021, min_days: 3, max_days: 4 },
{ pincode: 144022, min_days: 3, max_days: 4 },
{ pincode: 144023, min_days: 3, max_days: 4 },
{ pincode: 144027, min_days: 3, max_days: 4 },
{ pincode: 144032, min_days: 3, max_days: 4 },
{ pincode: 144033, min_days: 3, max_days: 4 },
{ pincode: 144039, min_days: 3, max_days: 4 },
{ pincode: 144040, min_days: 3, max_days: 4 },
{ pincode: 144041, min_days: 3, max_days: 4 },
{ pincode: 144102, min_days: 4, max_days: 5 },
{ pincode: 144201, min_days: 4, max_days: 5 },
{ pincode: 144203, min_days: 4, max_days: 5 },
{ pincode: 144204, min_days: 4, max_days: 5 },
{ pincode: 144205, min_days: 4, max_days: 5 },
{ pincode: 144207, min_days: 4, max_days: 5 },
{ pincode: 144211, min_days: 4, max_days: 5 },
{ pincode: 144216, min_days: 5, max_days: 6 },
{ pincode: 144401, min_days: 3, max_days: 4 },
{ pincode: 144402, min_days: 3, max_days: 4 },
{ pincode: 144403, min_days: 3, max_days: 4 },
{ pincode: 144405, min_days: 3, max_days: 4 },
{ pincode: 144407, min_days: 3, max_days: 4 },
{ pincode: 144408, min_days: 3, max_days: 4 },
{ pincode: 144409, min_days: 4, max_days: 5 },
{ pincode: 144410, min_days: 4, max_days: 5 },
{ pincode: 144411, min_days: 3, max_days: 4 },
{ pincode: 144415, min_days: 4, max_days: 5 },
{ pincode: 144416, min_days: 4, max_days: 5 },
{ pincode: 144417, min_days: 4, max_days: 5 },
{ pincode: 144421, min_days: 4, max_days: 5 },
{ pincode: 144422, min_days: 4, max_days: 5 },
{ pincode: 144501, min_days: 3, max_days: 4 },
{ pincode: 144502, min_days: 3, max_days: 4 },
{ pincode: 144503, min_days: 3, max_days: 4 },
{ pincode: 144504, min_days: 3, max_days: 4 },
{ pincode: 144505, min_days: 3, max_days: 4 },
{ pincode: 144506, min_days: 3, max_days: 4 },
{ pincode: 144507, min_days: 3, max_days: 4 },
{ pincode: 144508, min_days: 3, max_days: 4 },
{ pincode: 144509, min_days: 4, max_days: 5 },
{ pincode: 144510, min_days: 4, max_days: 5 },
{ pincode: 144511, min_days: 4, max_days: 5 },
{ pincode: 144512, min_days: 4, max_days: 5 },
{ pincode: 144513, min_days: 4, max_days: 5 },
{ pincode: 144514, min_days: 4, max_days: 5 },
{ pincode: 144515, min_days: 4, max_days: 5 },
{ pincode: 144516, min_days: 4, max_days: 5 },
{ pincode: 144517, min_days: 4, max_days: 5 },
{ pincode: 144518, min_days: 4, max_days: 5 },
{ pincode: 144521, min_days: 4, max_days: 5 },
{ pincode: 144523, min_days: 4, max_days: 5 },
{ pincode: 144524, min_days: 4, max_days: 5 },
{ pincode: 144525, min_days: 4, max_days: 5 },
{ pincode: 144526, min_days: 4, max_days: 5 },
{ pincode: 144527, min_days: 4, max_days: 5 },
{ pincode: 144528, min_days: 4, max_days: 5 },
{ pincode: 144532, min_days: 4, max_days: 5 },
{ pincode: 144533, min_days: 3, max_days: 4 },
{ pincode: 144601, min_days: 3, max_days: 4 },
{ pincode: 144602, min_days: 3, max_days: 4 },
{ pincode: 144621, min_days: 3, max_days: 4 },
{ pincode: 144624, min_days: 3, max_days: 4 },
{ pincode: 144626, min_days: 4, max_days: 5 },
{ pincode: 144632, min_days: 3, max_days: 4 },
{ pincode: 144633, min_days: 3, max_days: 4 },
{ pincode: 144801, min_days: 4, max_days: 5 },
{ pincode: 144802, min_days: 3, max_days: 4 },
{ pincode: 145001, min_days: 4, max_days: 5 },
{ pincode: 145023, min_days: 4, max_days: 5 },
{ pincode: 146001, min_days: 4, max_days: 5 },
{ pincode: 146021, min_days: 4, max_days: 5 },
{ pincode: 146022, min_days: 4, max_days: 5 },
{ pincode: 146023, min_days: 4, max_days: 5 },
{ pincode: 146024, min_days: 4, max_days: 5 },
{ pincode: 146105, min_days: 4, max_days: 5 },
{ pincode: 146111, min_days: 4, max_days: 5 },
{ pincode: 147001, min_days: 3, max_days: 4 },
{ pincode: 147002, min_days: 3, max_days: 4 },
{ pincode: 147003, min_days: 3, max_days: 4 },
{ pincode: 147004, min_days: 3, max_days: 4 },
{ pincode: 147005, min_days: 3, max_days: 4 },
{ pincode: 147021, min_days: 3, max_days: 4 },
{ pincode: 147101, min_days: 4, max_days: 5 },
{ pincode: 147102, min_days: 4, max_days: 5 },
{ pincode: 147103, min_days: 3, max_days: 4 },
{ pincode: 147105, min_days: 4, max_days: 5 },
{ pincode: 147111, min_days: 3, max_days: 4 },
{ pincode: 147201, min_days: 3, max_days: 4 },
{ pincode: 147202, min_days: 3, max_days: 4 },
{ pincode: 147203, min_days: 3, max_days: 4 },
{ pincode: 147301, min_days: 3, max_days: 4 },
{ pincode: 148001, min_days: 3, max_days: 4 },
{ pincode: 148002, min_days: 3, max_days: 4 },
{ pincode: 148017, min_days: 3, max_days: 4 },
{ pincode: 148023, min_days: 4, max_days: 5 },
{ pincode: 148024, min_days: 4, max_days: 5 },
{ pincode: 148025, min_days: 3, max_days: 4 },
{ pincode: 148026, min_days: 4, max_days: 5 },
{ pincode: 148028, min_days: 4, max_days: 5 },
{ pincode: 148029, min_days: 4, max_days: 5 },
{ pincode: 148031, min_days: 4, max_days: 5 },
{ pincode: 148033, min_days: 4, max_days: 5 },
{ pincode: 148034, min_days: 3, max_days: 4 },
{ pincode: 148035, min_days: 4, max_days: 5 },
{ pincode: 148100, min_days: 3, max_days: 4 },
{ pincode: 148101, min_days: 3, max_days: 4 },
{ pincode: 148102, min_days: 3, max_days: 4 },
{ pincode: 148103, min_days: 3, max_days: 4 },
{ pincode: 148104, min_days: 3, max_days: 4 },
{ pincode: 148105, min_days: 3, max_days: 4 },
{ pincode: 148106, min_days: 4, max_days: 5 },
{ pincode: 148107, min_days: 3, max_days: 4 },
{ pincode: 148108, min_days: 4, max_days: 5 },
{ pincode: 148109, min_days: 4, max_days: 5 },
{ pincode: 151001, min_days: 3, max_days: 4 },
{ pincode: 151002, min_days: 3, max_days: 4 },
{ pincode: 151003, min_days: 3, max_days: 4 },
{ pincode: 151004, min_days: 3, max_days: 4 },
{ pincode: 151005, min_days: 3, max_days: 4 },
{ pincode: 151101, min_days: 3, max_days: 4 },
{ pincode: 151102, min_days: 3, max_days: 4 },
{ pincode: 151103, min_days: 4, max_days: 5 },
{ pincode: 151104, min_days: 4, max_days: 5 },
{ pincode: 151105, min_days: 4, max_days: 5 },
{ pincode: 151106, min_days: 4, max_days: 5 },
{ pincode: 151108, min_days: 4, max_days: 5 },
{ pincode: 151111, min_days: 4, max_days: 5 },
{ pincode: 151201, min_days: 3, max_days: 4 },
{ pincode: 151202, min_days: 4, max_days: 5 },
{ pincode: 151203, min_days: 4, max_days: 5 },
{ pincode: 151204, min_days: 4, max_days: 5 },
{ pincode: 151205, min_days: 4, max_days: 5 },
{ pincode: 151206, min_days: 4, max_days: 5 },
{ pincode: 151207, min_days: 4, max_days: 5 },
{ pincode: 151209, min_days: 4, max_days: 5 },
{ pincode: 151210, min_days: 4, max_days: 5 },
{ pincode: 151212, min_days: 4, max_days: 5 },
{ pincode: 151301, min_days: 3, max_days: 4 },
{ pincode: 151302, min_days: 3, max_days: 4 },
{ pincode: 151401, min_days: 3, max_days: 4 },
{ pincode: 151501, min_days: 4, max_days: 5 },
{ pincode: 151502, min_days: 4, max_days: 5 },
{ pincode: 151503, min_days: 4, max_days: 5 },
{ pincode: 151504, min_days: 4, max_days: 5 },
{ pincode: 151505, min_days: 3, max_days: 4 },
{ pincode: 151507, min_days: 4, max_days: 5 },
{ pincode: 151508, min_days: 4, max_days: 5 },
{ pincode: 151509, min_days: 3, max_days: 4 },
{ pincode: 151510, min_days: 3, max_days: 4 },
{ pincode: 152001, min_days: 4, max_days: 5 },
{ pincode: 152002, min_days: 4, max_days: 5 },
{ pincode: 152003, min_days: 4, max_days: 5 },
{ pincode: 152004, min_days: 4, max_days: 5 },
{ pincode: 152005, min_days: 4, max_days: 5 },
{ pincode: 152020, min_days: 4, max_days: 5 },
{ pincode: 152021, min_days: 4, max_days: 5 },
{ pincode: 152022, min_days: 4, max_days: 5 },
{ pincode: 152023, min_days: 4, max_days: 5 },
{ pincode: 152024, min_days: 4, max_days: 5 },
{ pincode: 152025, min_days: 4, max_days: 5 },
{ pincode: 152026, min_days: 4, max_days: 5 },
{ pincode: 152031, min_days: 4, max_days: 5 },
{ pincode: 152032, min_days: 4, max_days: 5 },
{ pincode: 152033, min_days: 4, max_days: 5 },
{ pincode: 152101, min_days: 4, max_days: 5 },
{ pincode: 152107, min_days: 4, max_days: 5 },
{ pincode: 152112, min_days: 4, max_days: 5 },
{ pincode: 152113, min_days: 4, max_days: 5 },
{ pincode: 152114, min_days: 4, max_days: 5 },
{ pincode: 152115, min_days: 4, max_days: 5 },
{ pincode: 152116, min_days: 4, max_days: 5 },
{ pincode: 152117, min_days: 4, max_days: 5 },
{ pincode: 152118, min_days: 4, max_days: 5 },
{ pincode: 152121, min_days: 4, max_days: 5 },
{ pincode: 152122, min_days: 4, max_days: 5 },
{ pincode: 152123, min_days: 4, max_days: 5 },
{ pincode: 152124, min_days: 4, max_days: 5 },
{ pincode: 152128, min_days: 4, max_days: 5 },
{ pincode: 152132, min_days: 4, max_days: 5 },
{ pincode: 160001, min_days: 3, max_days: 4 },
{ pincode: 160002, min_days: 3, max_days: 4 },
{ pincode: 160003, min_days: 3, max_days: 4 },
{ pincode: 160004, min_days: 3, max_days: 4 },
{ pincode: 160005, min_days: 3, max_days: 4 },
{ pincode: 160006, min_days: 3, max_days: 4 },
{ pincode: 160007, min_days: 3, max_days: 4 },
{ pincode: 160008, min_days: 3, max_days: 4 },
{ pincode: 160009, min_days: 3, max_days: 4 },
{ pincode: 160010, min_days: 3, max_days: 4 },
{ pincode: 160011, min_days: 3, max_days: 4 },
{ pincode: 160012, min_days: 3, max_days: 4 },
{ pincode: 160013, min_days: 3, max_days: 4 },
{ pincode: 160014, min_days: 3, max_days: 4 },
{ pincode: 160015, min_days: 3, max_days: 4 },
{ pincode: 160016, min_days: 3, max_days: 4 },
{ pincode: 160017, min_days: 3, max_days: 4 },
{ pincode: 160018, min_days: 3, max_days: 4 },
{ pincode: 160019, min_days: 3, max_days: 4 },
{ pincode: 160020, min_days: 3, max_days: 4 },
{ pincode: 160021, min_days: 3, max_days: 4 },
{ pincode: 160022, min_days: 3, max_days: 4 },
{ pincode: 160023, min_days: 3, max_days: 4 },
{ pincode: 160024, min_days: 3, max_days: 4 },
{ pincode: 160025, min_days: 3, max_days: 4 },
{ pincode: 160026, min_days: 3, max_days: 4 },
{ pincode: 160027, min_days: 3, max_days: 4 },
{ pincode: 160028, min_days: 3, max_days: 4 },
{ pincode: 160029, min_days: 3, max_days: 4 },
{ pincode: 160030, min_days: 3, max_days: 4 },
{ pincode: 160031, min_days: 3, max_days: 4 },
{ pincode: 160032, min_days: 3, max_days: 4 },
{ pincode: 160033, min_days: 3, max_days: 4 },
{ pincode: 160034, min_days: 3, max_days: 4 },
{ pincode: 160035, min_days: 3, max_days: 4 },
{ pincode: 160036, min_days: 3, max_days: 4 },
{ pincode: 160037, min_days: 3, max_days: 4 },
{ pincode: 160038, min_days: 3, max_days: 4 },
{ pincode: 160039, min_days: 3, max_days: 4 },
{ pincode: 160040, min_days: 3, max_days: 4 },
{ pincode: 160041, min_days: 3, max_days: 4 },
{ pincode: 160042, min_days: 3, max_days: 4 },
{ pincode: 160043, min_days: 3, max_days: 4 },
{ pincode: 160044, min_days: 3, max_days: 4 },
{ pincode: 160045, min_days: 3, max_days: 4 },
{ pincode: 160046, min_days: 3, max_days: 4 },
{ pincode: 160047, min_days: 3, max_days: 4 },
{ pincode: 160048, min_days: 3, max_days: 4 },
{ pincode: 160049, min_days: 3, max_days: 4 },
{ pincode: 160051, min_days: 3, max_days: 4 },
{ pincode: 160052, min_days: 3, max_days: 4 },
{ pincode: 160053, min_days: 3, max_days: 4 },
{ pincode: 160054, min_days: 3, max_days: 4 },
{ pincode: 160055, min_days: 3, max_days: 4 },
{ pincode: 160056, min_days: 3, max_days: 4 },
{ pincode: 160057, min_days: 3, max_days: 4 },
{ pincode: 160058, min_days: 3, max_days: 4 },
{ pincode: 160059, min_days: 3, max_days: 4 },
{ pincode: 160061, min_days: 3, max_days: 4 },
{ pincode: 160062, min_days: 3, max_days: 4 },
{ pincode: 160071, min_days: 3, max_days: 4 },
{ pincode: 160101, min_days: 3, max_days: 4 },
{ pincode: 160102, min_days: 3, max_days: 4 },
{ pincode: 160103, min_days: 3, max_days: 4 },
{ pincode: 160104, min_days: 3, max_days: 4 },
{ pincode: 160106, min_days: 3, max_days: 4 },
{ pincode: 171001, min_days: 3, max_days: 4 },
{ pincode: 171002, min_days: 3, max_days: 4 },
{ pincode: 171003, min_days: 3, max_days: 4 },
{ pincode: 171004, min_days: 3, max_days: 4 },
{ pincode: 171005, min_days: 3, max_days: 4 },
{ pincode: 171006, min_days: 3, max_days: 4 },
{ pincode: 171008, min_days: 4, max_days: 5 },
{ pincode: 171009, min_days: 3, max_days: 4 },
{ pincode: 171010, min_days: 3, max_days: 4 },
{ pincode: 171011, min_days: 4, max_days: 5 },
{ pincode: 171013, min_days: 4, max_days: 5 },
{ pincode: 171014, min_days: 4, max_days: 5 },
{ pincode: 171015, min_days: 4, max_days: 5 },
{ pincode: 171102, min_days: 4, max_days: 5 },
{ pincode: 171201, min_days: 4, max_days: 5 },
{ pincode: 171209, min_days: 4, max_days: 5 },
{ pincode: 171212, min_days: 4, max_days: 5 },
{ pincode: 171213, min_days: 5, max_days: 6 },
{ pincode: 171220, min_days: 4, max_days: 5 },
{ pincode: 171222, min_days: 4, max_days: 5 },
{ pincode: 171226, min_days: 4, max_days: 5 },
{ pincode: 172001, min_days: 4, max_days: 5 },
{ pincode: 172024, min_days: 4, max_days: 5 },
{ pincode: 172027, min_days: 4, max_days: 5 },
{ pincode: 172029, min_days: 4, max_days: 5 },
{ pincode: 172030, min_days: 4, max_days: 5 },
{ pincode: 172031, min_days: 4, max_days: 5 },
{ pincode: 172105, min_days: 5, max_days: 6 },
{ pincode: 172107, min_days: 5, max_days: 6 },
{ pincode: 172108, min_days: 5, max_days: 6 },
{ pincode: 172116, min_days: 6, max_days: 7 },
{ pincode: 172201, min_days: 4, max_days: 5 },
{ pincode: 173001, min_days: 3, max_days: 4 },
{ pincode: 173021, min_days: 3, max_days: 4 },
{ pincode: 173025, min_days: 3, max_days: 4 },
{ pincode: 173026, min_days: 3, max_days: 4 },
{ pincode: 173029, min_days: 3, max_days: 4 },
{ pincode: 173030, min_days: 3, max_days: 4 },
{ pincode: 173031, min_days: 3, max_days: 4 },
{ pincode: 173101, min_days: 4, max_days: 5 },
{ pincode: 173201, min_days: 3, max_days: 4 },
{ pincode: 173202, min_days: 3, max_days: 4 },
{ pincode: 173204, min_days: 3, max_days: 4 },
{ pincode: 173205, min_days: 3, max_days: 4 },
{ pincode: 173206, min_days: 3, max_days: 4 },
{ pincode: 173207, min_days: 4, max_days: 5 },
{ pincode: 173208, min_days: 4, max_days: 5 },
{ pincode: 173209, min_days: 3, max_days: 4 },
{ pincode: 173210, min_days: 3, max_days: 4 },
{ pincode: 173211, min_days: 3, max_days: 4 },
{ pincode: 173212, min_days: 3, max_days: 4 },
{ pincode: 173213, min_days: 3, max_days: 4 },
{ pincode: 173214, min_days: 3, max_days: 4 },
{ pincode: 173220, min_days: 3, max_days: 4 },
{ pincode: 173222, min_days: 4, max_days: 5 },
{ pincode: 173223, min_days: 3, max_days: 4 },
{ pincode: 173229, min_days: 3, max_days: 4 },
{ pincode: 173230, min_days: 3, max_days: 4 },
{ pincode: 173235, min_days: 4, max_days: 5 },
{ pincode: 174001, min_days: 3, max_days: 4 },
{ pincode: 174002, min_days: 4, max_days: 5 },
{ pincode: 174004, min_days: 3, max_days: 4 },
{ pincode: 174005, min_days: 3, max_days: 4 },
{ pincode: 174011, min_days: 4, max_days: 5 },
{ pincode: 174012, min_days: 3, max_days: 4 },
{ pincode: 174013, min_days: 3, max_days: 4 },
{ pincode: 174015, min_days: 4, max_days: 5 },
{ pincode: 174021, min_days: 3, max_days: 4 },
{ pincode: 174023, min_days: 3, max_days: 4 },
{ pincode: 174024, min_days: 3, max_days: 4 },
{ pincode: 174026, min_days: 3, max_days: 4 },
{ pincode: 174027, min_days: 3, max_days: 4 },
{ pincode: 174028, min_days: 3, max_days: 4 },
{ pincode: 174029, min_days: 3, max_days: 4 },
{ pincode: 174030, min_days: 3, max_days: 4 },
{ pincode: 174031, min_days: 3, max_days: 4 },
{ pincode: 174032, min_days: 3, max_days: 4 },
{ pincode: 174033, min_days: 3, max_days: 4 },
{ pincode: 174034, min_days: 3, max_days: 4 },
{ pincode: 174036, min_days: 3, max_days: 4 },
{ pincode: 174101, min_days: 3, max_days: 4 },
{ pincode: 174103, min_days: 3, max_days: 4 },
{ pincode: 174201, min_days: 4, max_days: 5 },
{ pincode: 174301, min_days: 3, max_days: 4 },
{ pincode: 174302, min_days: 4, max_days: 5 },
{ pincode: 174303, min_days: 3, max_days: 4 },
{ pincode: 174304, min_days: 4, max_days: 5 },
{ pincode: 174305, min_days: 4, max_days: 5 },
{ pincode: 174306, min_days: 3, max_days: 4 },
{ pincode: 174307, min_days: 4, max_days: 5 },
{ pincode: 174308, min_days: 4, max_days: 5 },
{ pincode: 174310, min_days: 4, max_days: 5 },
{ pincode: 174314, min_days: 4, max_days: 5 },
{ pincode: 174315, min_days: 3, max_days: 4 },
{ pincode: 174317, min_days: 3, max_days: 4 },
{ pincode: 174319, min_days: 4, max_days: 5 },
{ pincode: 174507, min_days: 3, max_days: 4 },
{ pincode: 175001, min_days: 4, max_days: 5 },
{ pincode: 175002, min_days: 4, max_days: 5 },
{ pincode: 175003, min_days: 5, max_days: 6 },
{ pincode: 175004, min_days: 4, max_days: 5 },
{ pincode: 175005, min_days: 5, max_days: 6 },
{ pincode: 175006, min_days: 4, max_days: 5 },
{ pincode: 175008, min_days: 4, max_days: 5 },
{ pincode: 175010, min_days: 4, max_days: 5 },
{ pincode: 175011, min_days: 4, max_days: 5 },
{ pincode: 175012, min_days: 5, max_days: 6 },
{ pincode: 175015, min_days: 4, max_days: 5 },
{ pincode: 175017, min_days: 3, max_days: 4 },
{ pincode: 175018, min_days: 4, max_days: 5 },
{ pincode: 175019, min_days: 4, max_days: 5 },
{ pincode: 175021, min_days: 4, max_days: 5 },
{ pincode: 175023, min_days: 5, max_days: 6 },
{ pincode: 175024, min_days: 4, max_days: 5 },
{ pincode: 175025, min_days: 4, max_days: 5 },
{ pincode: 175026, min_days: 4, max_days: 5 },
{ pincode: 175027, min_days: 4, max_days: 5 },
{ pincode: 175028, min_days: 5, max_days: 6 },
{ pincode: 175029, min_days: 5, max_days: 6 },
{ pincode: 175030, min_days: 3, max_days: 4 },
{ pincode: 175032, min_days: 5, max_days: 6 },
{ pincode: 175033, min_days: 5, max_days: 6 },
{ pincode: 175034, min_days: 4, max_days: 5 },
{ pincode: 175036, min_days: 5, max_days: 6 },
{ pincode: 175039, min_days: 4, max_days: 5 },
{ pincode: 175040, min_days: 4, max_days: 5 },
{ pincode: 175042, min_days: 4, max_days: 5 },
{ pincode: 175045, min_days: 5, max_days: 6 },
{ pincode: 175046, min_days: 5, max_days: 6 },
{ pincode: 175049, min_days: 4, max_days: 5 },
{ pincode: 175101, min_days: 4, max_days: 5 },
{ pincode: 175103, min_days: 5, max_days: 6 },
{ pincode: 175104, min_days: 5, max_days: 6 },
{ pincode: 175121, min_days: 4, max_days: 5 },
{ pincode: 175125, min_days: 4, max_days: 5 },
{ pincode: 175126, min_days: 4, max_days: 5 },
{ pincode: 175128, min_days: 4, max_days: 5 },
{ pincode: 175129, min_days: 4, max_days: 5 },
{ pincode: 175130, min_days: 5, max_days: 6 },
{ pincode: 175131, min_days: 4, max_days: 5 },
{ pincode: 175136, min_days: 4, max_days: 5 },
{ pincode: 175138, min_days: 4, max_days: 5 },
{ pincode: 175143, min_days: 4, max_days: 5 },
{ pincode: 176001, min_days: 4, max_days: 5 },
{ pincode: 176002, min_days: 4, max_days: 5 },
{ pincode: 176022, min_days: 8, max_days: 9 },
{ pincode: 176023, min_days: 7, max_days: 8 },
{ pincode: 176026, min_days: 5, max_days: 6 },
{ pincode: 176028, min_days: 5, max_days: 6 },
{ pincode: 176029, min_days: 4, max_days: 5 },
{ pincode: 176031, min_days: 4, max_days: 5 },
{ pincode: 176036, min_days: 4, max_days: 5 },
{ pincode: 176037, min_days: 5, max_days: 6 },
{ pincode: 176038, min_days: 5, max_days: 6 },
{ pincode: 176041, min_days: 4, max_days: 5 },
{ pincode: 176042, min_days: 3, max_days: 4 },
{ pincode: 176043, min_days: 3, max_days: 4 },
{ pincode: 176045, min_days: 5, max_days: 6 },
{ pincode: 176047, min_days: 4, max_days: 5 },
{ pincode: 176048, min_days: 5, max_days: 6 },
{ pincode: 176051, min_days: 7, max_days: 8 },
{ pincode: 176052, min_days: 4, max_days: 5 },
{ pincode: 176053, min_days: 7, max_days: 8 },
{ pincode: 176054, min_days: 5, max_days: 6 },
{ pincode: 176056, min_days: 4, max_days: 5 },
{ pincode: 176057, min_days: 4, max_days: 5 },
{ pincode: 176059, min_days: 4, max_days: 5 },
{ pincode: 176060, min_days: 4, max_days: 5 },
{ pincode: 176061, min_days: 4, max_days: 5 },
{ pincode: 176062, min_days: 4, max_days: 5 },
{ pincode: 176063, min_days: 4, max_days: 5 },
{ pincode: 176064, min_days: 4, max_days: 5 },
{ pincode: 176066, min_days: 4, max_days: 5 },
{ pincode: 176073, min_days: 4, max_days: 5 },
{ pincode: 176075, min_days: 4, max_days: 5 },
{ pincode: 176076, min_days: 5, max_days: 6 },
{ pincode: 176077, min_days: 5, max_days: 6 },
{ pincode: 176081, min_days: 4, max_days: 5 },
{ pincode: 176082, min_days: 4, max_days: 5 },
{ pincode: 176083, min_days: 4, max_days: 5 },
{ pincode: 176084, min_days: 4, max_days: 5 },
{ pincode: 176085, min_days: 4, max_days: 5 },
{ pincode: 176086, min_days: 4, max_days: 5 },
{ pincode: 176087, min_days: 4, max_days: 5 },
{ pincode: 176088, min_days: 5, max_days: 6 },
{ pincode: 176090, min_days: 4, max_days: 5 },
{ pincode: 176091, min_days: 4, max_days: 5 },
{ pincode: 176092, min_days: 4, max_days: 5 },
{ pincode: 176093, min_days: 4, max_days: 5 },
{ pincode: 176095, min_days: 4, max_days: 5 },
{ pincode: 176096, min_days: 4, max_days: 5 },
{ pincode: 176097, min_days: 4, max_days: 5 },
{ pincode: 176098, min_days: 4, max_days: 5 },
{ pincode: 176101, min_days: 4, max_days: 5 },
{ pincode: 176102, min_days: 4, max_days: 5 },
{ pincode: 176103, min_days: 4, max_days: 5 },
{ pincode: 176107, min_days: 4, max_days: 5 },
{ pincode: 176108, min_days: 4, max_days: 5 },
{ pincode: 176109, min_days: 4, max_days: 5 },
{ pincode: 176110, min_days: 4, max_days: 5 },
{ pincode: 176111, min_days: 5, max_days: 6 },
{ pincode: 176115, min_days: 4, max_days: 5 },
{ pincode: 176125, min_days: 4, max_days: 5 },
{ pincode: 176128, min_days: 4, max_days: 5 },
{ pincode: 176201, min_days: 7, max_days: 8 },
{ pincode: 176202, min_days: 7, max_days: 8 },
{ pincode: 176205, min_days: 5, max_days: 6 },
{ pincode: 176206, min_days: 4, max_days: 5 },
{ pincode: 176208, min_days: 4, max_days: 5 },
{ pincode: 176209, min_days: 4, max_days: 5 },
{ pincode: 176213, min_days: 5, max_days: 6 },
{ pincode: 176214, min_days: 4, max_days: 5 },
{ pincode: 176215, min_days: 4, max_days: 5 },
{ pincode: 176216, min_days: 4, max_days: 5 },
{ pincode: 176217, min_days: 4, max_days: 5 },
{ pincode: 176218, min_days: 4, max_days: 5 },
{ pincode: 176219, min_days: 4, max_days: 5 },
{ pincode: 176301, min_days: 7, max_days: 8 },
{ pincode: 176302, min_days: 8, max_days: 9 },
{ pincode: 176303, min_days: 7, max_days: 8 },
{ pincode: 176304, min_days: 7, max_days: 8 },
{ pincode: 176305, min_days: 7, max_days: 8 },
{ pincode: 176306, min_days: 7, max_days: 8 },
{ pincode: 176310, min_days: 7, max_days: 8 },
{ pincode: 176314, min_days: 7, max_days: 8 },
{ pincode: 176318, min_days: 7, max_days: 8 },
{ pincode: 176403, min_days: 4, max_days: 5 },
{ pincode: 176601, min_days: 3, max_days: 4 },
{ pincode: 177001, min_days: 3, max_days: 4 },
{ pincode: 177005, min_days: 3, max_days: 4 },
{ pincode: 177022, min_days: 4, max_days: 5 },
{ pincode: 177023, min_days: 4, max_days: 5 },
{ pincode: 177024, min_days: 4, max_days: 5 },
{ pincode: 177025, min_days: 5, max_days: 6 },
{ pincode: 177026, min_days: 5, max_days: 6 },
{ pincode: 177027, min_days: 4, max_days: 5 },
{ pincode: 177028, min_days: 4, max_days: 5 },
{ pincode: 177029, min_days: 4, max_days: 5 },
{ pincode: 177033, min_days: 4, max_days: 5 },
{ pincode: 177038, min_days: 4, max_days: 5 },
{ pincode: 177040, min_days: 5, max_days: 6 },
{ pincode: 177041, min_days: 5, max_days: 6 },
{ pincode: 177042, min_days: 5, max_days: 6 },
{ pincode: 177043, min_days: 4, max_days: 5 },
{ pincode: 177044, min_days: 5, max_days: 6 },
{ pincode: 177045, min_days: 5, max_days: 6 },
{ pincode: 177048, min_days: 5, max_days: 6 },
{ pincode: 177101, min_days: 4, max_days: 5 },
{ pincode: 177103, min_days: 4, max_days: 5 },
{ pincode: 177104, min_days: 4, max_days: 5 },
{ pincode: 177105, min_days: 4, max_days: 5 },
{ pincode: 177106, min_days: 4, max_days: 5 },
{ pincode: 177107, min_days: 4, max_days: 5 },
{ pincode: 177108, min_days: 4, max_days: 5 },
{ pincode: 177109, min_days: 5, max_days: 6 },
{ pincode: 177110, min_days: 4, max_days: 5 },
{ pincode: 177113, min_days: 4, max_days: 5 },
{ pincode: 177114, min_days: 4, max_days: 5 },
{ pincode: 177117, min_days: 4, max_days: 5 },
{ pincode: 177201, min_days: 4, max_days: 5 },
{ pincode: 177202, min_days: 4, max_days: 5 },
{ pincode: 177203, min_days: 4, max_days: 5 },
{ pincode: 177204, min_days: 4, max_days: 5 },
{ pincode: 177205, min_days: 4, max_days: 5 },
{ pincode: 177206, min_days: 4, max_days: 5 },
{ pincode: 177207, min_days: 3, max_days: 4 },
{ pincode: 177208, min_days: 4, max_days: 5 },
{ pincode: 177209, min_days: 3, max_days: 4 },
{ pincode: 177210, min_days: 4, max_days: 5 },
{ pincode: 177211, min_days: 4, max_days: 5 },
{ pincode: 177212, min_days: 4, max_days: 5 },
{ pincode: 177213, min_days: 4, max_days: 5 },
{ pincode: 177219, min_days: 4, max_days: 5 },
{ pincode: 177220, min_days: 3, max_days: 4 },
{ pincode: 177301, min_days: 5, max_days: 6 },
{ pincode: 177601, min_days: 4, max_days: 5 },
{ pincode: 180001, min_days: 3, max_days: 4 },
{ pincode: 180002, min_days: 3, max_days: 4 },
{ pincode: 180003, min_days: 4, max_days: 5 },
{ pincode: 180004, min_days: 3, max_days: 4 },
{ pincode: 180005, min_days: 3, max_days: 4 },
{ pincode: 180006, min_days: 3, max_days: 4 },
{ pincode: 180007, min_days: 3, max_days: 4 },
{ pincode: 180010, min_days: 3, max_days: 4 },
{ pincode: 180011, min_days: 3, max_days: 4 },
{ pincode: 180012, min_days: 3, max_days: 4 },
{ pincode: 180013, min_days: 3, max_days: 4 },
{ pincode: 180015, min_days: 3, max_days: 4 },
{ pincode: 180016, min_days: 3, max_days: 4 },
{ pincode: 180017, min_days: 4, max_days: 5 },
{ pincode: 180018, min_days: 3, max_days: 4 },
{ pincode: 180019, min_days: 4, max_days: 5 },
{ pincode: 180020, min_days: 3, max_days: 4 },
{ pincode: 181101, min_days: 4, max_days: 5 },
{ pincode: 181102, min_days: 4, max_days: 5 },
{ pincode: 181111, min_days: 4, max_days: 5 },
{ pincode: 181121, min_days: 3, max_days: 4 },
{ pincode: 181122, min_days: 4, max_days: 5 },
{ pincode: 181124, min_days: 3, max_days: 4 },
{ pincode: 181132, min_days: 4, max_days: 5 },
{ pincode: 181133, min_days: 4, max_days: 5 },
{ pincode: 181143, min_days: 4, max_days: 5 },
{ pincode: 181145, min_days: 4, max_days: 5 },
{ pincode: 181152, min_days: 3, max_days: 4 },
{ pincode: 181201, min_days: 4, max_days: 5 },
{ pincode: 181202, min_days: 4, max_days: 5 },
{ pincode: 181205, min_days: 3, max_days: 4 },
{ pincode: 181221, min_days: 4, max_days: 5 },
{ pincode: 182101, min_days: 4, max_days: 5 },
{ pincode: 182104, min_days: 4, max_days: 5 },
{ pincode: 182121, min_days: 4, max_days: 5 },
{ pincode: 182122, min_days: 4, max_days: 5 },
{ pincode: 182301, min_days: 4, max_days: 5 },
{ pincode: 182311, min_days: 4, max_days: 5 },
{ pincode: 182320, min_days: 4, max_days: 5 },
{ pincode: 184101, min_days: 4, max_days: 5 },
{ pincode: 184102, min_days: 4, max_days: 5 },
{ pincode: 184120, min_days: 4, max_days: 5 },
{ pincode: 184121, min_days: 4, max_days: 5 },
{ pincode: 184141, min_days: 4, max_days: 5 },
{ pincode: 184142, min_days: 4, max_days: 5 },
{ pincode: 190001, min_days: 4, max_days: 5 },
{ pincode: 190002, min_days: 4, max_days: 5 },
{ pincode: 190003, min_days: 4, max_days: 5 },
{ pincode: 190004, min_days: 4, max_days: 5 },
{ pincode: 190005, min_days: 4, max_days: 5 },
{ pincode: 190006, min_days: 4, max_days: 5 },
{ pincode: 190007, min_days: 4, max_days: 5 },
{ pincode: 190008, min_days: 4, max_days: 5 },
{ pincode: 190009, min_days: 4, max_days: 5 },
{ pincode: 190010, min_days: 4, max_days: 5 },
{ pincode: 190011, min_days: 4, max_days: 5 },
{ pincode: 190012, min_days: 4, max_days: 5 },
{ pincode: 190014, min_days: 4, max_days: 5 },
{ pincode: 190015, min_days: 4, max_days: 5 },
{ pincode: 190017, min_days: 4, max_days: 5 },
{ pincode: 190020, min_days: 4, max_days: 5 },
{ pincode: 190023, min_days: 4, max_days: 5 },
{ pincode: 191101, min_days: 4, max_days: 5 },
{ pincode: 191104, min_days: 4, max_days: 5 },
{ pincode: 191115, min_days: 4, max_days: 5 },
{ pincode: 191123, min_days: 4, max_days: 5 },
{ pincode: 191124, min_days: 4, max_days: 5 },
{ pincode: 191201, min_days: 4, max_days: 5 },
{ pincode: 192101, min_days: 4, max_days: 5 },
{ pincode: 192102, min_days: 4, max_days: 5 },
{ pincode: 192124, min_days: 4, max_days: 5 },
{ pincode: 192125, min_days: 4, max_days: 5 },
{ pincode: 192210, min_days: 4, max_days: 5 },
{ pincode: 192301, min_days: 4, max_days: 5 },
{ pincode: 193101, min_days: 4, max_days: 5 },
{ pincode: 193201, min_days: 4, max_days: 5 },
{ pincode: 193202, min_days: 4, max_days: 5 },
{ pincode: 194101, min_days: 3, max_days: 4 },
{ pincode: 201001, min_days: 2, max_days: 3 },
{ pincode: 201002, min_days: 2, max_days: 3 },
{ pincode: 201003, min_days: 2, max_days: 3 },
{ pincode: 201004, min_days: 2, max_days: 3 },
{ pincode: 201005, min_days: 2, max_days: 3 },
{ pincode: 201006, min_days: 2, max_days: 3 },
{ pincode: 201007, min_days: 2, max_days: 3 },
{ pincode: 201008, min_days: 2, max_days: 3 },
{ pincode: 201009, min_days: 2, max_days: 3 },
{ pincode: 201010, min_days: 2, max_days: 3 },
{ pincode: 201011, min_days: 2, max_days: 3 },
{ pincode: 201012, min_days: 2, max_days: 3 },
{ pincode: 201013, min_days: 2, max_days: 3 },
{ pincode: 201014, min_days: 2, max_days: 3 },
{ pincode: 201015, min_days: 2, max_days: 3 },
{ pincode: 201016, min_days: 2, max_days: 3 },
{ pincode: 201017, min_days: 2, max_days: 3 },
{ pincode: 201018, min_days: 2, max_days: 3 },
{ pincode: 201019, min_days: 2, max_days: 3 },
{ pincode: 201020, min_days: 2, max_days: 3 },
{ pincode: 201102, min_days: 2, max_days: 3 },
{ pincode: 201103, min_days: 2, max_days: 3 },
{ pincode: 201111, min_days: 2, max_days: 3 },
{ pincode: 201201, min_days: 2, max_days: 3 },
{ pincode: 201204, min_days: 2, max_days: 3 },
{ pincode: 201206, min_days: 2, max_days: 3 },
{ pincode: 201300, min_days: 2, max_days: 3 },
{ pincode: 201301, min_days: 2, max_days: 3 },
{ pincode: 201303, min_days: 2, max_days: 3 },
{ pincode: 201304, min_days: 2, max_days: 3 },
{ pincode: 201305, min_days: 2, max_days: 3 },
{ pincode: 201306, min_days: 2, max_days: 3 },
{ pincode: 201307, min_days: 2, max_days: 3 },
{ pincode: 201308, min_days: 2, max_days: 3 },
{ pincode: 201309, min_days: 2, max_days: 3 },
{ pincode: 201310, min_days: 2, max_days: 3 },
{ pincode: 201311, min_days: 2, max_days: 3 },
{ pincode: 201312, min_days: 2, max_days: 3 },
{ pincode: 201313, min_days: 2, max_days: 3 },
{ pincode: 201314, min_days: 2, max_days: 3 },
{ pincode: 201315, min_days: 2, max_days: 3 },
{ pincode: 201316, min_days: 2, max_days: 3 },
{ pincode: 201317, min_days: 2, max_days: 3 },
{ pincode: 201318, min_days: 2, max_days: 3 },
{ pincode: 201333, min_days: 2, max_days: 3 },
{ pincode: 202001, min_days: 2, max_days: 3 },
{ pincode: 202002, min_days: 2, max_days: 3 },
{ pincode: 202124, min_days: 2, max_days: 3 },
{ pincode: 202125, min_days: 2, max_days: 3 },
{ pincode: 202127, min_days: 2, max_days: 3 },
{ pincode: 202130, min_days: 2, max_days: 3 },
{ pincode: 202138, min_days: 2, max_days: 3 },
{ pincode: 202145, min_days: 2, max_days: 3 },
{ pincode: 202280, min_days: 2, max_days: 3 },
{ pincode: 203001, min_days: 2, max_days: 3 },
{ pincode: 203002, min_days: 3, max_days: 4 },
{ pincode: 203131, min_days: 2, max_days: 3 },
{ pincode: 203132, min_days: 3, max_days: 4 },
{ pincode: 203135, min_days: 2, max_days: 3 },
{ pincode: 203150, min_days: 3, max_days: 4 },
{ pincode: 203201, min_days: 2, max_days: 3 },
{ pincode: 203202, min_days: 2, max_days: 3 },
{ pincode: 203203, min_days: 2, max_days: 3 },
{ pincode: 203205, min_days: 2, max_days: 3 },
{ pincode: 203206, min_days: 2, max_days: 3 },
{ pincode: 203207, min_days: 2, max_days: 3 },
{ pincode: 203209, min_days: 2, max_days: 3 },
{ pincode: 203389, min_days: 3, max_days: 4 },
{ pincode: 203390, min_days: 3, max_days: 4 },
{ pincode: 203393, min_days: 3, max_days: 4 },
{ pincode: 203394, min_days: 3, max_days: 4 },
{ pincode: 203395, min_days: 3, max_days: 4 },
{ pincode: 203401, min_days: 3, max_days: 4 },
{ pincode: 203411, min_days: 3, max_days: 4 },
{ pincode: 203412, min_days: 3, max_days: 4 },
{ pincode: 204101, min_days: 3, max_days: 4 },
{ pincode: 204213, min_days: 3, max_days: 4 },
{ pincode: 204215, min_days: 2, max_days: 3 },
{ pincode: 204216, min_days: 3, max_days: 4 },
{ pincode: 205001, min_days: 4, max_days: 5 },
{ pincode: 205121, min_days: 4, max_days: 5 },
{ pincode: 205261, min_days: 4, max_days: 5 },
{ pincode: 205262, min_days: 4, max_days: 5 },
{ pincode: 205264, min_days: 4, max_days: 5 },
{ pincode: 205265, min_days: 4, max_days: 5 },
{ pincode: 205301, min_days: 4, max_days: 5 },
{ pincode: 205303, min_days: 4, max_days: 5 },
{ pincode: 206001, min_days: 4, max_days: 5 },
{ pincode: 206002, min_days: 4, max_days: 5 },
{ pincode: 206003, min_days: 4, max_days: 5 },
{ pincode: 206120, min_days: 4, max_days: 5 },
{ pincode: 206121, min_days: 5, max_days: 6 },
{ pincode: 206122, min_days: 4, max_days: 5 },
{ pincode: 206123, min_days: 4, max_days: 5 },
{ pincode: 206124, min_days: 4, max_days: 5 },
{ pincode: 206125, min_days: 4, max_days: 5 },
{ pincode: 206126, min_days: 4, max_days: 5 },
{ pincode: 206127, min_days: 4, max_days: 5 },
{ pincode: 206128, min_days: 4, max_days: 5 },
{ pincode: 206129, min_days: 5, max_days: 6 },
{ pincode: 206130, min_days: 4, max_days: 5 },
{ pincode: 206131, min_days: 4, max_days: 5 },
{ pincode: 206241, min_days: 5, max_days: 6 },
{ pincode: 206242, min_days: 4, max_days: 5 },
{ pincode: 206243, min_days: 5, max_days: 6 },
{ pincode: 206244, min_days: 4, max_days: 5 },
{ pincode: 206245, min_days: 4, max_days: 5 },
{ pincode: 206246, min_days: 5, max_days: 6 },
{ pincode: 206247, min_days: 5, max_days: 6 },
{ pincode: 206249, min_days: 5, max_days: 6 },
{ pincode: 206252, min_days: 5, max_days: 6 },
{ pincode: 206253, min_days: 4, max_days: 5 },
{ pincode: 207001, min_days: 3, max_days: 4 },
{ pincode: 208001, min_days: 3, max_days: 4 },
{ pincode: 208002, min_days: 3, max_days: 4 },
{ pincode: 208003, min_days: 3, max_days: 4 },
{ pincode: 208004, min_days: 3, max_days: 4 },
{ pincode: 208005, min_days: 3, max_days: 4 },
{ pincode: 208006, min_days: 3, max_days: 4 },
{ pincode: 208007, min_days: 3, max_days: 4 },
{ pincode: 208008, min_days: 3, max_days: 4 },
{ pincode: 208009, min_days: 3, max_days: 4 },
{ pincode: 208010, min_days: 3, max_days: 4 },
{ pincode: 208011, min_days: 3, max_days: 4 },
{ pincode: 208012, min_days: 3, max_days: 4 },
{ pincode: 208013, min_days: 3, max_days: 4 },
{ pincode: 208014, min_days: 3, max_days: 4 },
{ pincode: 208015, min_days: 3, max_days: 4 },
{ pincode: 208016, min_days: 3, max_days: 4 },
{ pincode: 208017, min_days: 3, max_days: 4 },
{ pincode: 208018, min_days: 3, max_days: 4 },
{ pincode: 208019, min_days: 3, max_days: 4 },
{ pincode: 208020, min_days: 3, max_days: 4 },
{ pincode: 208021, min_days: 3, max_days: 4 },
{ pincode: 208022, min_days: 3, max_days: 4 },
{ pincode: 208023, min_days: 3, max_days: 4 },
{ pincode: 208024, min_days: 3, max_days: 4 },
{ pincode: 208025, min_days: 3, max_days: 4 },
{ pincode: 208026, min_days: 3, max_days: 4 },
{ pincode: 208027, min_days: 3, max_days: 4 },
{ pincode: 209101, min_days: 3, max_days: 4 },
{ pincode: 209111, min_days: 3, max_days: 4 },
{ pincode: 209112, min_days: 4, max_days: 5 },
{ pincode: 209115, min_days: 4, max_days: 5 },
{ pincode: 209121, min_days: 4, max_days: 5 },
{ pincode: 209125, min_days: 4, max_days: 5 },
{ pincode: 209202, min_days: 5, max_days: 6 },
{ pincode: 209203, min_days: 3, max_days: 4 },
{ pincode: 209204, min_days: 4, max_days: 5 },
{ pincode: 209205, min_days: 4, max_days: 5 },
{ pincode: 209206, min_days: 5, max_days: 6 },
{ pincode: 209214, min_days: 4, max_days: 5 },
{ pincode: 209217, min_days: 4, max_days: 5 },
{ pincode: 209302, min_days: 4, max_days: 5 },
{ pincode: 209303, min_days: 4, max_days: 5 },
{ pincode: 209304, min_days: 4, max_days: 5 },
{ pincode: 209305, min_days: 3, max_days: 4 },
{ pincode: 209306, min_days: 4, max_days: 5 },
{ pincode: 209307, min_days: 4, max_days: 5 },
{ pincode: 209310, min_days: 4, max_days: 5 },
{ pincode: 209311, min_days: 4, max_days: 5 },
{ pincode: 209401, min_days: 4, max_days: 5 },
{ pincode: 209402, min_days: 4, max_days: 5 },
{ pincode: 209501, min_days: 5, max_days: 6 },
{ pincode: 209502, min_days: 5, max_days: 6 },
{ pincode: 209503, min_days: 5, max_days: 6 },
{ pincode: 209601, min_days: 4, max_days: 5 },
{ pincode: 209602, min_days: 5, max_days: 6 },
{ pincode: 209621, min_days: 5, max_days: 6 },
{ pincode: 209622, min_days: 5, max_days: 6 },
{ pincode: 209624, min_days: 5, max_days: 6 },
{ pincode: 209625, min_days: 4, max_days: 5 },
{ pincode: 209651, min_days: 5, max_days: 6 },
{ pincode: 209652, min_days: 5, max_days: 6 },
{ pincode: 209721, min_days: 5, max_days: 6 },
{ pincode: 209722, min_days: 5, max_days: 6 },
{ pincode: 209723, min_days: 5, max_days: 6 },
{ pincode: 209724, min_days: 5, max_days: 6 },
{ pincode: 209725, min_days: 4, max_days: 5 },
{ pincode: 209726, min_days: 4, max_days: 5 },
{ pincode: 209727, min_days: 4, max_days: 5 },
{ pincode: 209728, min_days: 5, max_days: 6 },
{ pincode: 209729, min_days: 5, max_days: 6 },
{ pincode: 209731, min_days: 5, max_days: 6 },
{ pincode: 209732, min_days: 5, max_days: 6 },
{ pincode: 209733, min_days: 5, max_days: 6 },
{ pincode: 209739, min_days: 5, max_days: 6 },
{ pincode: 209743, min_days: 5, max_days: 6 },
{ pincode: 209801, min_days: 3, max_days: 4 },
{ pincode: 209821, min_days: 4, max_days: 5 },
{ pincode: 209825, min_days: 4, max_days: 5 },
{ pincode: 209827, min_days: 4, max_days: 5 },
{ pincode: 209831, min_days: 4, max_days: 5 },
{ pincode: 209841, min_days: 4, max_days: 5 },
{ pincode: 209859, min_days: 4, max_days: 5 },
{ pincode: 209861, min_days: 3, max_days: 4 },
{ pincode: 209862, min_days: 4, max_days: 5 },
{ pincode: 209863, min_days: 4, max_days: 5 },
{ pincode: 209865, min_days: 4, max_days: 5 },
{ pincode: 209866, min_days: 4, max_days: 5 },
{ pincode: 209867, min_days: 4, max_days: 5 },
{ pincode: 209868, min_days: 4, max_days: 5 },
{ pincode: 209871, min_days: 4, max_days: 5 },
{ pincode: 210001, min_days: 4, max_days: 5 },
{ pincode: 210010, min_days: 3, max_days: 4 },
{ pincode: 210129, min_days: 6, max_days: 7 },
{ pincode: 210201, min_days: 6, max_days: 7 },
{ pincode: 210204, min_days: 5, max_days: 6 },
{ pincode: 210205, min_days: 5, max_days: 6 },
{ pincode: 210206, min_days: 6, max_days: 7 },
{ pincode: 210207, min_days: 6, max_days: 7 },
{ pincode: 210208, min_days: 6, max_days: 7 },
{ pincode: 210209, min_days: 6, max_days: 7 },
{ pincode: 210301, min_days: 4, max_days: 5 },
{ pincode: 210341, min_days: 5, max_days: 6 },
{ pincode: 210421, min_days: 5, max_days: 6 },
{ pincode: 210423, min_days: 5, max_days: 6 },
{ pincode: 210424, min_days: 5, max_days: 6 },
{ pincode: 210425, min_days: 5, max_days: 6 },
{ pincode: 210426, min_days: 5, max_days: 6 },
{ pincode: 210427, min_days: 4, max_days: 5 },
{ pincode: 210429, min_days: 5, max_days: 6 },
{ pincode: 210431, min_days: 5, max_days: 6 },
{ pincode: 210501, min_days: 5, max_days: 6 },
{ pincode: 210502, min_days: 5, max_days: 6 },
{ pincode: 210504, min_days: 5, max_days: 6 },
{ pincode: 210505, min_days: 5, max_days: 6 },
{ pincode: 210506, min_days: 5, max_days: 6 },
{ pincode: 210507, min_days: 5, max_days: 6 },
{ pincode: 211001, min_days: 3, max_days: 4 },
{ pincode: 211002, min_days: 3, max_days: 4 },
{ pincode: 211003, min_days: 3, max_days: 4 },
{ pincode: 211004, min_days: 3, max_days: 4 },
{ pincode: 211005, min_days: 3, max_days: 4 },
{ pincode: 211006, min_days: 3, max_days: 4 },
{ pincode: 211007, min_days: 3, max_days: 4 },
{ pincode: 211008, min_days: 3, max_days: 4 },
{ pincode: 211009, min_days: 3, max_days: 4 },
{ pincode: 211010, min_days: 3, max_days: 4 },
{ pincode: 211011, min_days: 3, max_days: 4 },
{ pincode: 211012, min_days: 3, max_days: 4 },
{ pincode: 211014, min_days: 3, max_days: 4 },
{ pincode: 211015, min_days: 3, max_days: 4 },
{ pincode: 211016, min_days: 3, max_days: 4 },
{ pincode: 211017, min_days: 3, max_days: 4 },
{ pincode: 211018, min_days: 3, max_days: 4 },
{ pincode: 212105, min_days: 3, max_days: 4 },
{ pincode: 212201, min_days: 4, max_days: 5 },
{ pincode: 212202, min_days: 4, max_days: 5 },
{ pincode: 212203, min_days: 4, max_days: 5 },
{ pincode: 212205, min_days: 4, max_days: 5 },
{ pincode: 212206, min_days: 4, max_days: 5 },
{ pincode: 212207, min_days: 4, max_days: 5 },
{ pincode: 212212, min_days: 3, max_days: 4 },
{ pincode: 212213, min_days: 4, max_days: 5 },
{ pincode: 212217, min_days: 4, max_days: 5 },
{ pincode: 212301, min_days: 3, max_days: 4 },
{ pincode: 212405, min_days: 3, max_days: 4 },
{ pincode: 212601, min_days: 4, max_days: 5 },
{ pincode: 212620, min_days: 5, max_days: 6 },
{ pincode: 212622, min_days: 5, max_days: 6 },
{ pincode: 212635, min_days: 5, max_days: 6 },
{ pincode: 212651, min_days: 5, max_days: 6 },
{ pincode: 212652, min_days: 5, max_days: 6 },
{ pincode: 212655, min_days: 5, max_days: 6 },
{ pincode: 212657, min_days: 5, max_days: 6 },
{ pincode: 212663, min_days: 5, max_days: 6 },
{ pincode: 212664, min_days: 5, max_days: 6 },
{ pincode: 212665, min_days: 5, max_days: 6 },
{ pincode: 221001, min_days: 3, max_days: 4 },
{ pincode: 221002, min_days: 3, max_days: 4 },
{ pincode: 221003, min_days: 3, max_days: 4 },
{ pincode: 221004, min_days: 3, max_days: 4 },
{ pincode: 221005, min_days: 3, max_days: 4 },
{ pincode: 221006, min_days: 3, max_days: 4 },
{ pincode: 221007, min_days: 3, max_days: 4 },
{ pincode: 221008, min_days: 4, max_days: 5 },
{ pincode: 221010, min_days: 3, max_days: 4 },
{ pincode: 221011, min_days: 3, max_days: 4 },
{ pincode: 221012, min_days: 3, max_days: 4 },
{ pincode: 221101, min_days: 3, max_days: 4 },
{ pincode: 221103, min_days: 3, max_days: 4 },
{ pincode: 221105, min_days: 3, max_days: 4 },
{ pincode: 221106, min_days: 3, max_days: 4 },
{ pincode: 221107, min_days: 3, max_days: 4 },
{ pincode: 221108, min_days: 3, max_days: 4 },
{ pincode: 221109, min_days: 3, max_days: 4 },
{ pincode: 221301, min_days: 4, max_days: 5 },
{ pincode: 221302, min_days: 3, max_days: 4 },
{ pincode: 221303, min_days: 4, max_days: 5 },
{ pincode: 221304, min_days: 4, max_days: 5 },
{ pincode: 221306, min_days: 4, max_days: 5 },
{ pincode: 221308, min_days: 4, max_days: 5 },
{ pincode: 221310, min_days: 4, max_days: 5 },
{ pincode: 221314, min_days: 4, max_days: 5 },
{ pincode: 221401, min_days: 4, max_days: 5 },
{ pincode: 221402, min_days: 4, max_days: 5 },
{ pincode: 221403, min_days: 4, max_days: 5 },
{ pincode: 221404, min_days: 4, max_days: 5 },
{ pincode: 221406, min_days: 4, max_days: 5 },
{ pincode: 221409, min_days: 4, max_days: 5 },
{ pincode: 221701, min_days: 4, max_days: 5 },
{ pincode: 221711, min_days: 4, max_days: 5 },
{ pincode: 221712, min_days: 4, max_days: 5 },
{ pincode: 221713, min_days: 4, max_days: 5 },
{ pincode: 221717, min_days: 4, max_days: 5 },
{ pincode: 222001, min_days: 4, max_days: 5 },
{ pincode: 222002, min_days: 4, max_days: 5 },
{ pincode: 222109, min_days: 4, max_days: 5 },
{ pincode: 222125, min_days: 4, max_days: 5 },
{ pincode: 222129, min_days: 4, max_days: 5 },
{ pincode: 222131, min_days: 4, max_days: 5 },
{ pincode: 222132, min_days: 4, max_days: 5 },
{ pincode: 222136, min_days: 4, max_days: 5 },
{ pincode: 222139, min_days: 4, max_days: 5 },
{ pincode: 222142, min_days: 4, max_days: 5 },
{ pincode: 222143, min_days: 4, max_days: 5 },
{ pincode: 222161, min_days: 4, max_days: 5 },
{ pincode: 222170, min_days: 4, max_days: 5 },
{ pincode: 222180, min_days: 4, max_days: 5 },
{ pincode: 222201, min_days: 4, max_days: 5 },
{ pincode: 222203, min_days: 4, max_days: 5 },
{ pincode: 222302, min_days: 3, max_days: 4 },
{ pincode: 222333, min_days: 2, max_days: 3 },
{ pincode: 223101, min_days: 4, max_days: 5 },
{ pincode: 223223, min_days: 4, max_days: 5 },
{ pincode: 224001, min_days: 4, max_days: 5 },
{ pincode: 224120, min_days: 4, max_days: 5 },
{ pincode: 224122, min_days: 5, max_days: 6 },
{ pincode: 224123, min_days: 4, max_days: 5 },
{ pincode: 224127, min_days: 4, max_days: 5 },
{ pincode: 224129, min_days: 5, max_days: 6 },
{ pincode: 224133, min_days: 4, max_days: 5 },
{ pincode: 224135, min_days: 4, max_days: 5 },
{ pincode: 224141, min_days: 4, max_days: 5 },
{ pincode: 224143, min_days: 5, max_days: 6 },
{ pincode: 224145, min_days: 5, max_days: 6 },
{ pincode: 224149, min_days: 5, max_days: 6 },
{ pincode: 224155, min_days: 5, max_days: 6 },
{ pincode: 224158, min_days: 4, max_days: 5 },
{ pincode: 224164, min_days: 4, max_days: 5 },
{ pincode: 224188, min_days: 4, max_days: 5 },
{ pincode: 224190, min_days: 5, max_days: 6 },
{ pincode: 224201, min_days: 4, max_days: 5 },
{ pincode: 224206, min_days: 4, max_days: 5 },
{ pincode: 224207, min_days: 4, max_days: 5 },
{ pincode: 224209, min_days: 4, max_days: 5 },
{ pincode: 224229, min_days: 4, max_days: 5 },
{ pincode: 224238, min_days: 5, max_days: 6 },
{ pincode: 225001, min_days: 4, max_days: 5 },
{ pincode: 225002, min_days: 4, max_days: 5 },
{ pincode: 225003, min_days: 4, max_days: 5 },
{ pincode: 225119, min_days: 4, max_days: 5 },
{ pincode: 225120, min_days: 4, max_days: 5 },
{ pincode: 225121, min_days: 4, max_days: 5 },
{ pincode: 225122, min_days: 4, max_days: 5 },
{ pincode: 225123, min_days: 4, max_days: 5 },
{ pincode: 225124, min_days: 4, max_days: 5 },
{ pincode: 225201, min_days: 4, max_days: 5 },
{ pincode: 225202, min_days: 4, max_days: 5 },
{ pincode: 225203, min_days: 4, max_days: 5 },
{ pincode: 225204, min_days: 4, max_days: 5 },
{ pincode: 225205, min_days: 4, max_days: 5 },
{ pincode: 225206, min_days: 4, max_days: 5 },
{ pincode: 225207, min_days: 4, max_days: 5 },
{ pincode: 225208, min_days: 4, max_days: 5 },
{ pincode: 225301, min_days: 4, max_days: 5 },
{ pincode: 225302, min_days: 4, max_days: 5 },
{ pincode: 225303, min_days: 4, max_days: 5 },
{ pincode: 225304, min_days: 4, max_days: 5 },
{ pincode: 225305, min_days: 4, max_days: 5 },
{ pincode: 225306, min_days: 4, max_days: 5 },
{ pincode: 225403, min_days: 4, max_days: 5 },
{ pincode: 225405, min_days: 4, max_days: 5 },
{ pincode: 225409, min_days: 4, max_days: 5 },
{ pincode: 225412, min_days: 4, max_days: 5 },
{ pincode: 225413, min_days: 4, max_days: 5 },
{ pincode: 225414, min_days: 4, max_days: 5 },
{ pincode: 225415, min_days: 4, max_days: 5 },
{ pincode: 226001, min_days: 3, max_days: 4 },
{ pincode: 226002, min_days: 3, max_days: 4 },
{ pincode: 226003, min_days: 3, max_days: 4 },
{ pincode: 226004, min_days: 3, max_days: 4 },
{ pincode: 226005, min_days: 3, max_days: 4 },
{ pincode: 226006, min_days: 3, max_days: 4 },
{ pincode: 226007, min_days: 3, max_days: 4 },
{ pincode: 226008, min_days: 3, max_days: 4 },
{ pincode: 226009, min_days: 3, max_days: 4 },
{ pincode: 226010, min_days: 3, max_days: 4 },
{ pincode: 226011, min_days: 3, max_days: 4 },
{ pincode: 226012, min_days: 3, max_days: 4 },
{ pincode: 226013, min_days: 3, max_days: 4 },
{ pincode: 226014, min_days: 3, max_days: 4 },
{ pincode: 226015, min_days: 3, max_days: 4 },
{ pincode: 226016, min_days: 3, max_days: 4 },
{ pincode: 226017, min_days: 3, max_days: 4 },
{ pincode: 226018, min_days: 3, max_days: 4 },
{ pincode: 226019, min_days: 3, max_days: 4 },
{ pincode: 226020, min_days: 3, max_days: 4 },
{ pincode: 226021, min_days: 3, max_days: 4 },
{ pincode: 226022, min_days: 3, max_days: 4 },
{ pincode: 226023, min_days: 3, max_days: 4 },
{ pincode: 226024, min_days: 3, max_days: 4 },
{ pincode: 226025, min_days: 3, max_days: 4 },
{ pincode: 226026, min_days: 3, max_days: 4 },
{ pincode: 226027, min_days: 3, max_days: 4 },
{ pincode: 226028, min_days: 3, max_days: 4 },
{ pincode: 226029, min_days: 3, max_days: 4 },
{ pincode: 226030, min_days: 3, max_days: 4 },
{ pincode: 226031, min_days: 3, max_days: 4 },
{ pincode: 226101, min_days: 3, max_days: 4 },
{ pincode: 226102, min_days: 3, max_days: 4 },
{ pincode: 226103, min_days: 3, max_days: 4 },
{ pincode: 226104, min_days: 3, max_days: 4 },
{ pincode: 226201, min_days: 3, max_days: 4 },
{ pincode: 226202, min_days: 3, max_days: 4 },
{ pincode: 226203, min_days: 3, max_days: 4 },
{ pincode: 226301, min_days: 3, max_days: 4 },
{ pincode: 226302, min_days: 3, max_days: 4 },
{ pincode: 226303, min_days: 3, max_days: 4 },
{ pincode: 226401, min_days: 3, max_days: 4 },
{ pincode: 226501, min_days: 3, max_days: 4 },
{ pincode: 227105, min_days: 3, max_days: 4 },
{ pincode: 227405, min_days: 3, max_days: 4 },
{ pincode: 227408, min_days: 3, max_days: 4 },
{ pincode: 227409, min_days: 3, max_days: 4 },
{ pincode: 227411, min_days: 3, max_days: 4 },
{ pincode: 227412, min_days: 3, max_days: 4 },
{ pincode: 227801, min_days: 3, max_days: 4 },
{ pincode: 227805, min_days: 3, max_days: 4 },
{ pincode: 227808, min_days: 3, max_days: 4 },
{ pincode: 227809, min_days: 3, max_days: 4 },
{ pincode: 227812, min_days: 3, max_days: 4 },
{ pincode: 227813, min_days: 3, max_days: 4 },
{ pincode: 227817, min_days: 3, max_days: 4 },
{ pincode: 228001, min_days: 3, max_days: 4 },
{ pincode: 228118, min_days: 3, max_days: 4 },
{ pincode: 228119, min_days: 3, max_days: 4 },
{ pincode: 228125, min_days: 3, max_days: 4 },
{ pincode: 228141, min_days: 3, max_days: 4 },
{ pincode: 228145, min_days: 3, max_days: 4 },
{ pincode: 228155, min_days: 3, max_days: 4 },
{ pincode: 229001, min_days: 3, max_days: 4 },
{ pincode: 229010, min_days: 3, max_days: 4 },
{ pincode: 229120, min_days: 3, max_days: 4 },
{ pincode: 229122, min_days: 3, max_days: 4 },
{ pincode: 229124, min_days: 3, max_days: 4 },
{ pincode: 229126, min_days: 3, max_days: 4 },
{ pincode: 229127, min_days: 3, max_days: 4 },
{ pincode: 229129, min_days: 3, max_days: 4 },
{ pincode: 229206, min_days: 3, max_days: 4 },
{ pincode: 229207, min_days: 3, max_days: 4 },
{ pincode: 229301, min_days: 3, max_days: 4 },
{ pincode: 229302, min_days: 3, max_days: 4 },
{ pincode: 229303, min_days: 3, max_days: 4 },
{ pincode: 229304, min_days: 3, max_days: 4 },
{ pincode: 229305, min_days: 3, max_days: 4 },
{ pincode: 229306, min_days: 3, max_days: 4 },
{ pincode: 229307, min_days: 3, max_days: 4 },
{ pincode: 229309, min_days: 3, max_days: 4 },
{ pincode: 229310, min_days: 3, max_days: 4 },
{ pincode: 229316, min_days: 3, max_days: 4 },
{ pincode: 229401, min_days: 3, max_days: 4 },
{ pincode: 229402, min_days: 3, max_days: 4 },
{ pincode: 229404, min_days: 3, max_days: 4 },
{ pincode: 229405, min_days: 3, max_days: 4 },
{ pincode: 229406, min_days: 3, max_days: 4 },
{ pincode: 229801, min_days: 3, max_days: 4 },
{ pincode: 230001, min_days: 4, max_days: 5 },
{ pincode: 230002, min_days: 4, max_days: 5 },
{ pincode: 230124, min_days: 4, max_days: 5 },
{ pincode: 230132, min_days: 4, max_days: 5 },
{ pincode: 230135, min_days: 4, max_days: 5 },
{ pincode: 230136, min_days: 4, max_days: 5 },
{ pincode: 230301, min_days: 4, max_days: 5 },
{ pincode: 230304, min_days: 4, max_days: 5 },
{ pincode: 230402, min_days: 4, max_days: 5 },
{ pincode: 230403, min_days: 4, max_days: 5 },
{ pincode: 230501, min_days: 4, max_days: 5 },
{ pincode: 230502, min_days: 4, max_days: 5 },
{ pincode: 230503, min_days: 4, max_days: 5 },
{ pincode: 231001, min_days: 4, max_days: 5 },
{ pincode: 231205, min_days: 4, max_days: 5 },
{ pincode: 231206, min_days: 4, max_days: 5 },
{ pincode: 231208, min_days: 4, max_days: 5 },
{ pincode: 231210, min_days: 4, max_days: 5 },
{ pincode: 231213, min_days: 4, max_days: 5 },
{ pincode: 231215, min_days: 4, max_days: 5 },
{ pincode: 231216, min_days: 4, max_days: 5 },
{ pincode: 231217, min_days: 4, max_days: 5 },
{ pincode: 231218, min_days: 4, max_days: 5 },
{ pincode: 231219, min_days: 4, max_days: 5 },
{ pincode: 231220, min_days: 4, max_days: 5 },
{ pincode: 231221, min_days: 4, max_days: 5 },
{ pincode: 231222, min_days: 4, max_days: 5 },
{ pincode: 231223, min_days: 4, max_days: 5 },
{ pincode: 231225, min_days: 4, max_days: 5 },
{ pincode: 231301, min_days: 4, max_days: 5 },
{ pincode: 231304, min_days: 4, max_days: 5 },
{ pincode: 231305, min_days: 4, max_days: 5 },
{ pincode: 231306, min_days: 4, max_days: 5 },
{ pincode: 231307, min_days: 4, max_days: 5 },
{ pincode: 231501, min_days: 4, max_days: 5 },
{ pincode: 232101, min_days: 3, max_days: 4 },
{ pincode: 232104, min_days: 4, max_days: 5 },
{ pincode: 232326, min_days: 4, max_days: 5 },
{ pincode: 232333, min_days: 4, max_days: 5 },
{ pincode: 233001, min_days: 4, max_days: 5 },
{ pincode: 233224, min_days: 4, max_days: 5 },
{ pincode: 233226, min_days: 4, max_days: 5 },
{ pincode: 233228, min_days: 4, max_days: 5 },
{ pincode: 233230, min_days: 4, max_days: 5 },
{ pincode: 233232, min_days: 4, max_days: 5 },
{ pincode: 233300, min_days: 4, max_days: 5 },
{ pincode: 233302, min_days: 4, max_days: 5 },
{ pincode: 233303, min_days: 4, max_days: 5 },
{ pincode: 233304, min_days: 4, max_days: 5 },
{ pincode: 233305, min_days: 4, max_days: 5 },
{ pincode: 233306, min_days: 4, max_days: 5 },
{ pincode: 241001, min_days: 4, max_days: 5 },
{ pincode: 242001, min_days: 4, max_days: 5 },
{ pincode: 242021, min_days: 2, max_days: 3 },
{ pincode: 242042, min_days: 5, max_days: 6 },
{ pincode: 242220, min_days: 5, max_days: 6 },
{ pincode: 242221, min_days: 5, max_days: 6 },
{ pincode: 242223, min_days: 5, max_days: 6 },
{ pincode: 242301, min_days: 5, max_days: 6 },
{ pincode: 242305, min_days: 5, max_days: 6 },
{ pincode: 242306, min_days: 5, max_days: 6 },
{ pincode: 242307, min_days: 5, max_days: 6 },
{ pincode: 242401, min_days: 5, max_days: 6 },
{ pincode: 242405, min_days: 5, max_days: 6 },
{ pincode: 242406, min_days: 5, max_days: 6 },
{ pincode: 242407, min_days: 5, max_days: 6 },
{ pincode: 243001, min_days: 3, max_days: 4 },
{ pincode: 243002, min_days: 4, max_days: 5 },
{ pincode: 243003, min_days: 3, max_days: 4 },
{ pincode: 243004, min_days: 4, max_days: 5 },
{ pincode: 243005, min_days: 3, max_days: 4 },
{ pincode: 243006, min_days: 3, max_days: 4 },
{ pincode: 243122, min_days: 3, max_days: 4 },
{ pincode: 243123, min_days: 4, max_days: 5 },
{ pincode: 243126, min_days: 4, max_days: 5 },
{ pincode: 243201, min_days: 3, max_days: 4 },
{ pincode: 243202, min_days: 4, max_days: 5 },
{ pincode: 243301, min_days: 5, max_days: 6 },
{ pincode: 243302, min_days: 5, max_days: 6 },
{ pincode: 243303, min_days: 5, max_days: 6 },
{ pincode: 243401, min_days: 5, max_days: 6 },
{ pincode: 243403, min_days: 5, max_days: 6 },
{ pincode: 243501, min_days: 4, max_days: 5 },
{ pincode: 243502, min_days: 4, max_days: 5 },
{ pincode: 243503, min_days: 4, max_days: 5 },
{ pincode: 243504, min_days: 4, max_days: 5 },
{ pincode: 243505, min_days: 4, max_days: 5 },
{ pincode: 243601, min_days: 4, max_days: 5 },
{ pincode: 243631, min_days: 5, max_days: 6 },
{ pincode: 243633, min_days: 5, max_days: 6 },
{ pincode: 243634, min_days: 5, max_days: 6 },
{ pincode: 243635, min_days: 5, max_days: 6 },
{ pincode: 243636, min_days: 5, max_days: 6 },
{ pincode: 243637, min_days: 5, max_days: 6 },
{ pincode: 243638, min_days: 5, max_days: 6 },
{ pincode: 243639, min_days: 5, max_days: 6 },
{ pincode: 243641, min_days: 5, max_days: 6 },
{ pincode: 243720, min_days: 5, max_days: 6 },
{ pincode: 243722, min_days: 4, max_days: 5 },
{ pincode: 243723, min_days: 4, max_days: 5 },
{ pincode: 243724, min_days: 5, max_days: 6 },
{ pincode: 243726, min_days: 5, max_days: 6 },
{ pincode: 243727, min_days: 4, max_days: 5 },
{ pincode: 244001, min_days: 2, max_days: 3 },
{ pincode: 244102, min_days: 2, max_days: 3 },
{ pincode: 244103, min_days: 2, max_days: 3 },
{ pincode: 244104, min_days: 3, max_days: 4 },
{ pincode: 244105, min_days: 3, max_days: 4 },
{ pincode: 244221, min_days: 4, max_days: 5 },
{ pincode: 244222, min_days: 3, max_days: 4 },
{ pincode: 244223, min_days: 3, max_days: 4 },
{ pincode: 244225, min_days: 5, max_days: 6 },
{ pincode: 244231, min_days: 5, max_days: 6 },
{ pincode: 244235, min_days: 3, max_days: 4 },
{ pincode: 244236, min_days: 5, max_days: 6 },
{ pincode: 244241, min_days: 4, max_days: 5 },
{ pincode: 244242, min_days: 4, max_days: 5 },
{ pincode: 244251, min_days: 5, max_days: 6 },
{ pincode: 244301, min_days: 3, max_days: 4 },
{ pincode: 244302, min_days: 3, max_days: 4 },
{ pincode: 244303, min_days: 3, max_days: 4 },
{ pincode: 244304, min_days: 4, max_days: 5 },
{ pincode: 244401, min_days: 3, max_days: 4 },
{ pincode: 244402, min_days: 3, max_days: 4 },
{ pincode: 244410, min_days: 4, max_days: 5 },
{ pincode: 244411, min_days: 4, max_days: 5 },
{ pincode: 244412, min_days: 3, max_days: 4 },
{ pincode: 244413, min_days: 4, max_days: 5 },
{ pincode: 244501, min_days: 3, max_days: 4 },
{ pincode: 244601, min_days: 3, max_days: 4 },
{ pincode: 244602, min_days: 3, max_days: 4 },
{ pincode: 244701, min_days: 4, max_days: 5 },
{ pincode: 244712, min_days: 3, max_days: 4 },
{ pincode: 244713, min_days: 3, max_days: 4 },
{ pincode: 244715, min_days: 3, max_days: 4 },
{ pincode: 244901, min_days: 3, max_days: 4 },
{ pincode: 244921, min_days: 3, max_days: 4 },
{ pincode: 244922, min_days: 4, max_days: 5 },
{ pincode: 244923, min_days: 3, max_days: 4 },
{ pincode: 244924, min_days: 3, max_days: 4 },
{ pincode: 244925, min_days: 3, max_days: 4 },
{ pincode: 244927, min_days: 4, max_days: 5 },
{ pincode: 244928, min_days: 3, max_days: 4 },
{ pincode: 245205, min_days: 3, max_days: 4 },
{ pincode: 246001, min_days: 7, max_days: 8 },
{ pincode: 246127, min_days: 3, max_days: 4 },
{ pincode: 246149, min_days: 3, max_days: 4 },
{ pincode: 246171, min_days: 5, max_days: 6 },
{ pincode: 246174, min_days: 5, max_days: 6 },
{ pincode: 246401, min_days: 7, max_days: 8 },
{ pincode: 246421, min_days: 5, max_days: 6 },
{ pincode: 246424, min_days: 7, max_days: 8 },
{ pincode: 246472, min_days: 7, max_days: 8 },
{ pincode: 246475, min_days: 5, max_days: 6 },
{ pincode: 246701, min_days: 2, max_days: 3 },
{ pincode: 246721, min_days: 3, max_days: 4 },
{ pincode: 246722, min_days: 3, max_days: 4 },
{ pincode: 246724, min_days: 3, max_days: 4 },
{ pincode: 246725, min_days: 2, max_days: 3 },
{ pincode: 246726, min_days: 3, max_days: 4 },
{ pincode: 246727, min_days: 3, max_days: 4 },
{ pincode: 246728, min_days: 3, max_days: 4 },
{ pincode: 246731, min_days: 3, max_days: 4 },
{ pincode: 246732, min_days: 3, max_days: 4 },
{ pincode: 246733, min_days: 3, max_days: 4 },
{ pincode: 246734, min_days: 3, max_days: 4 },
{ pincode: 246735, min_days: 3, max_days: 4 },
{ pincode: 246736, min_days: 3, max_days: 4 },
{ pincode: 246746, min_days: 3, max_days: 4 },
{ pincode: 246747, min_days: 3, max_days: 4 },
{ pincode: 246749, min_days: 3, max_days: 4 },
{ pincode: 246761, min_days: 2, max_days: 3 },
{ pincode: 246762, min_days: 3, max_days: 4 },
{ pincode: 246763, min_days: 2, max_days: 3 },
{ pincode: 246764, min_days: 3, max_days: 4 },
{ pincode: 247001, min_days: 3, max_days: 4 },
{ pincode: 247002, min_days: 3, max_days: 4 },
{ pincode: 247120, min_days: 3, max_days: 4 },
{ pincode: 247121, min_days: 3, max_days: 4 },
{ pincode: 247122, min_days: 3, max_days: 4 },
{ pincode: 247129, min_days: 3, max_days: 4 },
{ pincode: 247231, min_days: 3, max_days: 4 },
{ pincode: 247232, min_days: 3, max_days: 4 },
{ pincode: 247340, min_days: 3, max_days: 4 },
{ pincode: 247341, min_days: 3, max_days: 4 },
{ pincode: 247342, min_days: 3, max_days: 4 },
{ pincode: 247451, min_days: 3, max_days: 4 },
{ pincode: 247452, min_days: 3, max_days: 4 },
{ pincode: 247551, min_days: 3, max_days: 4 },
{ pincode: 247554, min_days: 3, max_days: 4 },
{ pincode: 247656, min_days: 3, max_days: 4 },
{ pincode: 247661, min_days: 3, max_days: 4 },
{ pincode: 247662, min_days: 3, max_days: 4 },
{ pincode: 247663, min_days: 3, max_days: 4 },
{ pincode: 247664, min_days: 3, max_days: 4 },
{ pincode: 247665, min_days: 3, max_days: 4 },
{ pincode: 247666, min_days: 3, max_days: 4 },
{ pincode: 247667, min_days: 3, max_days: 4 },
{ pincode: 247668, min_days: 3, max_days: 4 },
{ pincode: 247669, min_days: 3, max_days: 4 },
{ pincode: 247771, min_days: 5, max_days: 6 },
{ pincode: 247772, min_days: 5, max_days: 6 },
{ pincode: 247773, min_days: 5, max_days: 6 },
{ pincode: 247774, min_days: 5, max_days: 6 },
{ pincode: 247775, min_days: 5, max_days: 6 },
{ pincode: 247776, min_days: 4, max_days: 5 },
{ pincode: 247777, min_days: 5, max_days: 6 },
{ pincode: 247778, min_days: 5, max_days: 6 },
{ pincode: 248001, min_days: 3, max_days: 4 },
{ pincode: 248002, min_days: 3, max_days: 4 },
{ pincode: 248003, min_days: 3, max_days: 4 },
{ pincode: 248005, min_days: 3, max_days: 4 },
{ pincode: 248006, min_days: 3, max_days: 4 },
{ pincode: 248007, min_days: 3, max_days: 4 },
{ pincode: 248008, min_days: 3, max_days: 4 },
{ pincode: 248009, min_days: 3, max_days: 4 },
{ pincode: 248010, min_days: 3, max_days: 4 },
{ pincode: 248011, min_days: 4, max_days: 5 },
{ pincode: 248012, min_days: 3, max_days: 4 },
{ pincode: 248013, min_days: 3, max_days: 4 },
{ pincode: 248014, min_days: 3, max_days: 4 },
{ pincode: 248015, min_days: 3, max_days: 4 },
{ pincode: 248016, min_days: 4, max_days: 5 },
{ pincode: 248102, min_days: 3, max_days: 4 },
{ pincode: 248110, min_days: 3, max_days: 4 },
{ pincode: 248115, min_days: 3, max_days: 4 },
{ pincode: 248121, min_days: 3, max_days: 4 },
{ pincode: 248122, min_days: 3, max_days: 4 },
{ pincode: 248125, min_days: 4, max_days: 5 },
{ pincode: 248126, min_days: 3, max_days: 4 },
{ pincode: 248140, min_days: 4, max_days: 5 },
{ pincode: 248141, min_days: 3, max_days: 4 },
{ pincode: 248142, min_days: 4, max_days: 5 },
{ pincode: 248143, min_days: 4, max_days: 5 },
{ pincode: 248145, min_days: 4, max_days: 5 },
{ pincode: 248146, min_days: 3, max_days: 4 },
{ pincode: 248160, min_days: 3, max_days: 4 },
{ pincode: 248161, min_days: 4, max_days: 5 },
{ pincode: 248171, min_days: 3, max_days: 4 },
{ pincode: 248179, min_days: 4, max_days: 5 },
{ pincode: 248195, min_days: 3, max_days: 4 },
{ pincode: 248197, min_days: 4, max_days: 5 },
{ pincode: 248198, min_days: 4, max_days: 5 },
{ pincode: 249137, min_days: 3, max_days: 4 },
{ pincode: 249175, min_days: 3, max_days: 4 },
{ pincode: 249201, min_days: 3, max_days: 4 },
{ pincode: 249202, min_days: 3, max_days: 4 },
{ pincode: 249203, min_days: 3, max_days: 4 },
{ pincode: 249204, min_days: 3, max_days: 4 },
{ pincode: 249205, min_days: 3, max_days: 4 },
{ pincode: 249302, min_days: 3, max_days: 4 },
{ pincode: 249401, min_days: 3, max_days: 4 },
{ pincode: 249402, min_days: 3, max_days: 4 },
{ pincode: 249403, min_days: 3, max_days: 4 },
{ pincode: 249404, min_days: 3, max_days: 4 },
{ pincode: 249405, min_days: 3, max_days: 4 },
{ pincode: 249407, min_days: 3, max_days: 4 },
{ pincode: 249408, min_days: 3, max_days: 4 },
{ pincode: 249409, min_days: 3, max_days: 4 },
{ pincode: 249410, min_days: 3, max_days: 4 },
{ pincode: 249411, min_days: 3, max_days: 4 },
{ pincode: 250001, min_days: 2, max_days: 3 },
{ pincode: 250002, min_days: 2, max_days: 3 },
{ pincode: 250003, min_days: 2, max_days: 3 },
{ pincode: 250004, min_days: 2, max_days: 3 },
{ pincode: 250005, min_days: 2, max_days: 3 },
{ pincode: 250101, min_days: 4, max_days: 5 },
{ pincode: 250103, min_days: 3, max_days: 4 },
{ pincode: 250104, min_days: 3, max_days: 4 },
{ pincode: 250105, min_days: 2, max_days: 3 },
{ pincode: 250106, min_days: 3, max_days: 4 },
{ pincode: 250110, min_days: 2, max_days: 3 },
{ pincode: 250205, min_days: 3, max_days: 4 },
{ pincode: 250221, min_days: 3, max_days: 4 },
{ pincode: 250222, min_days: 3, max_days: 4 },
{ pincode: 250223, min_days: 3, max_days: 4 },
{ pincode: 250341, min_days: 3, max_days: 4 },
{ pincode: 250342, min_days: 3, max_days: 4 },
{ pincode: 250345, min_days: 4, max_days: 5 },
{ pincode: 250401, min_days: 3, max_days: 4 },
{ pincode: 250402, min_days: 3, max_days: 4 },
{ pincode: 250404, min_days: 3, max_days: 4 },
{ pincode: 250406, min_days: 3, max_days: 4 },
{ pincode: 250501, min_days: 3, max_days: 4 },
{ pincode: 250502, min_days: 3, max_days: 4 },
{ pincode: 250601, min_days: 4, max_days: 5 },
{ pincode: 250606, min_days: 4, max_days: 5 },
{ pincode: 250609, min_days: 3, max_days: 4 },
{ pincode: 250611, min_days: 3, max_days: 4 },
{ pincode: 250615, min_days: 4, max_days: 5 },
{ pincode: 250617, min_days: 4, max_days: 5 },
{ pincode: 250619, min_days: 4, max_days: 5 },
{ pincode: 250620, min_days: 4, max_days: 5 },
{ pincode: 250622, min_days: 4, max_days: 5 },
{ pincode: 250625, min_days: 4, max_days: 5 },
{ pincode: 251001, min_days: 3, max_days: 4 },
{ pincode: 251002, min_days: 3, max_days: 4 },
{ pincode: 251003, min_days: 3, max_days: 4 },
{ pincode: 251201, min_days: 3, max_days: 4 },
{ pincode: 251202, min_days: 4, max_days: 5 },
{ pincode: 251203, min_days: 4, max_days: 5 },
{ pincode: 251301, min_days: 5, max_days: 6 },
{ pincode: 251305, min_days: 5, max_days: 6 },
{ pincode: 251306, min_days: 4, max_days: 5 },
{ pincode: 251307, min_days: 4, max_days: 5 },
{ pincode: 251308, min_days: 4, max_days: 5 },
{ pincode: 251309, min_days: 5, max_days: 6 },
{ pincode: 251310, min_days: 4, max_days: 5 },
{ pincode: 251311, min_days: 4, max_days: 5 },
{ pincode: 251314, min_days: 4, max_days: 5 },
{ pincode: 251315, min_days: 4, max_days: 5 },
{ pincode: 251316, min_days: 4, max_days: 5 },
{ pincode: 251318, min_days: 4, max_days: 5 },
{ pincode: 251319, min_days: 5, max_days: 6 },
{ pincode: 251327, min_days: 4, max_days: 5 },
{ pincode: 261001, min_days: 3, max_days: 4 },
{ pincode: 261121, min_days: 4, max_days: 5 },
{ pincode: 261131, min_days: 4, max_days: 5 },
{ pincode: 261135, min_days: 3, max_days: 4 },
{ pincode: 261141, min_days: 4, max_days: 5 },
{ pincode: 261201, min_days: 4, max_days: 5 },
{ pincode: 261202, min_days: 4, max_days: 5 },
{ pincode: 261203, min_days: 4, max_days: 5 },
{ pincode: 261204, min_days: 4, max_days: 5 },
{ pincode: 261205, min_days: 4, max_days: 5 },
{ pincode: 261206, min_days: 4, max_days: 5 },
{ pincode: 261208, min_days: 4, max_days: 5 },
{ pincode: 261301, min_days: 4, max_days: 5 },
{ pincode: 261302, min_days: 4, max_days: 5 },
{ pincode: 261303, min_days: 4, max_days: 5 },
{ pincode: 261401, min_days: 4, max_days: 5 },
{ pincode: 261402, min_days: 4, max_days: 5 },
{ pincode: 261403, min_days: 4, max_days: 5 },
{ pincode: 261405, min_days: 4, max_days: 5 },
{ pincode: 261501, min_days: 3, max_days: 4 },
{ pincode: 261505, min_days: 4, max_days: 5 },
{ pincode: 261506, min_days: 3, max_days: 4 },
{ pincode: 262001, min_days: 4, max_days: 5 },
{ pincode: 262122, min_days: 4, max_days: 5 },
{ pincode: 262201, min_days: 5, max_days: 6 },
{ pincode: 262302, min_days: 4, max_days: 5 },
{ pincode: 262308, min_days: 4, max_days: 5 },
{ pincode: 262401, min_days: 3, max_days: 4 },
{ pincode: 262405, min_days: 4, max_days: 5 },
{ pincode: 262406, min_days: 4, max_days: 5 },
{ pincode: 262501, min_days: 7, max_days: 8 },
{ pincode: 262520, min_days: 7, max_days: 8 },
{ pincode: 262523, min_days: 7, max_days: 8 },
{ pincode: 262524, min_days: 7, max_days: 8 },
{ pincode: 262530, min_days: 7, max_days: 8 },
{ pincode: 262701, min_days: 3, max_days: 4 },
{ pincode: 262702, min_days: 3, max_days: 4 },
{ pincode: 262721, min_days: 3, max_days: 4 },
{ pincode: 262722, min_days: 3, max_days: 4 },
{ pincode: 262724, min_days: 3, max_days: 4 },
{ pincode: 262725, min_days: 3, max_days: 4 },
{ pincode: 262726, min_days: 3, max_days: 4 },
{ pincode: 262728, min_days: 3, max_days: 4 },
{ pincode: 262801, min_days: 4, max_days: 5 },
{ pincode: 262802, min_days: 4, max_days: 5 },
{ pincode: 262803, min_days: 4, max_days: 5 },
{ pincode: 262804, min_days: 4, max_days: 5 },
{ pincode: 262805, min_days: 4, max_days: 5 },
{ pincode: 262901, min_days: 4, max_days: 5 },
{ pincode: 262902, min_days: 4, max_days: 5 },
{ pincode: 262903, min_days: 3, max_days: 4 },
{ pincode: 262907, min_days: 3, max_days: 4 },
{ pincode: 263145, min_days: 3, max_days: 4 },
{ pincode: 263148, min_days: 3, max_days: 4 },
{ pincode: 263152, min_days: 3, max_days: 4 },
{ pincode: 263153, min_days: 3, max_days: 4 },
{ pincode: 263160, min_days: 3, max_days: 4 },
{ pincode: 263601, min_days: 7, max_days: 8 },
{ pincode: 263637, min_days: 7, max_days: 8 },
{ pincode: 263645, min_days: 5, max_days: 6 },
{ pincode: 263653, min_days: 7, max_days: 8 },
{ pincode: 263656, min_days: 7, max_days: 8 },
{ pincode: 271001, min_days: 5, max_days: 6 },
{ pincode: 271002, min_days: 5, max_days: 6 },
{ pincode: 271003, min_days: 5, max_days: 6 },
{ pincode: 271201, min_days: 5, max_days: 6 },
{ pincode: 271205, min_days: 5, max_days: 6 },
{ pincode: 271208, min_days: 5, max_days: 6 },
{ pincode: 271210, min_days: 5, max_days: 6 },
{ pincode: 271302, min_days: 5, max_days: 6 },
{ pincode: 271303, min_days: 5, max_days: 6 },
{ pincode: 271305, min_days: 5, max_days: 6 },
{ pincode: 271306, min_days: 5, max_days: 6 },
{ pincode: 271313, min_days: 4, max_days: 5 },
{ pincode: 271604, min_days: 5, max_days: 6 },
{ pincode: 271607, min_days: 5, max_days: 6 },
{ pincode: 271609, min_days: 5, max_days: 6 },
{ pincode: 271801, min_days: 4, max_days: 5 },
{ pincode: 271803, min_days: 4, max_days: 5 },
{ pincode: 271821, min_days: 4, max_days: 5 },
{ pincode: 271824, min_days: 4, max_days: 5 },
{ pincode: 271831, min_days: 4, max_days: 5 },
{ pincode: 271835, min_days: 4, max_days: 5 },
{ pincode: 271845, min_days: 5, max_days: 6 },
{ pincode: 271851, min_days: 4, max_days: 5 },
{ pincode: 271855, min_days: 4, max_days: 5 },
{ pincode: 271861, min_days: 5, max_days: 6 },
{ pincode: 271865, min_days: 4, max_days: 5 },
{ pincode: 271871, min_days: 4, max_days: 5 },
{ pincode: 271875, min_days: 4, max_days: 5 },
{ pincode: 271882, min_days: 4, max_days: 5 },
{ pincode: 271902, min_days: 4, max_days: 5 },
{ pincode: 271903, min_days: 4, max_days: 5 },
{ pincode: 272001, min_days: 4, max_days: 5 },
{ pincode: 272002, min_days: 4, max_days: 5 },
{ pincode: 272123, min_days: 4, max_days: 5 },
{ pincode: 272124, min_days: 4, max_days: 5 },
{ pincode: 272125, min_days: 4, max_days: 5 },
{ pincode: 272127, min_days: 4, max_days: 5 },
{ pincode: 272131, min_days: 4, max_days: 5 },
{ pincode: 272151, min_days: 4, max_days: 5 },
{ pincode: 272152, min_days: 5, max_days: 6 },
{ pincode: 272153, min_days: 5, max_days: 6 },
{ pincode: 272155, min_days: 4, max_days: 5 },
{ pincode: 272162, min_days: 4, max_days: 5 },
{ pincode: 272163, min_days: 4, max_days: 5 },
{ pincode: 272164, min_days: 4, max_days: 5 },
{ pincode: 272172, min_days: 4, max_days: 5 },
{ pincode: 272173, min_days: 4, max_days: 5 },
{ pincode: 272175, min_days: 4, max_days: 5 },
{ pincode: 272176, min_days: 4, max_days: 5 },
{ pincode: 272178, min_days: 4, max_days: 5 },
{ pincode: 272182, min_days: 4, max_days: 5 },
{ pincode: 272189, min_days: 5, max_days: 6 },
{ pincode: 272190, min_days: 4, max_days: 5 },
{ pincode: 272192, min_days: 5, max_days: 6 },
{ pincode: 272194, min_days: 4, max_days: 5 },
{ pincode: 272199, min_days: 4, max_days: 5 },
{ pincode: 272201, min_days: 5, max_days: 6 },
{ pincode: 272202, min_days: 5, max_days: 6 },
{ pincode: 272203, min_days: 5, max_days: 6 },
{ pincode: 272204, min_days: 5, max_days: 6 },
{ pincode: 272205, min_days: 5, max_days: 6 },
{ pincode: 272206, min_days: 5, max_days: 6 },
{ pincode: 272207, min_days: 5, max_days: 6 },
{ pincode: 272270, min_days: 4, max_days: 5 },
{ pincode: 272271, min_days: 4, max_days: 5 },
{ pincode: 272301, min_days: 4, max_days: 5 },
{ pincode: 272302, min_days: 4, max_days: 5 },
{ pincode: 273001, min_days: 3, max_days: 4 },
{ pincode: 273002, min_days: 3, max_days: 4 },
{ pincode: 273003, min_days: 3, max_days: 4 },
{ pincode: 273004, min_days: 3, max_days: 4 },
{ pincode: 273005, min_days: 3, max_days: 4 },
{ pincode: 273006, min_days: 3, max_days: 4 },
{ pincode: 273007, min_days: 3, max_days: 4 },
{ pincode: 273008, min_days: 3, max_days: 4 },
{ pincode: 273009, min_days: 3, max_days: 4 },
{ pincode: 273010, min_days: 3, max_days: 4 },
{ pincode: 273012, min_days: 3, max_days: 4 },
{ pincode: 273013, min_days: 3, max_days: 4 },
{ pincode: 273014, min_days: 3, max_days: 4 },
{ pincode: 273015, min_days: 3, max_days: 4 },
{ pincode: 273016, min_days: 3, max_days: 4 },
{ pincode: 273017, min_days: 3, max_days: 4 },
{ pincode: 273151, min_days: 4, max_days: 5 },
{ pincode: 273152, min_days: 3, max_days: 4 },
{ pincode: 273155, min_days: 4, max_days: 5 },
{ pincode: 273161, min_days: 4, max_days: 5 },
{ pincode: 273162, min_days: 4, max_days: 5 },
{ pincode: 273163, min_days: 4, max_days: 5 },
{ pincode: 273164, min_days: 4, max_days: 5 },
{ pincode: 273165, min_days: 3, max_days: 4 },
{ pincode: 273201, min_days: 3, max_days: 4 },
{ pincode: 273202, min_days: 3, max_days: 4 },
{ pincode: 273203, min_days: 3, max_days: 4 },
{ pincode: 273207, min_days: 4, max_days: 5 },
{ pincode: 273209, min_days: 4, max_days: 5 },
{ pincode: 273212, min_days: 4, max_days: 5 },
{ pincode: 273213, min_days: 4, max_days: 5 },
{ pincode: 273301, min_days: 4, max_days: 5 },
{ pincode: 273302, min_days: 4, max_days: 5 },
{ pincode: 273303, min_days: 4, max_days: 5 },
{ pincode: 273304, min_days: 4, max_days: 5 },
{ pincode: 273305, min_days: 4, max_days: 5 },
{ pincode: 273308, min_days: 4, max_days: 5 },
{ pincode: 273310, min_days: 4, max_days: 5 },
{ pincode: 273401, min_days: 4, max_days: 5 },
{ pincode: 273402, min_days: 4, max_days: 5 },
{ pincode: 273403, min_days: 4, max_days: 5 },
{ pincode: 273406, min_days: 4, max_days: 5 },
{ pincode: 273408, min_days: 4, max_days: 5 },
{ pincode: 273409, min_days: 4, max_days: 5 },
{ pincode: 273411, min_days: 4, max_days: 5 },
{ pincode: 273412, min_days: 4, max_days: 5 },
{ pincode: 273413, min_days: 4, max_days: 5 },
{ pincode: 274001, min_days: 5, max_days: 6 },
{ pincode: 274202, min_days: 5, max_days: 6 },
{ pincode: 274204, min_days: 5, max_days: 6 },
{ pincode: 274304, min_days: 4, max_days: 5 },
{ pincode: 274401, min_days: 4, max_days: 5 },
{ pincode: 274402, min_days: 4, max_days: 5 },
{ pincode: 274403, min_days: 4, max_days: 5 },
{ pincode: 274404, min_days: 5, max_days: 6 },
{ pincode: 274406, min_days: 4, max_days: 5 },
{ pincode: 275101, min_days: 4, max_days: 5 },
{ pincode: 275102, min_days: 4, max_days: 5 },
{ pincode: 275201, min_days: 4, max_days: 5 },
{ pincode: 275301, min_days: 4, max_days: 5 },
{ pincode: 275303, min_days: 4, max_days: 5 },
{ pincode: 275304, min_days: 4, max_days: 5 },
{ pincode: 275305, min_days: 4, max_days: 5 },
{ pincode: 275307, min_days: 4, max_days: 5 },
{ pincode: 276001, min_days: 4, max_days: 5 },
{ pincode: 276121, min_days: 4, max_days: 5 },
{ pincode: 276128, min_days: 4, max_days: 5 },
{ pincode: 276129, min_days: 4, max_days: 5 },
{ pincode: 276141, min_days: 4, max_days: 5 },
{ pincode: 276202, min_days: 4, max_days: 5 },
{ pincode: 276204, min_days: 4, max_days: 5 },
{ pincode: 276206, min_days: 4, max_days: 5 },
{ pincode: 276207, min_days: 4, max_days: 5 },
{ pincode: 276303, min_days: 4, max_days: 5 },
{ pincode: 276304, min_days: 4, max_days: 5 },
{ pincode: 276305, min_days: 4, max_days: 5 },
{ pincode: 276306, min_days: 4, max_days: 5 },
{ pincode: 276402, min_days: 4, max_days: 5 },
{ pincode: 276403, min_days: 4, max_days: 5 },
{ pincode: 276404, min_days: 4, max_days: 5 },
{ pincode: 277001, min_days: 4, max_days: 5 },
{ pincode: 277123, min_days: 4, max_days: 5 },
{ pincode: 277202, min_days: 4, max_days: 5 },
{ pincode: 277209, min_days: 4, max_days: 5 },
{ pincode: 277211, min_days: 4, max_days: 5 },
{ pincode: 277303, min_days: 4, max_days: 5 },
{ pincode: 277304, min_days: 4, max_days: 5 },
{ pincode: 277401, min_days: 4, max_days: 5 },
{ pincode: 277501, min_days: 4, max_days: 5 },
{ pincode: 277503, min_days: 4, max_days: 5 },
{ pincode: 281001, min_days: 2, max_days: 3 },
{ pincode: 281003, min_days: 2, max_days: 3 },
{ pincode: 281004, min_days: 2, max_days: 3 },
{ pincode: 281005, min_days: 2, max_days: 3 },
{ pincode: 281006, min_days: 2, max_days: 3 },
{ pincode: 281121, min_days: 2, max_days: 3 },
{ pincode: 281122, min_days: 2, max_days: 3 },
{ pincode: 281123, min_days: 2, max_days: 3 },
{ pincode: 281201, min_days: 2, max_days: 3 },
{ pincode: 281202, min_days: 2, max_days: 3 },
{ pincode: 281204, min_days: 2, max_days: 3 },
{ pincode: 281301, min_days: 2, max_days: 3 },
{ pincode: 281306, min_days: 3, max_days: 4 },
{ pincode: 281401, min_days: 2, max_days: 3 },
{ pincode: 281403, min_days: 2, max_days: 3 },
{ pincode: 281406, min_days: 2, max_days: 3 },
{ pincode: 282001, min_days: 3, max_days: 4 },
{ pincode: 282002, min_days: 3, max_days: 4 },
{ pincode: 282003, min_days: 3, max_days: 4 },
{ pincode: 282004, min_days: 3, max_days: 4 },
{ pincode: 282005, min_days: 3, max_days: 4 },
{ pincode: 282006, min_days: 3, max_days: 4 },
{ pincode: 282007, min_days: 3, max_days: 4 },
{ pincode: 282008, min_days: 3, max_days: 4 },
{ pincode: 282009, min_days: 3, max_days: 4 },
{ pincode: 282010, min_days: 3, max_days: 4 },
{ pincode: 283101, min_days: 3, max_days: 4 },
{ pincode: 283102, min_days: 3, max_days: 4 },
{ pincode: 283105, min_days: 3, max_days: 4 },
{ pincode: 283110, min_days: 3, max_days: 4 },
{ pincode: 283111, min_days: 3, max_days: 4 },
{ pincode: 283112, min_days: 3, max_days: 4 },
{ pincode: 283119, min_days: 3, max_days: 4 },
{ pincode: 283121, min_days: 3, max_days: 4 },
{ pincode: 283122, min_days: 3, max_days: 4 },
{ pincode: 283124, min_days: 3, max_days: 4 },
{ pincode: 283125, min_days: 3, max_days: 4 },
{ pincode: 283126, min_days: 3, max_days: 4 },
{ pincode: 283130, min_days: 4, max_days: 5 },
{ pincode: 283135, min_days: 4, max_days: 5 },
{ pincode: 283145, min_days: 4, max_days: 5 },
{ pincode: 283151, min_days: 4, max_days: 5 },
{ pincode: 283152, min_days: 4, max_days: 5 },
{ pincode: 283201, min_days: 3, max_days: 4 },
{ pincode: 283202, min_days: 3, max_days: 4 },
{ pincode: 283203, min_days: 4, max_days: 5 },
{ pincode: 283204, min_days: 4, max_days: 5 },
{ pincode: 284001, min_days: 3, max_days: 4 },
{ pincode: 284002, min_days: 3, max_days: 4 },
{ pincode: 284003, min_days: 3, max_days: 4 },
{ pincode: 284120, min_days: 3, max_days: 4 },
{ pincode: 284121, min_days: 3, max_days: 4 },
{ pincode: 284124, min_days: 4, max_days: 5 },
{ pincode: 284125, min_days: 4, max_days: 5 },
{ pincode: 284126, min_days: 4, max_days: 5 },
{ pincode: 284128, min_days: 3, max_days: 4 },
{ pincode: 284135, min_days: 3, max_days: 4 },
{ pincode: 284201, min_days: 3, max_days: 4 },
{ pincode: 284202, min_days: 4, max_days: 5 },
{ pincode: 284204, min_days: 4, max_days: 5 },
{ pincode: 284205, min_days: 4, max_days: 5 },
{ pincode: 284301, min_days: 3, max_days: 4 },
{ pincode: 284303, min_days: 4, max_days: 5 },
{ pincode: 284305, min_days: 3, max_days: 4 },
{ pincode: 284401, min_days: 3, max_days: 4 },
{ pincode: 284403, min_days: 4, max_days: 5 },
{ pincode: 284404, min_days: 4, max_days: 5 },
{ pincode: 284405, min_days: 4, max_days: 5 },
{ pincode: 285001, min_days: 4, max_days: 5 },
{ pincode: 285122, min_days: 5, max_days: 6 },
{ pincode: 285123, min_days: 5, max_days: 6 },
{ pincode: 285201, min_days: 5, max_days: 6 },
{ pincode: 285202, min_days: 5, max_days: 6 },
{ pincode: 285204, min_days: 5, max_days: 6 },
{ pincode: 285205, min_days: 5, max_days: 6 },
{ pincode: 301001, min_days: 2, max_days: 3 },
{ pincode: 301018, min_days: 2, max_days: 3 },
{ pincode: 301019, min_days: 2, max_days: 3 },
{ pincode: 301020, min_days: 2, max_days: 3 },
{ pincode: 301021, min_days: 2, max_days: 3 },
{ pincode: 301022, min_days: 3, max_days: 4 },
{ pincode: 301024, min_days: 3, max_days: 4 },
{ pincode: 301030, min_days: 3, max_days: 4 },
{ pincode: 301402, min_days: 3, max_days: 4 },
{ pincode: 301404, min_days: 2, max_days: 3 },
{ pincode: 301405, min_days: 2, max_days: 3 },
{ pincode: 301427, min_days: 2, max_days: 3 },
{ pincode: 301701, min_days: 2, max_days: 3 },
{ pincode: 301703, min_days: 2, max_days: 3 },
{ pincode: 301704, min_days: 2, max_days: 3 },
{ pincode: 301705, min_days: 2, max_days: 3 },
{ pincode: 301706, min_days: 2, max_days: 3 },
{ pincode: 301707, min_days: 2, max_days: 3 },
{ pincode: 301713, min_days: 2, max_days: 3 },
{ pincode: 302001, min_days: 3, max_days: 4 },
{ pincode: 302002, min_days: 3, max_days: 4 },
{ pincode: 302003, min_days: 3, max_days: 4 },
{ pincode: 302004, min_days: 3, max_days: 4 },
{ pincode: 302005, min_days: 3, max_days: 4 },
{ pincode: 302006, min_days: 3, max_days: 4 },
{ pincode: 302007, min_days: 3, max_days: 4 },
{ pincode: 302008, min_days: 3, max_days: 4 },
{ pincode: 302009, min_days: 3, max_days: 4 },
{ pincode: 302010, min_days: 3, max_days: 4 },
{ pincode: 302011, min_days: 3, max_days: 4 },
{ pincode: 302012, min_days: 3, max_days: 4 },
{ pincode: 302013, min_days: 3, max_days: 4 },
{ pincode: 302015, min_days: 3, max_days: 4 },
{ pincode: 302016, min_days: 3, max_days: 4 },
{ pincode: 302017, min_days: 3, max_days: 4 },
{ pincode: 302018, min_days: 3, max_days: 4 },
{ pincode: 302019, min_days: 3, max_days: 4 },
{ pincode: 302020, min_days: 3, max_days: 4 },
{ pincode: 302021, min_days: 3, max_days: 4 },
{ pincode: 302022, min_days: 3, max_days: 4 },
{ pincode: 302023, min_days: 3, max_days: 4 },
{ pincode: 302024, min_days: 3, max_days: 4 },
{ pincode: 302025, min_days: 3, max_days: 4 },
{ pincode: 302026, min_days: 3, max_days: 4 },
{ pincode: 302027, min_days: 4, max_days: 5 },
{ pincode: 302028, min_days: 3, max_days: 4 },
{ pincode: 302029, min_days: 3, max_days: 4 },
{ pincode: 302031, min_days: 4, max_days: 5 },
{ pincode: 302032, min_days: 3, max_days: 4 },
{ pincode: 302033, min_days: 3, max_days: 4 },
{ pincode: 302034, min_days: 3, max_days: 4 },
{ pincode: 302037, min_days: 4, max_days: 5 },
{ pincode: 302039, min_days: 3, max_days: 4 },
{ pincode: 302111, min_days: 3, max_days: 4 },
{ pincode: 303005, min_days: 4, max_days: 5 },
{ pincode: 303007, min_days: 3, max_days: 4 },
{ pincode: 303008, min_days: 4, max_days: 5 },
{ pincode: 303012, min_days: 3, max_days: 4 },
{ pincode: 303101, min_days: 3, max_days: 4 },
{ pincode: 303103, min_days: 3, max_days: 4 },
{ pincode: 303106, min_days: 3, max_days: 4 },
{ pincode: 303108, min_days: 3, max_days: 4 },
{ pincode: 303301, min_days: 4, max_days: 5 },
{ pincode: 303303, min_days: 4, max_days: 5 },
{ pincode: 303305, min_days: 5, max_days: 6 },
{ pincode: 303313, min_days: 5, max_days: 6 },
{ pincode: 303326, min_days: 5, max_days: 6 },
{ pincode: 303338, min_days: 4, max_days: 5 },
{ pincode: 303501, min_days: 5, max_days: 6 },
{ pincode: 303503, min_days: 4, max_days: 5 },
{ pincode: 303504, min_days: 4, max_days: 5 },
{ pincode: 303505, min_days: 4, max_days: 5 },
{ pincode: 303509, min_days: 5, max_days: 6 },
{ pincode: 303510, min_days: 4, max_days: 5 },
{ pincode: 303511, min_days: 4, max_days: 5 },
{ pincode: 303702, min_days: 3, max_days: 4 },
{ pincode: 303704, min_days: 3, max_days: 4 },
{ pincode: 303901, min_days: 5, max_days: 6 },
{ pincode: 303903, min_days: 3, max_days: 4 },
{ pincode: 303904, min_days: 4, max_days: 5 },
{ pincode: 303905, min_days: 4, max_days: 5 },
{ pincode: 303908, min_days: 5, max_days: 6 },
{ pincode: 304021, min_days: 4, max_days: 5 },
{ pincode: 304022, min_days: 4, max_days: 5 },
{ pincode: 305001, min_days: 3, max_days: 4 },
{ pincode: 305002, min_days: 3, max_days: 4 },
{ pincode: 305003, min_days: 3, max_days: 4 },
{ pincode: 305004, min_days: 3, max_days: 4 },
{ pincode: 305005, min_days: 3, max_days: 4 },
{ pincode: 305006, min_days: 3, max_days: 4 },
{ pincode: 305007, min_days: 3, max_days: 4 },
{ pincode: 305008, min_days: 3, max_days: 4 },
{ pincode: 305022, min_days: 4, max_days: 5 },
{ pincode: 305404, min_days: 4, max_days: 5 },
{ pincode: 305601, min_days: 5, max_days: 6 },
{ pincode: 305624, min_days: 4, max_days: 5 },
{ pincode: 305801, min_days: 3, max_days: 4 },
{ pincode: 305802, min_days: 4, max_days: 5 },
{ pincode: 305814, min_days: 3, max_days: 4 },
{ pincode: 305817, min_days: 3, max_days: 4 },
{ pincode: 305901, min_days: 4, max_days: 5 },
{ pincode: 306103, min_days: 5, max_days: 6 },
{ pincode: 306104, min_days: 5, max_days: 6 },
{ pincode: 306115, min_days: 4, max_days: 5 },
{ pincode: 306116, min_days: 5, max_days: 6 },
{ pincode: 306302, min_days: 4, max_days: 5 },
{ pincode: 306401, min_days: 4, max_days: 5 },
{ pincode: 306902, min_days: 4, max_days: 5 },
{ pincode: 307001, min_days: 3, max_days: 4 },
{ pincode: 307019, min_days: 4, max_days: 5 },
{ pincode: 307022, min_days: 4, max_days: 5 },
{ pincode: 307023, min_days: 4, max_days: 5 },
{ pincode: 307026, min_days: 3, max_days: 4 },
{ pincode: 307027, min_days: 4, max_days: 5 },
{ pincode: 307029, min_days: 5, max_days: 6 },
{ pincode: 307510, min_days: 4, max_days: 5 },
{ pincode: 307513, min_days: 4, max_days: 5 },
{ pincode: 307514, min_days: 4, max_days: 5 },
{ pincode: 307801, min_days: 4, max_days: 5 },
{ pincode: 311001, min_days: 4, max_days: 5 },
{ pincode: 311011, min_days: 4, max_days: 5 },
{ pincode: 311021, min_days: 4, max_days: 5 },
{ pincode: 311022, min_days: 4, max_days: 5 },
{ pincode: 311024, min_days: 5, max_days: 6 },
{ pincode: 311025, min_days: 5, max_days: 6 },
{ pincode: 311301, min_days: 5, max_days: 6 },
{ pincode: 311401, min_days: 5, max_days: 6 },
{ pincode: 311402, min_days: 5, max_days: 6 },
{ pincode: 311403, min_days: 5, max_days: 6 },
{ pincode: 311601, min_days: 5, max_days: 6 },
{ pincode: 311603, min_days: 5, max_days: 6 },
{ pincode: 311604, min_days: 5, max_days: 6 },
{ pincode: 311801, min_days: 5, max_days: 6 },
{ pincode: 311802, min_days: 5, max_days: 6 },
{ pincode: 312001, min_days: 5, max_days: 6 },
{ pincode: 312021, min_days: 6, max_days: 7 },
{ pincode: 312022, min_days: 6, max_days: 7 },
{ pincode: 312024, min_days: 6, max_days: 7 },
{ pincode: 312601, min_days: 5, max_days: 6 },
{ pincode: 312605, min_days: 3, max_days: 4 },
{ pincode: 312612, min_days: 6, max_days: 7 },
{ pincode: 312617, min_days: 6, max_days: 7 },
{ pincode: 312901, min_days: 6, max_days: 7 },
{ pincode: 313001, min_days: 3, max_days: 4 },
{ pincode: 313002, min_days: 3, max_days: 4 },
{ pincode: 313003, min_days: 3, max_days: 4 },
{ pincode: 313004, min_days: 3, max_days: 4 },
{ pincode: 313011, min_days: 3, max_days: 4 },
{ pincode: 313022, min_days: 4, max_days: 5 },
{ pincode: 313024, min_days: 4, max_days: 5 },
{ pincode: 313202, min_days: 4, max_days: 5 },
{ pincode: 313203, min_days: 4, max_days: 5 },
{ pincode: 313205, min_days: 3, max_days: 4 },
{ pincode: 313211, min_days: 4, max_days: 5 },
{ pincode: 313301, min_days: 4, max_days: 5 },
{ pincode: 313324, min_days: 3, max_days: 4 },
{ pincode: 313601, min_days: 4, max_days: 5 },
{ pincode: 313602, min_days: 4, max_days: 5 },
{ pincode: 313901, min_days: 4, max_days: 5 },
{ pincode: 314025, min_days: 3, max_days: 4 },
{ pincode: 314026, min_days: 3, max_days: 4 },
{ pincode: 321001, min_days: 3, max_days: 4 },
{ pincode: 321201, min_days: 4, max_days: 5 },
{ pincode: 321202, min_days: 4, max_days: 5 },
{ pincode: 321401, min_days: 4, max_days: 5 },
{ pincode: 321404, min_days: 4, max_days: 5 },
{ pincode: 321602, min_days: 4, max_days: 5 },
{ pincode: 322001, min_days: 4, max_days: 5 },
{ pincode: 322021, min_days: 5, max_days: 6 },
{ pincode: 322024, min_days: 5, max_days: 6 },
{ pincode: 322201, min_days: 4, max_days: 5 },
{ pincode: 322202, min_days: 4, max_days: 5 },
{ pincode: 322220, min_days: 5, max_days: 6 },
{ pincode: 322230, min_days: 5, max_days: 6 },
{ pincode: 322241, min_days: 4, max_days: 5 },
{ pincode: 322702, min_days: 5, max_days: 6 },
{ pincode: 323001, min_days: 4, max_days: 5 },
{ pincode: 323021, min_days: 5, max_days: 6 },
{ pincode: 324001, min_days: 4, max_days: 5 },
{ pincode: 324002, min_days: 4, max_days: 5 },
{ pincode: 324003, min_days: 4, max_days: 5 },
{ pincode: 324004, min_days: 4, max_days: 5 },
{ pincode: 324005, min_days: 4, max_days: 5 },
{ pincode: 324006, min_days: 4, max_days: 5 },
{ pincode: 324007, min_days: 4, max_days: 5 },
{ pincode: 324008, min_days: 4, max_days: 5 },
{ pincode: 324009, min_days: 4, max_days: 5 },
{ pincode: 324010, min_days: 4, max_days: 5 },
{ pincode: 325001, min_days: 4, max_days: 5 },
{ pincode: 325202, min_days: 4, max_days: 5 },
{ pincode: 325601, min_days: 6, max_days: 7 },
{ pincode: 326001, min_days: 5, max_days: 6 },
{ pincode: 326038, min_days: 6, max_days: 7 },
{ pincode: 327001, min_days: 3, max_days: 4 },
{ pincode: 328001, min_days: 3, max_days: 4 },
{ pincode: 328021, min_days: 4, max_days: 5 },
{ pincode: 328024, min_days: 4, max_days: 5 },
{ pincode: 331001, min_days: 4, max_days: 5 },
{ pincode: 331021, min_days: 4, max_days: 5 },
{ pincode: 331022, min_days: 5, max_days: 6 },
{ pincode: 331023, min_days: 4, max_days: 5 },
{ pincode: 331024, min_days: 5, max_days: 6 },
{ pincode: 331025, min_days: 4, max_days: 5 },
{ pincode: 331027, min_days: 5, max_days: 6 },
{ pincode: 331028, min_days: 5, max_days: 6 },
{ pincode: 331304, min_days: 5, max_days: 6 },
{ pincode: 331305, min_days: 4, max_days: 5 },
{ pincode: 331403, min_days: 4, max_days: 5 },
{ pincode: 331411, min_days: 4, max_days: 5 },
{ pincode: 331506, min_days: 5, max_days: 6 },
{ pincode: 331507, min_days: 4, max_days: 5 },
{ pincode: 331517, min_days: 5, max_days: 6 },
{ pincode: 331802, min_days: 5, max_days: 6 },
{ pincode: 331803, min_days: 4, max_days: 5 },
{ pincode: 331811, min_days: 4, max_days: 5 },
{ pincode: 332001, min_days: 4, max_days: 5 },
{ pincode: 332002, min_days: 4, max_days: 5 },
{ pincode: 332021, min_days: 4, max_days: 5 },
{ pincode: 332023, min_days: 4, max_days: 5 },
{ pincode: 332024, min_days: 4, max_days: 5 },
{ pincode: 332031, min_days: 4, max_days: 5 },
{ pincode: 332041, min_days: 4, max_days: 5 },
{ pincode: 332301, min_days: 4, max_days: 5 },
{ pincode: 332311, min_days: 4, max_days: 5 },
{ pincode: 332402, min_days: 4, max_days: 5 },
{ pincode: 332403, min_days: 4, max_days: 5 },
{ pincode: 332404, min_days: 4, max_days: 5 },
{ pincode: 332405, min_days: 4, max_days: 5 },
{ pincode: 332713, min_days: 3, max_days: 4 },
{ pincode: 332715, min_days: 4, max_days: 5 },
{ pincode: 332718, min_days: 3, max_days: 4 },
{ pincode: 333001, min_days: 4, max_days: 5 },
{ pincode: 333021, min_days: 4, max_days: 5 },
{ pincode: 333022, min_days: 5, max_days: 6 },
{ pincode: 333023, min_days: 5, max_days: 6 },
{ pincode: 333025, min_days: 5, max_days: 6 },
{ pincode: 333026, min_days: 4, max_days: 5 },
{ pincode: 333029, min_days: 5, max_days: 6 },
{ pincode: 333031, min_days: 4, max_days: 5 },
{ pincode: 333035, min_days: 4, max_days: 5 },
{ pincode: 333042, min_days: 5, max_days: 6 },
{ pincode: 333307, min_days: 5, max_days: 6 },
{ pincode: 333333, min_days: 2, max_days: 3 },
{ pincode: 333516, min_days: 4, max_days: 5 },
{ pincode: 333704, min_days: 5, max_days: 6 },
{ pincode: 333705, min_days: 5, max_days: 6 },
{ pincode: 334001, min_days: 4, max_days: 5 },
{ pincode: 334003, min_days: 4, max_days: 5 },
{ pincode: 334004, min_days: 4, max_days: 5 },
{ pincode: 334006, min_days: 4, max_days: 5 },
{ pincode: 334022, min_days: 4, max_days: 5 },
{ pincode: 334401, min_days: 4, max_days: 5 },
{ pincode: 334402, min_days: 4, max_days: 5 },
{ pincode: 334403, min_days: 4, max_days: 5 },
{ pincode: 334603, min_days: 4, max_days: 5 },
{ pincode: 334802, min_days: 5, max_days: 6 },
{ pincode: 334803, min_days: 5, max_days: 6 },
{ pincode: 335001, min_days: 4, max_days: 5 },
{ pincode: 335002, min_days: 4, max_days: 5 },
{ pincode: 335024, min_days: 4, max_days: 5 },
{ pincode: 335027, min_days: 4, max_days: 5 },
{ pincode: 335037, min_days: 4, max_days: 5 },
{ pincode: 335041, min_days: 4, max_days: 5 },
{ pincode: 335051, min_days: 4, max_days: 5 },
{ pincode: 335062, min_days: 4, max_days: 5 },
{ pincode: 335063, min_days: 4, max_days: 5 },
{ pincode: 335073, min_days: 4, max_days: 5 },
{ pincode: 335501, min_days: 4, max_days: 5 },
{ pincode: 335502, min_days: 5, max_days: 6 },
{ pincode: 335504, min_days: 4, max_days: 5 },
{ pincode: 335505, min_days: 3, max_days: 4 },
{ pincode: 335511, min_days: 3, max_days: 4 },
{ pincode: 335512, min_days: 4, max_days: 5 },
{ pincode: 335513, min_days: 5, max_days: 6 },
{ pincode: 335514, min_days: 3, max_days: 4 },
{ pincode: 335523, min_days: 4, max_days: 5 },
{ pincode: 335524, min_days: 4, max_days: 5 },
{ pincode: 335525, min_days: 4, max_days: 5 },
{ pincode: 335526, min_days: 4, max_days: 5 },
{ pincode: 335702, min_days: 4, max_days: 5 },
{ pincode: 335704, min_days: 4, max_days: 5 },
{ pincode: 335801, min_days: 4, max_days: 5 },
{ pincode: 335802, min_days: 4, max_days: 5 },
{ pincode: 335803, min_days: 4, max_days: 5 },
{ pincode: 335804, min_days: 4, max_days: 5 },
{ pincode: 335805, min_days: 5, max_days: 6 },
{ pincode: 341001, min_days: 4, max_days: 5 },
{ pincode: 341021, min_days: 4, max_days: 5 },
{ pincode: 341024, min_days: 4, max_days: 5 },
{ pincode: 341026, min_days: 4, max_days: 5 },
{ pincode: 341028, min_days: 4, max_days: 5 },
{ pincode: 341302, min_days: 5, max_days: 6 },
{ pincode: 341303, min_days: 4, max_days: 5 },
{ pincode: 341304, min_days: 5, max_days: 6 },
{ pincode: 341306, min_days: 5, max_days: 6 },
{ pincode: 341316, min_days: 5, max_days: 6 },
{ pincode: 341502, min_days: 4, max_days: 5 },
{ pincode: 341505, min_days: 4, max_days: 5 },
{ pincode: 341506, min_days: 4, max_days: 5 },
{ pincode: 341508, min_days: 4, max_days: 5 },
{ pincode: 341509, min_days: 4, max_days: 5 },
{ pincode: 341512, min_days: 4, max_days: 5 },
{ pincode: 342001, min_days: 4, max_days: 5 },
{ pincode: 342002, min_days: 4, max_days: 5 },
{ pincode: 342003, min_days: 3, max_days: 4 },
{ pincode: 342004, min_days: 5, max_days: 6 },
{ pincode: 342005, min_days: 4, max_days: 5 },
{ pincode: 342006, min_days: 3, max_days: 4 },
{ pincode: 342007, min_days: 3, max_days: 4 },
{ pincode: 342008, min_days: 4, max_days: 5 },
{ pincode: 342009, min_days: 5, max_days: 6 },
{ pincode: 342010, min_days: 5, max_days: 6 },
{ pincode: 342011, min_days: 4, max_days: 5 },
{ pincode: 342012, min_days: 3, max_days: 4 },
{ pincode: 342013, min_days: 3, max_days: 4 },
{ pincode: 342014, min_days: 4, max_days: 5 },
{ pincode: 342015, min_days: 3, max_days: 4 },
{ pincode: 342024, min_days: 3, max_days: 4 },
{ pincode: 342026, min_days: 5, max_days: 6 },
{ pincode: 342027, min_days: 3, max_days: 4 },
{ pincode: 342030, min_days: 4, max_days: 5 },
{ pincode: 342037, min_days: 4, max_days: 5 },
{ pincode: 342301, min_days: 4, max_days: 5 },
{ pincode: 342304, min_days: 4, max_days: 5 },
{ pincode: 342307, min_days: 5, max_days: 6 },
{ pincode: 342601, min_days: 4, max_days: 5 },
{ pincode: 342602, min_days: 4, max_days: 5 },
{ pincode: 342801, min_days: 5, max_days: 6 },
{ pincode: 343001, min_days: 4, max_days: 5 },
{ pincode: 343022, min_days: 4, max_days: 5 },
{ pincode: 343029, min_days: 5, max_days: 6 },
{ pincode: 344001, min_days: 4, max_days: 5 },
{ pincode: 344011, min_days: 4, max_days: 5 },
{ pincode: 344022, min_days: 4, max_days: 5 },
{ pincode: 344024, min_days: 4, max_days: 5 },
{ pincode: 344032, min_days: 4, max_days: 5 },
{ pincode: 344033, min_days: 5, max_days: 6 },
{ pincode: 344034, min_days: 5, max_days: 6 },
{ pincode: 344035, min_days: 5, max_days: 6 },
{ pincode: 344701, min_days: 5, max_days: 6 },
{ pincode: 344702, min_days: 5, max_days: 6 },
{ pincode: 345001, min_days: 4, max_days: 5 },
{ pincode: 345021, min_days: 5, max_days: 6 },
{ pincode: 360001, min_days: 3, max_days: 4 },
{ pincode: 360002, min_days: 3, max_days: 4 },
{ pincode: 360003, min_days: 3, max_days: 4 },
{ pincode: 360004, min_days: 3, max_days: 4 },
{ pincode: 360005, min_days: 3, max_days: 4 },
{ pincode: 360006, min_days: 3, max_days: 4 },
{ pincode: 360007, min_days: 3, max_days: 4 },
{ pincode: 360008, min_days: 3, max_days: 4 },
{ pincode: 360009, min_days: 3, max_days: 4 },
{ pincode: 360020, min_days: 4, max_days: 5 },
{ pincode: 360021, min_days: 3, max_days: 4 },
{ pincode: 360023, min_days: 3, max_days: 4 },
{ pincode: 360024, min_days: 3, max_days: 4 },
{ pincode: 360040, min_days: 3, max_days: 4 },
{ pincode: 360050, min_days: 3, max_days: 4 },
{ pincode: 360055, min_days: 3, max_days: 4 },
{ pincode: 360060, min_days: 3, max_days: 4 },
{ pincode: 360070, min_days: 3, max_days: 4 },
{ pincode: 360110, min_days: 4, max_days: 5 },
{ pincode: 360311, min_days: 3, max_days: 4 },
{ pincode: 360320, min_days: 3, max_days: 4 },
{ pincode: 360360, min_days: 3, max_days: 4 },
{ pincode: 360370, min_days: 3, max_days: 4 },
{ pincode: 360375, min_days: 3, max_days: 4 },
{ pincode: 360405, min_days: 3, max_days: 4 },
{ pincode: 360410, min_days: 3, max_days: 4 },
{ pincode: 360421, min_days: 3, max_days: 4 },
{ pincode: 360430, min_days: 3, max_days: 4 },
{ pincode: 360440, min_days: 3, max_days: 4 },
{ pincode: 360450, min_days: 3, max_days: 4 },
{ pincode: 360452, min_days: 3, max_days: 4 },
{ pincode: 360460, min_days: 3, max_days: 4 },
{ pincode: 360470, min_days: 3, max_days: 4 },
{ pincode: 360480, min_days: 3, max_days: 4 },
{ pincode: 360490, min_days: 3, max_days: 4 },
{ pincode: 360510, min_days: 3, max_days: 4 },
{ pincode: 360530, min_days: 3, max_days: 4 },
{ pincode: 360545, min_days: 3, max_days: 4 },
{ pincode: 360550, min_days: 3, max_days: 4 },
{ pincode: 360560, min_days: 3, max_days: 4 },
{ pincode: 360570, min_days: 3, max_days: 4 },
{ pincode: 360575, min_days: 3, max_days: 4 },
{ pincode: 360576, min_days: 3, max_days: 4 },
{ pincode: 360577, min_days: 3, max_days: 4 },
{ pincode: 360578, min_days: 3, max_days: 4 },
{ pincode: 360579, min_days: 3, max_days: 4 },
{ pincode: 360590, min_days: 3, max_days: 4 },
{ pincode: 361001, min_days: 3, max_days: 4 },
{ pincode: 361002, min_days: 3, max_days: 4 },
{ pincode: 361003, min_days: 3, max_days: 4 },
{ pincode: 361004, min_days: 3, max_days: 4 },
{ pincode: 361005, min_days: 3, max_days: 4 },
{ pincode: 361006, min_days: 3, max_days: 4 },
{ pincode: 361007, min_days: 3, max_days: 4 },
{ pincode: 361008, min_days: 3, max_days: 4 },
{ pincode: 361009, min_days: 3, max_days: 4 },
{ pincode: 361010, min_days: 3, max_days: 4 },
{ pincode: 361110, min_days: 3, max_days: 4 },
{ pincode: 361120, min_days: 3, max_days: 4 },
{ pincode: 361140, min_days: 3, max_days: 4 },
{ pincode: 361141, min_days: 3, max_days: 4 },
{ pincode: 361142, min_days: 3, max_days: 4 },
{ pincode: 361150, min_days: 3, max_days: 4 },
{ pincode: 361170, min_days: 3, max_days: 4 },
{ pincode: 361210, min_days: 3, max_days: 4 },
{ pincode: 361280, min_days: 3, max_days: 4 },
{ pincode: 361305, min_days: 3, max_days: 4 },
{ pincode: 361306, min_days: 3, max_days: 4 },
{ pincode: 361310, min_days: 3, max_days: 4 },
{ pincode: 361315, min_days: 3, max_days: 4 },
{ pincode: 361330, min_days: 3, max_days: 4 },
{ pincode: 361335, min_days: 3, max_days: 4 },
{ pincode: 361345, min_days: 3, max_days: 4 },
{ pincode: 361347, min_days: 3, max_days: 4 },
{ pincode: 361350, min_days: 3, max_days: 4 },
{ pincode: 362001, min_days: 3, max_days: 4 },
{ pincode: 362002, min_days: 3, max_days: 4 },
{ pincode: 362003, min_days: 3, max_days: 4 },
{ pincode: 362004, min_days: 3, max_days: 4 },
{ pincode: 362011, min_days: 3, max_days: 4 },
{ pincode: 362015, min_days: 3, max_days: 4 },
{ pincode: 362020, min_days: 3, max_days: 4 },
{ pincode: 362030, min_days: 3, max_days: 4 },
{ pincode: 362037, min_days: 3, max_days: 4 },
{ pincode: 362110, min_days: 3, max_days: 4 },
{ pincode: 362120, min_days: 3, max_days: 4 },
{ pincode: 362135, min_days: 3, max_days: 4 },
{ pincode: 362140, min_days: 3, max_days: 4 },
{ pincode: 362150, min_days: 3, max_days: 4 },
{ pincode: 362205, min_days: 3, max_days: 4 },
{ pincode: 362215, min_days: 3, max_days: 4 },
{ pincode: 362220, min_days: 3, max_days: 4 },
{ pincode: 362222, min_days: 3, max_days: 4 },
{ pincode: 362225, min_days: 3, max_days: 4 },
{ pincode: 362226, min_days: 3, max_days: 4 },
{ pincode: 362227, min_days: 3, max_days: 4 },
{ pincode: 362229, min_days: 3, max_days: 4 },
{ pincode: 362230, min_days: 3, max_days: 4 },
{ pincode: 362235, min_days: 3, max_days: 4 },
{ pincode: 362240, min_days: 3, max_days: 4 },
{ pincode: 362245, min_days: 3, max_days: 4 },
{ pincode: 362250, min_days: 3, max_days: 4 },
{ pincode: 362255, min_days: 3, max_days: 4 },
{ pincode: 362260, min_days: 3, max_days: 4 },
{ pincode: 362265, min_days: 3, max_days: 4 },
{ pincode: 362266, min_days: 3, max_days: 4 },
{ pincode: 362267, min_days: 3, max_days: 4 },
{ pincode: 362268, min_days: 3, max_days: 4 },
{ pincode: 362269, min_days: 3, max_days: 4 },
{ pincode: 362275, min_days: 3, max_days: 4 },
{ pincode: 362310, min_days: 3, max_days: 4 },
{ pincode: 362315, min_days: 3, max_days: 4 },
{ pincode: 362520, min_days: 3, max_days: 4 },
{ pincode: 362540, min_days: 3, max_days: 4 },
{ pincode: 362560, min_days: 3, max_days: 4 },
{ pincode: 362610, min_days: 3, max_days: 4 },
{ pincode: 362620, min_days: 3, max_days: 4 },
{ pincode: 362625, min_days: 3, max_days: 4 },
{ pincode: 362630, min_days: 3, max_days: 4 },
{ pincode: 362640, min_days: 3, max_days: 4 },
{ pincode: 362650, min_days: 3, max_days: 4 },
{ pincode: 362715, min_days: 3, max_days: 4 },
{ pincode: 362720, min_days: 3, max_days: 4 },
{ pincode: 362725, min_days: 3, max_days: 4 },
{ pincode: 363001, min_days: 3, max_days: 4 },
{ pincode: 363002, min_days: 3, max_days: 4 },
{ pincode: 363020, min_days: 3, max_days: 4 },
{ pincode: 363030, min_days: 3, max_days: 4 },
{ pincode: 363035, min_days: 3, max_days: 4 },
{ pincode: 363040, min_days: 3, max_days: 4 },
{ pincode: 363110, min_days: 3, max_days: 4 },
{ pincode: 363115, min_days: 3, max_days: 4 },
{ pincode: 363310, min_days: 3, max_days: 4 },
{ pincode: 363320, min_days: 3, max_days: 4 },
{ pincode: 363330, min_days: 4, max_days: 5 },
{ pincode: 363415, min_days: 3, max_days: 4 },
{ pincode: 363421, min_days: 3, max_days: 4 },
{ pincode: 363427, min_days: 3, max_days: 4 },
{ pincode: 363430, min_days: 3, max_days: 4 },
{ pincode: 363435, min_days: 3, max_days: 4 },
{ pincode: 363510, min_days: 3, max_days: 4 },
{ pincode: 363520, min_days: 3, max_days: 4 },
{ pincode: 363530, min_days: 3, max_days: 4 },
{ pincode: 363621, min_days: 3, max_days: 4 },
{ pincode: 363641, min_days: 3, max_days: 4 },
{ pincode: 363642, min_days: 3, max_days: 4 },
{ pincode: 363643, min_days: 3, max_days: 4 },
{ pincode: 363650, min_days: 3, max_days: 4 },
{ pincode: 363660, min_days: 3, max_days: 4 },
{ pincode: 364001, min_days: 3, max_days: 4 },
{ pincode: 364002, min_days: 3, max_days: 4 },
{ pincode: 364003, min_days: 3, max_days: 4 },
{ pincode: 364004, min_days: 3, max_days: 4 },
{ pincode: 364005, min_days: 3, max_days: 4 },
{ pincode: 364006, min_days: 3, max_days: 4 },
{ pincode: 364050, min_days: 3, max_days: 4 },
{ pincode: 364055, min_days: 3, max_days: 4 },
{ pincode: 364060, min_days: 3, max_days: 4 },
{ pincode: 364110, min_days: 3, max_days: 4 },
{ pincode: 364140, min_days: 3, max_days: 4 },
{ pincode: 364150, min_days: 3, max_days: 4 },
{ pincode: 364230, min_days: 3, max_days: 4 },
{ pincode: 364240, min_days: 3, max_days: 4 },
{ pincode: 364250, min_days: 3, max_days: 4 },
{ pincode: 364265, min_days: 3, max_days: 4 },
{ pincode: 364270, min_days: 3, max_days: 4 },
{ pincode: 364290, min_days: 3, max_days: 4 },
{ pincode: 364295, min_days: 3, max_days: 4 },
{ pincode: 364310, min_days: 3, max_days: 4 },
{ pincode: 364421, min_days: 3, max_days: 4 },
{ pincode: 364490, min_days: 3, max_days: 4 },
{ pincode: 364505, min_days: 3, max_days: 4 },
{ pincode: 364515, min_days: 3, max_days: 4 },
{ pincode: 364521, min_days: 3, max_days: 4 },
{ pincode: 364522, min_days: 3, max_days: 4 },
{ pincode: 364525, min_days: 3, max_days: 4 },
{ pincode: 364540, min_days: 3, max_days: 4 },
{ pincode: 364630, min_days: 3, max_days: 4 },
{ pincode: 364710, min_days: 3, max_days: 4 },
{ pincode: 364720, min_days: 3, max_days: 4 },
{ pincode: 364750, min_days: 3, max_days: 4 },
{ pincode: 364765, min_days: 3, max_days: 4 },
{ pincode: 365220, min_days: 3, max_days: 4 },
{ pincode: 365410, min_days: 3, max_days: 4 },
{ pincode: 365421, min_days: 3, max_days: 4 },
{ pincode: 365435, min_days: 3, max_days: 4 },
{ pincode: 365440, min_days: 3, max_days: 4 },
{ pincode: 365455, min_days: 3, max_days: 4 },
{ pincode: 365456, min_days: 3, max_days: 4 },
{ pincode: 365460, min_days: 3, max_days: 4 },
{ pincode: 365535, min_days: 3, max_days: 4 },
{ pincode: 365540, min_days: 3, max_days: 4 },
{ pincode: 365541, min_days: 3, max_days: 4 },
{ pincode: 365545, min_days: 3, max_days: 4 },
{ pincode: 365550, min_days: 3, max_days: 4 },
{ pincode: 365560, min_days: 3, max_days: 4 },
{ pincode: 365565, min_days: 3, max_days: 4 },
{ pincode: 365601, min_days: 3, max_days: 4 },
{ pincode: 365610, min_days: 3, max_days: 4 },
{ pincode: 365620, min_days: 3, max_days: 4 },
{ pincode: 365630, min_days: 3, max_days: 4 },
{ pincode: 365635, min_days: 3, max_days: 4 },
{ pincode: 370001, min_days: 3, max_days: 4 },
{ pincode: 370015, min_days: 3, max_days: 4 },
{ pincode: 370020, min_days: 3, max_days: 4 },
{ pincode: 370030, min_days: 3, max_days: 4 },
{ pincode: 370105, min_days: 3, max_days: 4 },
{ pincode: 370110, min_days: 3, max_days: 4 },
{ pincode: 370130, min_days: 3, max_days: 4 },
{ pincode: 370140, min_days: 3, max_days: 4 },
{ pincode: 370150, min_days: 3, max_days: 4 },
{ pincode: 370165, min_days: 3, max_days: 4 },
{ pincode: 370203, min_days: 3, max_days: 4 },
{ pincode: 370230, min_days: 3, max_days: 4 },
{ pincode: 370240, min_days: 3, max_days: 4 },
{ pincode: 370405, min_days: 3, max_days: 4 },
{ pincode: 370415, min_days: 3, max_days: 4 },
{ pincode: 370421, min_days: 3, max_days: 4 },
{ pincode: 370429, min_days: 3, max_days: 4 },
{ pincode: 370430, min_days: 3, max_days: 4 },
{ pincode: 370435, min_days: 3, max_days: 4 },
{ pincode: 370445, min_days: 3, max_days: 4 },
{ pincode: 370450, min_days: 3, max_days: 4 },
{ pincode: 370455, min_days: 3, max_days: 4 },
{ pincode: 370460, min_days: 3, max_days: 4 },
{ pincode: 370465, min_days: 3, max_days: 4 },
{ pincode: 370475, min_days: 3, max_days: 4 },
{ pincode: 370511, min_days: 3, max_days: 4 },
{ pincode: 370601, min_days: 3, max_days: 4 },
{ pincode: 370605, min_days: 3, max_days: 4 },
{ pincode: 370610, min_days: 3, max_days: 4 },
{ pincode: 370615, min_days: 3, max_days: 4 },
{ pincode: 370645, min_days: 3, max_days: 4 },
{ pincode: 370655, min_days: 3, max_days: 4 },
{ pincode: 370665, min_days: 3, max_days: 4 },
{ pincode: 370670, min_days: 3, max_days: 4 },
{ pincode: 370675, min_days: 3, max_days: 4 },
{ pincode: 380001, min_days: 2, max_days: 3 },
{ pincode: 380002, min_days: 2, max_days: 3 },
{ pincode: 380003, min_days: 2, max_days: 3 },
{ pincode: 380004, min_days: 2, max_days: 3 },
{ pincode: 380005, min_days: 2, max_days: 3 },
{ pincode: 380006, min_days: 2, max_days: 3 },
{ pincode: 380007, min_days: 2, max_days: 3 },
{ pincode: 380008, min_days: 2, max_days: 3 },
{ pincode: 380009, min_days: 2, max_days: 3 },
{ pincode: 380012, min_days: 2, max_days: 3 },
{ pincode: 380013, min_days: 2, max_days: 3 },
{ pincode: 380014, min_days: 2, max_days: 3 },
{ pincode: 380015, min_days: 2, max_days: 3 },
{ pincode: 380016, min_days: 2, max_days: 3 },
{ pincode: 380018, min_days: 2, max_days: 3 },
{ pincode: 380019, min_days: 2, max_days: 3 },
{ pincode: 380021, min_days: 2, max_days: 3 },
{ pincode: 380022, min_days: 2, max_days: 3 },
{ pincode: 380023, min_days: 2, max_days: 3 },
{ pincode: 380024, min_days: 2, max_days: 3 },
{ pincode: 380025, min_days: 2, max_days: 3 },
{ pincode: 380026, min_days: 2, max_days: 3 },
{ pincode: 380027, min_days: 2, max_days: 3 },
{ pincode: 380051, min_days: 2, max_days: 3 },
{ pincode: 380052, min_days: 2, max_days: 3 },
{ pincode: 380053, min_days: 2, max_days: 3 },
{ pincode: 380055, min_days: 2, max_days: 3 },
{ pincode: 380061, min_days: 2, max_days: 3 },
{ pincode: 380063, min_days: 2, max_days: 3 },
{ pincode: 381111, min_days: 2, max_days: 3 },
{ pincode: 382001, min_days: 2, max_days: 3 },
{ pincode: 382002, min_days: 2, max_days: 3 },
{ pincode: 382003, min_days: 2, max_days: 3 },
{ pincode: 382004, min_days: 2, max_days: 3 },
{ pincode: 382005, min_days: 2, max_days: 3 },
{ pincode: 382006, min_days: 2, max_days: 3 },
{ pincode: 382007, min_days: 2, max_days: 3 },
{ pincode: 382008, min_days: 2, max_days: 3 },
{ pincode: 382009, min_days: 2, max_days: 3 },
{ pincode: 382010, min_days: 2, max_days: 3 },
{ pincode: 382011, min_days: 2, max_days: 3 },
{ pincode: 382012, min_days: 2, max_days: 3 },
{ pincode: 382013, min_days: 2, max_days: 3 },
{ pincode: 382014, min_days: 2, max_days: 3 },
{ pincode: 382015, min_days: 2, max_days: 3 },
{ pincode: 382016, min_days: 2, max_days: 3 },
{ pincode: 382017, min_days: 2, max_days: 3 },
{ pincode: 382018, min_days: 2, max_days: 3 },
{ pincode: 382019, min_days: 2, max_days: 3 },
{ pincode: 382020, min_days: 2, max_days: 3 },
{ pincode: 382021, min_days: 2, max_days: 3 },
{ pincode: 382022, min_days: 2, max_days: 3 },
{ pincode: 382023, min_days: 2, max_days: 3 },
{ pincode: 382024, min_days: 2, max_days: 3 },
{ pincode: 382025, min_days: 2, max_days: 3 },
{ pincode: 382026, min_days: 2, max_days: 3 },
{ pincode: 382027, min_days: 2, max_days: 3 },
{ pincode: 382028, min_days: 2, max_days: 3 },
{ pincode: 382029, min_days: 2, max_days: 3 },
{ pincode: 382030, min_days: 2, max_days: 3 },
{ pincode: 382041, min_days: 2, max_days: 3 },
{ pincode: 382042, min_days: 2, max_days: 3 },
{ pincode: 382044, min_days: 2, max_days: 3 },
{ pincode: 382050, min_days: 2, max_days: 3 },
{ pincode: 382051, min_days: 2, max_days: 3 },
{ pincode: 382110, min_days: 2, max_days: 3 },
{ pincode: 382115, min_days: 2, max_days: 3 },
{ pincode: 382120, min_days: 3, max_days: 4 },
{ pincode: 382150, min_days: 3, max_days: 4 },
{ pincode: 382170, min_days: 2, max_days: 3 },
{ pincode: 382210, min_days: 2, max_days: 3 },
{ pincode: 382220, min_days: 2, max_days: 3 },
{ pincode: 382240, min_days: 2, max_days: 3 },
{ pincode: 382245, min_days: 3, max_days: 4 },
{ pincode: 382255, min_days: 3, max_days: 4 },
{ pincode: 382260, min_days: 2, max_days: 3 },
{ pincode: 382305, min_days: 2, max_days: 3 },
{ pincode: 382308, min_days: 2, max_days: 3 },
{ pincode: 382315, min_days: 2, max_days: 3 },
{ pincode: 382325, min_days: 2, max_days: 3 },
{ pincode: 382340, min_days: 2, max_days: 3 },
{ pincode: 382345, min_days: 2, max_days: 3 },
{ pincode: 382346, min_days: 2, max_days: 3 },
{ pincode: 382350, min_days: 2, max_days: 3 },
{ pincode: 382352, min_days: 2, max_days: 3 },
{ pincode: 382355, min_days: 2, max_days: 3 },
{ pincode: 382405, min_days: 2, max_days: 3 },
{ pincode: 382410, min_days: 2, max_days: 3 },
{ pincode: 382415, min_days: 2, max_days: 3 },
{ pincode: 382418, min_days: 2, max_days: 3 },
{ pincode: 382420, min_days: 2, max_days: 3 },
{ pincode: 382421, min_days: 2, max_days: 3 },
{ pincode: 382422, min_days: 2, max_days: 3 },
{ pincode: 382424, min_days: 2, max_days: 3 },
{ pincode: 382425, min_days: 2, max_days: 3 },
{ pincode: 382426, min_days: 2, max_days: 3 },
{ pincode: 382427, min_days: 2, max_days: 3 },
{ pincode: 382428, min_days: 2, max_days: 3 },
{ pincode: 382440, min_days: 2, max_days: 3 },
{ pincode: 382442, min_days: 2, max_days: 3 },
{ pincode: 382443, min_days: 2, max_days: 3 },
{ pincode: 382449, min_days: 2, max_days: 3 },
{ pincode: 382450, min_days: 3, max_days: 4 },
{ pincode: 382455, min_days: 3, max_days: 4 },
{ pincode: 382460, min_days: 3, max_days: 4 },
{ pincode: 382463, min_days: 3, max_days: 4 },
{ pincode: 382465, min_days: 3, max_days: 4 },
{ pincode: 382470, min_days: 2, max_days: 3 },
{ pincode: 382475, min_days: 2, max_days: 3 },
{ pincode: 382480, min_days: 2, max_days: 3 },
{ pincode: 382481, min_days: 2, max_days: 3 },
{ pincode: 382610, min_days: 2, max_days: 3 },
{ pincode: 382620, min_days: 2, max_days: 3 },
{ pincode: 382625, min_days: 2, max_days: 3 },
{ pincode: 382644, min_days: 2, max_days: 3 },
{ pincode: 382655, min_days: 2, max_days: 3 },
{ pincode: 382705, min_days: 2, max_days: 3 },
{ pincode: 382715, min_days: 2, max_days: 3 },
{ pincode: 382721, min_days: 2, max_days: 3 },
{ pincode: 382725, min_days: 2, max_days: 3 },
{ pincode: 382729, min_days: 2, max_days: 3 },
{ pincode: 382732, min_days: 2, max_days: 3 },
{ pincode: 382735, min_days: 2, max_days: 3 },
{ pincode: 382740, min_days: 2, max_days: 3 },
{ pincode: 382775, min_days: 3, max_days: 4 },
{ pincode: 382845, min_days: 2, max_days: 3 },
{ pincode: 382870, min_days: 2, max_days: 3 },
{ pincode: 383001, min_days: 2, max_days: 3 },
{ pincode: 383006, min_days: 2, max_days: 3 },
{ pincode: 383110, min_days: 2, max_days: 3 },
{ pincode: 383205, min_days: 2, max_days: 3 },
{ pincode: 383215, min_days: 2, max_days: 3 },
{ pincode: 383235, min_days: 2, max_days: 3 },
{ pincode: 383245, min_days: 2, max_days: 3 },
{ pincode: 383255, min_days: 2, max_days: 3 },
{ pincode: 383305, min_days: 3, max_days: 4 },
{ pincode: 383307, min_days: 3, max_days: 4 },
{ pincode: 383310, min_days: 2, max_days: 3 },
{ pincode: 383315, min_days: 2, max_days: 3 },
{ pincode: 383325, min_days: 2, max_days: 3 },
{ pincode: 383350, min_days: 3, max_days: 4 },
{ pincode: 383410, min_days: 2, max_days: 3 },
{ pincode: 383430, min_days: 2, max_days: 3 },
{ pincode: 383460, min_days: 3, max_days: 4 },
{ pincode: 384001, min_days: 2, max_days: 3 },
{ pincode: 384002, min_days: 2, max_days: 3 },
{ pincode: 384003, min_days: 2, max_days: 3 },
{ pincode: 384120, min_days: 2, max_days: 3 },
{ pincode: 384160, min_days: 2, max_days: 3 },
{ pincode: 384205, min_days: 2, max_days: 3 },
{ pincode: 384206, min_days: 2, max_days: 3 },
{ pincode: 384210, min_days: 2, max_days: 3 },
{ pincode: 384240, min_days: 3, max_days: 4 },
{ pincode: 384245, min_days: 3, max_days: 4 },
{ pincode: 384265, min_days: 3, max_days: 4 },
{ pincode: 384315, min_days: 2, max_days: 3 },
{ pincode: 384325, min_days: 2, max_days: 3 },
{ pincode: 384330, min_days: 3, max_days: 4 },
{ pincode: 384355, min_days: 2, max_days: 3 },
{ pincode: 385001, min_days: 2, max_days: 3 },
{ pincode: 385010, min_days: 3, max_days: 4 },
{ pincode: 385135, min_days: 3, max_days: 4 },
{ pincode: 385210, min_days: 3, max_days: 4 },
{ pincode: 385310, min_days: 4, max_days: 5 },
{ pincode: 385320, min_days: 3, max_days: 4 },
{ pincode: 385330, min_days: 3, max_days: 4 },
{ pincode: 385340, min_days: 3, max_days: 4 },
{ pincode: 385360, min_days: 3, max_days: 4 },
{ pincode: 385410, min_days: 3, max_days: 4 },
{ pincode: 385421, min_days: 3, max_days: 4 },
{ pincode: 385505, min_days: 3, max_days: 4 },
{ pincode: 385510, min_days: 3, max_days: 4 },
{ pincode: 385515, min_days: 3, max_days: 4 },
{ pincode: 385520, min_days: 2, max_days: 3 },
{ pincode: 385530, min_days: 4, max_days: 5 },
{ pincode: 385535, min_days: 3, max_days: 4 },
{ pincode: 385555, min_days: 3, max_days: 4 },
{ pincode: 385565, min_days: 3, max_days: 4 },
{ pincode: 385566, min_days: 3, max_days: 4 },
{ pincode: 385570, min_days: 3, max_days: 4 },
{ pincode: 385575, min_days: 3, max_days: 4 },
{ pincode: 387001, min_days: 2, max_days: 3 },
{ pincode: 387002, min_days: 2, max_days: 3 },
{ pincode: 387003, min_days: 2, max_days: 3 },
{ pincode: 387110, min_days: 2, max_days: 3 },
{ pincode: 387115, min_days: 3, max_days: 4 },
{ pincode: 387120, min_days: 3, max_days: 4 },
{ pincode: 387130, min_days: 2, max_days: 3 },
{ pincode: 387210, min_days: 3, max_days: 4 },
{ pincode: 387230, min_days: 2, max_days: 3 },
{ pincode: 387240, min_days: 2, max_days: 3 },
{ pincode: 387310, min_days: 2, max_days: 3 },
{ pincode: 387315, min_days: 3, max_days: 4 },
{ pincode: 387320, min_days: 2, max_days: 3 },
{ pincode: 387325, min_days: 2, max_days: 3 },
{ pincode: 387330, min_days: 3, max_days: 4 },
{ pincode: 387335, min_days: 2, max_days: 3 },
{ pincode: 387350, min_days: 3, max_days: 4 },
{ pincode: 387355, min_days: 2, max_days: 3 },
{ pincode: 387365, min_days: 4, max_days: 5 },
{ pincode: 387370, min_days: 2, max_days: 3 },
{ pincode: 387380, min_days: 3, max_days: 4 },
{ pincode: 387411, min_days: 2, max_days: 3 },
{ pincode: 387430, min_days: 3, max_days: 4 },
{ pincode: 387520, min_days: 3, max_days: 4 },
{ pincode: 387530, min_days: 2, max_days: 3 },
{ pincode: 387540, min_days: 2, max_days: 3 },
{ pincode: 387560, min_days: 3, max_days: 4 },
{ pincode: 387570, min_days: 2, max_days: 3 },
{ pincode: 387610, min_days: 4, max_days: 5 },
{ pincode: 387620, min_days: 3, max_days: 4 },
{ pincode: 387630, min_days: 4, max_days: 5 },
{ pincode: 387635, min_days: 4, max_days: 5 },
{ pincode: 387650, min_days: 4, max_days: 5 },
{ pincode: 388001, min_days: 2, max_days: 3 },
{ pincode: 388110, min_days: 2, max_days: 3 },
{ pincode: 388120, min_days: 2, max_days: 3 },
{ pincode: 388121, min_days: 2, max_days: 3 },
{ pincode: 388130, min_days: 2, max_days: 3 },
{ pincode: 388140, min_days: 2, max_days: 3 },
{ pincode: 388150, min_days: 2, max_days: 3 },
{ pincode: 388160, min_days: 2, max_days: 3 },
{ pincode: 388180, min_days: 3, max_days: 4 },
{ pincode: 388205, min_days: 3, max_days: 4 },
{ pincode: 388210, min_days: 3, max_days: 4 },
{ pincode: 388215, min_days: 2, max_days: 3 },
{ pincode: 388220, min_days: 2, max_days: 3 },
{ pincode: 388225, min_days: 2, max_days: 3 },
{ pincode: 388235, min_days: 4, max_days: 5 },
{ pincode: 388239, min_days: 4, max_days: 5 },
{ pincode: 388245, min_days: 4, max_days: 5 },
{ pincode: 388250, min_days: 3, max_days: 4 },
{ pincode: 388255, min_days: 4, max_days: 5 },
{ pincode: 388260, min_days: 4, max_days: 5 },
{ pincode: 388265, min_days: 4, max_days: 5 },
{ pincode: 388305, min_days: 2, max_days: 3 },
{ pincode: 388306, min_days: 2, max_days: 3 },
{ pincode: 388307, min_days: 2, max_days: 3 },
{ pincode: 388315, min_days: 2, max_days: 3 },
{ pincode: 388320, min_days: 2, max_days: 3 },
{ pincode: 388325, min_days: 2, max_days: 3 },
{ pincode: 388340, min_days: 2, max_days: 3 },
{ pincode: 388345, min_days: 2, max_days: 3 },
{ pincode: 388350, min_days: 2, max_days: 3 },
{ pincode: 388365, min_days: 3, max_days: 4 },
{ pincode: 388370, min_days: 2, max_days: 3 },
{ pincode: 388421, min_days: 2, max_days: 3 },
{ pincode: 388430, min_days: 2, max_days: 3 },
{ pincode: 388440, min_days: 2, max_days: 3 },
{ pincode: 388450, min_days: 2, max_days: 3 },
{ pincode: 388460, min_days: 2, max_days: 3 },
{ pincode: 388465, min_days: 2, max_days: 3 },
{ pincode: 388470, min_days: 2, max_days: 3 },
{ pincode: 388480, min_days: 2, max_days: 3 },
{ pincode: 388510, min_days: 2, max_days: 3 },
{ pincode: 388520, min_days: 2, max_days: 3 },
{ pincode: 388530, min_days: 2, max_days: 3 },
{ pincode: 388540, min_days: 2, max_days: 3 },
{ pincode: 388545, min_days: 2, max_days: 3 },
{ pincode: 388550, min_days: 2, max_days: 3 },
{ pincode: 388560, min_days: 2, max_days: 3 },
{ pincode: 388570, min_days: 2, max_days: 3 },
{ pincode: 388580, min_days: 2, max_days: 3 },
{ pincode: 388590, min_days: 2, max_days: 3 },
{ pincode: 388610, min_days: 2, max_days: 3 },
{ pincode: 388620, min_days: 3, max_days: 4 },
{ pincode: 388625, min_days: 4, max_days: 5 },
{ pincode: 388630, min_days: 3, max_days: 4 },
{ pincode: 388640, min_days: 3, max_days: 4 },
{ pincode: 388710, min_days: 4, max_days: 5 },
{ pincode: 388713, min_days: 3, max_days: 4 },
{ pincode: 389001, min_days: 3, max_days: 4 },
{ pincode: 389002, min_days: 4, max_days: 5 },
{ pincode: 389115, min_days: 4, max_days: 5 },
{ pincode: 389120, min_days: 3, max_days: 4 },
{ pincode: 389130, min_days: 3, max_days: 4 },
{ pincode: 389140, min_days: 3, max_days: 4 },
{ pincode: 389151, min_days: 3, max_days: 4 },
{ pincode: 389152, min_days: 3, max_days: 4 },
{ pincode: 389155, min_days: 3, max_days: 4 },
{ pincode: 389160, min_days: 3, max_days: 4 },
{ pincode: 389170, min_days: 4, max_days: 5 },
{ pincode: 389172, min_days: 3, max_days: 4 },
{ pincode: 389175, min_days: 3, max_days: 4 },
{ pincode: 389180, min_days: 4, max_days: 5 },
{ pincode: 389190, min_days: 3, max_days: 4 },
{ pincode: 389210, min_days: 4, max_days: 5 },
{ pincode: 389220, min_days: 4, max_days: 5 },
{ pincode: 389230, min_days: 3, max_days: 4 },
{ pincode: 389260, min_days: 4, max_days: 5 },
{ pincode: 389320, min_days: 2, max_days: 3 },
{ pincode: 389330, min_days: 3, max_days: 4 },
{ pincode: 389340, min_days: 4, max_days: 5 },
{ pincode: 389341, min_days: 2, max_days: 3 },
{ pincode: 389345, min_days: 2, max_days: 3 },
{ pincode: 389350, min_days: 2, max_days: 3 },
{ pincode: 389351, min_days: 3, max_days: 4 },
{ pincode: 389352, min_days: 2, max_days: 3 },
{ pincode: 389360, min_days: 2, max_days: 3 },
{ pincode: 389365, min_days: 2, max_days: 3 },
{ pincode: 389380, min_days: 3, max_days: 4 },
{ pincode: 389390, min_days: 2, max_days: 3 },
{ pincode: 390001, min_days: 2, max_days: 3 },
{ pincode: 390002, min_days: 2, max_days: 3 },
{ pincode: 390003, min_days: 2, max_days: 3 },
{ pincode: 390004, min_days: 2, max_days: 3 },
{ pincode: 390005, min_days: 2, max_days: 3 },
{ pincode: 390006, min_days: 2, max_days: 3 },
{ pincode: 390007, min_days: 2, max_days: 3 },
{ pincode: 390008, min_days: 2, max_days: 3 },
{ pincode: 390009, min_days: 2, max_days: 3 },
{ pincode: 390010, min_days: 2, max_days: 3 },
{ pincode: 390011, min_days: 2, max_days: 3 },
{ pincode: 390012, min_days: 2, max_days: 3 },
{ pincode: 390013, min_days: 2, max_days: 3 },
{ pincode: 390014, min_days: 2, max_days: 3 },
{ pincode: 390015, min_days: 2, max_days: 3 },
{ pincode: 390016, min_days: 2, max_days: 3 },
{ pincode: 390017, min_days: 2, max_days: 3 },
{ pincode: 390018, min_days: 2, max_days: 3 },
{ pincode: 390019, min_days: 2, max_days: 3 },
{ pincode: 390020, min_days: 2, max_days: 3 },
{ pincode: 390021, min_days: 2, max_days: 3 },
{ pincode: 390022, min_days: 2, max_days: 3 },
{ pincode: 390023, min_days: 2, max_days: 3 },
{ pincode: 390024, min_days: 2, max_days: 3 },
{ pincode: 390025, min_days: 2, max_days: 3 },
{ pincode: 391101, min_days: 2, max_days: 3 },
{ pincode: 391105, min_days: 3, max_days: 4 },
{ pincode: 391110, min_days: 3, max_days: 4 },
{ pincode: 391115, min_days: 3, max_days: 4 },
{ pincode: 391135, min_days: 3, max_days: 4 },
{ pincode: 391145, min_days: 3, max_days: 4 },
{ pincode: 391150, min_days: 3, max_days: 4 },
{ pincode: 391160, min_days: 3, max_days: 4 },
{ pincode: 391165, min_days: 3, max_days: 4 },
{ pincode: 391170, min_days: 3, max_days: 4 },
{ pincode: 391210, min_days: 3, max_days: 4 },
{ pincode: 391240, min_days: 3, max_days: 4 },
{ pincode: 391243, min_days: 2, max_days: 3 },
{ pincode: 391244, min_days: 4, max_days: 5 },
{ pincode: 391250, min_days: 4, max_days: 5 },
{ pincode: 391310, min_days: 2, max_days: 3 },
{ pincode: 391320, min_days: 2, max_days: 3 },
{ pincode: 391330, min_days: 2, max_days: 3 },
{ pincode: 391340, min_days: 2, max_days: 3 },
{ pincode: 391345, min_days: 2, max_days: 3 },
{ pincode: 391346, min_days: 2, max_days: 3 },
{ pincode: 391347, min_days: 2, max_days: 3 },
{ pincode: 391350, min_days: 2, max_days: 3 },
{ pincode: 391410, min_days: 2, max_days: 3 },
{ pincode: 391430, min_days: 2, max_days: 3 },
{ pincode: 391440, min_days: 2, max_days: 3 },
{ pincode: 391447, min_days: 3, max_days: 4 },
{ pincode: 391450, min_days: 2, max_days: 3 },
{ pincode: 391510, min_days: 3, max_days: 4 },
{ pincode: 391520, min_days: 2, max_days: 3 },
{ pincode: 391740, min_days: 2, max_days: 3 },
{ pincode: 391742, min_days: 2, max_days: 3 },
{ pincode: 391745, min_days: 2, max_days: 3 },
{ pincode: 391750, min_days: 2, max_days: 3 },
{ pincode: 391760, min_days: 2, max_days: 3 },
{ pincode: 391770, min_days: 2, max_days: 3 },
{ pincode: 391775, min_days: 2, max_days: 3 },
{ pincode: 391780, min_days: 2, max_days: 3 },
{ pincode: 392001, min_days: 3, max_days: 4 },
{ pincode: 392002, min_days: 3, max_days: 4 },
{ pincode: 392011, min_days: 3, max_days: 4 },
{ pincode: 392012, min_days: 4, max_days: 5 },
{ pincode: 392015, min_days: 3, max_days: 4 },
{ pincode: 392020, min_days: 4, max_days: 5 },
{ pincode: 392025, min_days: 4, max_days: 5 },
{ pincode: 392110, min_days: 4, max_days: 5 },
{ pincode: 392130, min_days: 4, max_days: 5 },
{ pincode: 392140, min_days: 4, max_days: 5 },
{ pincode: 392150, min_days: 4, max_days: 5 },
{ pincode: 392210, min_days: 4, max_days: 5 },
{ pincode: 392215, min_days: 4, max_days: 5 },
{ pincode: 392220, min_days: 3, max_days: 4 },
{ pincode: 392240, min_days: 4, max_days: 5 },
{ pincode: 392310, min_days: 4, max_days: 5 },
{ pincode: 393001, min_days: 3, max_days: 4 },
{ pincode: 393002, min_days: 3, max_days: 4 },
{ pincode: 393010, min_days: 3, max_days: 4 },
{ pincode: 393017, min_days: 4, max_days: 5 },
{ pincode: 393030, min_days: 4, max_days: 5 },
{ pincode: 393110, min_days: 3, max_days: 4 },
{ pincode: 393115, min_days: 4, max_days: 5 },
{ pincode: 393120, min_days: 3, max_days: 4 },
{ pincode: 393125, min_days: 4, max_days: 5 },
{ pincode: 393130, min_days: 4, max_days: 5 },
{ pincode: 393135, min_days: 3, max_days: 4 },
{ pincode: 393140, min_days: 3, max_days: 4 },
{ pincode: 393145, min_days: 3, max_days: 4 },
{ pincode: 393151, min_days: 3, max_days: 4 },
{ pincode: 394101, min_days: 3, max_days: 4 },
{ pincode: 394105, min_days: 3, max_days: 4 },
{ pincode: 394110, min_days: 3, max_days: 4 },
{ pincode: 394111, min_days: 3, max_days: 4 },
{ pincode: 394115, min_days: 3, max_days: 4 },
{ pincode: 394116, min_days: 3, max_days: 4 },
{ pincode: 394120, min_days: 3, max_days: 4 },
{ pincode: 394125, min_days: 4, max_days: 5 },
{ pincode: 394130, min_days: 3, max_days: 4 },
{ pincode: 394140, min_days: 3, max_days: 4 },
{ pincode: 394150, min_days: 3, max_days: 4 },
{ pincode: 394155, min_days: 3, max_days: 4 },
{ pincode: 394160, min_days: 3, max_days: 4 },
{ pincode: 394170, min_days: 3, max_days: 4 },
{ pincode: 394180, min_days: 3, max_days: 4 },
{ pincode: 394185, min_days: 3, max_days: 4 },
{ pincode: 394190, min_days: 3, max_days: 4 },
{ pincode: 394210, min_days: 3, max_days: 4 },
{ pincode: 394220, min_days: 3, max_days: 4 },
{ pincode: 394221, min_days: 3, max_days: 4 },
{ pincode: 394230, min_days: 3, max_days: 4 },
{ pincode: 394235, min_days: 3, max_days: 4 },
{ pincode: 394240, min_days: 3, max_days: 4 },
{ pincode: 394245, min_days: 3, max_days: 4 },
{ pincode: 394246, min_days: 3, max_days: 4 },
{ pincode: 394248, min_days: 3, max_days: 4 },
{ pincode: 394250, min_days: 3, max_days: 4 },
{ pincode: 394270, min_days: 4, max_days: 5 },
{ pincode: 394305, min_days: 3, max_days: 4 },
{ pincode: 394310, min_days: 3, max_days: 4 },
{ pincode: 394315, min_days: 3, max_days: 4 },
{ pincode: 394317, min_days: 3, max_days: 4 },
{ pincode: 394320, min_days: 3, max_days: 4 },
{ pincode: 394325, min_days: 3, max_days: 4 },
{ pincode: 394326, min_days: 3, max_days: 4 },
{ pincode: 394327, min_days: 3, max_days: 4 },
{ pincode: 394330, min_days: 3, max_days: 4 },
{ pincode: 394335, min_days: 3, max_days: 4 },
{ pincode: 394340, min_days: 3, max_days: 4 },
{ pincode: 394345, min_days: 3, max_days: 4 },
{ pincode: 394350, min_days: 3, max_days: 4 },
{ pincode: 394352, min_days: 3, max_days: 4 },
{ pincode: 394355, min_days: 3, max_days: 4 },
{ pincode: 394360, min_days: 3, max_days: 4 },
{ pincode: 394375, min_days: 3, max_days: 4 },
{ pincode: 394410, min_days: 4, max_days: 5 },
{ pincode: 394421, min_days: 3, max_days: 4 },
{ pincode: 394430, min_days: 3, max_days: 4 },
{ pincode: 394444, min_days: 3, max_days: 4 },
{ pincode: 394510, min_days: 4, max_days: 5 },
{ pincode: 394515, min_days: 4, max_days: 5 },
{ pincode: 394516, min_days: 4, max_days: 5 },
{ pincode: 394518, min_days: 4, max_days: 5 },
{ pincode: 394520, min_days: 3, max_days: 4 },
{ pincode: 394540, min_days: 4, max_days: 5 },
{ pincode: 394601, min_days: 3, max_days: 4 },
{ pincode: 394602, min_days: 3, max_days: 4 },
{ pincode: 394620, min_days: 3, max_days: 4 },
{ pincode: 394630, min_days: 3, max_days: 4 },
{ pincode: 394633, min_days: 3, max_days: 4 },
{ pincode: 394635, min_days: 3, max_days: 4 },
{ pincode: 394640, min_days: 3, max_days: 4 },
{ pincode: 394641, min_days: 3, max_days: 4 },
{ pincode: 394650, min_days: 3, max_days: 4 },
{ pincode: 394651, min_days: 3, max_days: 4 },
{ pincode: 394652, min_days: 3, max_days: 4 },
{ pincode: 394655, min_days: 3, max_days: 4 },
{ pincode: 394660, min_days: 3, max_days: 4 },
{ pincode: 394670, min_days: 3, max_days: 4 },
{ pincode: 394680, min_days: 3, max_days: 4 },
{ pincode: 394690, min_days: 3, max_days: 4 },
{ pincode: 394710, min_days: 4, max_days: 5 },
{ pincode: 394810, min_days: 4, max_days: 5 },
{ pincode: 395001, min_days: 3, max_days: 4 },
{ pincode: 395002, min_days: 3, max_days: 4 },
{ pincode: 395005, min_days: 3, max_days: 4 },
{ pincode: 395006, min_days: 3, max_days: 4 },
{ pincode: 395007, min_days: 3, max_days: 4 },
{ pincode: 395008, min_days: 3, max_days: 4 },
{ pincode: 395009, min_days: 3, max_days: 4 },
{ pincode: 395010, min_days: 3, max_days: 4 },
{ pincode: 395011, min_days: 3, max_days: 4 },
{ pincode: 395012, min_days: 3, max_days: 4 },
{ pincode: 395013, min_days: 3, max_days: 4 },
{ pincode: 395017, min_days: 3, max_days: 4 },
{ pincode: 395023, min_days: 3, max_days: 4 },
{ pincode: 396001, min_days: 3, max_days: 4 },
{ pincode: 396002, min_days: 3, max_days: 4 },
{ pincode: 396007, min_days: 3, max_days: 4 },
{ pincode: 396020, min_days: 3, max_days: 4 },
{ pincode: 396030, min_days: 3, max_days: 4 },
{ pincode: 396035, min_days: 3, max_days: 4 },
{ pincode: 396040, min_days: 4, max_days: 5 },
{ pincode: 396045, min_days: 3, max_days: 4 },
{ pincode: 396050, min_days: 3, max_days: 4 },
{ pincode: 396055, min_days: 3, max_days: 4 },
{ pincode: 396060, min_days: 4, max_days: 5 },
{ pincode: 396065, min_days: 3, max_days: 4 },
{ pincode: 396105, min_days: 3, max_days: 4 },
{ pincode: 396120, min_days: 3, max_days: 4 },
{ pincode: 396125, min_days: 3, max_days: 4 },
{ pincode: 396130, min_days: 4, max_days: 5 },
{ pincode: 396135, min_days: 4, max_days: 5 },
{ pincode: 396150, min_days: 4, max_days: 5 },
{ pincode: 396155, min_days: 3, max_days: 4 },
{ pincode: 396165, min_days: 3, max_days: 4 },
{ pincode: 396170, min_days: 3, max_days: 4 },
{ pincode: 396171, min_days: 3, max_days: 4 },
{ pincode: 396180, min_days: 3, max_days: 4 },
{ pincode: 396191, min_days: 3, max_days: 4 },
{ pincode: 396193, min_days: 3, max_days: 4 },
{ pincode: 396195, min_days: 3, max_days: 4 },
{ pincode: 396210, min_days: 3, max_days: 4 },
{ pincode: 396215, min_days: 3, max_days: 4 },
{ pincode: 396220, min_days: 3, max_days: 4 },
{ pincode: 396230, min_days: 3, max_days: 4 },
{ pincode: 396235, min_days: 3, max_days: 4 },
{ pincode: 396240, min_days: 3, max_days: 4 },
{ pincode: 396310, min_days: 3, max_days: 4 },
{ pincode: 396321, min_days: 3, max_days: 4 },
{ pincode: 396325, min_days: 3, max_days: 4 },
{ pincode: 396350, min_days: 3, max_days: 4 },
{ pincode: 396360, min_days: 3, max_days: 4 },
{ pincode: 396370, min_days: 3, max_days: 4 },
{ pincode: 396375, min_days: 3, max_days: 4 },
{ pincode: 396380, min_days: 3, max_days: 4 },
{ pincode: 396409, min_days: 4, max_days: 5 },
{ pincode: 396415, min_days: 3, max_days: 4 },
{ pincode: 396421, min_days: 3, max_days: 4 },
{ pincode: 396424, min_days: 3, max_days: 4 },
{ pincode: 396427, min_days: 3, max_days: 4 },
{ pincode: 396430, min_days: 3, max_days: 4 },
{ pincode: 396436, min_days: 3, max_days: 4 },
{ pincode: 396439, min_days: 3, max_days: 4 },
{ pincode: 396445, min_days: 3, max_days: 4 },
{ pincode: 396450, min_days: 3, max_days: 4 },
{ pincode: 396463, min_days: 3, max_days: 4 },
{ pincode: 396475, min_days: 3, max_days: 4 },
{ pincode: 396521, min_days: 3, max_days: 4 },
{ pincode: 396530, min_days: 4, max_days: 5 },
{ pincode: 396560, min_days: 4, max_days: 5 },
{ pincode: 396580, min_days: 4, max_days: 5 },
{ pincode: 396590, min_days: 3, max_days: 4 },
{ pincode: 400000, min_days: 2, max_days: 3 },
{ pincode: 400001, min_days: 2, max_days: 3 },
{ pincode: 400002, min_days: 2, max_days: 3 },
{ pincode: 400003, min_days: 2, max_days: 3 },
{ pincode: 400004, min_days: 2, max_days: 3 },
{ pincode: 400005, min_days: 2, max_days: 3 },
{ pincode: 400006, min_days: 2, max_days: 3 },
{ pincode: 400007, min_days: 2, max_days: 3 },
{ pincode: 400008, min_days: 2, max_days: 3 },
{ pincode: 400009, min_days: 2, max_days: 3 },
{ pincode: 400010, min_days: 2, max_days: 3 },
{ pincode: 400011, min_days: 2, max_days: 3 },
{ pincode: 400012, min_days: 2, max_days: 3 },
{ pincode: 400013, min_days: 2, max_days: 3 },
{ pincode: 400014, min_days: 2, max_days: 3 },
{ pincode: 400015, min_days: 2, max_days: 3 },
{ pincode: 400016, min_days: 2, max_days: 3 },
{ pincode: 400017, min_days: 2, max_days: 3 },
{ pincode: 400018, min_days: 2, max_days: 3 },
{ pincode: 400019, min_days: 2, max_days: 3 },
{ pincode: 400020, min_days: 2, max_days: 3 },
{ pincode: 400021, min_days: 2, max_days: 3 },
{ pincode: 400022, min_days: 2, max_days: 3 },
{ pincode: 400023, min_days: 2, max_days: 3 },
{ pincode: 400024, min_days: 2, max_days: 3 },
{ pincode: 400025, min_days: 2, max_days: 3 },
{ pincode: 400026, min_days: 2, max_days: 3 },
{ pincode: 400027, min_days: 2, max_days: 3 },
{ pincode: 400028, min_days: 2, max_days: 3 },
{ pincode: 400029, min_days: 2, max_days: 3 },
{ pincode: 400030, min_days: 2, max_days: 3 },
{ pincode: 400031, min_days: 2, max_days: 3 },
{ pincode: 400032, min_days: 2, max_days: 3 },
{ pincode: 400033, min_days: 2, max_days: 3 },
{ pincode: 400034, min_days: 2, max_days: 3 },
{ pincode: 400035, min_days: 2, max_days: 3 },
{ pincode: 400036, min_days: 2, max_days: 3 },
{ pincode: 400037, min_days: 2, max_days: 3 },
{ pincode: 400038, min_days: 2, max_days: 3 },
{ pincode: 400039, min_days: 2, max_days: 3 },
{ pincode: 400042, min_days: 2, max_days: 3 },
{ pincode: 400043, min_days: 2, max_days: 3 },
{ pincode: 400049, min_days: 2, max_days: 3 },
{ pincode: 400050, min_days: 2, max_days: 3 },
{ pincode: 400051, min_days: 2, max_days: 3 },
{ pincode: 400052, min_days: 2, max_days: 3 },
{ pincode: 400053, min_days: 2, max_days: 3 },
{ pincode: 400054, min_days: 2, max_days: 3 },
{ pincode: 400055, min_days: 2, max_days: 3 },
{ pincode: 400056, min_days: 2, max_days: 3 },
{ pincode: 400057, min_days: 2, max_days: 3 },
{ pincode: 400058, min_days: 2, max_days: 3 },
{ pincode: 400059, min_days: 2, max_days: 3 },
{ pincode: 400060, min_days: 2, max_days: 3 },
{ pincode: 400061, min_days: 2, max_days: 3 },
{ pincode: 400062, min_days: 2, max_days: 3 },
{ pincode: 400063, min_days: 2, max_days: 3 },
{ pincode: 400064, min_days: 2, max_days: 3 },
{ pincode: 400065, min_days: 2, max_days: 3 },
{ pincode: 400066, min_days: 2, max_days: 3 },
{ pincode: 400067, min_days: 2, max_days: 3 },
{ pincode: 400068, min_days: 2, max_days: 3 },
{ pincode: 400069, min_days: 2, max_days: 3 },
{ pincode: 400070, min_days: 2, max_days: 3 },
{ pincode: 400071, min_days: 2, max_days: 3 },
{ pincode: 400072, min_days: 2, max_days: 3 },
{ pincode: 400074, min_days: 2, max_days: 3 },
{ pincode: 400075, min_days: 2, max_days: 3 },
{ pincode: 400076, min_days: 2, max_days: 3 },
{ pincode: 400077, min_days: 2, max_days: 3 },
{ pincode: 400078, min_days: 2, max_days: 3 },
{ pincode: 400079, min_days: 2, max_days: 3 },
{ pincode: 400080, min_days: 2, max_days: 3 },
{ pincode: 400081, min_days: 2, max_days: 3 },
{ pincode: 400082, min_days: 2, max_days: 3 },
{ pincode: 400083, min_days: 2, max_days: 3 },
{ pincode: 400084, min_days: 2, max_days: 3 },
{ pincode: 400085, min_days: 2, max_days: 3 },
{ pincode: 400086, min_days: 2, max_days: 3 },
{ pincode: 400087, min_days: 2, max_days: 3 },
{ pincode: 400088, min_days: 2, max_days: 3 },
{ pincode: 400089, min_days: 2, max_days: 3 },
{ pincode: 400090, min_days: 2, max_days: 3 },
{ pincode: 400091, min_days: 2, max_days: 3 },
{ pincode: 400092, min_days: 2, max_days: 3 },
{ pincode: 400093, min_days: 2, max_days: 3 },
{ pincode: 400094, min_days: 2, max_days: 3 },
{ pincode: 400095, min_days: 2, max_days: 3 },
{ pincode: 400096, min_days: 2, max_days: 3 },
{ pincode: 400097, min_days: 2, max_days: 3 },
{ pincode: 400098, min_days: 2, max_days: 3 },
{ pincode: 400099, min_days: 2, max_days: 3 },
{ pincode: 400101, min_days: 2, max_days: 3 },
{ pincode: 400102, min_days: 2, max_days: 3 },
{ pincode: 400103, min_days: 2, max_days: 3 },
{ pincode: 400104, min_days: 2, max_days: 3 },
{ pincode: 400218, min_days: 2, max_days: 3 },
{ pincode: 400601, min_days: 2, max_days: 3 },
{ pincode: 400602, min_days: 2, max_days: 3 },
{ pincode: 400603, min_days: 2, max_days: 3 },
{ pincode: 400604, min_days: 2, max_days: 3 },
{ pincode: 400605, min_days: 2, max_days: 3 },
{ pincode: 400606, min_days: 2, max_days: 3 },
{ pincode: 400607, min_days: 2, max_days: 3 },
{ pincode: 400608, min_days: 2, max_days: 3 },
{ pincode: 400609, min_days: 2, max_days: 3 },
{ pincode: 400610, min_days: 2, max_days: 3 },
{ pincode: 400611, min_days: 2, max_days: 3 },
{ pincode: 400612, min_days: 2, max_days: 3 },
{ pincode: 400614, min_days: 2, max_days: 3 },
{ pincode: 400615, min_days: 2, max_days: 3 },
{ pincode: 400701, min_days: 2, max_days: 3 },
{ pincode: 400702, min_days: 2, max_days: 3 },
{ pincode: 400703, min_days: 2, max_days: 3 },
{ pincode: 400704, min_days: 2, max_days: 3 },
{ pincode: 400705, min_days: 2, max_days: 3 },
{ pincode: 400706, min_days: 2, max_days: 3 },
{ pincode: 400707, min_days: 2, max_days: 3 },
{ pincode: 400708, min_days: 2, max_days: 3 },
{ pincode: 400709, min_days: 2, max_days: 3 },
{ pincode: 400710, min_days: 2, max_days: 3 },
{ pincode: 401101, min_days: 2, max_days: 3 },
{ pincode: 401102, min_days: 2, max_days: 3 },
{ pincode: 401103, min_days: 2, max_days: 3 },
{ pincode: 401104, min_days: 2, max_days: 3 },
{ pincode: 401105, min_days: 2, max_days: 3 },
{ pincode: 401106, min_days: 2, max_days: 3 },
{ pincode: 401107, min_days: 2, max_days: 3 },
{ pincode: 401201, min_days: 2, max_days: 3 },
{ pincode: 401202, min_days: 2, max_days: 3 },
{ pincode: 401203, min_days: 2, max_days: 3 },
{ pincode: 401205, min_days: 2, max_days: 3 },
{ pincode: 401207, min_days: 2, max_days: 3 },
{ pincode: 401208, min_days: 2, max_days: 3 },
{ pincode: 401209, min_days: 2, max_days: 3 },
{ pincode: 401210, min_days: 2, max_days: 3 },
{ pincode: 401301, min_days: 2, max_days: 3 },
{ pincode: 401302, min_days: 2, max_days: 3 },
{ pincode: 401303, min_days: 2, max_days: 3 },
{ pincode: 401304, min_days: 2, max_days: 3 },
{ pincode: 401305, min_days: 2, max_days: 3 },
{ pincode: 401401, min_days: 2, max_days: 3 },
{ pincode: 401402, min_days: 2, max_days: 3 },
{ pincode: 401403, min_days: 2, max_days: 3 },
{ pincode: 401404, min_days: 2, max_days: 3 },
{ pincode: 401405, min_days: 2, max_days: 3 },
{ pincode: 401407, min_days: 2, max_days: 3 },
{ pincode: 401501, min_days: 2, max_days: 3 },
{ pincode: 401502, min_days: 2, max_days: 3 },
{ pincode: 401503, min_days: 2, max_days: 3 },
{ pincode: 401504, min_days: 2, max_days: 3 },
{ pincode: 401506, min_days: 2, max_days: 3 },
{ pincode: 401601, min_days: 2, max_days: 3 },
{ pincode: 401602, min_days: 2, max_days: 3 },
{ pincode: 401607, min_days: 2, max_days: 3 },
{ pincode: 401608, min_days: 2, max_days: 3 },
{ pincode: 401701, min_days: 2, max_days: 3 },
{ pincode: 401702, min_days: 2, max_days: 3 },
{ pincode: 402101, min_days: 3, max_days: 4 },
{ pincode: 402103, min_days: 3, max_days: 4 },
{ pincode: 402104, min_days: 3, max_days: 4 },
{ pincode: 402105, min_days: 3, max_days: 4 },
{ pincode: 402106, min_days: 3, max_days: 4 },
{ pincode: 402107, min_days: 3, max_days: 4 },
{ pincode: 402109, min_days: 3, max_days: 4 },
{ pincode: 402110, min_days: 3, max_days: 4 },
{ pincode: 402111, min_days: 3, max_days: 4 },
{ pincode: 402112, min_days: 3, max_days: 4 },
{ pincode: 402113, min_days: 3, max_days: 4 },
{ pincode: 402114, min_days: 3, max_days: 4 },
{ pincode: 402115, min_days: 3, max_days: 4 },
{ pincode: 402116, min_days: 3, max_days: 4 },
{ pincode: 402117, min_days: 3, max_days: 4 },
{ pincode: 402120, min_days: 3, max_days: 4 },
{ pincode: 402125, min_days: 3, max_days: 4 },
{ pincode: 402126, min_days: 3, max_days: 4 },
{ pincode: 402201, min_days: 3, max_days: 4 },
{ pincode: 402202, min_days: 3, max_days: 4 },
{ pincode: 402203, min_days: 3, max_days: 4 },
{ pincode: 402207, min_days: 3, max_days: 4 },
{ pincode: 402208, min_days: 3, max_days: 4 },
{ pincode: 402209, min_days: 3, max_days: 4 },
{ pincode: 402301, min_days: 3, max_days: 4 },
{ pincode: 402302, min_days: 3, max_days: 4 },
{ pincode: 402303, min_days: 3, max_days: 4 },
{ pincode: 402304, min_days: 3, max_days: 4 },
{ pincode: 402305, min_days: 3, max_days: 4 },
{ pincode: 402306, min_days: 3, max_days: 4 },
{ pincode: 402307, min_days: 3, max_days: 4 },
{ pincode: 402308, min_days: 3, max_days: 4 },
{ pincode: 402309, min_days: 3, max_days: 4 },
{ pincode: 402401, min_days: 3, max_days: 4 },
{ pincode: 402403, min_days: 3, max_days: 4 },
{ pincode: 402404, min_days: 3, max_days: 4 },
{ pincode: 403001, min_days: 2, max_days: 3 },
{ pincode: 403002, min_days: 2, max_days: 3 },
{ pincode: 403003, min_days: 2, max_days: 3 },
{ pincode: 403004, min_days: 2, max_days: 3 },
{ pincode: 403005, min_days: 2, max_days: 3 },
{ pincode: 403006, min_days: 2, max_days: 3 },
{ pincode: 403101, min_days: 2, max_days: 3 },
{ pincode: 403104, min_days: 2, max_days: 3 },
{ pincode: 403105, min_days: 3, max_days: 4 },
{ pincode: 403106, min_days: 2, max_days: 3 },
{ pincode: 403107, min_days: 2, max_days: 3 },
{ pincode: 403108, min_days: 2, max_days: 3 },
{ pincode: 403109, min_days: 2, max_days: 3 },
{ pincode: 403110, min_days: 2, max_days: 3 },
{ pincode: 403114, min_days: 2, max_days: 3 },
{ pincode: 403115, min_days: 2, max_days: 3 },
{ pincode: 403201, min_days: 2, max_days: 3 },
{ pincode: 403202, min_days: 2, max_days: 3 },
{ pincode: 403203, min_days: 2, max_days: 3 },
{ pincode: 403204, min_days: 2, max_days: 3 },
{ pincode: 403206, min_days: 2, max_days: 3 },
{ pincode: 403401, min_days: 2, max_days: 3 },
{ pincode: 403402, min_days: 2, max_days: 3 },
{ pincode: 403404, min_days: 2, max_days: 3 },
{ pincode: 403405, min_days: 2, max_days: 3 },
{ pincode: 403406, min_days: 2, max_days: 3 },
{ pincode: 403409, min_days: 2, max_days: 3 },
{ pincode: 403501, min_days: 2, max_days: 3 },
{ pincode: 403502, min_days: 2, max_days: 3 },
{ pincode: 403503, min_days: 3, max_days: 4 },
{ pincode: 403504, min_days: 3, max_days: 4 },
{ pincode: 403505, min_days: 3, max_days: 4 },
{ pincode: 403506, min_days: 3, max_days: 4 },
{ pincode: 403507, min_days: 2, max_days: 3 },
{ pincode: 403508, min_days: 2, max_days: 3 },
{ pincode: 403509, min_days: 2, max_days: 3 },
{ pincode: 403510, min_days: 2, max_days: 3 },
{ pincode: 403511, min_days: 2, max_days: 3 },
{ pincode: 403512, min_days: 3, max_days: 4 },
{ pincode: 403513, min_days: 3, max_days: 4 },
{ pincode: 403514, min_days: 2, max_days: 3 },
{ pincode: 403515, min_days: 2, max_days: 3 },
{ pincode: 403516, min_days: 2, max_days: 3 },
{ pincode: 403517, min_days: 2, max_days: 3 },
{ pincode: 403518, min_days: 2, max_days: 3 },
{ pincode: 403519, min_days: 2, max_days: 3 },
{ pincode: 403521, min_days: 2, max_days: 3 },
{ pincode: 403523, min_days: 2, max_days: 3 },
{ pincode: 403524, min_days: 3, max_days: 4 },
{ pincode: 403526, min_days: 2, max_days: 3 },
{ pincode: 403527, min_days: 3, max_days: 4 },
{ pincode: 403529, min_days: 3, max_days: 4 },
{ pincode: 403530, min_days: 3, max_days: 4 },
{ pincode: 403601, min_days: 2, max_days: 3 },
{ pincode: 403602, min_days: 2, max_days: 3 },
{ pincode: 403604, min_days: 2, max_days: 3 },
{ pincode: 403701, min_days: 2, max_days: 3 },
{ pincode: 403703, min_days: 2, max_days: 3 },
{ pincode: 403704, min_days: 2, max_days: 3 },
{ pincode: 403705, min_days: 2, max_days: 3 },
{ pincode: 403706, min_days: 2, max_days: 3 },
{ pincode: 403707, min_days: 2, max_days: 3 },
{ pincode: 403708, min_days: 2, max_days: 3 },
{ pincode: 403709, min_days: 2, max_days: 3 },
{ pincode: 403710, min_days: 2, max_days: 3 },
{ pincode: 403711, min_days: 2, max_days: 3 },
{ pincode: 403712, min_days: 2, max_days: 3 },
{ pincode: 403713, min_days: 2, max_days: 3 },
{ pincode: 403714, min_days: 2, max_days: 3 },
{ pincode: 403715, min_days: 2, max_days: 3 },
{ pincode: 403716, min_days: 2, max_days: 3 },
{ pincode: 403717, min_days: 2, max_days: 3 },
{ pincode: 403718, min_days: 2, max_days: 3 },
{ pincode: 403719, min_days: 2, max_days: 3 },
{ pincode: 403720, min_days: 2, max_days: 3 },
{ pincode: 403721, min_days: 2, max_days: 3 },
{ pincode: 403722, min_days: 2, max_days: 3 },
{ pincode: 403723, min_days: 2, max_days: 3 },
{ pincode: 403724, min_days: 2, max_days: 3 },
{ pincode: 403725, min_days: 2, max_days: 3 },
{ pincode: 403726, min_days: 2, max_days: 3 },
{ pincode: 403729, min_days: 2, max_days: 3 },
{ pincode: 403731, min_days: 2, max_days: 3 },
{ pincode: 403801, min_days: 2, max_days: 3 },
{ pincode: 403802, min_days: 2, max_days: 3 },
{ pincode: 403803, min_days: 2, max_days: 3 },
{ pincode: 403804, min_days: 2, max_days: 3 },
{ pincode: 403806, min_days: 2, max_days: 3 },
{ pincode: 410000, min_days: 2, max_days: 3 },
{ pincode: 410101, min_days: 3, max_days: 4 },
{ pincode: 410201, min_days: 3, max_days: 4 },
{ pincode: 410202, min_days: 2, max_days: 3 },
{ pincode: 410203, min_days: 2, max_days: 3 },
{ pincode: 410204, min_days: 2, max_days: 3 },
{ pincode: 410205, min_days: 3, max_days: 4 },
{ pincode: 410206, min_days: 3, max_days: 4 },
{ pincode: 410207, min_days: 2, max_days: 3 },
{ pincode: 410208, min_days: 2, max_days: 3 },
{ pincode: 410209, min_days: 2, max_days: 3 },
{ pincode: 410210, min_days: 2, max_days: 3 },
{ pincode: 410216, min_days: 2, max_days: 3 },
{ pincode: 410217, min_days: 2, max_days: 3 },
{ pincode: 410218, min_days: 2, max_days: 3 },
{ pincode: 410220, min_days: 2, max_days: 3 },
{ pincode: 410221, min_days: 2, max_days: 3 },
{ pincode: 410222, min_days: 2, max_days: 3 },
{ pincode: 410301, min_days: 2, max_days: 3 },
{ pincode: 410302, min_days: 2, max_days: 3 },
{ pincode: 410401, min_days: 2, max_days: 3 },
{ pincode: 410402, min_days: 2, max_days: 3 },
{ pincode: 410403, min_days: 2, max_days: 3 },
{ pincode: 410405, min_days: 2, max_days: 3 },
{ pincode: 410501, min_days: 2, max_days: 3 },
{ pincode: 410502, min_days: 3, max_days: 4 },
{ pincode: 410503, min_days: 3, max_days: 4 },
{ pincode: 410504, min_days: 3, max_days: 4 },
{ pincode: 410505, min_days: 3, max_days: 4 },
{ pincode: 410506, min_days: 2, max_days: 3 },
{ pincode: 410507, min_days: 2, max_days: 3 },
{ pincode: 410508, min_days: 3, max_days: 4 },
{ pincode: 410509, min_days: 3, max_days: 4 },
{ pincode: 410510, min_days: 3, max_days: 4 },
{ pincode: 410511, min_days: 3, max_days: 4 },
{ pincode: 410512, min_days: 3, max_days: 4 },
{ pincode: 410513, min_days: 3, max_days: 4 },
{ pincode: 410515, min_days: 3, max_days: 4 },
{ pincode: 410516, min_days: 3, max_days: 4 },
{ pincode: 410613, min_days: 2, max_days: 3 },
{ pincode: 411001, min_days: 2, max_days: 3 },
{ pincode: 411002, min_days: 2, max_days: 3 },
{ pincode: 411003, min_days: 2, max_days: 3 },
{ pincode: 411004, min_days: 2, max_days: 3 },
{ pincode: 411005, min_days: 2, max_days: 3 },
{ pincode: 411006, min_days: 2, max_days: 3 },
{ pincode: 411007, min_days: 2, max_days: 3 },
{ pincode: 411008, min_days: 2, max_days: 3 },
{ pincode: 411009, min_days: 2, max_days: 3 },
{ pincode: 411010, min_days: 2, max_days: 3 },
{ pincode: 411011, min_days: 2, max_days: 3 },
{ pincode: 411012, min_days: 2, max_days: 3 },
{ pincode: 411013, min_days: 2, max_days: 3 },
{ pincode: 411014, min_days: 2, max_days: 3 },
{ pincode: 411015, min_days: 2, max_days: 3 },
{ pincode: 411016, min_days: 2, max_days: 3 },
{ pincode: 411017, min_days: 2, max_days: 3 },
{ pincode: 411018, min_days: 2, max_days: 3 },
{ pincode: 411019, min_days: 2, max_days: 3 },
{ pincode: 411020, min_days: 2, max_days: 3 },
{ pincode: 411021, min_days: 2, max_days: 3 },
{ pincode: 411022, min_days: 2, max_days: 3 },
{ pincode: 411023, min_days: 2, max_days: 3 },
{ pincode: 411024, min_days: 2, max_days: 3 },
{ pincode: 411025, min_days: 2, max_days: 3 },
{ pincode: 411026, min_days: 2, max_days: 3 },
{ pincode: 411027, min_days: 2, max_days: 3 },
{ pincode: 411028, min_days: 2, max_days: 3 },
{ pincode: 411029, min_days: 2, max_days: 3 },
{ pincode: 411030, min_days: 2, max_days: 3 },
{ pincode: 411031, min_days: 2, max_days: 3 },
{ pincode: 411032, min_days: 2, max_days: 3 },
{ pincode: 411033, min_days: 2, max_days: 3 },
{ pincode: 411034, min_days: 2, max_days: 3 },
{ pincode: 411035, min_days: 2, max_days: 3 },
{ pincode: 411036, min_days: 2, max_days: 3 },
{ pincode: 411037, min_days: 2, max_days: 3 },
{ pincode: 411038, min_days: 2, max_days: 3 },
{ pincode: 411039, min_days: 2, max_days: 3 },
{ pincode: 411040, min_days: 2, max_days: 3 },
{ pincode: 411041, min_days: 2, max_days: 3 },
{ pincode: 411042, min_days: 2, max_days: 3 },
{ pincode: 411043, min_days: 2, max_days: 3 },
{ pincode: 411044, min_days: 2, max_days: 3 },
{ pincode: 411045, min_days: 2, max_days: 3 },
{ pincode: 411046, min_days: 2, max_days: 3 },
{ pincode: 411047, min_days: 2, max_days: 3 },
{ pincode: 411048, min_days: 2, max_days: 3 },
{ pincode: 411051, min_days: 2, max_days: 3 },
{ pincode: 411052, min_days: 2, max_days: 3 },
{ pincode: 411053, min_days: 2, max_days: 3 },
{ pincode: 411057, min_days: 2, max_days: 3 },
{ pincode: 411058, min_days: 2, max_days: 3 },
{ pincode: 411060, min_days: 2, max_days: 3 },
{ pincode: 411061, min_days: 2, max_days: 3 },
{ pincode: 411062, min_days: 2, max_days: 3 },
{ pincode: 411067, min_days: 2, max_days: 3 },
{ pincode: 411068, min_days: 2, max_days: 3 },
{ pincode: 411070, min_days: 2, max_days: 3 },
{ pincode: 411081, min_days: 2, max_days: 3 },
{ pincode: 411111, min_days: 2, max_days: 3 },
{ pincode: 411201, min_days: 2, max_days: 3 },
{ pincode: 412101, min_days: 2, max_days: 3 },
{ pincode: 412102, min_days: 3, max_days: 4 },
{ pincode: 412103, min_days: 3, max_days: 4 },
{ pincode: 412105, min_days: 2, max_days: 3 },
{ pincode: 412106, min_days: 2, max_days: 3 },
{ pincode: 412108, min_days: 3, max_days: 4 },
{ pincode: 412109, min_days: 2, max_days: 3 },
{ pincode: 412111, min_days: 3, max_days: 4 },
{ pincode: 412112, min_days: 3, max_days: 4 },
{ pincode: 412113, min_days: 2, max_days: 3 },
{ pincode: 412115, min_days: 3, max_days: 4 },
{ pincode: 412201, min_days: 3, max_days: 4 },
{ pincode: 412202, min_days: 3, max_days: 4 },
{ pincode: 412205, min_days: 3, max_days: 4 },
{ pincode: 412207, min_days: 3, max_days: 4 },
{ pincode: 412208, min_days: 3, max_days: 4 },
{ pincode: 412209, min_days: 3, max_days: 4 },
{ pincode: 412210, min_days: 3, max_days: 4 },
{ pincode: 412213, min_days: 3, max_days: 4 },
{ pincode: 412215, min_days: 3, max_days: 4 },
{ pincode: 412216, min_days: 3, max_days: 4 },
{ pincode: 412218, min_days: 3, max_days: 4 },
{ pincode: 412219, min_days: 3, max_days: 4 },
{ pincode: 412220, min_days: 3, max_days: 4 },
{ pincode: 412301, min_days: 3, max_days: 4 },
{ pincode: 412303, min_days: 3, max_days: 4 },
{ pincode: 412306, min_days: 3, max_days: 4 },
{ pincode: 412307, min_days: 3, max_days: 4 },
{ pincode: 412308, min_days: 2, max_days: 3 },
{ pincode: 412401, min_days: 3, max_days: 4 },
{ pincode: 412402, min_days: 3, max_days: 4 },
{ pincode: 412403, min_days: 3, max_days: 4 },
{ pincode: 412404, min_days: 3, max_days: 4 },
{ pincode: 412405, min_days: 3, max_days: 4 },
{ pincode: 412406, min_days: 3, max_days: 4 },
{ pincode: 412408, min_days: 3, max_days: 4 },
{ pincode: 412409, min_days: 3, max_days: 4 },
{ pincode: 412410, min_days: 3, max_days: 4 },
{ pincode: 412411, min_days: 3, max_days: 4 },
{ pincode: 412412, min_days: 3, max_days: 4 },
{ pincode: 412801, min_days: 3, max_days: 4 },
{ pincode: 412802, min_days: 3, max_days: 4 },
{ pincode: 412803, min_days: 4, max_days: 5 },
{ pincode: 412804, min_days: 4, max_days: 5 },
{ pincode: 412805, min_days: 4, max_days: 5 },
{ pincode: 412806, min_days: 4, max_days: 5 },
{ pincode: 412999, min_days: 2, max_days: 3 },
{ pincode: 413001, min_days: 3, max_days: 4 },
{ pincode: 413002, min_days: 3, max_days: 4 },
{ pincode: 413003, min_days: 3, max_days: 4 },
{ pincode: 413004, min_days: 3, max_days: 4 },
{ pincode: 413005, min_days: 3, max_days: 4 },
{ pincode: 413006, min_days: 3, max_days: 4 },
{ pincode: 413007, min_days: 3, max_days: 4 },
{ pincode: 413008, min_days: 3, max_days: 4 },
{ pincode: 413101, min_days: 3, max_days: 4 },
{ pincode: 413102, min_days: 3, max_days: 4 },
{ pincode: 413103, min_days: 3, max_days: 4 },
{ pincode: 413105, min_days: 3, max_days: 4 },
{ pincode: 413106, min_days: 3, max_days: 4 },
{ pincode: 413107, min_days: 3, max_days: 4 },
{ pincode: 413108, min_days: 3, max_days: 4 },
{ pincode: 413109, min_days: 3, max_days: 4 },
{ pincode: 413110, min_days: 3, max_days: 4 },
{ pincode: 413111, min_days: 3, max_days: 4 },
{ pincode: 413112, min_days: 3, max_days: 4 },
{ pincode: 413113, min_days: 3, max_days: 4 },
{ pincode: 413115, min_days: 3, max_days: 4 },
{ pincode: 413116, min_days: 3, max_days: 4 },
{ pincode: 413118, min_days: 3, max_days: 4 },
{ pincode: 413120, min_days: 3, max_days: 4 },
{ pincode: 413130, min_days: 3, max_days: 4 },
{ pincode: 413132, min_days: 3, max_days: 4 },
{ pincode: 413133, min_days: 3, max_days: 4 },
{ pincode: 413208, min_days: 3, max_days: 4 },
{ pincode: 413209, min_days: 3, max_days: 4 },
{ pincode: 413213, min_days: 3, max_days: 4 },
{ pincode: 413215, min_days: 3, max_days: 4 },
{ pincode: 413216, min_days: 3, max_days: 4 },
{ pincode: 413222, min_days: 3, max_days: 4 },
{ pincode: 413224, min_days: 3, max_days: 4 },
{ pincode: 413228, min_days: 3, max_days: 4 },
{ pincode: 413250, min_days: 3, max_days: 4 },
{ pincode: 413255, min_days: 3, max_days: 4 },
{ pincode: 413310, min_days: 3, max_days: 4 },
{ pincode: 413401, min_days: 3, max_days: 4 },
{ pincode: 413402, min_days: 3, max_days: 4 },
{ pincode: 413403, min_days: 3, max_days: 4 },
{ pincode: 413405, min_days: 3, max_days: 4 },
{ pincode: 413409, min_days: 3, max_days: 4 },
{ pincode: 413410, min_days: 3, max_days: 4 },
{ pincode: 413411, min_days: 3, max_days: 4 },
{ pincode: 413432, min_days: 4, max_days: 5 },
{ pincode: 413501, min_days: 3, max_days: 4 },
{ pincode: 413502, min_days: 3, max_days: 4 },
{ pincode: 413503, min_days: 3, max_days: 4 },
{ pincode: 413504, min_days: 3, max_days: 4 },
{ pincode: 413506, min_days: 3, max_days: 4 },
{ pincode: 413507, min_days: 3, max_days: 4 },
{ pincode: 413509, min_days: 3, max_days: 4 },
{ pincode: 413512, min_days: 3, max_days: 4 },
{ pincode: 413517, min_days: 4, max_days: 5 },
{ pincode: 413518, min_days: 4, max_days: 5 },
{ pincode: 413519, min_days: 4, max_days: 5 },
{ pincode: 413520, min_days: 3, max_days: 4 },
{ pincode: 413527, min_days: 3, max_days: 4 },
{ pincode: 413531, min_days: 3, max_days: 4 },
{ pincode: 413532, min_days: 4, max_days: 5 },
{ pincode: 413544, min_days: 3, max_days: 4 },
{ pincode: 413580, min_days: 3, max_days: 4 },
{ pincode: 413582, min_days: 3, max_days: 4 },
{ pincode: 413601, min_days: 3, max_days: 4 },
{ pincode: 413604, min_days: 3, max_days: 4 },
{ pincode: 413605, min_days: 3, max_days: 4 },
{ pincode: 413606, min_days: 3, max_days: 4 },
{ pincode: 413701, min_days: 3, max_days: 4 },
{ pincode: 413702, min_days: 4, max_days: 5 },
{ pincode: 413703, min_days: 3, max_days: 4 },
{ pincode: 413704, min_days: 3, max_days: 4 },
{ pincode: 413705, min_days: 3, max_days: 4 },
{ pincode: 413706, min_days: 3, max_days: 4 },
{ pincode: 413707, min_days: 3, max_days: 4 },
{ pincode: 413709, min_days: 3, max_days: 4 },
{ pincode: 413710, min_days: 3, max_days: 4 },
{ pincode: 413711, min_days: 3, max_days: 4 },
{ pincode: 413712, min_days: 3, max_days: 4 },
{ pincode: 413713, min_days: 3, max_days: 4 },
{ pincode: 413714, min_days: 3, max_days: 4 },
{ pincode: 413715, min_days: 3, max_days: 4 },
{ pincode: 413716, min_days: 3, max_days: 4 },
{ pincode: 413717, min_days: 3, max_days: 4 },
{ pincode: 413718, min_days: 3, max_days: 4 },
{ pincode: 413720, min_days: 3, max_days: 4 },
{ pincode: 413721, min_days: 3, max_days: 4 },
{ pincode: 413723, min_days: 3, max_days: 4 },
{ pincode: 413726, min_days: 3, max_days: 4 },
{ pincode: 413728, min_days: 3, max_days: 4 },
{ pincode: 413736, min_days: 3, max_days: 4 },
{ pincode: 413737, min_days: 3, max_days: 4 },
{ pincode: 413738, min_days: 3, max_days: 4 },
{ pincode: 413739, min_days: 3, max_days: 4 },
{ pincode: 413801, min_days: 3, max_days: 4 },
{ pincode: 413802, min_days: 3, max_days: 4 },
{ pincode: 414001, min_days: 3, max_days: 4 },
{ pincode: 414002, min_days: 3, max_days: 4 },
{ pincode: 414003, min_days: 3, max_days: 4 },
{ pincode: 414005, min_days: 3, max_days: 4 },
{ pincode: 414006, min_days: 3, max_days: 4 },
{ pincode: 414102, min_days: 3, max_days: 4 },
{ pincode: 414105, min_days: 3, max_days: 4 },
{ pincode: 414106, min_days: 3, max_days: 4 },
{ pincode: 414110, min_days: 3, max_days: 4 },
{ pincode: 414111, min_days: 3, max_days: 4 },
{ pincode: 414141, min_days: 2, max_days: 3 },
{ pincode: 414201, min_days: 3, max_days: 4 },
{ pincode: 414301, min_days: 3, max_days: 4 },
{ pincode: 414303, min_days: 3, max_days: 4 },
{ pincode: 414306, min_days: 3, max_days: 4 },
{ pincode: 414401, min_days: 3, max_days: 4 },
{ pincode: 414402, min_days: 3, max_days: 4 },
{ pincode: 414403, min_days: 3, max_days: 4 },
{ pincode: 414501, min_days: 3, max_days: 4 },
{ pincode: 414502, min_days: 3, max_days: 4 },
{ pincode: 414503, min_days: 3, max_days: 4 },
{ pincode: 414504, min_days: 3, max_days: 4 },
{ pincode: 414505, min_days: 3, max_days: 4 },
{ pincode: 414601, min_days: 3, max_days: 4 },
{ pincode: 414602, min_days: 3, max_days: 4 },
{ pincode: 414603, min_days: 3, max_days: 4 },
{ pincode: 414604, min_days: 3, max_days: 4 },
{ pincode: 414605, min_days: 3, max_days: 4 },
{ pincode: 414607, min_days: 3, max_days: 4 },
{ pincode: 414609, min_days: 3, max_days: 4 },
{ pincode: 414701, min_days: 3, max_days: 4 },
{ pincode: 415001, min_days: 3, max_days: 4 },
{ pincode: 415002, min_days: 3, max_days: 4 },
{ pincode: 415003, min_days: 3, max_days: 4 },
{ pincode: 415004, min_days: 3, max_days: 4 },
{ pincode: 415010, min_days: 3, max_days: 4 },
{ pincode: 415011, min_days: 3, max_days: 4 },
{ pincode: 415015, min_days: 3, max_days: 4 },
{ pincode: 415019, min_days: 3, max_days: 4 },
{ pincode: 415101, min_days: 3, max_days: 4 },
{ pincode: 415103, min_days: 3, max_days: 4 },
{ pincode: 415104, min_days: 3, max_days: 4 },
{ pincode: 415105, min_days: 3, max_days: 4 },
{ pincode: 415106, min_days: 3, max_days: 4 },
{ pincode: 415107, min_days: 3, max_days: 4 },
{ pincode: 415108, min_days: 3, max_days: 4 },
{ pincode: 415109, min_days: 3, max_days: 4 },
{ pincode: 415110, min_days: 3, max_days: 4 },
{ pincode: 415111, min_days: 3, max_days: 4 },
{ pincode: 415114, min_days: 3, max_days: 4 },
{ pincode: 415115, min_days: 3, max_days: 4 },
{ pincode: 415122, min_days: 3, max_days: 4 },
{ pincode: 415124, min_days: 3, max_days: 4 },
{ pincode: 415203, min_days: 3, max_days: 4 },
{ pincode: 415205, min_days: 3, max_days: 4 },
{ pincode: 415206, min_days: 3, max_days: 4 },
{ pincode: 415209, min_days: 3, max_days: 4 },
{ pincode: 415212, min_days: 3, max_days: 4 },
{ pincode: 415213, min_days: 3, max_days: 4 },
{ pincode: 415409, min_days: 3, max_days: 4 },
{ pincode: 415414, min_days: 3, max_days: 4 },
{ pincode: 415501, min_days: 3, max_days: 4 },
{ pincode: 415508, min_days: 3, max_days: 4 },
{ pincode: 415511, min_days: 3, max_days: 4 },
{ pincode: 415513, min_days: 4, max_days: 5 },
{ pincode: 415514, min_days: 4, max_days: 5 },
{ pincode: 415515, min_days: 4, max_days: 5 },
{ pincode: 415516, min_days: 4, max_days: 5 },
{ pincode: 415517, min_days: 4, max_days: 5 },
{ pincode: 415518, min_days: 3, max_days: 4 },
{ pincode: 415519, min_days: 3, max_days: 4 },
{ pincode: 415521, min_days: 3, max_days: 4 },
{ pincode: 415522, min_days: 3, max_days: 4 },
{ pincode: 415523, min_days: 3, max_days: 4 },
{ pincode: 415524, min_days: 3, max_days: 4 },
{ pincode: 415528, min_days: 3, max_days: 4 },
{ pincode: 415530, min_days: 4, max_days: 5 },
{ pincode: 415536, min_days: 4, max_days: 5 },
{ pincode: 415537, min_days: 3, max_days: 4 },
{ pincode: 415539, min_days: 3, max_days: 4 },
{ pincode: 415601, min_days: 3, max_days: 4 },
{ pincode: 415602, min_days: 3, max_days: 4 },
{ pincode: 415603, min_days: 3, max_days: 4 },
{ pincode: 415605, min_days: 3, max_days: 4 },
{ pincode: 415606, min_days: 3, max_days: 4 },
{ pincode: 415608, min_days: 3, max_days: 4 },
{ pincode: 415609, min_days: 4, max_days: 5 },
{ pincode: 415610, min_days: 4, max_days: 5 },
{ pincode: 415611, min_days: 4, max_days: 5 },
{ pincode: 415612, min_days: 3, max_days: 4 },
{ pincode: 415613, min_days: 4, max_days: 5 },
{ pincode: 415614, min_days: 3, max_days: 4 },
{ pincode: 415615, min_days: 3, max_days: 4 },
{ pincode: 415616, min_days: 3, max_days: 4 },
{ pincode: 415617, min_days: 3, max_days: 4 },
{ pincode: 415619, min_days: 3, max_days: 4 },
{ pincode: 415620, min_days: 3, max_days: 4 },
{ pincode: 415621, min_days: 3, max_days: 4 },
{ pincode: 415626, min_days: 3, max_days: 4 },
{ pincode: 415628, min_days: 4, max_days: 5 },
{ pincode: 415629, min_days: 3, max_days: 4 },
{ pincode: 415634, min_days: 4, max_days: 5 },
{ pincode: 415639, min_days: 3, max_days: 4 },
{ pincode: 415643, min_days: 3, max_days: 4 },
{ pincode: 415702, min_days: 4, max_days: 5 },
{ pincode: 415703, min_days: 4, max_days: 5 },
{ pincode: 415705, min_days: 4, max_days: 5 },
{ pincode: 415706, min_days: 3, max_days: 4 },
{ pincode: 415709, min_days: 3, max_days: 4 },
{ pincode: 415711, min_days: 3, max_days: 4 },
{ pincode: 415712, min_days: 3, max_days: 4 },
{ pincode: 415713, min_days: 3, max_days: 4 },
{ pincode: 415714, min_days: 3, max_days: 4 },
{ pincode: 415716, min_days: 3, max_days: 4 },
{ pincode: 415717, min_days: 3, max_days: 4 },
{ pincode: 415719, min_days: 4, max_days: 5 },
{ pincode: 415720, min_days: 3, max_days: 4 },
{ pincode: 415722, min_days: 3, max_days: 4 },
{ pincode: 415724, min_days: 4, max_days: 5 },
{ pincode: 415726, min_days: 4, max_days: 5 },
{ pincode: 415728, min_days: 4, max_days: 5 },
{ pincode: 415729, min_days: 4, max_days: 5 },
{ pincode: 415730, min_days: 3, max_days: 4 },
{ pincode: 415801, min_days: 4, max_days: 5 },
{ pincode: 415802, min_days: 4, max_days: 5 },
{ pincode: 415803, min_days: 3, max_days: 4 },
{ pincode: 415804, min_days: 4, max_days: 5 },
{ pincode: 415805, min_days: 3, max_days: 4 },
{ pincode: 415806, min_days: 3, max_days: 4 },
{ pincode: 415807, min_days: 3, max_days: 4 },
{ pincode: 416001, min_days: 3, max_days: 4 },
{ pincode: 416002, min_days: 3, max_days: 4 },
{ pincode: 416003, min_days: 3, max_days: 4 },
{ pincode: 416004, min_days: 3, max_days: 4 },
{ pincode: 416005, min_days: 3, max_days: 4 },
{ pincode: 416006, min_days: 3, max_days: 4 },
{ pincode: 416007, min_days: 3, max_days: 4 },
{ pincode: 416008, min_days: 3, max_days: 4 },
{ pincode: 416009, min_days: 3, max_days: 4 },
{ pincode: 416010, min_days: 3, max_days: 4 },
{ pincode: 416011, min_days: 3, max_days: 4 },
{ pincode: 416012, min_days: 3, max_days: 4 },
{ pincode: 416013, min_days: 3, max_days: 4 },
{ pincode: 416101, min_days: 3, max_days: 4 },
{ pincode: 416107, min_days: 3, max_days: 4 },
{ pincode: 416108, min_days: 3, max_days: 4 },
{ pincode: 416109, min_days: 3, max_days: 4 },
{ pincode: 416110, min_days: 3, max_days: 4 },
{ pincode: 416112, min_days: 3, max_days: 4 },
{ pincode: 416113, min_days: 3, max_days: 4 },
{ pincode: 416114, min_days: 3, max_days: 4 },
{ pincode: 416115, min_days: 3, max_days: 4 },
{ pincode: 416116, min_days: 3, max_days: 4 },
{ pincode: 416117, min_days: 3, max_days: 4 },
{ pincode: 416118, min_days: 3, max_days: 4 },
{ pincode: 416119, min_days: 3, max_days: 4 },
{ pincode: 416121, min_days: 3, max_days: 4 },
{ pincode: 416122, min_days: 3, max_days: 4 },
{ pincode: 416129, min_days: 3, max_days: 4 },
{ pincode: 416138, min_days: 3, max_days: 4 },
{ pincode: 416143, min_days: 3, max_days: 4 },
{ pincode: 416144, min_days: 3, max_days: 4 },
{ pincode: 416146, min_days: 3, max_days: 4 },
{ pincode: 416203, min_days: 3, max_days: 4 },
{ pincode: 416205, min_days: 3, max_days: 4 },
{ pincode: 416207, min_days: 3, max_days: 4 },
{ pincode: 416213, min_days: 3, max_days: 4 },
{ pincode: 416216, min_days: 3, max_days: 4 },
{ pincode: 416219, min_days: 3, max_days: 4 },
{ pincode: 416221, min_days: 3, max_days: 4 },
{ pincode: 416229, min_days: 3, max_days: 4 },
{ pincode: 416230, min_days: 3, max_days: 4 },
{ pincode: 416232, min_days: 3, max_days: 4 },
{ pincode: 416234, min_days: 3, max_days: 4 },
{ pincode: 416235, min_days: 3, max_days: 4 },
{ pincode: 416236, min_days: 3, max_days: 4 },
{ pincode: 416301, min_days: 3, max_days: 4 },
{ pincode: 416302, min_days: 3, max_days: 4 },
{ pincode: 416303, min_days: 3, max_days: 4 },
{ pincode: 416307, min_days: 3, max_days: 4 },
{ pincode: 416308, min_days: 3, max_days: 4 },
{ pincode: 416309, min_days: 3, max_days: 4 },
{ pincode: 416310, min_days: 3, max_days: 4 },
{ pincode: 416311, min_days: 3, max_days: 4 },
{ pincode: 416312, min_days: 3, max_days: 4 },
{ pincode: 416314, min_days: 3, max_days: 4 },
{ pincode: 416406, min_days: 3, max_days: 4 },
{ pincode: 416408, min_days: 3, max_days: 4 },
{ pincode: 416410, min_days: 3, max_days: 4 },
{ pincode: 416415, min_days: 3, max_days: 4 },
{ pincode: 416416, min_days: 3, max_days: 4 },
{ pincode: 416419, min_days: 3, max_days: 4 },
{ pincode: 416436, min_days: 3, max_days: 4 },
{ pincode: 416502, min_days: 3, max_days: 4 },
{ pincode: 416505, min_days: 3, max_days: 4 },
{ pincode: 416509, min_days: 3, max_days: 4 },
{ pincode: 416510, min_days: 3, max_days: 4 },
{ pincode: 416511, min_days: 3, max_days: 4 },
{ pincode: 416512, min_days: 3, max_days: 4 },
{ pincode: 416516, min_days: 3, max_days: 4 },
{ pincode: 416518, min_days: 3, max_days: 4 },
{ pincode: 416520, min_days: 3, max_days: 4 },
{ pincode: 416528, min_days: 3, max_days: 4 },
{ pincode: 416541, min_days: 3, max_days: 4 },
{ pincode: 416550, min_days: 3, max_days: 4 },
{ pincode: 416601, min_days: 3, max_days: 4 },
{ pincode: 416602, min_days: 3, max_days: 4 },
{ pincode: 416603, min_days: 3, max_days: 4 },
{ pincode: 416606, min_days: 3, max_days: 4 },
{ pincode: 416609, min_days: 3, max_days: 4 },
{ pincode: 416610, min_days: 3, max_days: 4 },
{ pincode: 416611, min_days: 3, max_days: 4 },
{ pincode: 416613, min_days: 3, max_days: 4 },
{ pincode: 416614, min_days: 3, max_days: 4 },
{ pincode: 416616, min_days: 3, max_days: 4 },
{ pincode: 416628, min_days: 3, max_days: 4 },
{ pincode: 416701, min_days: 3, max_days: 4 },
{ pincode: 416702, min_days: 3, max_days: 4 },
{ pincode: 416704, min_days: 3, max_days: 4 },
{ pincode: 416705, min_days: 3, max_days: 4 },
{ pincode: 416707, min_days: 3, max_days: 4 },
{ pincode: 416709, min_days: 3, max_days: 4 },
{ pincode: 416712, min_days: 3, max_days: 4 },
{ pincode: 416713, min_days: 3, max_days: 4 },
{ pincode: 416801, min_days: 3, max_days: 4 },
{ pincode: 416810, min_days: 3, max_days: 4 },
{ pincode: 416812, min_days: 3, max_days: 4 },
{ pincode: 421001, min_days: 2, max_days: 3 },
{ pincode: 421002, min_days: 2, max_days: 3 },
{ pincode: 421003, min_days: 2, max_days: 3 },
{ pincode: 421004, min_days: 2, max_days: 3 },
{ pincode: 421005, min_days: 2, max_days: 3 },
{ pincode: 421101, min_days: 2, max_days: 3 },
{ pincode: 421102, min_days: 2, max_days: 3 },
{ pincode: 421103, min_days: 2, max_days: 3 },
{ pincode: 421111, min_days: 2, max_days: 3 },
{ pincode: 421201, min_days: 2, max_days: 3 },
{ pincode: 421202, min_days: 2, max_days: 3 },
{ pincode: 421203, min_days: 2, max_days: 3 },
{ pincode: 421204, min_days: 2, max_days: 3 },
{ pincode: 421300, min_days: 2, max_days: 3 },
{ pincode: 421301, min_days: 2, max_days: 3 },
{ pincode: 421302, min_days: 2, max_days: 3 },
{ pincode: 421303, min_days: 2, max_days: 3 },
{ pincode: 421304, min_days: 2, max_days: 3 },
{ pincode: 421305, min_days: 2, max_days: 3 },
{ pincode: 421306, min_days: 2, max_days: 3 },
{ pincode: 421308, min_days: 2, max_days: 3 },
{ pincode: 421311, min_days: 2, max_days: 3 },
{ pincode: 421312, min_days: 2, max_days: 3 },
{ pincode: 421501, min_days: 2, max_days: 3 },
{ pincode: 421502, min_days: 2, max_days: 3 },
{ pincode: 421503, min_days: 2, max_days: 3 },
{ pincode: 421504, min_days: 2, max_days: 3 },
{ pincode: 421505, min_days: 2, max_days: 3 },
{ pincode: 421506, min_days: 2, max_days: 3 },
{ pincode: 421601, min_days: 2, max_days: 3 },
{ pincode: 421605, min_days: 2, max_days: 3 },
{ pincode: 422001, min_days: 3, max_days: 4 },
{ pincode: 422002, min_days: 3, max_days: 4 },
{ pincode: 422003, min_days: 3, max_days: 4 },
{ pincode: 422004, min_days: 3, max_days: 4 },
{ pincode: 422005, min_days: 3, max_days: 4 },
{ pincode: 422006, min_days: 3, max_days: 4 },
{ pincode: 422007, min_days: 3, max_days: 4 },
{ pincode: 422008, min_days: 3, max_days: 4 },
{ pincode: 422009, min_days: 3, max_days: 4 },
{ pincode: 422010, min_days: 3, max_days: 4 },
{ pincode: 422011, min_days: 3, max_days: 4 },
{ pincode: 422012, min_days: 3, max_days: 4 },
{ pincode: 422013, min_days: 3, max_days: 4 },
{ pincode: 422101, min_days: 3, max_days: 4 },
{ pincode: 422102, min_days: 3, max_days: 4 },
{ pincode: 422103, min_days: 2, max_days: 3 },
{ pincode: 422105, min_days: 3, max_days: 4 },
{ pincode: 422112, min_days: 2, max_days: 3 },
{ pincode: 422113, min_days: 2, max_days: 3 },
{ pincode: 422203, min_days: 3, max_days: 4 },
{ pincode: 422206, min_days: 3, max_days: 4 },
{ pincode: 422207, min_days: 3, max_days: 4 },
{ pincode: 422209, min_days: 3, max_days: 4 },
{ pincode: 422303, min_days: 3, max_days: 4 },
{ pincode: 422305, min_days: 3, max_days: 4 },
{ pincode: 422306, min_days: 3, max_days: 4 },
{ pincode: 422308, min_days: 3, max_days: 4 },
{ pincode: 422401, min_days: 3, max_days: 4 },
{ pincode: 422403, min_days: 2, max_days: 3 },
{ pincode: 422601, min_days: 3, max_days: 4 },
{ pincode: 422602, min_days: 3, max_days: 4 },
{ pincode: 422603, min_days: 3, max_days: 4 },
{ pincode: 422604, min_days: 3, max_days: 4 },
{ pincode: 422605, min_days: 3, max_days: 4 },
{ pincode: 422608, min_days: 3, max_days: 4 },
{ pincode: 422610, min_days: 3, max_days: 4 },
{ pincode: 422611, min_days: 3, max_days: 4 },
{ pincode: 422615, min_days: 3, max_days: 4 },
{ pincode: 422620, min_days: 3, max_days: 4 },
{ pincode: 422622, min_days: 3, max_days: 4 },
{ pincode: 423101, min_days: 3, max_days: 4 },
{ pincode: 423102, min_days: 3, max_days: 4 },
{ pincode: 423104, min_days: 3, max_days: 4 },
{ pincode: 423105, min_days: 3, max_days: 4 },
{ pincode: 423106, min_days: 3, max_days: 4 },
{ pincode: 423107, min_days: 3, max_days: 4 },
{ pincode: 423109, min_days: 3, max_days: 4 },
{ pincode: 423201, min_days: 3, max_days: 4 },
{ pincode: 423202, min_days: 3, max_days: 4 },
{ pincode: 423203, min_days: 3, max_days: 4 },
{ pincode: 423401, min_days: 3, max_days: 4 },
{ pincode: 423402, min_days: 3, max_days: 4 },
{ pincode: 423403, min_days: 3, max_days: 4 },
{ pincode: 423601, min_days: 3, max_days: 4 },
{ pincode: 423602, min_days: 3, max_days: 4 },
{ pincode: 423603, min_days: 3, max_days: 4 },
{ pincode: 423701, min_days: 3, max_days: 4 },
{ pincode: 423702, min_days: 3, max_days: 4 },
{ pincode: 423703, min_days: 3, max_days: 4 },
{ pincode: 424001, min_days: 3, max_days: 4 },
{ pincode: 424002, min_days: 3, max_days: 4 },
{ pincode: 424003, min_days: 3, max_days: 4 },
{ pincode: 424004, min_days: 3, max_days: 4 },
{ pincode: 424005, min_days: 3, max_days: 4 },
{ pincode: 424006, min_days: 3, max_days: 4 },
{ pincode: 424101, min_days: 3, max_days: 4 },
{ pincode: 424102, min_days: 3, max_days: 4 },
{ pincode: 424103, min_days: 3, max_days: 4 },
{ pincode: 424104, min_days: 3, max_days: 4 },
{ pincode: 424105, min_days: 3, max_days: 4 },
{ pincode: 424106, min_days: 3, max_days: 4 },
{ pincode: 424107, min_days: 3, max_days: 4 },
{ pincode: 424108, min_days: 3, max_days: 4 },
{ pincode: 424116, min_days: 3, max_days: 4 },
{ pincode: 424119, min_days: 3, max_days: 4 },
{ pincode: 424201, min_days: 3, max_days: 4 },
{ pincode: 424202, min_days: 3, max_days: 4 },
{ pincode: 424203, min_days: 3, max_days: 4 },
{ pincode: 424204, min_days: 3, max_days: 4 },
{ pincode: 424205, min_days: 3, max_days: 4 },
{ pincode: 424206, min_days: 3, max_days: 4 },
{ pincode: 424207, min_days: 3, max_days: 4 },
{ pincode: 424301, min_days: 3, max_days: 4 },
{ pincode: 424302, min_days: 3, max_days: 4 },
{ pincode: 424303, min_days: 3, max_days: 4 },
{ pincode: 424304, min_days: 3, max_days: 4 },
{ pincode: 424305, min_days: 3, max_days: 4 },
{ pincode: 424306, min_days: 3, max_days: 4 },
{ pincode: 424307, min_days: 3, max_days: 4 },
{ pincode: 424308, min_days: 3, max_days: 4 },
{ pincode: 424309, min_days: 3, max_days: 4 },
{ pincode: 424311, min_days: 3, max_days: 4 },
{ pincode: 424318, min_days: 3, max_days: 4 },
{ pincode: 425001, min_days: 3, max_days: 4 },
{ pincode: 425002, min_days: 3, max_days: 4 },
{ pincode: 425003, min_days: 3, max_days: 4 },
{ pincode: 425004, min_days: 3, max_days: 4 },
{ pincode: 425101, min_days: 3, max_days: 4 },
{ pincode: 425102, min_days: 3, max_days: 4 },
{ pincode: 425103, min_days: 3, max_days: 4 },
{ pincode: 425104, min_days: 3, max_days: 4 },
{ pincode: 425105, min_days: 3, max_days: 4 },
{ pincode: 425106, min_days: 3, max_days: 4 },
{ pincode: 425107, min_days: 3, max_days: 4 },
{ pincode: 425108, min_days: 3, max_days: 4 },
{ pincode: 425109, min_days: 3, max_days: 4 },
{ pincode: 425110, min_days: 3, max_days: 4 },
{ pincode: 425111, min_days: 3, max_days: 4 },
{ pincode: 425112, min_days: 3, max_days: 4 },
{ pincode: 425113, min_days: 3, max_days: 4 },
{ pincode: 425114, min_days: 3, max_days: 4 },
{ pincode: 425115, min_days: 3, max_days: 4 },
{ pincode: 425116, min_days: 3, max_days: 4 },
{ pincode: 425117, min_days: 3, max_days: 4 },
{ pincode: 425201, min_days: 3, max_days: 4 },
{ pincode: 425203, min_days: 3, max_days: 4 },
{ pincode: 425301, min_days: 3, max_days: 4 },
{ pincode: 425302, min_days: 3, max_days: 4 },
{ pincode: 425304, min_days: 3, max_days: 4 },
{ pincode: 425305, min_days: 3, max_days: 4 },
{ pincode: 425306, min_days: 3, max_days: 4 },
{ pincode: 425307, min_days: 3, max_days: 4 },
{ pincode: 425308, min_days: 3, max_days: 4 },
{ pincode: 425309, min_days: 3, max_days: 4 },
{ pincode: 425310, min_days: 3, max_days: 4 },
{ pincode: 425311, min_days: 3, max_days: 4 },
{ pincode: 425401, min_days: 4, max_days: 5 },
{ pincode: 425407, min_days: 3, max_days: 4 },
{ pincode: 425408, min_days: 3, max_days: 4 },
{ pincode: 425411, min_days: 3, max_days: 4 },
{ pincode: 425412, min_days: 3, max_days: 4 },
{ pincode: 425413, min_days: 3, max_days: 4 },
{ pincode: 425415, min_days: 3, max_days: 4 },
{ pincode: 425416, min_days: 3, max_days: 4 },
{ pincode: 425422, min_days: 3, max_days: 4 },
{ pincode: 425423, min_days: 3, max_days: 4 },
{ pincode: 425501, min_days: 3, max_days: 4 },
{ pincode: 425502, min_days: 3, max_days: 4 },
{ pincode: 425503, min_days: 3, max_days: 4 },
{ pincode: 425504, min_days: 3, max_days: 4 },
{ pincode: 425505, min_days: 3, max_days: 4 },
{ pincode: 425506, min_days: 3, max_days: 4 },
{ pincode: 425507, min_days: 3, max_days: 4 },
{ pincode: 425508, min_days: 3, max_days: 4 },
{ pincode: 425519, min_days: 3, max_days: 4 },
{ pincode: 425523, min_days: 3, max_days: 4 },
{ pincode: 425524, min_days: 3, max_days: 4 },
{ pincode: 431001, min_days: 3, max_days: 4 },
{ pincode: 431002, min_days: 3, max_days: 4 },
{ pincode: 431003, min_days: 3, max_days: 4 },
{ pincode: 431004, min_days: 3, max_days: 4 },
{ pincode: 431005, min_days: 3, max_days: 4 },
{ pincode: 431006, min_days: 3, max_days: 4 },
{ pincode: 431007, min_days: 3, max_days: 4 },
{ pincode: 431009, min_days: 3, max_days: 4 },
{ pincode: 431010, min_days: 3, max_days: 4 },
{ pincode: 431101, min_days: 3, max_days: 4 },
{ pincode: 431102, min_days: 3, max_days: 4 },
{ pincode: 431103, min_days: 3, max_days: 4 },
{ pincode: 431104, min_days: 3, max_days: 4 },
{ pincode: 431105, min_days: 3, max_days: 4 },
{ pincode: 431107, min_days: 3, max_days: 4 },
{ pincode: 431109, min_days: 3, max_days: 4 },
{ pincode: 431112, min_days: 3, max_days: 4 },
{ pincode: 431113, min_days: 3, max_days: 4 },
{ pincode: 431114, min_days: 3, max_days: 4 },
{ pincode: 431115, min_days: 3, max_days: 4 },
{ pincode: 431116, min_days: 3, max_days: 4 },
{ pincode: 431117, min_days: 3, max_days: 4 },
{ pincode: 431118, min_days: 3, max_days: 4 },
{ pincode: 431122, min_days: 3, max_days: 4 },
{ pincode: 431123, min_days: 3, max_days: 4 },
{ pincode: 431124, min_days: 3, max_days: 4 },
{ pincode: 431127, min_days: 3, max_days: 4 },
{ pincode: 431128, min_days: 3, max_days: 4 },
{ pincode: 431132, min_days: 3, max_days: 4 },
{ pincode: 431133, min_days: 3, max_days: 4 },
{ pincode: 431134, min_days: 3, max_days: 4 },
{ pincode: 431135, min_days: 3, max_days: 4 },
{ pincode: 431136, min_days: 3, max_days: 4 },
{ pincode: 431143, min_days: 3, max_days: 4 },
{ pincode: 431147, min_days: 3, max_days: 4 },
{ pincode: 431150, min_days: 3, max_days: 4 },
{ pincode: 431151, min_days: 3, max_days: 4 },
{ pincode: 431154, min_days: 3, max_days: 4 },
{ pincode: 431202, min_days: 3, max_days: 4 },
{ pincode: 431203, min_days: 3, max_days: 4 },
{ pincode: 431204, min_days: 3, max_days: 4 },
{ pincode: 431210, min_days: 3, max_days: 4 },
{ pincode: 431213, min_days: 3, max_days: 4 },
{ pincode: 431401, min_days: 3, max_days: 4 },
{ pincode: 431402, min_days: 3, max_days: 4 },
{ pincode: 431502, min_days: 3, max_days: 4 },
{ pincode: 431503, min_days: 3, max_days: 4 },
{ pincode: 431505, min_days: 3, max_days: 4 },
{ pincode: 431506, min_days: 3, max_days: 4 },
{ pincode: 431508, min_days: 3, max_days: 4 },
{ pincode: 431509, min_days: 3, max_days: 4 },
{ pincode: 431510, min_days: 3, max_days: 4 },
{ pincode: 431511, min_days: 3, max_days: 4 },
{ pincode: 431512, min_days: 3, max_days: 4 },
{ pincode: 431513, min_days: 4, max_days: 5 },
{ pincode: 431514, min_days: 3, max_days: 4 },
{ pincode: 431515, min_days: 3, max_days: 4 },
{ pincode: 431516, min_days: 3, max_days: 4 },
{ pincode: 431517, min_days: 3, max_days: 4 },
{ pincode: 431519, min_days: 3, max_days: 4 },
{ pincode: 431520, min_days: 3, max_days: 4 },
{ pincode: 431521, min_days: 3, max_days: 4 },
{ pincode: 431523, min_days: 3, max_days: 4 },
{ pincode: 431530, min_days: 3, max_days: 4 },
{ pincode: 431537, min_days: 3, max_days: 4 },
{ pincode: 431540, min_days: 3, max_days: 4 },
{ pincode: 431542, min_days: 4, max_days: 5 },
{ pincode: 431601, min_days: 3, max_days: 4 },
{ pincode: 431602, min_days: 3, max_days: 4 },
{ pincode: 431603, min_days: 3, max_days: 4 },
{ pincode: 431604, min_days: 3, max_days: 4 },
{ pincode: 431605, min_days: 3, max_days: 4 },
{ pincode: 431606, min_days: 3, max_days: 4 },
{ pincode: 431701, min_days: 4, max_days: 5 },
{ pincode: 431702, min_days: 4, max_days: 5 },
{ pincode: 431705, min_days: 4, max_days: 5 },
{ pincode: 431708, min_days: 3, max_days: 4 },
{ pincode: 431709, min_days: 3, max_days: 4 },
{ pincode: 431714, min_days: 3, max_days: 4 },
{ pincode: 431716, min_days: 4, max_days: 5 },
{ pincode: 440001, min_days: 3, max_days: 4 },
{ pincode: 440002, min_days: 3, max_days: 4 },
{ pincode: 440003, min_days: 3, max_days: 4 },
{ pincode: 440004, min_days: 3, max_days: 4 },
{ pincode: 440005, min_days: 3, max_days: 4 },
{ pincode: 440006, min_days: 3, max_days: 4 },
{ pincode: 440007, min_days: 3, max_days: 4 },
{ pincode: 440008, min_days: 3, max_days: 4 },
{ pincode: 440009, min_days: 3, max_days: 4 },
{ pincode: 440010, min_days: 3, max_days: 4 },
{ pincode: 440011, min_days: 3, max_days: 4 },
{ pincode: 440012, min_days: 3, max_days: 4 },
{ pincode: 440013, min_days: 3, max_days: 4 },
{ pincode: 440014, min_days: 3, max_days: 4 },
{ pincode: 440015, min_days: 3, max_days: 4 },
{ pincode: 440016, min_days: 3, max_days: 4 },
{ pincode: 440017, min_days: 3, max_days: 4 },
{ pincode: 440018, min_days: 3, max_days: 4 },
{ pincode: 440019, min_days: 3, max_days: 4 },
{ pincode: 440020, min_days: 3, max_days: 4 },
{ pincode: 440021, min_days: 3, max_days: 4 },
{ pincode: 440022, min_days: 3, max_days: 4 },
{ pincode: 440023, min_days: 3, max_days: 4 },
{ pincode: 440024, min_days: 3, max_days: 4 },
{ pincode: 440025, min_days: 3, max_days: 4 },
{ pincode: 440026, min_days: 3, max_days: 4 },
{ pincode: 440027, min_days: 3, max_days: 4 },
{ pincode: 440028, min_days: 3, max_days: 4 },
{ pincode: 440029, min_days: 3, max_days: 4 },
{ pincode: 440030, min_days: 3, max_days: 4 },
{ pincode: 440032, min_days: 3, max_days: 4 },
{ pincode: 440033, min_days: 3, max_days: 4 },
{ pincode: 440034, min_days: 3, max_days: 4 },
{ pincode: 440035, min_days: 3, max_days: 4 },
{ pincode: 440036, min_days: 3, max_days: 4 },
{ pincode: 440037, min_days: 3, max_days: 4 },
{ pincode: 441001, min_days: 4, max_days: 5 },
{ pincode: 441002, min_days: 4, max_days: 5 },
{ pincode: 441102, min_days: 3, max_days: 4 },
{ pincode: 441104, min_days: 3, max_days: 4 },
{ pincode: 441105, min_days: 4, max_days: 5 },
{ pincode: 441106, min_days: 4, max_days: 5 },
{ pincode: 441107, min_days: 3, max_days: 4 },
{ pincode: 441108, min_days: 4, max_days: 5 },
{ pincode: 441109, min_days: 4, max_days: 5 },
{ pincode: 441110, min_days: 3, max_days: 4 },
{ pincode: 441111, min_days: 3, max_days: 4 },
{ pincode: 441113, min_days: 4, max_days: 5 },
{ pincode: 441122, min_days: 4, max_days: 5 },
{ pincode: 441203, min_days: 4, max_days: 5 },
{ pincode: 441204, min_days: 3, max_days: 4 },
{ pincode: 441301, min_days: 5, max_days: 6 },
{ pincode: 441302, min_days: 5, max_days: 6 },
{ pincode: 441304, min_days: 5, max_days: 6 },
{ pincode: 441305, min_days: 5, max_days: 6 },
{ pincode: 441401, min_days: 4, max_days: 5 },
{ pincode: 441404, min_days: 4, max_days: 5 },
{ pincode: 441501, min_days: 3, max_days: 4 },
{ pincode: 441502, min_days: 3, max_days: 4 },
{ pincode: 441601, min_days: 4, max_days: 5 },
{ pincode: 441612, min_days: 4, max_days: 5 },
{ pincode: 441614, min_days: 4, max_days: 5 },
{ pincode: 441801, min_days: 4, max_days: 5 },
{ pincode: 441807, min_days: 4, max_days: 5 },
{ pincode: 441904, min_days: 4, max_days: 5 },
{ pincode: 441906, min_days: 4, max_days: 5 },
{ pincode: 441911, min_days: 4, max_days: 5 },
{ pincode: 441916, min_days: 4, max_days: 5 },
{ pincode: 442001, min_days: 4, max_days: 5 },
{ pincode: 442006, min_days: 4, max_days: 5 },
{ pincode: 442102, min_days: 4, max_days: 5 },
{ pincode: 442202, min_days: 5, max_days: 6 },
{ pincode: 442301, min_days: 4, max_days: 5 },
{ pincode: 442304, min_days: 4, max_days: 5 },
{ pincode: 442305, min_days: 4, max_days: 5 },
{ pincode: 442307, min_days: 4, max_days: 5 },
{ pincode: 442401, min_days: 4, max_days: 5 },
{ pincode: 442402, min_days: 4, max_days: 5 },
{ pincode: 442403, min_days: 4, max_days: 5 },
{ pincode: 442404, min_days: 4, max_days: 5 },
{ pincode: 442501, min_days: 5, max_days: 6 },
{ pincode: 442605, min_days: 5, max_days: 6 },
{ pincode: 442701, min_days: 5, max_days: 6 },
{ pincode: 442901, min_days: 5, max_days: 6 },
{ pincode: 442902, min_days: 5, max_days: 6 },
{ pincode: 442905, min_days: 5, max_days: 6 },
{ pincode: 442907, min_days: 5, max_days: 6 },
{ pincode: 443101, min_days: 5, max_days: 6 },
{ pincode: 443103, min_days: 5, max_days: 6 },
{ pincode: 443112, min_days: 3, max_days: 4 },
{ pincode: 443204, min_days: 3, max_days: 4 },
{ pincode: 443404, min_days: 5, max_days: 6 },
{ pincode: 443405, min_days: 5, max_days: 6 },
{ pincode: 444001, min_days: 4, max_days: 5 },
{ pincode: 444002, min_days: 4, max_days: 5 },
{ pincode: 444003, min_days: 4, max_days: 5 },
{ pincode: 444004, min_days: 4, max_days: 5 },
{ pincode: 444005, min_days: 4, max_days: 5 },
{ pincode: 444006, min_days: 4, max_days: 5 },
{ pincode: 444104, min_days: 4, max_days: 5 },
{ pincode: 444105, min_days: 5, max_days: 6 },
{ pincode: 444107, min_days: 5, max_days: 6 },
{ pincode: 444302, min_days: 4, max_days: 5 },
{ pincode: 444303, min_days: 5, max_days: 6 },
{ pincode: 444312, min_days: 5, max_days: 6 },
{ pincode: 444402, min_days: 5, max_days: 6 },
{ pincode: 444403, min_days: 5, max_days: 6 },
{ pincode: 444503, min_days: 5, max_days: 6 },
{ pincode: 444504, min_days: 5, max_days: 6 },
{ pincode: 444505, min_days: 5, max_days: 6 },
{ pincode: 444506, min_days: 5, max_days: 6 },
{ pincode: 444507, min_days: 5, max_days: 6 },
{ pincode: 444601, min_days: 4, max_days: 5 },
{ pincode: 444602, min_days: 4, max_days: 5 },
{ pincode: 444603, min_days: 4, max_days: 5 },
{ pincode: 444604, min_days: 4, max_days: 5 },
{ pincode: 444605, min_days: 4, max_days: 5 },
{ pincode: 444606, min_days: 4, max_days: 5 },
{ pincode: 444607, min_days: 4, max_days: 5 },
{ pincode: 444701, min_days: 4, max_days: 5 },
{ pincode: 444704, min_days: 5, max_days: 6 },
{ pincode: 444705, min_days: 5, max_days: 6 },
{ pincode: 444708, min_days: 4, max_days: 5 },
{ pincode: 444709, min_days: 4, max_days: 5 },
{ pincode: 444717, min_days: 5, max_days: 6 },
{ pincode: 444801, min_days: 4, max_days: 5 },
{ pincode: 444803, min_days: 4, max_days: 5 },
{ pincode: 444805, min_days: 5, max_days: 6 },
{ pincode: 444806, min_days: 5, max_days: 6 },
{ pincode: 444807, min_days: 5, max_days: 6 },
{ pincode: 444901, min_days: 4, max_days: 5 },
{ pincode: 444904, min_days: 4, max_days: 5 },
{ pincode: 444905, min_days: 5, max_days: 6 },
{ pincode: 444906, min_days: 5, max_days: 6 },
{ pincode: 445001, min_days: 4, max_days: 5 },
{ pincode: 445002, min_days: 4, max_days: 5 },
{ pincode: 445103, min_days: 5, max_days: 6 },
{ pincode: 445105, min_days: 5, max_days: 6 },
{ pincode: 445106, min_days: 5, max_days: 6 },
{ pincode: 445204, min_days: 5, max_days: 6 },
{ pincode: 445208, min_days: 4, max_days: 5 },
{ pincode: 445215, min_days: 5, max_days: 6 },
{ pincode: 450001, min_days: 3, max_days: 4 },
{ pincode: 450051, min_days: 3, max_days: 4 },
{ pincode: 450110, min_days: 3, max_days: 4 },
{ pincode: 450112, min_days: 3, max_days: 4 },
{ pincode: 450113, min_days: 3, max_days: 4 },
{ pincode: 450116, min_days: 3, max_days: 4 },
{ pincode: 450117, min_days: 3, max_days: 4 },
{ pincode: 450331, min_days: 3, max_days: 4 },
{ pincode: 450445, min_days: 3, max_days: 4 },
{ pincode: 451001, min_days: 3, max_days: 4 },
{ pincode: 451111, min_days: 3, max_days: 4 },
{ pincode: 451113, min_days: 3, max_days: 4 },
{ pincode: 451115, min_days: 3, max_days: 4 },
{ pincode: 451220, min_days: 3, max_days: 4 },
{ pincode: 451221, min_days: 3, max_days: 4 },
{ pincode: 451224, min_days: 3, max_days: 4 },
{ pincode: 451225, min_days: 3, max_days: 4 },
{ pincode: 451228, min_days: 3, max_days: 4 },
{ pincode: 451331, min_days: 3, max_days: 4 },
{ pincode: 451332, min_days: 3, max_days: 4 },
{ pincode: 451335, min_days: 3, max_days: 4 },
{ pincode: 451440, min_days: 3, max_days: 4 },
{ pincode: 451442, min_days: 3, max_days: 4 },
{ pincode: 451447, min_days: 3, max_days: 4 },
{ pincode: 451449, min_days: 3, max_days: 4 },
{ pincode: 451551, min_days: 3, max_days: 4 },
{ pincode: 451556, min_days: 3, max_days: 4 },
{ pincode: 451660, min_days: 3, max_days: 4 },
{ pincode: 451666, min_days: 3, max_days: 4 },
{ pincode: 451770, min_days: 3, max_days: 4 },
{ pincode: 452001, min_days: 3, max_days: 4 },
{ pincode: 452002, min_days: 3, max_days: 4 },
{ pincode: 452003, min_days: 3, max_days: 4 },
{ pincode: 452004, min_days: 3, max_days: 4 },
{ pincode: 452005, min_days: 3, max_days: 4 },
{ pincode: 452006, min_days: 3, max_days: 4 },
{ pincode: 452007, min_days: 3, max_days: 4 },
{ pincode: 452008, min_days: 3, max_days: 4 },
{ pincode: 452009, min_days: 3, max_days: 4 },
{ pincode: 452010, min_days: 3, max_days: 4 },
{ pincode: 452011, min_days: 3, max_days: 4 },
{ pincode: 452012, min_days: 3, max_days: 4 },
{ pincode: 452013, min_days: 3, max_days: 4 },
{ pincode: 452014, min_days: 3, max_days: 4 },
{ pincode: 452015, min_days: 3, max_days: 4 },
{ pincode: 452016, min_days: 3, max_days: 4 },
{ pincode: 452017, min_days: 3, max_days: 4 },
{ pincode: 452018, min_days: 3, max_days: 4 },
{ pincode: 452019, min_days: 3, max_days: 4 },
{ pincode: 452020, min_days: 3, max_days: 4 },
{ pincode: 453001, min_days: 3, max_days: 4 },
{ pincode: 453111, min_days: 3, max_days: 4 },
{ pincode: 453112, min_days: 3, max_days: 4 },
{ pincode: 453115, min_days: 3, max_days: 4 },
{ pincode: 453220, min_days: 3, max_days: 4 },
{ pincode: 453331, min_days: 3, max_days: 4 },
{ pincode: 453441, min_days: 3, max_days: 4 },
{ pincode: 453551, min_days: 3, max_days: 4 },
{ pincode: 453555, min_days: 3, max_days: 4 },
{ pincode: 453556, min_days: 3, max_days: 4 },
{ pincode: 453771, min_days: 3, max_days: 4 },
{ pincode: 454001, min_days: 3, max_days: 4 },
{ pincode: 454111, min_days: 3, max_days: 4 },
{ pincode: 454116, min_days: 3, max_days: 4 },
{ pincode: 454331, min_days: 3, max_days: 4 },
{ pincode: 454335, min_days: 3, max_days: 4 },
{ pincode: 454441, min_days: 3, max_days: 4 },
{ pincode: 454446, min_days: 3, max_days: 4 },
{ pincode: 454449, min_days: 3, max_days: 4 },
{ pincode: 454552, min_days: 3, max_days: 4 },
{ pincode: 454660, min_days: 3, max_days: 4 },
{ pincode: 454665, min_days: 3, max_days: 4 },
{ pincode: 454772, min_days: 3, max_days: 4 },
{ pincode: 454773, min_days: 3, max_days: 4 },
{ pincode: 454774, min_days: 3, max_days: 4 },
{ pincode: 454775, min_days: 3, max_days: 4 },
{ pincode: 455001, min_days: 3, max_days: 4 },
{ pincode: 455003, min_days: 3, max_days: 4 },
{ pincode: 455111, min_days: 3, max_days: 4 },
{ pincode: 455115, min_days: 3, max_days: 4 },
{ pincode: 455116, min_days: 3, max_days: 4 },
{ pincode: 455118, min_days: 3, max_days: 4 },
{ pincode: 455223, min_days: 3, max_days: 4 },
{ pincode: 455227, min_days: 3, max_days: 4 },
{ pincode: 455332, min_days: 4, max_days: 5 },
{ pincode: 455336, min_days: 4, max_days: 5 },
{ pincode: 456001, min_days: 3, max_days: 4 },
{ pincode: 456003, min_days: 3, max_days: 4 },
{ pincode: 456006, min_days: 3, max_days: 4 },
{ pincode: 456010, min_days: 3, max_days: 4 },
{ pincode: 456221, min_days: 3, max_days: 4 },
{ pincode: 456224, min_days: 3, max_days: 4 },
{ pincode: 456313, min_days: 3, max_days: 4 },
{ pincode: 456331, min_days: 3, max_days: 4 },
{ pincode: 456335, min_days: 3, max_days: 4 },
{ pincode: 456440, min_days: 3, max_days: 4 },
{ pincode: 456443, min_days: 3, max_days: 4 },
{ pincode: 456665, min_days: 3, max_days: 4 },
{ pincode: 456770, min_days: 3, max_days: 4 },
{ pincode: 456771, min_days: 3, max_days: 4 },
{ pincode: 457001, min_days: 3, max_days: 4 },
{ pincode: 457112, min_days: 3, max_days: 4 },
{ pincode: 457114, min_days: 3, max_days: 4 },
{ pincode: 457226, min_days: 3, max_days: 4 },
{ pincode: 457661, min_days: 3, max_days: 4 },
{ pincode: 457773, min_days: 3, max_days: 4 },
{ pincode: 457775, min_days: 3, max_days: 4 },
{ pincode: 457777, min_days: 3, max_days: 4 },
{ pincode: 457779, min_days: 3, max_days: 4 },
{ pincode: 457882, min_days: 3, max_days: 4 },
{ pincode: 457887, min_days: 3, max_days: 4 },
{ pincode: 457888, min_days: 3, max_days: 4 },
{ pincode: 457990, min_days: 3, max_days: 4 },
{ pincode: 457993, min_days: 3, max_days: 4 },
{ pincode: 458001, min_days: 3, max_days: 4 },
{ pincode: 458002, min_days: 4, max_days: 5 },
{ pincode: 458110, min_days: 4, max_days: 5 },
{ pincode: 458118, min_days: 4, max_days: 5 },
{ pincode: 458330, min_days: 4, max_days: 5 },
{ pincode: 458441, min_days: 3, max_days: 4 },
{ pincode: 458468, min_days: 4, max_days: 5 },
{ pincode: 458470, min_days: 4, max_days: 5 },
{ pincode: 458556, min_days: 4, max_days: 5 },
{ pincode: 458664, min_days: 4, max_days: 5 },
{ pincode: 458667, min_days: 4, max_days: 5 },
{ pincode: 460001, min_days: 3, max_days: 4 },
{ pincode: 460002, min_days: 3, max_days: 4 },
{ pincode: 460004, min_days: 3, max_days: 4 },
{ pincode: 460005, min_days: 3, max_days: 4 },
{ pincode: 460110, min_days: 3, max_days: 4 },
{ pincode: 460225, min_days: 3, max_days: 4 },
{ pincode: 460330, min_days: 3, max_days: 4 },
{ pincode: 460440, min_days: 3, max_days: 4 },
{ pincode: 460443, min_days: 3, max_days: 4 },
{ pincode: 460447, min_days: 3, max_days: 4 },
{ pincode: 460449, min_days: 3, max_days: 4 },
{ pincode: 460551, min_days: 4, max_days: 5 },
{ pincode: 460553, min_days: 4, max_days: 5 },
{ pincode: 460661, min_days: 4, max_days: 5 },
{ pincode: 460668, min_days: 4, max_days: 5 },
{ pincode: 461001, min_days: 3, max_days: 4 },
{ pincode: 461005, min_days: 3, max_days: 4 },
{ pincode: 461110, min_days: 3, max_days: 4 },
{ pincode: 461111, min_days: 3, max_days: 4 },
{ pincode: 461114, min_days: 3, max_days: 4 },
{ pincode: 461115, min_days: 3, max_days: 4 },
{ pincode: 461116, min_days: 3, max_days: 4 },
{ pincode: 461122, min_days: 3, max_days: 4 },
{ pincode: 461221, min_days: 3, max_days: 4 },
{ pincode: 461223, min_days: 3, max_days: 4 },
{ pincode: 461331, min_days: 3, max_days: 4 },
{ pincode: 461441, min_days: 3, max_days: 4 },
{ pincode: 461446, min_days: 3, max_days: 4 },
{ pincode: 461551, min_days: 3, max_days: 4 },
{ pincode: 461661, min_days: 3, max_days: 4 },
{ pincode: 461771, min_days: 3, max_days: 4 },
{ pincode: 461775, min_days: 3, max_days: 4 },
{ pincode: 461881, min_days: 3, max_days: 4 },
{ pincode: 461990, min_days: 3, max_days: 4 },
{ pincode: 462001, min_days: 3, max_days: 4 },
{ pincode: 462002, min_days: 3, max_days: 4 },
{ pincode: 462003, min_days: 3, max_days: 4 },
{ pincode: 462004, min_days: 3, max_days: 4 },
{ pincode: 462007, min_days: 3, max_days: 4 },
{ pincode: 462008, min_days: 3, max_days: 4 },
{ pincode: 462010, min_days: 3, max_days: 4 },
{ pincode: 462011, min_days: 3, max_days: 4 },
{ pincode: 462012, min_days: 3, max_days: 4 },
{ pincode: 462013, min_days: 3, max_days: 4 },
{ pincode: 462016, min_days: 3, max_days: 4 },
{ pincode: 462018, min_days: 3, max_days: 4 },
{ pincode: 462020, min_days: 3, max_days: 4 },
{ pincode: 462021, min_days: 3, max_days: 4 },
{ pincode: 462022, min_days: 3, max_days: 4 },
{ pincode: 462023, min_days: 3, max_days: 4 },
{ pincode: 462024, min_days: 3, max_days: 4 },
{ pincode: 462026, min_days: 3, max_days: 4 },
{ pincode: 462027, min_days: 3, max_days: 4 },
{ pincode: 462030, min_days: 4, max_days: 5 },
{ pincode: 462031, min_days: 3, max_days: 4 },
{ pincode: 462032, min_days: 3, max_days: 4 },
{ pincode: 462033, min_days: 3, max_days: 4 },
{ pincode: 462036, min_days: 3, max_days: 4 },
{ pincode: 462037, min_days: 3, max_days: 4 },
{ pincode: 462038, min_days: 3, max_days: 4 },
{ pincode: 462039, min_days: 3, max_days: 4 },
{ pincode: 462040, min_days: 3, max_days: 4 },
{ pincode: 462041, min_days: 3, max_days: 4 },
{ pincode: 462042, min_days: 3, max_days: 4 },
{ pincode: 462043, min_days: 3, max_days: 4 },
{ pincode: 462044, min_days: 3, max_days: 4 },
{ pincode: 462045, min_days: 3, max_days: 4 },
{ pincode: 462046, min_days: 3, max_days: 4 },
{ pincode: 462047, min_days: 3, max_days: 4 },
{ pincode: 462066, min_days: 4, max_days: 5 },
{ pincode: 462100, min_days: 4, max_days: 5 },
{ pincode: 462101, min_days: 4, max_days: 5 },
{ pincode: 463106, min_days: 4, max_days: 5 },
{ pincode: 464001, min_days: 3, max_days: 4 },
{ pincode: 464002, min_days: 3, max_days: 4 },
{ pincode: 464221, min_days: 3, max_days: 4 },
{ pincode: 464224, min_days: 4, max_days: 5 },
{ pincode: 464226, min_days: 3, max_days: 4 },
{ pincode: 464228, min_days: 3, max_days: 4 },
{ pincode: 464331, min_days: 3, max_days: 4 },
{ pincode: 464334, min_days: 3, max_days: 4 },
{ pincode: 464337, min_days: 4, max_days: 5 },
{ pincode: 464551, min_days: 3, max_days: 4 },
{ pincode: 464570, min_days: 3, max_days: 4 },
{ pincode: 464661, min_days: 3, max_days: 4 },
{ pincode: 464884, min_days: 3, max_days: 4 },
{ pincode: 464986, min_days: 3, max_days: 4 },
{ pincode: 464990, min_days: 3, max_days: 4 },
{ pincode: 464993, min_days: 3, max_days: 4 },
{ pincode: 465001, min_days: 3, max_days: 4 },
{ pincode: 465106, min_days: 3, max_days: 4 },
{ pincode: 465110, min_days: 3, max_days: 4 },
{ pincode: 465223, min_days: 3, max_days: 4 },
{ pincode: 465333, min_days: 3, max_days: 4 },
{ pincode: 465337, min_days: 3, max_days: 4 },
{ pincode: 465339, min_days: 3, max_days: 4 },
{ pincode: 465441, min_days: 3, max_days: 4 },
{ pincode: 465445, min_days: 3, max_days: 4 },
{ pincode: 465447, min_days: 3, max_days: 4 },
{ pincode: 465550, min_days: 3, max_days: 4 },
{ pincode: 465661, min_days: 3, max_days: 4 },
{ pincode: 465667, min_days: 3, max_days: 4 },
{ pincode: 465669, min_days: 3, max_days: 4 },
{ pincode: 465674, min_days: 3, max_days: 4 },
{ pincode: 465677, min_days: 3, max_days: 4 },
{ pincode: 465679, min_days: 3, max_days: 4 },
{ pincode: 465683, min_days: 3, max_days: 4 },
{ pincode: 465685, min_days: 3, max_days: 4 },
{ pincode: 465697, min_days: 3, max_days: 4 },
{ pincode: 466001, min_days: 3, max_days: 4 },
{ pincode: 466114, min_days: 3, max_days: 4 },
{ pincode: 466115, min_days: 3, max_days: 4 },
{ pincode: 466116, min_days: 3, max_days: 4 },
{ pincode: 466331, min_days: 3, max_days: 4 },
{ pincode: 466445, min_days: 3, max_days: 4 },
{ pincode: 466446, min_days: 3, max_days: 4 },
{ pincode: 466651, min_days: 3, max_days: 4 },
{ pincode: 466661, min_days: 3, max_days: 4 },
{ pincode: 466666, min_days: 2, max_days: 3 },
{ pincode: 470001, min_days: 3, max_days: 4 },
{ pincode: 470002, min_days: 3, max_days: 4 },
{ pincode: 470003, min_days: 3, max_days: 4 },
{ pincode: 470004, min_days: 3, max_days: 4 },
{ pincode: 470005, min_days: 3, max_days: 4 },
{ pincode: 470021, min_days: 3, max_days: 4 },
{ pincode: 470051, min_days: 3, max_days: 4 },
{ pincode: 470113, min_days: 4, max_days: 5 },
{ pincode: 470115, min_days: 4, max_days: 5 },
{ pincode: 470117, min_days: 4, max_days: 5 },
{ pincode: 470120, min_days: 3, max_days: 4 },
{ pincode: 470124, min_days: 4, max_days: 5 },
{ pincode: 470221, min_days: 3, max_days: 4 },
{ pincode: 470223, min_days: 3, max_days: 4 },
{ pincode: 470226, min_days: 3, max_days: 4 },
{ pincode: 470227, min_days: 3, max_days: 4 },
{ pincode: 470228, min_days: 3, max_days: 4 },
{ pincode: 470229, min_days: 3, max_days: 4 },
{ pincode: 470335, min_days: 3, max_days: 4 },
{ pincode: 470337, min_days: 3, max_days: 4 },
{ pincode: 470339, min_days: 3, max_days: 4 },
{ pincode: 470442, min_days: 3, max_days: 4 },
{ pincode: 470661, min_days: 3, max_days: 4 },
{ pincode: 470666, min_days: 3, max_days: 4 },
{ pincode: 470672, min_days: 3, max_days: 4 },
{ pincode: 470675, min_days: 3, max_days: 4 },
{ pincode: 470775, min_days: 3, max_days: 4 },
{ pincode: 471001, min_days: 3, max_days: 4 },
{ pincode: 471111, min_days: 3, max_days: 4 },
{ pincode: 471201, min_days: 3, max_days: 4 },
{ pincode: 471301, min_days: 3, max_days: 4 },
{ pincode: 471311, min_days: 3, max_days: 4 },
{ pincode: 471405, min_days: 3, max_days: 4 },
{ pincode: 471501, min_days: 3, max_days: 4 },
{ pincode: 471515, min_days: 4, max_days: 5 },
{ pincode: 471525, min_days: 4, max_days: 5 },
{ pincode: 471606, min_days: 4, max_days: 5 },
{ pincode: 471625, min_days: 4, max_days: 5 },
{ pincode: 472001, min_days: 4, max_days: 5 },
{ pincode: 472115, min_days: 4, max_days: 5 },
{ pincode: 472118, min_days: 4, max_days: 5 },
{ pincode: 472221, min_days: 4, max_days: 5 },
{ pincode: 472246, min_days: 4, max_days: 5 },
{ pincode: 472336, min_days: 4, max_days: 5 },
{ pincode: 472442, min_days: 4, max_days: 5 },
{ pincode: 473001, min_days: 4, max_days: 5 },
{ pincode: 473002, min_days: 4, max_days: 5 },
{ pincode: 473101, min_days: 4, max_days: 5 },
{ pincode: 473110, min_days: 5, max_days: 6 },
{ pincode: 473111, min_days: 5, max_days: 6 },
{ pincode: 473112, min_days: 5, max_days: 6 },
{ pincode: 473115, min_days: 3, max_days: 4 },
{ pincode: 473222, min_days: 5, max_days: 6 },
{ pincode: 473226, min_days: 5, max_days: 6 },
{ pincode: 473331, min_days: 4, max_days: 5 },
{ pincode: 473335, min_days: 4, max_days: 5 },
{ pincode: 473443, min_days: 4, max_days: 5 },
{ pincode: 473446, min_days: 4, max_days: 5 },
{ pincode: 473551, min_days: 4, max_days: 5 },
{ pincode: 473638, min_days: 4, max_days: 5 },
{ pincode: 473660, min_days: 4, max_days: 5 },
{ pincode: 473885, min_days: 4, max_days: 5 },
{ pincode: 473995, min_days: 4, max_days: 5 },
{ pincode: 474001, min_days: 3, max_days: 4 },
{ pincode: 474002, min_days: 3, max_days: 4 },
{ pincode: 474003, min_days: 3, max_days: 4 },
{ pincode: 474004, min_days: 3, max_days: 4 },
{ pincode: 474005, min_days: 3, max_days: 4 },
{ pincode: 474006, min_days: 3, max_days: 4 },
{ pincode: 474007, min_days: 3, max_days: 4 },
{ pincode: 474008, min_days: 3, max_days: 4 },
{ pincode: 474009, min_days: 3, max_days: 4 },
{ pincode: 474010, min_days: 3, max_days: 4 },
{ pincode: 474011, min_days: 3, max_days: 4 },
{ pincode: 474012, min_days: 3, max_days: 4 },
{ pincode: 474015, min_days: 3, max_days: 4 },
{ pincode: 474020, min_days: 3, max_days: 4 },
{ pincode: 475005, min_days: 4, max_days: 5 },
{ pincode: 475110, min_days: 4, max_days: 5 },
{ pincode: 475115, min_days: 4, max_days: 5 },
{ pincode: 475335, min_days: 4, max_days: 5 },
{ pincode: 475661, min_days: 4, max_days: 5 },
{ pincode: 476001, min_days: 4, max_days: 5 },
{ pincode: 476111, min_days: 4, max_days: 5 },
{ pincode: 476115, min_days: 4, max_days: 5 },
{ pincode: 476221, min_days: 4, max_days: 5 },
{ pincode: 476224, min_days: 4, max_days: 5 },
{ pincode: 476229, min_days: 4, max_days: 5 },
{ pincode: 476337, min_days: 5, max_days: 6 },
{ pincode: 477001, min_days: 4, max_days: 5 },
{ pincode: 477116, min_days: 3, max_days: 4 },
{ pincode: 477117, min_days: 3, max_days: 4 },
{ pincode: 477441, min_days: 4, max_days: 5 },
{ pincode: 477445, min_days: 4, max_days: 5 },
{ pincode: 477660, min_days: 4, max_days: 5 },
{ pincode: 480001, min_days: 3, max_days: 4 },
{ pincode: 480002, min_days: 3, max_days: 4 },
{ pincode: 480105, min_days: 4, max_days: 5 },
{ pincode: 480106, min_days: 4, max_days: 5 },
{ pincode: 480107, min_days: 3, max_days: 4 },
{ pincode: 480108, min_days: 4, max_days: 5 },
{ pincode: 480112, min_days: 3, max_days: 4 },
{ pincode: 480115, min_days: 3, max_days: 4 },
{ pincode: 480334, min_days: 4, max_days: 5 },
{ pincode: 480337, min_days: 4, max_days: 5 },
{ pincode: 480441, min_days: 3, max_days: 4 },
{ pincode: 480551, min_days: 3, max_days: 4 },
{ pincode: 480661, min_days: 4, max_days: 5 },
{ pincode: 480667, min_days: 4, max_days: 5 },
{ pincode: 480880, min_days: 4, max_days: 5 },
{ pincode: 480882, min_days: 4, max_days: 5 },
{ pincode: 480884, min_days: 4, max_days: 5 },
{ pincode: 480886, min_days: 4, max_days: 5 },
{ pincode: 480888, min_days: 4, max_days: 5 },
{ pincode: 480990, min_days: 4, max_days: 5 },
{ pincode: 480991, min_days: 4, max_days: 5 },
{ pincode: 480994, min_days: 4, max_days: 5 },
{ pincode: 480997, min_days: 4, max_days: 5 },
{ pincode: 481001, min_days: 4, max_days: 5 },
{ pincode: 481102, min_days: 4, max_days: 5 },
{ pincode: 481115, min_days: 4, max_days: 5 },
{ pincode: 481224, min_days: 4, max_days: 5 },
{ pincode: 481226, min_days: 4, max_days: 5 },
{ pincode: 481331, min_days: 4, max_days: 5 },
{ pincode: 481332, min_days: 4, max_days: 5 },
{ pincode: 481335, min_days: 4, max_days: 5 },
{ pincode: 481337, min_days: 4, max_days: 5 },
{ pincode: 481441, min_days: 4, max_days: 5 },
{ pincode: 481661, min_days: 4, max_days: 5 },
{ pincode: 481879, min_days: 5, max_days: 6 },
{ pincode: 481880, min_days: 5, max_days: 6 },
{ pincode: 481882, min_days: 5, max_days: 6 },
{ pincode: 481883, min_days: 5, max_days: 6 },
{ pincode: 481884, min_days: 5, max_days: 6 },
{ pincode: 481990, min_days: 5, max_days: 6 },
{ pincode: 482001, min_days: 4, max_days: 5 },
{ pincode: 482002, min_days: 4, max_days: 5 },
{ pincode: 482003, min_days: 4, max_days: 5 },
{ pincode: 482004, min_days: 4, max_days: 5 },
{ pincode: 482005, min_days: 4, max_days: 5 },
{ pincode: 482006, min_days: 4, max_days: 5 },
{ pincode: 482007, min_days: 4, max_days: 5 },
{ pincode: 482008, min_days: 4, max_days: 5 },
{ pincode: 482009, min_days: 4, max_days: 5 },
{ pincode: 482010, min_days: 4, max_days: 5 },
{ pincode: 482011, min_days: 4, max_days: 5 },
{ pincode: 482020, min_days: 4, max_days: 5 },
{ pincode: 482021, min_days: 5, max_days: 6 },
{ pincode: 482051, min_days: 5, max_days: 6 },
{ pincode: 482056, min_days: 5, max_days: 6 },
{ pincode: 483053, min_days: 5, max_days: 6 },
{ pincode: 483119, min_days: 5, max_days: 6 },
{ pincode: 483220, min_days: 5, max_days: 6 },
{ pincode: 483222, min_days: 4, max_days: 5 },
{ pincode: 483225, min_days: 4, max_days: 5 },
{ pincode: 483334, min_days: 4, max_days: 5 },
{ pincode: 483336, min_days: 4, max_days: 5 },
{ pincode: 483501, min_days: 4, max_days: 5 },
{ pincode: 483503, min_days: 4, max_days: 5 },
{ pincode: 483504, min_days: 4, max_days: 5 },
{ pincode: 483770, min_days: 4, max_days: 5 },
{ pincode: 483775, min_days: 4, max_days: 5 },
{ pincode: 483880, min_days: 4, max_days: 5 },
{ pincode: 484001, min_days: 4, max_days: 5 },
{ pincode: 484110, min_days: 4, max_days: 5 },
{ pincode: 484114, min_days: 4, max_days: 5 },
{ pincode: 484116, min_days: 4, max_days: 5 },
{ pincode: 484117, min_days: 4, max_days: 5 },
{ pincode: 484120, min_days: 4, max_days: 5 },
{ pincode: 484220, min_days: 4, max_days: 5 },
{ pincode: 484224, min_days: 4, max_days: 5 },
{ pincode: 484330, min_days: 4, max_days: 5 },
{ pincode: 484334, min_days: 4, max_days: 5 },
{ pincode: 484336, min_days: 4, max_days: 5 },
{ pincode: 484440, min_days: 4, max_days: 5 },
{ pincode: 484444, min_days: 4, max_days: 5 },
{ pincode: 484551, min_days: 4, max_days: 5 },
{ pincode: 484555, min_days: 4, max_days: 5 },
{ pincode: 484661, min_days: 4, max_days: 5 },
{ pincode: 484771, min_days: 5, max_days: 6 },
{ pincode: 484774, min_days: 5, max_days: 6 },
{ pincode: 484776, min_days: 5, max_days: 6 },
{ pincode: 485001, min_days: 4, max_days: 5 },
{ pincode: 485002, min_days: 4, max_days: 5 },
{ pincode: 485003, min_days: 4, max_days: 5 },
{ pincode: 485004, min_days: 4, max_days: 5 },
{ pincode: 485005, min_days: 4, max_days: 5 },
{ pincode: 485111, min_days: 4, max_days: 5 },
{ pincode: 485112, min_days: 4, max_days: 5 },
{ pincode: 485113, min_days: 4, max_days: 5 },
{ pincode: 485114, min_days: 4, max_days: 5 },
{ pincode: 485221, min_days: 4, max_days: 5 },
{ pincode: 485226, min_days: 4, max_days: 5 },
{ pincode: 485441, min_days: 4, max_days: 5 },
{ pincode: 485446, min_days: 4, max_days: 5 },
{ pincode: 485661, min_days: 4, max_days: 5 },
{ pincode: 485666, min_days: 4, max_days: 5 },
{ pincode: 485771, min_days: 4, max_days: 5 },
{ pincode: 485772, min_days: 4, max_days: 5 },
{ pincode: 485773, min_days: 4, max_days: 5 },
{ pincode: 485774, min_days: 4, max_days: 5 },
{ pincode: 485775, min_days: 4, max_days: 5 },
{ pincode: 486001, min_days: 4, max_days: 5 },
{ pincode: 486002, min_days: 4, max_days: 5 },
{ pincode: 486003, min_days: 4, max_days: 5 },
{ pincode: 486005, min_days: 4, max_days: 5 },
{ pincode: 486006, min_days: 4, max_days: 5 },
{ pincode: 486111, min_days: 4, max_days: 5 },
{ pincode: 486335, min_days: 5, max_days: 6 },
{ pincode: 486338, min_days: 4, max_days: 5 },
{ pincode: 486341, min_days: 4, max_days: 5 },
{ pincode: 486440, min_days: 4, max_days: 5 },
{ pincode: 486441, min_days: 4, max_days: 5 },
{ pincode: 486446, min_days: 4, max_days: 5 },
{ pincode: 486450, min_days: 4, max_days: 5 },
{ pincode: 486550, min_days: 4, max_days: 5 },
{ pincode: 486661, min_days: 5, max_days: 6 },
{ pincode: 486669, min_days: 5, max_days: 6 },
{ pincode: 486670, min_days: 5, max_days: 6 },
{ pincode: 486675, min_days: 5, max_days: 6 },
{ pincode: 486771, min_days: 5, max_days: 6 },
{ pincode: 486775, min_days: 5, max_days: 6 },
{ pincode: 486884, min_days: 5, max_days: 6 },
{ pincode: 486885, min_days: 5, max_days: 6 },
{ pincode: 486886, min_days: 5, max_days: 6 },
{ pincode: 486887, min_days: 5, max_days: 6 },
{ pincode: 486888, min_days: 5, max_days: 6 },
{ pincode: 486889, min_days: 5, max_days: 6 },
{ pincode: 486890, min_days: 5, max_days: 6 },
{ pincode: 486892, min_days: 5, max_days: 6 },
{ pincode: 487001, min_days: 4, max_days: 5 },
{ pincode: 487110, min_days: 4, max_days: 5 },
{ pincode: 487114, min_days: 4, max_days: 5 },
{ pincode: 487118, min_days: 4, max_days: 5 },
{ pincode: 487221, min_days: 4, max_days: 5 },
{ pincode: 487330, min_days: 4, max_days: 5 },
{ pincode: 487334, min_days: 4, max_days: 5 },
{ pincode: 487337, min_days: 4, max_days: 5 },
{ pincode: 487551, min_days: 4, max_days: 5 },
{ pincode: 487555, min_days: 4, max_days: 5 },
{ pincode: 487661, min_days: 4, max_days: 5 },
{ pincode: 487770, min_days: 4, max_days: 5 },
{ pincode: 487881, min_days: 4, max_days: 5 },
{ pincode: 488001, min_days: 4, max_days: 5 },
{ pincode: 488333, min_days: 4, max_days: 5 },
{ pincode: 488888, min_days: 2, max_days: 3 },
{ pincode: 490001, min_days: 3, max_days: 4 },
{ pincode: 490006, min_days: 3, max_days: 4 },
{ pincode: 490009, min_days: 3, max_days: 4 },
{ pincode: 490011, min_days: 3, max_days: 4 },
{ pincode: 490012, min_days: 3, max_days: 4 },
{ pincode: 490013, min_days: 3, max_days: 4 },
{ pincode: 490020, min_days: 3, max_days: 4 },
{ pincode: 490021, min_days: 3, max_days: 4 },
{ pincode: 490022, min_days: 3, max_days: 4 },
{ pincode: 490023, min_days: 3, max_days: 4 },
{ pincode: 490024, min_days: 3, max_days: 4 },
{ pincode: 490025, min_days: 3, max_days: 4 },
{ pincode: 490026, min_days: 3, max_days: 4 },
{ pincode: 490027, min_days: 3, max_days: 4 },
{ pincode: 490036, min_days: 3, max_days: 4 },
{ pincode: 490042, min_days: 3, max_days: 4 },
{ pincode: 491001, min_days: 3, max_days: 4 },
{ pincode: 491002, min_days: 3, max_days: 4 },
{ pincode: 491107, min_days: 3, max_days: 4 },
{ pincode: 491227, min_days: 4, max_days: 5 },
{ pincode: 491331, min_days: 3, max_days: 4 },
{ pincode: 491441, min_days: 4, max_days: 5 },
{ pincode: 492001, min_days: 3, max_days: 4 },
{ pincode: 492002, min_days: 3, max_days: 4 },
{ pincode: 492003, min_days: 3, max_days: 4 },
{ pincode: 492004, min_days: 3, max_days: 4 },
{ pincode: 492005, min_days: 3, max_days: 4 },
{ pincode: 492006, min_days: 3, max_days: 4 },
{ pincode: 492007, min_days: 3, max_days: 4 },
{ pincode: 492008, min_days: 3, max_days: 4 },
{ pincode: 492009, min_days: 3, max_days: 4 },
{ pincode: 492010, min_days: 3, max_days: 4 },
{ pincode: 492012, min_days: 3, max_days: 4 },
{ pincode: 492013, min_days: 3, max_days: 4 },
{ pincode: 492014, min_days: 3, max_days: 4 },
{ pincode: 492015, min_days: 3, max_days: 4 },
{ pincode: 492099, min_days: 3, max_days: 4 },
{ pincode: 493114, min_days: 4, max_days: 5 },
{ pincode: 493118, min_days: 4, max_days: 5 },
{ pincode: 493221, min_days: 3, max_days: 4 },
{ pincode: 493770, min_days: 4, max_days: 5 },
{ pincode: 493773, min_days: 4, max_days: 5 },
{ pincode: 493776, min_days: 4, max_days: 5 },
{ pincode: 494001, min_days: 4, max_days: 5 },
{ pincode: 495001, min_days: 3, max_days: 4 },
{ pincode: 495004, min_days: 3, max_days: 4 },
{ pincode: 495005, min_days: 3, max_days: 4 },
{ pincode: 495006, min_days: 3, max_days: 4 },
{ pincode: 495009, min_days: 3, max_days: 4 },
{ pincode: 495220, min_days: 3, max_days: 4 },
{ pincode: 495223, min_days: 3, max_days: 4 },
{ pincode: 495450, min_days: 4, max_days: 5 },
{ pincode: 495454, min_days: 4, max_days: 5 },
{ pincode: 495551, min_days: 3, max_days: 4 },
{ pincode: 495557, min_days: 4, max_days: 5 },
{ pincode: 495671, min_days: 4, max_days: 5 },
{ pincode: 495677, min_days: 4, max_days: 5 },
{ pincode: 495678, min_days: 4, max_days: 5 },
{ pincode: 495684, min_days: 4, max_days: 5 },
{ pincode: 495689, min_days: 4, max_days: 5 },
{ pincode: 495690, min_days: 4, max_days: 5 },
{ pincode: 496001, min_days: 4, max_days: 5 },
{ pincode: 496005, min_days: 4, max_days: 5 },
{ pincode: 497001, min_days: 4, max_days: 5 },
{ pincode: 497101, min_days: 4, max_days: 5 },
{ pincode: 497226, min_days: 4, max_days: 5 },
{ pincode: 499999, min_days: 2, max_days: 3 },
{ pincode: 500000, min_days: 2, max_days: 3 },
{ pincode: 500001, min_days: 2, max_days: 3 },
{ pincode: 500002, min_days: 2, max_days: 3 },
{ pincode: 500003, min_days: 2, max_days: 3 },
{ pincode: 500004, min_days: 2, max_days: 3 },
{ pincode: 500005, min_days: 2, max_days: 3 },
{ pincode: 500006, min_days: 2, max_days: 3 },
{ pincode: 500007, min_days: 2, max_days: 3 },
{ pincode: 500008, min_days: 2, max_days: 3 },
{ pincode: 500009, min_days: 2, max_days: 3 },
{ pincode: 500010, min_days: 2, max_days: 3 },
{ pincode: 500011, min_days: 2, max_days: 3 },
{ pincode: 500012, min_days: 2, max_days: 3 },
{ pincode: 500013, min_days: 2, max_days: 3 },
{ pincode: 500014, min_days: 2, max_days: 3 },
{ pincode: 500015, min_days: 2, max_days: 3 },
{ pincode: 500016, min_days: 2, max_days: 3 },
{ pincode: 500017, min_days: 2, max_days: 3 },
{ pincode: 500018, min_days: 2, max_days: 3 },
{ pincode: 500019, min_days: 2, max_days: 3 },
{ pincode: 500020, min_days: 2, max_days: 3 },
{ pincode: 500021, min_days: 2, max_days: 3 },
{ pincode: 500022, min_days: 2, max_days: 3 },
{ pincode: 500023, min_days: 2, max_days: 3 },
{ pincode: 500024, min_days: 2, max_days: 3 },
{ pincode: 500025, min_days: 2, max_days: 3 },
{ pincode: 500026, min_days: 2, max_days: 3 },
{ pincode: 500027, min_days: 2, max_days: 3 },
{ pincode: 500028, min_days: 2, max_days: 3 },
{ pincode: 500029, min_days: 2, max_days: 3 },
{ pincode: 500030, min_days: 2, max_days: 3 },
{ pincode: 500031, min_days: 2, max_days: 3 },
{ pincode: 500032, min_days: 2, max_days: 3 },
{ pincode: 500033, min_days: 2, max_days: 3 },
{ pincode: 500034, min_days: 2, max_days: 3 },
{ pincode: 500035, min_days: 2, max_days: 3 },
{ pincode: 500036, min_days: 2, max_days: 3 },
{ pincode: 500037, min_days: 2, max_days: 3 },
{ pincode: 500038, min_days: 2, max_days: 3 },
{ pincode: 500039, min_days: 2, max_days: 3 },
{ pincode: 500040, min_days: 2, max_days: 3 },
{ pincode: 500041, min_days: 2, max_days: 3 },
{ pincode: 500042, min_days: 2, max_days: 3 },
{ pincode: 500043, min_days: 2, max_days: 3 },
{ pincode: 500044, min_days: 2, max_days: 3 },
{ pincode: 500045, min_days: 2, max_days: 3 },
{ pincode: 500046, min_days: 2, max_days: 3 },
{ pincode: 500047, min_days: 2, max_days: 3 },
{ pincode: 500048, min_days: 2, max_days: 3 },
{ pincode: 500049, min_days: 2, max_days: 3 },
{ pincode: 500050, min_days: 2, max_days: 3 },
{ pincode: 500051, min_days: 2, max_days: 3 },
{ pincode: 500052, min_days: 2, max_days: 3 },
{ pincode: 500053, min_days: 2, max_days: 3 },
{ pincode: 500054, min_days: 2, max_days: 3 },
{ pincode: 500055, min_days: 2, max_days: 3 },
{ pincode: 500056, min_days: 2, max_days: 3 },
{ pincode: 500057, min_days: 2, max_days: 3 },
{ pincode: 500058, min_days: 2, max_days: 3 },
{ pincode: 500059, min_days: 2, max_days: 3 },
{ pincode: 500060, min_days: 2, max_days: 3 },
{ pincode: 500061, min_days: 2, max_days: 3 },
{ pincode: 500062, min_days: 2, max_days: 3 },
{ pincode: 500063, min_days: 2, max_days: 3 },
{ pincode: 500064, min_days: 2, max_days: 3 },
{ pincode: 500065, min_days: 2, max_days: 3 },
{ pincode: 500066, min_days: 2, max_days: 3 },
{ pincode: 500067, min_days: 2, max_days: 3 },
{ pincode: 500068, min_days: 2, max_days: 3 },
{ pincode: 500069, min_days: 2, max_days: 3 },
{ pincode: 500070, min_days: 2, max_days: 3 },
{ pincode: 500071, min_days: 2, max_days: 3 },
{ pincode: 500072, min_days: 2, max_days: 3 },
{ pincode: 500073, min_days: 2, max_days: 3 },
{ pincode: 500074, min_days: 2, max_days: 3 },
{ pincode: 500075, min_days: 2, max_days: 3 },
{ pincode: 500076, min_days: 2, max_days: 3 },
{ pincode: 500077, min_days: 2, max_days: 3 },
{ pincode: 500078, min_days: 2, max_days: 3 },
{ pincode: 500079, min_days: 2, max_days: 3 },
{ pincode: 500080, min_days: 2, max_days: 3 },
{ pincode: 500081, min_days: 2, max_days: 3 },
{ pincode: 500082, min_days: 2, max_days: 3 },
{ pincode: 500083, min_days: 2, max_days: 3 },
{ pincode: 500084, min_days: 2, max_days: 3 },
{ pincode: 500085, min_days: 2, max_days: 3 },
{ pincode: 500086, min_days: 2, max_days: 3 },
{ pincode: 500087, min_days: 2, max_days: 3 },
{ pincode: 500088, min_days: 2, max_days: 3 },
{ pincode: 500089, min_days: 2, max_days: 3 },
{ pincode: 500090, min_days: 2, max_days: 3 },
{ pincode: 500091, min_days: 2, max_days: 3 },
{ pincode: 500092, min_days: 2, max_days: 3 },
{ pincode: 500093, min_days: 2, max_days: 3 },
{ pincode: 500094, min_days: 2, max_days: 3 },
{ pincode: 500095, min_days: 2, max_days: 3 },
{ pincode: 500096, min_days: 2, max_days: 3 },
{ pincode: 500097, min_days: 2, max_days: 3 },
{ pincode: 500098, min_days: 2, max_days: 3 },
{ pincode: 500100, min_days: 2, max_days: 3 },
{ pincode: 500101, min_days: 2, max_days: 3 },
{ pincode: 500102, min_days: 2, max_days: 3 },
{ pincode: 500103, min_days: 2, max_days: 3 },
{ pincode: 500104, min_days: 2, max_days: 3 },
{ pincode: 500105, min_days: 2, max_days: 3 },
{ pincode: 500107, min_days: 2, max_days: 3 },
{ pincode: 500108, min_days: 2, max_days: 3 },
{ pincode: 500110, min_days: 2, max_days: 3 },
{ pincode: 500111, min_days: 2, max_days: 3 },
{ pincode: 500123, min_days: 2, max_days: 3 },
{ pincode: 500146, min_days: 2, max_days: 3 },
{ pincode: 500170, min_days: 2, max_days: 3 },
{ pincode: 500177, min_days: 2, max_days: 3 },
{ pincode: 500178, min_days: 2, max_days: 3 },
{ pincode: 500195, min_days: 2, max_days: 3 },
{ pincode: 500409, min_days: 2, max_days: 3 },
{ pincode: 500472, min_days: 2, max_days: 3 },
{ pincode: 500475, min_days: 2, max_days: 3 },
{ pincode: 500476, min_days: 2, max_days: 3 },
{ pincode: 500484, min_days: 2, max_days: 3 },
{ pincode: 500486, min_days: 2, max_days: 3 },
{ pincode: 500488, min_days: 2, max_days: 3 },
{ pincode: 500605, min_days: 2, max_days: 3 },
{ pincode: 500768, min_days: 2, max_days: 3 },
{ pincode: 500789, min_days: 2, max_days: 3 },
{ pincode: 500890, min_days: 2, max_days: 3 },
{ pincode: 500960, min_days: 2, max_days: 3 },
{ pincode: 500991, min_days: 2, max_days: 3 },
{ pincode: 501101, min_days: 3, max_days: 4 },
{ pincode: 501102, min_days: 3, max_days: 4 },
{ pincode: 501218, min_days: 2, max_days: 3 },
{ pincode: 501301, min_days: 2, max_days: 3 },
{ pincode: 501359, min_days: 2, max_days: 3 },
{ pincode: 501401, min_days: 2, max_days: 3 },
{ pincode: 501503, min_days: 3, max_days: 4 },
{ pincode: 501505, min_days: 2, max_days: 3 },
{ pincode: 501506, min_days: 2, max_days: 3 },
{ pincode: 501507, min_days: 2, max_days: 3 },
{ pincode: 501508, min_days: 2, max_days: 3 },
{ pincode: 501510, min_days: 2, max_days: 3 },
{ pincode: 501511, min_days: 2, max_days: 3 },
{ pincode: 501512, min_days: 2, max_days: 3 },
{ pincode: 502001, min_days: 3, max_days: 4 },
{ pincode: 502032, min_days: 2, max_days: 3 },
{ pincode: 502103, min_days: 3, max_days: 4 },
{ pincode: 502110, min_days: 5, max_days: 6 },
{ pincode: 502205, min_days: 2, max_days: 3 },
{ pincode: 502220, min_days: 4, max_days: 5 },
{ pincode: 502248, min_days: 5, max_days: 6 },
{ pincode: 502269, min_days: 5, max_days: 6 },
{ pincode: 502270, min_days: 5, max_days: 6 },
{ pincode: 502278, min_days: 4, max_days: 5 },
{ pincode: 502285, min_days: 2, max_days: 3 },
{ pincode: 502286, min_days: 5, max_days: 6 },
{ pincode: 502290, min_days: 5, max_days: 6 },
{ pincode: 502291, min_days: 4, max_days: 5 },
{ pincode: 502300, min_days: 2, max_days: 3 },
{ pincode: 502305, min_days: 2, max_days: 3 },
{ pincode: 502307, min_days: 2, max_days: 3 },
{ pincode: 502312, min_days: 4, max_days: 5 },
{ pincode: 502319, min_days: 2, max_days: 3 },
{ pincode: 502324, min_days: 2, max_days: 3 },
{ pincode: 502325, min_days: 2, max_days: 3 },
{ pincode: 502329, min_days: 2, max_days: 3 },
{ pincode: 503001, min_days: 4, max_days: 5 },
{ pincode: 503002, min_days: 4, max_days: 5 },
{ pincode: 503003, min_days: 4, max_days: 5 },
{ pincode: 503165, min_days: 3, max_days: 4 },
{ pincode: 503174, min_days: 4, max_days: 5 },
{ pincode: 503175, min_days: 4, max_days: 5 },
{ pincode: 503180, min_days: 4, max_days: 5 },
{ pincode: 503185, min_days: 4, max_days: 5 },
{ pincode: 503186, min_days: 4, max_days: 5 },
{ pincode: 503217, min_days: 4, max_days: 5 },
{ pincode: 503224, min_days: 4, max_days: 5 },
{ pincode: 503230, min_days: 4, max_days: 5 },
{ pincode: 503307, min_days: 3, max_days: 4 },
{ pincode: 503311, min_days: 3, max_days: 4 },
{ pincode: 504106, min_days: 4, max_days: 5 },
{ pincode: 504208, min_days: 3, max_days: 4 },
{ pincode: 504218, min_days: 4, max_days: 5 },
{ pincode: 504220, min_days: 4, max_days: 5 },
{ pincode: 504231, min_days: 4, max_days: 5 },
{ pincode: 504251, min_days: 4, max_days: 5 },
{ pincode: 504272, min_days: 4, max_days: 5 },
{ pincode: 504302, min_days: 4, max_days: 5 },
{ pincode: 504307, min_days: 4, max_days: 5 },
{ pincode: 505001, min_days: 3, max_days: 4 },
{ pincode: 505002, min_days: 3, max_days: 4 },
{ pincode: 505122, min_days: 3, max_days: 4 },
{ pincode: 505172, min_days: 3, max_days: 4 },
{ pincode: 505186, min_days: 3, max_days: 4 },
{ pincode: 505187, min_days: 3, max_days: 4 },
{ pincode: 505208, min_days: 3, max_days: 4 },
{ pincode: 505209, min_days: 3, max_days: 4 },
{ pincode: 505210, min_days: 3, max_days: 4 },
{ pincode: 505211, min_days: 3, max_days: 4 },
{ pincode: 505215, min_days: 3, max_days: 4 },
{ pincode: 505301, min_days: 3, max_days: 4 },
{ pincode: 505302, min_days: 3, max_days: 4 },
{ pincode: 505305, min_days: 3, max_days: 4 },
{ pincode: 505307, min_days: 3, max_days: 4 },
{ pincode: 505325, min_days: 3, max_days: 4 },
{ pincode: 505326, min_days: 3, max_days: 4 },
{ pincode: 505327, min_days: 3, max_days: 4 },
{ pincode: 505330, min_days: 3, max_days: 4 },
{ pincode: 505401, min_days: 3, max_days: 4 },
{ pincode: 505402, min_days: 3, max_days: 4 },
{ pincode: 505403, min_days: 3, max_days: 4 },
{ pincode: 505404, min_days: 3, max_days: 4 },
{ pincode: 505405, min_days: 3, max_days: 4 },
{ pincode: 505415, min_days: 3, max_days: 4 },
{ pincode: 505450, min_days: 3, max_days: 4 },
{ pincode: 505460, min_days: 3, max_days: 4 },
{ pincode: 505467, min_days: 3, max_days: 4 },
{ pincode: 505468, min_days: 3, max_days: 4 },
{ pincode: 505470, min_days: 3, max_days: 4 },
{ pincode: 505490, min_days: 3, max_days: 4 },
{ pincode: 505524, min_days: 3, max_days: 4 },
{ pincode: 506001, min_days: 3, max_days: 4 },
{ pincode: 506002, min_days: 3, max_days: 4 },
{ pincode: 506003, min_days: 3, max_days: 4 },
{ pincode: 506004, min_days: 3, max_days: 4 },
{ pincode: 506005, min_days: 3, max_days: 4 },
{ pincode: 506006, min_days: 3, max_days: 4 },
{ pincode: 506007, min_days: 3, max_days: 4 },
{ pincode: 506008, min_days: 3, max_days: 4 },
{ pincode: 506009, min_days: 3, max_days: 4 },
{ pincode: 506010, min_days: 3, max_days: 4 },
{ pincode: 506011, min_days: 3, max_days: 4 },
{ pincode: 506012, min_days: 3, max_days: 4 },
{ pincode: 506013, min_days: 3, max_days: 4 },
{ pincode: 506015, min_days: 3, max_days: 4 },
{ pincode: 506101, min_days: 4, max_days: 5 },
{ pincode: 506132, min_days: 3, max_days: 4 },
{ pincode: 506142, min_days: 3, max_days: 4 },
{ pincode: 506163, min_days: 3, max_days: 4 },
{ pincode: 506164, min_days: 3, max_days: 4 },
{ pincode: 506166, min_days: 3, max_days: 4 },
{ pincode: 506167, min_days: 3, max_days: 4 },
{ pincode: 506168, min_days: 3, max_days: 4 },
{ pincode: 506169, min_days: 3, max_days: 4 },
{ pincode: 506172, min_days: 3, max_days: 4 },
{ pincode: 506315, min_days: 3, max_days: 4 },
{ pincode: 506319, min_days: 3, max_days: 4 },
{ pincode: 506370, min_days: 3, max_days: 4 },
{ pincode: 506371, min_days: 3, max_days: 4 },
{ pincode: 506381, min_days: 4, max_days: 5 },
{ pincode: 507001, min_days: 3, max_days: 4 },
{ pincode: 507002, min_days: 3, max_days: 4 },
{ pincode: 507003, min_days: 3, max_days: 4 },
{ pincode: 507004, min_days: 3, max_days: 4 },
{ pincode: 507101, min_days: 3, max_days: 4 },
{ pincode: 507111, min_days: 4, max_days: 5 },
{ pincode: 507113, min_days: 4, max_days: 5 },
{ pincode: 507115, min_days: 3, max_days: 4 },
{ pincode: 507121, min_days: 4, max_days: 5 },
{ pincode: 507123, min_days: 4, max_days: 5 },
{ pincode: 507128, min_days: 4, max_days: 5 },
{ pincode: 507129, min_days: 4, max_days: 5 },
{ pincode: 507130, min_days: 4, max_days: 5 },
{ pincode: 507133, min_days: 4, max_days: 5 },
{ pincode: 507134, min_days: 4, max_days: 5 },
{ pincode: 507137, min_days: 4, max_days: 5 },
{ pincode: 507140, min_days: 4, max_days: 5 },
{ pincode: 507168, min_days: 3, max_days: 4 },
{ pincode: 507203, min_days: 3, max_days: 4 },
{ pincode: 507303, min_days: 4, max_days: 5 },
{ pincode: 507318, min_days: 3, max_days: 4 },
{ pincode: 508001, min_days: 3, max_days: 4 },
{ pincode: 508116, min_days: 3, max_days: 4 },
{ pincode: 508126, min_days: 2, max_days: 3 },
{ pincode: 508204, min_days: 3, max_days: 4 },
{ pincode: 508206, min_days: 3, max_days: 4 },
{ pincode: 508207, min_days: 3, max_days: 4 },
{ pincode: 508213, min_days: 3, max_days: 4 },
{ pincode: 508233, min_days: 3, max_days: 4 },
{ pincode: 508234, min_days: 3, max_days: 4 },
{ pincode: 508238, min_days: 3, max_days: 4 },
{ pincode: 508252, min_days: 3, max_days: 4 },
{ pincode: 509001, min_days: 3, max_days: 4 },
{ pincode: 509002, min_days: 3, max_days: 4 },
{ pincode: 509102, min_days: 3, max_days: 4 },
{ pincode: 509103, min_days: 4, max_days: 5 },
{ pincode: 509104, min_days: 3, max_days: 4 },
{ pincode: 509106, min_days: 3, max_days: 4 },
{ pincode: 509110, min_days: 3, max_days: 4 },
{ pincode: 509120, min_days: 3, max_days: 4 },
{ pincode: 509125, min_days: 3, max_days: 4 },
{ pincode: 509131, min_days: 3, max_days: 4 },
{ pincode: 509202, min_days: 3, max_days: 4 },
{ pincode: 509206, min_days: 3, max_days: 4 },
{ pincode: 509208, min_days: 3, max_days: 4 },
{ pincode: 509209, min_days: 4, max_days: 5 },
{ pincode: 509210, min_days: 3, max_days: 4 },
{ pincode: 509215, min_days: 4, max_days: 5 },
{ pincode: 509216, min_days: 3, max_days: 4 },
{ pincode: 509219, min_days: 3, max_days: 4 },
{ pincode: 509228, min_days: 3, max_days: 4 },
{ pincode: 509301, min_days: 3, max_days: 4 },
{ pincode: 509302, min_days: 3, max_days: 4 },
{ pincode: 509351, min_days: 3, max_days: 4 },
{ pincode: 509381, min_days: 3, max_days: 4 },
{ pincode: 509407, min_days: 3, max_days: 4 },
{ pincode: 509412, min_days: 3, max_days: 4 },
{ pincode: 511111, min_days: 2, max_days: 3 },
{ pincode: 515001, min_days: 3, max_days: 4 },
{ pincode: 515002, min_days: 3, max_days: 4 },
{ pincode: 515003, min_days: 3, max_days: 4 },
{ pincode: 515004, min_days: 3, max_days: 4 },
{ pincode: 515005, min_days: 3, max_days: 4 },
{ pincode: 515101, min_days: 3, max_days: 4 },
{ pincode: 515102, min_days: 3, max_days: 4 },
{ pincode: 515110, min_days: 3, max_days: 4 },
{ pincode: 515122, min_days: 3, max_days: 4 },
{ pincode: 515133, min_days: 3, max_days: 4 },
{ pincode: 515134, min_days: 3, max_days: 4 },
{ pincode: 515144, min_days: 3, max_days: 4 },
{ pincode: 515164, min_days: 3, max_days: 4 },
{ pincode: 515201, min_days: 3, max_days: 4 },
{ pincode: 515202, min_days: 3, max_days: 4 },
{ pincode: 515211, min_days: 3, max_days: 4 },
{ pincode: 515212, min_days: 3, max_days: 4 },
{ pincode: 515213, min_days: 3, max_days: 4 },
{ pincode: 515231, min_days: 3, max_days: 4 },
{ pincode: 515241, min_days: 3, max_days: 4 },
{ pincode: 515261, min_days: 3, max_days: 4 },
{ pincode: 515271, min_days: 3, max_days: 4 },
{ pincode: 515291, min_days: 3, max_days: 4 },
{ pincode: 515301, min_days: 3, max_days: 4 },
{ pincode: 515303, min_days: 3, max_days: 4 },
{ pincode: 515331, min_days: 3, max_days: 4 },
{ pincode: 515401, min_days: 3, max_days: 4 },
{ pincode: 515402, min_days: 3, max_days: 4 },
{ pincode: 515404, min_days: 3, max_days: 4 },
{ pincode: 515405, min_days: 3, max_days: 4 },
{ pincode: 515411, min_days: 3, max_days: 4 },
{ pincode: 515413, min_days: 3, max_days: 4 },
{ pincode: 515415, min_days: 3, max_days: 4 },
{ pincode: 515425, min_days: 3, max_days: 4 },
{ pincode: 515427, min_days: 3, max_days: 4 },
{ pincode: 515445, min_days: 3, max_days: 4 },
{ pincode: 515446, min_days: 3, max_days: 4 },
{ pincode: 515501, min_days: 3, max_days: 4 },
{ pincode: 515502, min_days: 3, max_days: 4 },
{ pincode: 515541, min_days: 3, max_days: 4 },
{ pincode: 515551, min_days: 3, max_days: 4 },
{ pincode: 515561, min_days: 3, max_days: 4 },
{ pincode: 515591, min_days: 3, max_days: 4 },
{ pincode: 515631, min_days: 3, max_days: 4 },
{ pincode: 515651, min_days: 3, max_days: 4 },
{ pincode: 515671, min_days: 3, max_days: 4 },
{ pincode: 515701, min_days: 3, max_days: 4 },
{ pincode: 515722, min_days: 3, max_days: 4 },
{ pincode: 515741, min_days: 3, max_days: 4 },
{ pincode: 515761, min_days: 3, max_days: 4 },
{ pincode: 515763, min_days: 3, max_days: 4 },
{ pincode: 515767, min_days: 3, max_days: 4 },
{ pincode: 515801, min_days: 3, max_days: 4 },
{ pincode: 515803, min_days: 3, max_days: 4 },
{ pincode: 515832, min_days: 3, max_days: 4 },
{ pincode: 515834, min_days: 3, max_days: 4 },
{ pincode: 515842, min_days: 3, max_days: 4 },
{ pincode: 515843, min_days: 3, max_days: 4 },
{ pincode: 515865, min_days: 3, max_days: 4 },
{ pincode: 515867, min_days: 3, max_days: 4 },
{ pincode: 516001, min_days: 3, max_days: 4 },
{ pincode: 516002, min_days: 3, max_days: 4 },
{ pincode: 516003, min_days: 3, max_days: 4 },
{ pincode: 516004, min_days: 3, max_days: 4 },
{ pincode: 516005, min_days: 3, max_days: 4 },
{ pincode: 516104, min_days: 3, max_days: 4 },
{ pincode: 516107, min_days: 3, max_days: 4 },
{ pincode: 516115, min_days: 3, max_days: 4 },
{ pincode: 516126, min_days: 3, max_days: 4 },
{ pincode: 516127, min_days: 3, max_days: 4 },
{ pincode: 516128, min_days: 3, max_days: 4 },
{ pincode: 516130, min_days: 3, max_days: 4 },
{ pincode: 516150, min_days: 3, max_days: 4 },
{ pincode: 516151, min_days: 3, max_days: 4 },
{ pincode: 516152, min_days: 3, max_days: 4 },
{ pincode: 516162, min_days: 3, max_days: 4 },
{ pincode: 516163, min_days: 3, max_days: 4 },
{ pincode: 516172, min_days: 3, max_days: 4 },
{ pincode: 516193, min_days: 3, max_days: 4 },
{ pincode: 516203, min_days: 3, max_days: 4 },
{ pincode: 516213, min_days: 3, max_days: 4 },
{ pincode: 516214, min_days: 3, max_days: 4 },
{ pincode: 516215, min_days: 3, max_days: 4 },
{ pincode: 516216, min_days: 3, max_days: 4 },
{ pincode: 516218, min_days: 3, max_days: 4 },
{ pincode: 516227, min_days: 3, max_days: 4 },
{ pincode: 516228, min_days: 3, max_days: 4 },
{ pincode: 516233, min_days: 3, max_days: 4 },
{ pincode: 516237, min_days: 3, max_days: 4 },
{ pincode: 516247, min_days: 3, max_days: 4 },
{ pincode: 516257, min_days: 3, max_days: 4 },
{ pincode: 516267, min_days: 3, max_days: 4 },
{ pincode: 516268, min_days: 3, max_days: 4 },
{ pincode: 516269, min_days: 3, max_days: 4 },
{ pincode: 516270, min_days: 3, max_days: 4 },
{ pincode: 516289, min_days: 3, max_days: 4 },
{ pincode: 516293, min_days: 3, max_days: 4 },
{ pincode: 516309, min_days: 3, max_days: 4 },
{ pincode: 516310, min_days: 3, max_days: 4 },
{ pincode: 516311, min_days: 3, max_days: 4 },
{ pincode: 516312, min_days: 3, max_days: 4 },
{ pincode: 516321, min_days: 3, max_days: 4 },
{ pincode: 516329, min_days: 3, max_days: 4 },
{ pincode: 516339, min_days: 3, max_days: 4 },
{ pincode: 516349, min_days: 3, max_days: 4 },
{ pincode: 516350, min_days: 3, max_days: 4 },
{ pincode: 516355, min_days: 3, max_days: 4 },
{ pincode: 516359, min_days: 3, max_days: 4 },
{ pincode: 516360, min_days: 3, max_days: 4 },
{ pincode: 516361, min_days: 3, max_days: 4 },
{ pincode: 516362, min_days: 3, max_days: 4 },
{ pincode: 516366, min_days: 3, max_days: 4 },
{ pincode: 516390, min_days: 3, max_days: 4 },
{ pincode: 516391, min_days: 3, max_days: 4 },
{ pincode: 516396, min_days: 3, max_days: 4 },
{ pincode: 516401, min_days: 3, max_days: 4 },
{ pincode: 516421, min_days: 3, max_days: 4 },
{ pincode: 516434, min_days: 3, max_days: 4 },
{ pincode: 516454, min_days: 3, max_days: 4 },
{ pincode: 516501, min_days: 3, max_days: 4 },
{ pincode: 516502, min_days: 3, max_days: 4 },
{ pincode: 516504, min_days: 3, max_days: 4 },
{ pincode: 516505, min_days: 3, max_days: 4 },
{ pincode: 517001, min_days: 3, max_days: 4 },
{ pincode: 517002, min_days: 3, max_days: 4 },
{ pincode: 517003, min_days: 3, max_days: 4 },
{ pincode: 517004, min_days: 3, max_days: 4 },
{ pincode: 517101, min_days: 3, max_days: 4 },
{ pincode: 517102, min_days: 3, max_days: 4 },
{ pincode: 517112, min_days: 3, max_days: 4 },
{ pincode: 517113, min_days: 4, max_days: 5 },
{ pincode: 517123, min_days: 4, max_days: 5 },
{ pincode: 517124, min_days: 3, max_days: 4 },
{ pincode: 517125, min_days: 3, max_days: 4 },
{ pincode: 517126, min_days: 3, max_days: 4 },
{ pincode: 517127, min_days: 3, max_days: 4 },
{ pincode: 517128, min_days: 3, max_days: 4 },
{ pincode: 517129, min_days: 4, max_days: 5 },
{ pincode: 517130, min_days: 3, max_days: 4 },
{ pincode: 517131, min_days: 3, max_days: 4 },
{ pincode: 517132, min_days: 3, max_days: 4 },
{ pincode: 517143, min_days: 3, max_days: 4 },
{ pincode: 517152, min_days: 4, max_days: 5 },
{ pincode: 517167, min_days: 3, max_days: 4 },
{ pincode: 517192, min_days: 4, max_days: 5 },
{ pincode: 517193, min_days: 4, max_days: 5 },
{ pincode: 517214, min_days: 4, max_days: 5 },
{ pincode: 517234, min_days: 4, max_days: 5 },
{ pincode: 517247, min_days: 4, max_days: 5 },
{ pincode: 517305, min_days: 3, max_days: 4 },
{ pincode: 517325, min_days: 4, max_days: 5 },
{ pincode: 517403, min_days: 3, max_days: 4 },
{ pincode: 517408, min_days: 4, max_days: 5 },
{ pincode: 517415, min_days: 4, max_days: 5 },
{ pincode: 517416, min_days: 4, max_days: 5 },
{ pincode: 517419, min_days: 3, max_days: 4 },
{ pincode: 517421, min_days: 3, max_days: 4 },
{ pincode: 517422, min_days: 3, max_days: 4 },
{ pincode: 517423, min_days: 3, max_days: 4 },
{ pincode: 517425, min_days: 3, max_days: 4 },
{ pincode: 517426, min_days: 3, max_days: 4 },
{ pincode: 517429, min_days: 4, max_days: 5 },
{ pincode: 517501, min_days: 3, max_days: 4 },
{ pincode: 517502, min_days: 3, max_days: 4 },
{ pincode: 517503, min_days: 3, max_days: 4 },
{ pincode: 517504, min_days: 3, max_days: 4 },
{ pincode: 517505, min_days: 3, max_days: 4 },
{ pincode: 517506, min_days: 3, max_days: 4 },
{ pincode: 517507, min_days: 3, max_days: 4 },
{ pincode: 517520, min_days: 3, max_days: 4 },
{ pincode: 517526, min_days: 3, max_days: 4 },
{ pincode: 517536, min_days: 3, max_days: 4 },
{ pincode: 517541, min_days: 3, max_days: 4 },
{ pincode: 517551, min_days: 3, max_days: 4 },
{ pincode: 517561, min_days: 3, max_days: 4 },
{ pincode: 517569, min_days: 3, max_days: 4 },
{ pincode: 517571, min_days: 3, max_days: 4 },
{ pincode: 517581, min_days: 3, max_days: 4 },
{ pincode: 517582, min_days: 3, max_days: 4 },
{ pincode: 517583, min_days: 3, max_days: 4 },
{ pincode: 517584, min_days: 3, max_days: 4 },
{ pincode: 517586, min_days: 3, max_days: 4 },
{ pincode: 517587, min_days: 3, max_days: 4 },
{ pincode: 517588, min_days: 3, max_days: 4 },
{ pincode: 517589, min_days: 3, max_days: 4 },
{ pincode: 517590, min_days: 3, max_days: 4 },
{ pincode: 517591, min_days: 3, max_days: 4 },
{ pincode: 517592, min_days: 3, max_days: 4 },
{ pincode: 517599, min_days: 4, max_days: 5 },
{ pincode: 517620, min_days: 3, max_days: 4 },
{ pincode: 517640, min_days: 3, max_days: 4 },
{ pincode: 517641, min_days: 3, max_days: 4 },
{ pincode: 517643, min_days: 3, max_days: 4 },
{ pincode: 517644, min_days: 3, max_days: 4 },
{ pincode: 517645, min_days: 3, max_days: 4 },
{ pincode: 517646, min_days: 3, max_days: 4 },
{ pincode: 518001, min_days: 3, max_days: 4 },
{ pincode: 518002, min_days: 3, max_days: 4 },
{ pincode: 518003, min_days: 3, max_days: 4 },
{ pincode: 518004, min_days: 3, max_days: 4 },
{ pincode: 518005, min_days: 3, max_days: 4 },
{ pincode: 518006, min_days: 3, max_days: 4 },
{ pincode: 518007, min_days: 3, max_days: 4 },
{ pincode: 518010, min_days: 3, max_days: 4 },
{ pincode: 518124, min_days: 3, max_days: 4 },
{ pincode: 518186, min_days: 3, max_days: 4 },
{ pincode: 518222, min_days: 3, max_days: 4 },
{ pincode: 518301, min_days: 3, max_days: 4 },
{ pincode: 518360, min_days: 3, max_days: 4 },
{ pincode: 518422, min_days: 3, max_days: 4 },
{ pincode: 518452, min_days: 3, max_days: 4 },
{ pincode: 518501, min_days: 3, max_days: 4 },
{ pincode: 518502, min_days: 3, max_days: 4 },
{ pincode: 520001, min_days: 3, max_days: 4 },
{ pincode: 520002, min_days: 3, max_days: 4 },
{ pincode: 520003, min_days: 3, max_days: 4 },
{ pincode: 520004, min_days: 3, max_days: 4 },
{ pincode: 520005, min_days: 3, max_days: 4 },
{ pincode: 520006, min_days: 3, max_days: 4 },
{ pincode: 520007, min_days: 3, max_days: 4 },
{ pincode: 520008, min_days: 3, max_days: 4 },
{ pincode: 520009, min_days: 3, max_days: 4 },
{ pincode: 520010, min_days: 3, max_days: 4 },
{ pincode: 520011, min_days: 3, max_days: 4 },
{ pincode: 520012, min_days: 3, max_days: 4 },
{ pincode: 520013, min_days: 3, max_days: 4 },
{ pincode: 520014, min_days: 3, max_days: 4 },
{ pincode: 520015, min_days: 3, max_days: 4 },
{ pincode: 521001, min_days: 3, max_days: 4 },
{ pincode: 521002, min_days: 3, max_days: 4 },
{ pincode: 521101, min_days: 3, max_days: 4 },
{ pincode: 521102, min_days: 3, max_days: 4 },
{ pincode: 521104, min_days: 3, max_days: 4 },
{ pincode: 521105, min_days: 3, max_days: 4 },
{ pincode: 521106, min_days: 3, max_days: 4 },
{ pincode: 521107, min_days: 3, max_days: 4 },
{ pincode: 521108, min_days: 3, max_days: 4 },
{ pincode: 521109, min_days: 3, max_days: 4 },
{ pincode: 521110, min_days: 3, max_days: 4 },
{ pincode: 521111, min_days: 3, max_days: 4 },
{ pincode: 521113, min_days: 3, max_days: 4 },
{ pincode: 521114, min_days: 3, max_days: 4 },
{ pincode: 521121, min_days: 3, max_days: 4 },
{ pincode: 521125, min_days: 3, max_days: 4 },
{ pincode: 521126, min_days: 3, max_days: 4 },
{ pincode: 521137, min_days: 3, max_days: 4 },
{ pincode: 521139, min_days: 3, max_days: 4 },
{ pincode: 521148, min_days: 3, max_days: 4 },
{ pincode: 521151, min_days: 3, max_days: 4 },
{ pincode: 521158, min_days: 3, max_days: 4 },
{ pincode: 521165, min_days: 3, max_days: 4 },
{ pincode: 521175, min_days: 3, max_days: 4 },
{ pincode: 521185, min_days: 3, max_days: 4 },
{ pincode: 521201, min_days: 3, max_days: 4 },
{ pincode: 521202, min_days: 3, max_days: 4 },
{ pincode: 521212, min_days: 3, max_days: 4 },
{ pincode: 521215, min_days: 3, max_days: 4 },
{ pincode: 521225, min_days: 3, max_days: 4 },
{ pincode: 521230, min_days: 3, max_days: 4 },
{ pincode: 521263, min_days: 3, max_days: 4 },
{ pincode: 521286, min_days: 3, max_days: 4 },
{ pincode: 521301, min_days: 3, max_days: 4 },
{ pincode: 521311, min_days: 3, max_days: 4 },
{ pincode: 521312, min_days: 3, max_days: 4 },
{ pincode: 521321, min_days: 3, max_days: 4 },
{ pincode: 521322, min_days: 3, max_days: 4 },
{ pincode: 521323, min_days: 3, max_days: 4 },
{ pincode: 521325, min_days: 3, max_days: 4 },
{ pincode: 521326, min_days: 3, max_days: 4 },
{ pincode: 521327, min_days: 3, max_days: 4 },
{ pincode: 521330, min_days: 3, max_days: 4 },
{ pincode: 521331, min_days: 3, max_days: 4 },
{ pincode: 521343, min_days: 3, max_days: 4 },
{ pincode: 521345, min_days: 3, max_days: 4 },
{ pincode: 521356, min_days: 3, max_days: 4 },
{ pincode: 521358, min_days: 3, max_days: 4 },
{ pincode: 521444, min_days: 3, max_days: 4 },
{ pincode: 521456, min_days: 3, max_days: 4 },
{ pincode: 522001, min_days: 3, max_days: 4 },
{ pincode: 522002, min_days: 3, max_days: 4 },
{ pincode: 522003, min_days: 3, max_days: 4 },
{ pincode: 522004, min_days: 3, max_days: 4 },
{ pincode: 522005, min_days: 3, max_days: 4 },
{ pincode: 522006, min_days: 3, max_days: 4 },
{ pincode: 522007, min_days: 3, max_days: 4 },
{ pincode: 522009, min_days: 3, max_days: 4 },
{ pincode: 522022, min_days: 3, max_days: 4 },
{ pincode: 522034, min_days: 3, max_days: 4 },
{ pincode: 522101, min_days: 3, max_days: 4 },
{ pincode: 522102, min_days: 3, max_days: 4 },
{ pincode: 522124, min_days: 3, max_days: 4 },
{ pincode: 522201, min_days: 3, max_days: 4 },
{ pincode: 522202, min_days: 3, max_days: 4 },
{ pincode: 522212, min_days: 3, max_days: 4 },
{ pincode: 522222, min_days: 2, max_days: 3 },
{ pincode: 522262, min_days: 3, max_days: 4 },
{ pincode: 522263, min_days: 3, max_days: 4 },
{ pincode: 522265, min_days: 3, max_days: 4 },
{ pincode: 522314, min_days: 3, max_days: 4 },
{ pincode: 522315, min_days: 3, max_days: 4 },
{ pincode: 522329, min_days: 3, max_days: 4 },
{ pincode: 522403, min_days: 4, max_days: 5 },
{ pincode: 522413, min_days: 4, max_days: 5 },
{ pincode: 522501, min_days: 3, max_days: 4 },
{ pincode: 522502, min_days: 3, max_days: 4 },
{ pincode: 522503, min_days: 3, max_days: 4 },
{ pincode: 522508, min_days: 3, max_days: 4 },
{ pincode: 522509, min_days: 3, max_days: 4 },
{ pincode: 522510, min_days: 3, max_days: 4 },
{ pincode: 522601, min_days: 3, max_days: 4 },
{ pincode: 522614, min_days: 4, max_days: 5 },
{ pincode: 522616, min_days: 3, max_days: 4 },
{ pincode: 523115, min_days: 3, max_days: 4 },
{ pincode: 523155, min_days: 3, max_days: 4 },
{ pincode: 523157, min_days: 3, max_days: 4 },
{ pincode: 523201, min_days: 3, max_days: 4 },
{ pincode: 523211, min_days: 3, max_days: 4 },
{ pincode: 523212, min_days: 3, max_days: 4 },
{ pincode: 523247, min_days: 3, max_days: 4 },
{ pincode: 523262, min_days: 3, max_days: 4 },
{ pincode: 523274, min_days: 3, max_days: 4 },
{ pincode: 523301, min_days: 3, max_days: 4 },
{ pincode: 523316, min_days: 3, max_days: 4 },
{ pincode: 523333, min_days: 3, max_days: 4 },
{ pincode: 523334, min_days: 3, max_days: 4 },
{ pincode: 523357, min_days: 3, max_days: 4 },
{ pincode: 524001, min_days: 3, max_days: 4 },
{ pincode: 524002, min_days: 3, max_days: 4 },
{ pincode: 524003, min_days: 3, max_days: 4 },
{ pincode: 524004, min_days: 3, max_days: 4 },
{ pincode: 524005, min_days: 3, max_days: 4 },
{ pincode: 524101, min_days: 3, max_days: 4 },
{ pincode: 524121, min_days: 3, max_days: 4 },
{ pincode: 524126, min_days: 3, max_days: 4 },
{ pincode: 524129, min_days: 3, max_days: 4 },
{ pincode: 524132, min_days: 3, max_days: 4 },
{ pincode: 524137, min_days: 3, max_days: 4 },
{ pincode: 524142, min_days: 3, max_days: 4 },
{ pincode: 524152, min_days: 3, max_days: 4 },
{ pincode: 524201, min_days: 3, max_days: 4 },
{ pincode: 524202, min_days: 3, max_days: 4 },
{ pincode: 524203, min_days: 3, max_days: 4 },
{ pincode: 524221, min_days: 5, max_days: 6 },
{ pincode: 524222, min_days: 5, max_days: 6 },
{ pincode: 524223, min_days: 3, max_days: 4 },
{ pincode: 524224, min_days: 5, max_days: 6 },
{ pincode: 524227, min_days: 5, max_days: 6 },
{ pincode: 524228, min_days: 4, max_days: 5 },
{ pincode: 524230, min_days: 5, max_days: 6 },
{ pincode: 524234, min_days: 5, max_days: 6 },
{ pincode: 524239, min_days: 5, max_days: 6 },
{ pincode: 524240, min_days: 3, max_days: 4 },
{ pincode: 524301, min_days: 5, max_days: 6 },
{ pincode: 524303, min_days: 5, max_days: 6 },
{ pincode: 524304, min_days: 5, max_days: 6 },
{ pincode: 524305, min_days: 3, max_days: 4 },
{ pincode: 524307, min_days: 5, max_days: 6 },
{ pincode: 524308, min_days: 5, max_days: 6 },
{ pincode: 524309, min_days: 5, max_days: 6 },
{ pincode: 524311, min_days: 3, max_days: 4 },
{ pincode: 524313, min_days: 3, max_days: 4 },
{ pincode: 524315, min_days: 3, max_days: 4 },
{ pincode: 524316, min_days: 3, max_days: 4 },
{ pincode: 524317, min_days: 3, max_days: 4 },
{ pincode: 524318, min_days: 3, max_days: 4 },
{ pincode: 524319, min_days: 3, max_days: 4 },
{ pincode: 524320, min_days: 3, max_days: 4 },
{ pincode: 524322, min_days: 4, max_days: 5 },
{ pincode: 524341, min_days: 5, max_days: 6 },
{ pincode: 524344, min_days: 3, max_days: 4 },
{ pincode: 524346, min_days: 3, max_days: 4 },
{ pincode: 524366, min_days: 3, max_days: 4 },
{ pincode: 524401, min_days: 3, max_days: 4 },
{ pincode: 524405, min_days: 3, max_days: 4 },
{ pincode: 524410, min_days: 3, max_days: 4 },
{ pincode: 524411, min_days: 3, max_days: 4 },
{ pincode: 524412, min_days: 3, max_days: 4 },
{ pincode: 524413, min_days: 3, max_days: 4 },
{ pincode: 524415, min_days: 3, max_days: 4 },
{ pincode: 524421, min_days: 3, max_days: 4 },
{ pincode: 528101, min_days: 3, max_days: 4 },
{ pincode: 530001, min_days: 3, max_days: 4 },
{ pincode: 530002, min_days: 3, max_days: 4 },
{ pincode: 530003, min_days: 3, max_days: 4 },
{ pincode: 530004, min_days: 3, max_days: 4 },
{ pincode: 530005, min_days: 2, max_days: 3 },
{ pincode: 530006, min_days: 3, max_days: 4 },
{ pincode: 530007, min_days: 3, max_days: 4 },
{ pincode: 530008, min_days: 3, max_days: 4 },
{ pincode: 530009, min_days: 3, max_days: 4 },
{ pincode: 530010, min_days: 3, max_days: 4 },
{ pincode: 530011, min_days: 2, max_days: 3 },
{ pincode: 530012, min_days: 2, max_days: 3 },
{ pincode: 530013, min_days: 3, max_days: 4 },
{ pincode: 530014, min_days: 2, max_days: 3 },
{ pincode: 530015, min_days: 2, max_days: 3 },
{ pincode: 530016, min_days: 3, max_days: 4 },
{ pincode: 530017, min_days: 3, max_days: 4 },
{ pincode: 530018, min_days: 3, max_days: 4 },
{ pincode: 530020, min_days: 3, max_days: 4 },
{ pincode: 530021, min_days: 3, max_days: 4 },
{ pincode: 530022, min_days: 3, max_days: 4 },
{ pincode: 530023, min_days: 3, max_days: 4 },
{ pincode: 530024, min_days: 3, max_days: 4 },
{ pincode: 530025, min_days: 2, max_days: 3 },
{ pincode: 530026, min_days: 2, max_days: 3 },
{ pincode: 530027, min_days: 3, max_days: 4 },
{ pincode: 530028, min_days: 3, max_days: 4 },
{ pincode: 530029, min_days: 3, max_days: 4 },
{ pincode: 530032, min_days: 3, max_days: 4 },
{ pincode: 530035, min_days: 3, max_days: 4 },
{ pincode: 530037, min_days: 3, max_days: 4 },
{ pincode: 530040, min_days: 3, max_days: 4 },
{ pincode: 530041, min_days: 3, max_days: 4 },
{ pincode: 530042, min_days: 3, max_days: 4 },
{ pincode: 530043, min_days: 3, max_days: 4 },
{ pincode: 530044, min_days: 2, max_days: 3 },
{ pincode: 530045, min_days: 3, max_days: 4 },
{ pincode: 530046, min_days: 3, max_days: 4 },
{ pincode: 530047, min_days: 3, max_days: 4 },
{ pincode: 530048, min_days: 3, max_days: 4 },
{ pincode: 530049, min_days: 3, max_days: 4 },
{ pincode: 530051, min_days: 3, max_days: 4 },
{ pincode: 530052, min_days: 3, max_days: 4 },
{ pincode: 530053, min_days: 3, max_days: 4 },
{ pincode: 531001, min_days: 3, max_days: 4 },
{ pincode: 531011, min_days: 3, max_days: 4 },
{ pincode: 531019, min_days: 3, max_days: 4 },
{ pincode: 531020, min_days: 3, max_days: 4 },
{ pincode: 531021, min_days: 3, max_days: 4 },
{ pincode: 531033, min_days: 3, max_days: 4 },
{ pincode: 531061, min_days: 3, max_days: 4 },
{ pincode: 531114, min_days: 3, max_days: 4 },
{ pincode: 531116, min_days: 3, max_days: 4 },
{ pincode: 531118, min_days: 3, max_days: 4 },
{ pincode: 531126, min_days: 3, max_days: 4 },
{ pincode: 531162, min_days: 3, max_days: 4 },
{ pincode: 531163, min_days: 3, max_days: 4 },
{ pincode: 531173, min_days: 3, max_days: 4 },
{ pincode: 532001, min_days: 3, max_days: 4 },
{ pincode: 532005, min_days: 3, max_days: 4 },
{ pincode: 532127, min_days: 4, max_days: 5 },
{ pincode: 532185, min_days: 4, max_days: 5 },
{ pincode: 532186, min_days: 4, max_days: 5 },
{ pincode: 532195, min_days: 4, max_days: 5 },
{ pincode: 532201, min_days: 4, max_days: 5 },
{ pincode: 532203, min_days: 4, max_days: 5 },
{ pincode: 532211, min_days: 4, max_days: 5 },
{ pincode: 532212, min_days: 4, max_days: 5 },
{ pincode: 532221, min_days: 4, max_days: 5 },
{ pincode: 532222, min_days: 4, max_days: 5 },
{ pincode: 532405, min_days: 4, max_days: 5 },
{ pincode: 532406, min_days: 4, max_days: 5 },
{ pincode: 532409, min_days: 3, max_days: 4 },
{ pincode: 532421, min_days: 4, max_days: 5 },
{ pincode: 532430, min_days: 4, max_days: 5 },
{ pincode: 532464, min_days: 3, max_days: 4 },
{ pincode: 532484, min_days: 4, max_days: 5 },
{ pincode: 533001, min_days: 3, max_days: 4 },
{ pincode: 533002, min_days: 3, max_days: 4 },
{ pincode: 533003, min_days: 3, max_days: 4 },
{ pincode: 533004, min_days: 3, max_days: 4 },
{ pincode: 533005, min_days: 3, max_days: 4 },
{ pincode: 533006, min_days: 3, max_days: 4 },
{ pincode: 533007, min_days: 3, max_days: 4 },
{ pincode: 533008, min_days: 3, max_days: 4 },
{ pincode: 533016, min_days: 3, max_days: 4 },
{ pincode: 533101, min_days: 3, max_days: 4 },
{ pincode: 533102, min_days: 3, max_days: 4 },
{ pincode: 533103, min_days: 3, max_days: 4 },
{ pincode: 533104, min_days: 3, max_days: 4 },
{ pincode: 533105, min_days: 3, max_days: 4 },
{ pincode: 533106, min_days: 3, max_days: 4 },
{ pincode: 533107, min_days: 3, max_days: 4 },
{ pincode: 533125, min_days: 3, max_days: 4 },
{ pincode: 533126, min_days: 3, max_days: 4 },
{ pincode: 533201, min_days: 3, max_days: 4 },
{ pincode: 533211, min_days: 3, max_days: 4 },
{ pincode: 533216, min_days: 3, max_days: 4 },
{ pincode: 533223, min_days: 3, max_days: 4 },
{ pincode: 533242, min_days: 3, max_days: 4 },
{ pincode: 533244, min_days: 3, max_days: 4 },
{ pincode: 533250, min_days: 3, max_days: 4 },
{ pincode: 533251, min_days: 3, max_days: 4 },
{ pincode: 533253, min_days: 3, max_days: 4 },
{ pincode: 533254, min_days: 3, max_days: 4 },
{ pincode: 533291, min_days: 3, max_days: 4 },
{ pincode: 533294, min_days: 3, max_days: 4 },
{ pincode: 533296, min_days: 3, max_days: 4 },
{ pincode: 533342, min_days: 3, max_days: 4 },
{ pincode: 533345, min_days: 3, max_days: 4 },
{ pincode: 533346, min_days: 3, max_days: 4 },
{ pincode: 533349, min_days: 3, max_days: 4 },
{ pincode: 533350, min_days: 3, max_days: 4 },
{ pincode: 533351, min_days: 3, max_days: 4 },
{ pincode: 533401, min_days: 3, max_days: 4 },
{ pincode: 533406, min_days: 3, max_days: 4 },
{ pincode: 533444, min_days: 3, max_days: 4 },
{ pincode: 533445, min_days: 3, max_days: 4 },
{ pincode: 533447, min_days: 3, max_days: 4 },
{ pincode: 533450, min_days: 3, max_days: 4 },
{ pincode: 533463, min_days: 3, max_days: 4 },
{ pincode: 533464, min_days: 3, max_days: 4 },
{ pincode: 534001, min_days: 3, max_days: 4 },
{ pincode: 534002, min_days: 3, max_days: 4 },
{ pincode: 534003, min_days: 3, max_days: 4 },
{ pincode: 534004, min_days: 3, max_days: 4 },
{ pincode: 534005, min_days: 3, max_days: 4 },
{ pincode: 534006, min_days: 3, max_days: 4 },
{ pincode: 534007, min_days: 3, max_days: 4 },
{ pincode: 534101, min_days: 3, max_days: 4 },
{ pincode: 534102, min_days: 3, max_days: 4 },
{ pincode: 534111, min_days: 3, max_days: 4 },
{ pincode: 534112, min_days: 3, max_days: 4 },
{ pincode: 534145, min_days: 3, max_days: 4 },
{ pincode: 534146, min_days: 3, max_days: 4 },
{ pincode: 534165, min_days: 3, max_days: 4 },
{ pincode: 534166, min_days: 3, max_days: 4 },
{ pincode: 534195, min_days: 3, max_days: 4 },
{ pincode: 534196, min_days: 3, max_days: 4 },
{ pincode: 534197, min_days: 3, max_days: 4 },
{ pincode: 534201, min_days: 3, max_days: 4 },
{ pincode: 534202, min_days: 3, max_days: 4 },
{ pincode: 534203, min_days: 3, max_days: 4 },
{ pincode: 534204, min_days: 3, max_days: 4 },
{ pincode: 534211, min_days: 3, max_days: 4 },
{ pincode: 534247, min_days: 3, max_days: 4 },
{ pincode: 534250, min_days: 3, max_days: 4 },
{ pincode: 534251, min_days: 3, max_days: 4 },
{ pincode: 534260, min_days: 3, max_days: 4 },
{ pincode: 534265, min_days: 3, max_days: 4 },
{ pincode: 534266, min_days: 3, max_days: 4 },
{ pincode: 534268, min_days: 3, max_days: 4 },
{ pincode: 534275, min_days: 4, max_days: 5 },
{ pincode: 534281, min_days: 3, max_days: 4 },
{ pincode: 534301, min_days: 3, max_days: 4 },
{ pincode: 534305, min_days: 3, max_days: 4 },
{ pincode: 534313, min_days: 3, max_days: 4 },
{ pincode: 534327, min_days: 3, max_days: 4 },
{ pincode: 534338, min_days: 3, max_days: 4 },
{ pincode: 534350, min_days: 3, max_days: 4 },
{ pincode: 534401, min_days: 3, max_days: 4 },
{ pincode: 534406, min_days: 3, max_days: 4 },
{ pincode: 534411, min_days: 3, max_days: 4 },
{ pincode: 534416, min_days: 3, max_days: 4 },
{ pincode: 534425, min_days: 3, max_days: 4 },
{ pincode: 534435, min_days: 3, max_days: 4 },
{ pincode: 534437, min_days: 3, max_days: 4 },
{ pincode: 534442, min_days: 3, max_days: 4 },
{ pincode: 534444, min_days: 3, max_days: 4 },
{ pincode: 534460, min_days: 4, max_days: 5 },
{ pincode: 534467, min_days: 3, max_days: 4 },
{ pincode: 534475, min_days: 3, max_days: 4 },
{ pincode: 535001, min_days: 3, max_days: 4 },
{ pincode: 535002, min_days: 3, max_days: 4 },
{ pincode: 535101, min_days: 4, max_days: 5 },
{ pincode: 535117, min_days: 3, max_days: 4 },
{ pincode: 535128, min_days: 4, max_days: 5 },
{ pincode: 535204, min_days: 3, max_days: 4 },
{ pincode: 535217, min_days: 4, max_days: 5 },
{ pincode: 535501, min_days: 4, max_days: 5 },
{ pincode: 535502, min_days: 4, max_days: 5 },
{ pincode: 535522, min_days: 4, max_days: 5 },
{ pincode: 535527, min_days: 4, max_days: 5 },
{ pincode: 536201, min_days: 2, max_days: 3 },
{ pincode: 544444, min_days: 2, max_days: 3 },
{ pincode: 555555, min_days: 2, max_days: 3 },
{ pincode: 560000, min_days: 2, max_days: 3 },
{ pincode: 560001, min_days: 2, max_days: 3 },
{ pincode: 560002, min_days: 2, max_days: 3 },
{ pincode: 560003, min_days: 2, max_days: 3 },
{ pincode: 560004, min_days: 2, max_days: 3 },
{ pincode: 560005, min_days: 2, max_days: 3 },
{ pincode: 560006, min_days: 2, max_days: 3 },
{ pincode: 560007, min_days: 2, max_days: 3 },
{ pincode: 560008, min_days: 2, max_days: 3 },
{ pincode: 560009, min_days: 2, max_days: 3 },
{ pincode: 560010, min_days: 2, max_days: 3 },
{ pincode: 560011, min_days: 2, max_days: 3 },
{ pincode: 560012, min_days: 2, max_days: 3 },
{ pincode: 560013, min_days: 2, max_days: 3 },
{ pincode: 560014, min_days: 2, max_days: 3 },
{ pincode: 560015, min_days: 2, max_days: 3 },
{ pincode: 560016, min_days: 2, max_days: 3 },
{ pincode: 560017, min_days: 2, max_days: 3 },
{ pincode: 560018, min_days: 2, max_days: 3 },
{ pincode: 560019, min_days: 2, max_days: 3 },
{ pincode: 560020, min_days: 2, max_days: 3 },
{ pincode: 560021, min_days: 2, max_days: 3 },
{ pincode: 560022, min_days: 2, max_days: 3 },
{ pincode: 560023, min_days: 2, max_days: 3 },
{ pincode: 560024, min_days: 2, max_days: 3 },
{ pincode: 560025, min_days: 2, max_days: 3 },
{ pincode: 560026, min_days: 2, max_days: 3 },
{ pincode: 560027, min_days: 2, max_days: 3 },
{ pincode: 560028, min_days: 2, max_days: 3 },
{ pincode: 560029, min_days: 2, max_days: 3 },
{ pincode: 560030, min_days: 2, max_days: 3 },
{ pincode: 560031, min_days: 2, max_days: 3 },
{ pincode: 560032, min_days: 2, max_days: 3 },
{ pincode: 560033, min_days: 2, max_days: 3 },
{ pincode: 560034, min_days: 2, max_days: 3 },
{ pincode: 560035, min_days: 2, max_days: 3 },
{ pincode: 560036, min_days: 2, max_days: 3 },
{ pincode: 560037, min_days: 2, max_days: 3 },
{ pincode: 560038, min_days: 2, max_days: 3 },
{ pincode: 560039, min_days: 2, max_days: 3 },
{ pincode: 560040, min_days: 2, max_days: 3 },
{ pincode: 560041, min_days: 2, max_days: 3 },
{ pincode: 560042, min_days: 2, max_days: 3 },
{ pincode: 560043, min_days: 2, max_days: 3 },
{ pincode: 560044, min_days: 2, max_days: 3 },
{ pincode: 560045, min_days: 2, max_days: 3 },
{ pincode: 560046, min_days: 2, max_days: 3 },
{ pincode: 560047, min_days: 2, max_days: 3 },
{ pincode: 560048, min_days: 2, max_days: 3 },
{ pincode: 560049, min_days: 2, max_days: 3 },
{ pincode: 560050, min_days: 2, max_days: 3 },
{ pincode: 560051, min_days: 2, max_days: 3 },
{ pincode: 560052, min_days: 2, max_days: 3 },
{ pincode: 560053, min_days: 2, max_days: 3 },
{ pincode: 560054, min_days: 2, max_days: 3 },
{ pincode: 560055, min_days: 2, max_days: 3 },
{ pincode: 560056, min_days: 2, max_days: 3 },
{ pincode: 560057, min_days: 2, max_days: 3 },
{ pincode: 560058, min_days: 2, max_days: 3 },
{ pincode: 560059, min_days: 2, max_days: 3 },
{ pincode: 560060, min_days: 2, max_days: 3 },
{ pincode: 560061, min_days: 2, max_days: 3 },
{ pincode: 560062, min_days: 2, max_days: 3 },
{ pincode: 560063, min_days: 2, max_days: 3 },
{ pincode: 560064, min_days: 2, max_days: 3 },
{ pincode: 560065, min_days: 2, max_days: 3 },
{ pincode: 560066, min_days: 2, max_days: 3 },
{ pincode: 560067, min_days: 2, max_days: 3 },
{ pincode: 560068, min_days: 2, max_days: 3 },
{ pincode: 560069, min_days: 2, max_days: 3 },
{ pincode: 560070, min_days: 2, max_days: 3 },
{ pincode: 560071, min_days: 2, max_days: 3 },
{ pincode: 560072, min_days: 2, max_days: 3 },
{ pincode: 560073, min_days: 2, max_days: 3 },
{ pincode: 560074, min_days: 2, max_days: 3 },
{ pincode: 560075, min_days: 2, max_days: 3 },
{ pincode: 560076, min_days: 2, max_days: 3 },
{ pincode: 560077, min_days: 2, max_days: 3 },
{ pincode: 560078, min_days: 2, max_days: 3 },
{ pincode: 560079, min_days: 2, max_days: 3 },
{ pincode: 560080, min_days: 2, max_days: 3 },
{ pincode: 560081, min_days: 2, max_days: 3 },
{ pincode: 560082, min_days: 2, max_days: 3 },
{ pincode: 560083, min_days: 2, max_days: 3 },
{ pincode: 560084, min_days: 2, max_days: 3 },
{ pincode: 560085, min_days: 2, max_days: 3 },
{ pincode: 560086, min_days: 2, max_days: 3 },
{ pincode: 560087, min_days: 2, max_days: 3 },
{ pincode: 560088, min_days: 2, max_days: 3 },
{ pincode: 560089, min_days: 2, max_days: 3 },
{ pincode: 560090, min_days: 2, max_days: 3 },
{ pincode: 560091, min_days: 2, max_days: 3 },
{ pincode: 560092, min_days: 2, max_days: 3 },
{ pincode: 560093, min_days: 2, max_days: 3 },
{ pincode: 560094, min_days: 2, max_days: 3 },
{ pincode: 560095, min_days: 2, max_days: 3 },
{ pincode: 560096, min_days: 2, max_days: 3 },
{ pincode: 560097, min_days: 2, max_days: 3 },
{ pincode: 560098, min_days: 2, max_days: 3 },
{ pincode: 560099, min_days: 2, max_days: 3 },
{ pincode: 560100, min_days: 2, max_days: 3 },
{ pincode: 560102, min_days: 2, max_days: 3 },
{ pincode: 560103, min_days: 2, max_days: 3 },
{ pincode: 560104, min_days: 2, max_days: 3 },
{ pincode: 560105, min_days: 2, max_days: 3 },
{ pincode: 560106, min_days: 2, max_days: 3 },
{ pincode: 560107, min_days: 2, max_days: 3 },
{ pincode: 560108, min_days: 2, max_days: 3 },
{ pincode: 560109, min_days: 2, max_days: 3 },
{ pincode: 560110, min_days: 2, max_days: 3 },
{ pincode: 560111, min_days: 2, max_days: 3 },
{ pincode: 560112, min_days: 2, max_days: 3 },
{ pincode: 560300, min_days: 2, max_days: 3 },
{ pincode: 560500, min_days: 2, max_days: 3 },
{ pincode: 561201, min_days: 2, max_days: 3 },
{ pincode: 561202, min_days: 3, max_days: 4 },
{ pincode: 561203, min_days: 2, max_days: 3 },
{ pincode: 561205, min_days: 2, max_days: 3 },
{ pincode: 561206, min_days: 3, max_days: 4 },
{ pincode: 561207, min_days: 3, max_days: 4 },
{ pincode: 561208, min_days: 3, max_days: 4 },
{ pincode: 561210, min_days: 3, max_days: 4 },
{ pincode: 561211, min_days: 3, max_days: 4 },
{ pincode: 561212, min_days: 3, max_days: 4 },
{ pincode: 561213, min_days: 3, max_days: 4 },
{ pincode: 562101, min_days: 2, max_days: 3 },
{ pincode: 562103, min_days: 2, max_days: 3 },
{ pincode: 562105, min_days: 2, max_days: 3 },
{ pincode: 562106, min_days: 2, max_days: 3 },
{ pincode: 562107, min_days: 2, max_days: 3 },
{ pincode: 562109, min_days: 2, max_days: 3 },
{ pincode: 562110, min_days: 2, max_days: 3 },
{ pincode: 562111, min_days: 3, max_days: 4 },
{ pincode: 562112, min_days: 3, max_days: 4 },
{ pincode: 562114, min_days: 2, max_days: 3 },
{ pincode: 562115, min_days: 2, max_days: 3 },
{ pincode: 562116, min_days: 2, max_days: 3 },
{ pincode: 562120, min_days: 3, max_days: 4 },
{ pincode: 562122, min_days: 2, max_days: 3 },
{ pincode: 562123, min_days: 2, max_days: 3 },
{ pincode: 562125, min_days: 2, max_days: 3 },
{ pincode: 562127, min_days: 3, max_days: 4 },
{ pincode: 562129, min_days: 2, max_days: 3 },
{ pincode: 562130, min_days: 3, max_days: 4 },
{ pincode: 562132, min_days: 2, max_days: 3 },
{ pincode: 562137, min_days: 3, max_days: 4 },
{ pincode: 562149, min_days: 2, max_days: 3 },
{ pincode: 562151, min_days: 3, max_days: 4 },
{ pincode: 562152, min_days: 2, max_days: 3 },
{ pincode: 562157, min_days: 2, max_days: 3 },
{ pincode: 562159, min_days: 3, max_days: 4 },
{ pincode: 562160, min_days: 3, max_days: 4 },
{ pincode: 562161, min_days: 3, max_days: 4 },
{ pincode: 562162, min_days: 2, max_days: 3 },
{ pincode: 562163, min_days: 2, max_days: 3 },
{ pincode: 563101, min_days: 2, max_days: 3 },
{ pincode: 563102, min_days: 2, max_days: 3 },
{ pincode: 563103, min_days: 2, max_days: 3 },
{ pincode: 563109, min_days: 2, max_days: 3 },
{ pincode: 563113, min_days: 2, max_days: 3 },
{ pincode: 563115, min_days: 2, max_days: 3 },
{ pincode: 563116, min_days: 2, max_days: 3 },
{ pincode: 563117, min_days: 2, max_days: 3 },
{ pincode: 563118, min_days: 2, max_days: 3 },
{ pincode: 563119, min_days: 2, max_days: 3 },
{ pincode: 563120, min_days: 2, max_days: 3 },
{ pincode: 563121, min_days: 2, max_days: 3 },
{ pincode: 563122, min_days: 2, max_days: 3 },
{ pincode: 563125, min_days: 2, max_days: 3 },
{ pincode: 563128, min_days: 2, max_days: 3 },
{ pincode: 563130, min_days: 2, max_days: 3 },
{ pincode: 563131, min_days: 2, max_days: 3 },
{ pincode: 563133, min_days: 2, max_days: 3 },
{ pincode: 563333, min_days: 2, max_days: 3 },
{ pincode: 564545, min_days: 1, max_days: 2 },
{ pincode: 566105, min_days: 2, max_days: 3 },
{ pincode: 566666, min_days: 2, max_days: 3 },
{ pincode: 566667, min_days: 2, max_days: 3 },
{ pincode: 567233, min_days: 2, max_days: 3 },
{ pincode: 567777, min_days: 2, max_days: 3 },
{ pincode: 569999, min_days: 2, max_days: 3 },
{ pincode: 570001, min_days: 2, max_days: 3 },
{ pincode: 570002, min_days: 2, max_days: 3 },
{ pincode: 570003, min_days: 2, max_days: 3 },
{ pincode: 570004, min_days: 2, max_days: 3 },
{ pincode: 570005, min_days: 2, max_days: 3 },
{ pincode: 570006, min_days: 2, max_days: 3 },
{ pincode: 570007, min_days: 2, max_days: 3 },
{ pincode: 570008, min_days: 2, max_days: 3 },
{ pincode: 570009, min_days: 2, max_days: 3 },
{ pincode: 570010, min_days: 2, max_days: 3 },
{ pincode: 570011, min_days: 2, max_days: 3 },
{ pincode: 570012, min_days: 2, max_days: 3 },
{ pincode: 570013, min_days: 2, max_days: 3 },
{ pincode: 570014, min_days: 2, max_days: 3 },
{ pincode: 570015, min_days: 2, max_days: 3 },
{ pincode: 570016, min_days: 2, max_days: 3 },
{ pincode: 570017, min_days: 2, max_days: 3 },
{ pincode: 570018, min_days: 2, max_days: 3 },
{ pincode: 570019, min_days: 2, max_days: 3 },
{ pincode: 570020, min_days: 2, max_days: 3 },
{ pincode: 570021, min_days: 2, max_days: 3 },
{ pincode: 570022, min_days: 2, max_days: 3 },
{ pincode: 570023, min_days: 2, max_days: 3 },
{ pincode: 570024, min_days: 2, max_days: 3 },
{ pincode: 570025, min_days: 2, max_days: 3 },
{ pincode: 570026, min_days: 2, max_days: 3 },
{ pincode: 570027, min_days: 2, max_days: 3 },
{ pincode: 570028, min_days: 2, max_days: 3 },
{ pincode: 570029, min_days: 2, max_days: 3 },
{ pincode: 570030, min_days: 2, max_days: 3 },
{ pincode: 570031, min_days: 2, max_days: 3 },
{ pincode: 570041, min_days: 3, max_days: 4 },
{ pincode: 570301, min_days: 3, max_days: 4 },
{ pincode: 571101, min_days: 3, max_days: 4 },
{ pincode: 571103, min_days: 2, max_days: 3 },
{ pincode: 571104, min_days: 3, max_days: 4 },
{ pincode: 571105, min_days: 2, max_days: 3 },
{ pincode: 571106, min_days: 2, max_days: 3 },
{ pincode: 571107, min_days: 3, max_days: 4 },
{ pincode: 571109, min_days: 3, max_days: 4 },
{ pincode: 571110, min_days: 3, max_days: 4 },
{ pincode: 571111, min_days: 3, max_days: 4 },
{ pincode: 571114, min_days: 2, max_days: 3 },
{ pincode: 571115, min_days: 3, max_days: 4 },
{ pincode: 571116, min_days: 2, max_days: 3 },
{ pincode: 571117, min_days: 3, max_days: 4 },
{ pincode: 571118, min_days: 3, max_days: 4 },
{ pincode: 571119, min_days: 3, max_days: 4 },
{ pincode: 571120, min_days: 3, max_days: 4 },
{ pincode: 571121, min_days: 2, max_days: 3 },
{ pincode: 571122, min_days: 3, max_days: 4 },
{ pincode: 571123, min_days: 3, max_days: 4 },
{ pincode: 571124, min_days: 3, max_days: 4 },
{ pincode: 571127, min_days: 3, max_days: 4 },
{ pincode: 571128, min_days: 3, max_days: 4 },
{ pincode: 571129, min_days: 3, max_days: 4 },
{ pincode: 571130, min_days: 2, max_days: 3 },
{ pincode: 571139, min_days: 3, max_days: 4 },
{ pincode: 571156, min_days: 3, max_days: 4 },
{ pincode: 571159, min_days: 3, max_days: 4 },
{ pincode: 571166, min_days: 2, max_days: 3 },
{ pincode: 571186, min_days: 2, max_days: 3 },
{ pincode: 571189, min_days: 2, max_days: 3 },
{ pincode: 571201, min_days: 3, max_days: 4 },
{ pincode: 571213, min_days: 3, max_days: 4 },
{ pincode: 571214, min_days: 3, max_days: 4 },
{ pincode: 571215, min_days: 3, max_days: 4 },
{ pincode: 571216, min_days: 3, max_days: 4 },
{ pincode: 571217, min_days: 3, max_days: 4 },
{ pincode: 571218, min_days: 3, max_days: 4 },
{ pincode: 571219, min_days: 3, max_days: 4 },
{ pincode: 571221, min_days: 3, max_days: 4 },
{ pincode: 571231, min_days: 3, max_days: 4 },
{ pincode: 571232, min_days: 3, max_days: 4 },
{ pincode: 571233, min_days: 3, max_days: 4 },
{ pincode: 571234, min_days: 3, max_days: 4 },
{ pincode: 571235, min_days: 3, max_days: 4 },
{ pincode: 571236, min_days: 3, max_days: 4 },
{ pincode: 571237, min_days: 3, max_days: 4 },
{ pincode: 571248, min_days: 3, max_days: 4 },
{ pincode: 571251, min_days: 3, max_days: 4 },
{ pincode: 571301, min_days: 3, max_days: 4 },
{ pincode: 571302, min_days: 3, max_days: 4 },
{ pincode: 571304, min_days: 3, max_days: 4 },
{ pincode: 571311, min_days: 3, max_days: 4 },
{ pincode: 571312, min_days: 3, max_days: 4 },
{ pincode: 571313, min_days: 3, max_days: 4 },
{ pincode: 571314, min_days: 3, max_days: 4 },
{ pincode: 571315, min_days: 3, max_days: 4 },
{ pincode: 571319, min_days: 3, max_days: 4 },
{ pincode: 571320, min_days: 3, max_days: 4 },
{ pincode: 571321, min_days: 3, max_days: 4 },
{ pincode: 571322, min_days: 2, max_days: 3 },
{ pincode: 571325, min_days: 3, max_days: 4 },
{ pincode: 571329, min_days: 3, max_days: 4 },
{ pincode: 571331, min_days: 3, max_days: 4 },
{ pincode: 571337, min_days: 3, max_days: 4 },
{ pincode: 571342, min_days: 3, max_days: 4 },
{ pincode: 571401, min_days: 3, max_days: 4 },
{ pincode: 571402, min_days: 3, max_days: 4 },
{ pincode: 571403, min_days: 3, max_days: 4 },
{ pincode: 571404, min_days: 3, max_days: 4 },
{ pincode: 571405, min_days: 3, max_days: 4 },
{ pincode: 571415, min_days: 3, max_days: 4 },
{ pincode: 571416, min_days: 3, max_days: 4 },
{ pincode: 571418, min_days: 3, max_days: 4 },
{ pincode: 571419, min_days: 3, max_days: 4 },
{ pincode: 571422, min_days: 3, max_days: 4 },
{ pincode: 571423, min_days: 3, max_days: 4 },
{ pincode: 571425, min_days: 3, max_days: 4 },
{ pincode: 571426, min_days: 3, max_days: 4 },
{ pincode: 571427, min_days: 3, max_days: 4 },
{ pincode: 571428, min_days: 3, max_days: 4 },
{ pincode: 571429, min_days: 3, max_days: 4 },
{ pincode: 571430, min_days: 3, max_days: 4 },
{ pincode: 571431, min_days: 3, max_days: 4 },
{ pincode: 571432, min_days: 3, max_days: 4 },
{ pincode: 571433, min_days: 3, max_days: 4 },
{ pincode: 571434, min_days: 3, max_days: 4 },
{ pincode: 571435, min_days: 3, max_days: 4 },
{ pincode: 571436, min_days: 3, max_days: 4 },
{ pincode: 571437, min_days: 3, max_days: 4 },
{ pincode: 571438, min_days: 3, max_days: 4 },
{ pincode: 571439, min_days: 3, max_days: 4 },
{ pincode: 571440, min_days: 3, max_days: 4 },
{ pincode: 571441, min_days: 3, max_days: 4 },
{ pincode: 571442, min_days: 3, max_days: 4 },
{ pincode: 571443, min_days: 3, max_days: 4 },
{ pincode: 571445, min_days: 3, max_days: 4 },
{ pincode: 571446, min_days: 3, max_days: 4 },
{ pincode: 571448, min_days: 3, max_days: 4 },
{ pincode: 571450, min_days: 3, max_days: 4 },
{ pincode: 571454, min_days: 3, max_days: 4 },
{ pincode: 571455, min_days: 3, max_days: 4 },
{ pincode: 571457, min_days: 3, max_days: 4 },
{ pincode: 571463, min_days: 3, max_days: 4 },
{ pincode: 571476, min_days: 3, max_days: 4 },
{ pincode: 571477, min_days: 3, max_days: 4 },
{ pincode: 571478, min_days: 3, max_days: 4 },
{ pincode: 571480, min_days: 3, max_days: 4 },
{ pincode: 571483, min_days: 2, max_days: 3 },
{ pincode: 571501, min_days: 3, max_days: 4 },
{ pincode: 571502, min_days: 3, max_days: 4 },
{ pincode: 571511, min_days: 3, max_days: 4 },
{ pincode: 571602, min_days: 2, max_days: 3 },
{ pincode: 571603, min_days: 2, max_days: 3 },
{ pincode: 571604, min_days: 2, max_days: 3 },
{ pincode: 571605, min_days: 3, max_days: 4 },
{ pincode: 571606, min_days: 3, max_days: 4 },
{ pincode: 571607, min_days: 3, max_days: 4 },
{ pincode: 571610, min_days: 2, max_days: 3 },
{ pincode: 571617, min_days: 2, max_days: 3 },
{ pincode: 571802, min_days: 3, max_days: 4 },
{ pincode: 571810, min_days: 3, max_days: 4 },
{ pincode: 571811, min_days: 3, max_days: 4 },
{ pincode: 571812, min_days: 3, max_days: 4 },
{ pincode: 572101, min_days: 3, max_days: 4 },
{ pincode: 572102, min_days: 3, max_days: 4 },
{ pincode: 572103, min_days: 3, max_days: 4 },
{ pincode: 572104, min_days: 3, max_days: 4 },
{ pincode: 572105, min_days: 3, max_days: 4 },
{ pincode: 572106, min_days: 3, max_days: 4 },
{ pincode: 572107, min_days: 3, max_days: 4 },
{ pincode: 572108, min_days: 3, max_days: 4 },
{ pincode: 572111, min_days: 3, max_days: 4 },
{ pincode: 572112, min_days: 3, max_days: 4 },
{ pincode: 572114, min_days: 3, max_days: 4 },
{ pincode: 572118, min_days: 3, max_days: 4 },
{ pincode: 572122, min_days: 3, max_days: 4 },
{ pincode: 572128, min_days: 3, max_days: 4 },
{ pincode: 572130, min_days: 3, max_days: 4 },
{ pincode: 572137, min_days: 3, max_days: 4 },
{ pincode: 572138, min_days: 3, max_days: 4 },
{ pincode: 572140, min_days: 3, max_days: 4 },
{ pincode: 572143, min_days: 3, max_days: 4 },
{ pincode: 572144, min_days: 3, max_days: 4 },
{ pincode: 572145, min_days: 3, max_days: 4 },
{ pincode: 572151, min_days: 3, max_days: 4 },
{ pincode: 572168, min_days: 3, max_days: 4 },
{ pincode: 572201, min_days: 3, max_days: 4 },
{ pincode: 572202, min_days: 3, max_days: 4 },
{ pincode: 572441, min_days: 3, max_days: 4 },
{ pincode: 573101, min_days: 2, max_days: 3 },
{ pincode: 573102, min_days: 3, max_days: 4 },
{ pincode: 573103, min_days: 3, max_days: 4 },
{ pincode: 573111, min_days: 3, max_days: 4 },
{ pincode: 573112, min_days: 3, max_days: 4 },
{ pincode: 573115, min_days: 2, max_days: 3 },
{ pincode: 573116, min_days: 3, max_days: 4 },
{ pincode: 573118, min_days: 2, max_days: 3 },
{ pincode: 573120, min_days: 2, max_days: 3 },
{ pincode: 573121, min_days: 2, max_days: 3 },
{ pincode: 573124, min_days: 3, max_days: 4 },
{ pincode: 573128, min_days: 2, max_days: 3 },
{ pincode: 573130, min_days: 3, max_days: 4 },
{ pincode: 573131, min_days: 3, max_days: 4 },
{ pincode: 573133, min_days: 3, max_days: 4 },
{ pincode: 573134, min_days: 3, max_days: 4 },
{ pincode: 573135, min_days: 3, max_days: 4 },
{ pincode: 573143, min_days: 2, max_days: 3 },
{ pincode: 573145, min_days: 2, max_days: 3 },
{ pincode: 573147, min_days: 3, max_days: 4 },
{ pincode: 573150, min_days: 3, max_days: 4 },
{ pincode: 573160, min_days: 3, max_days: 4 },
{ pincode: 573165, min_days: 3, max_days: 4 },
{ pincode: 573201, min_days: 2, max_days: 3 },
{ pincode: 573202, min_days: 2, max_days: 3 },
{ pincode: 573210, min_days: 3, max_days: 4 },
{ pincode: 573211, min_days: 3, max_days: 4 },
{ pincode: 573212, min_days: 2, max_days: 3 },
{ pincode: 573215, min_days: 2, max_days: 3 },
{ pincode: 573216, min_days: 2, max_days: 3 },
{ pincode: 573217, min_days: 2, max_days: 3 },
{ pincode: 573219, min_days: 2, max_days: 3 },
{ pincode: 573220, min_days: 2, max_days: 3 },
{ pincode: 573225, min_days: 2, max_days: 3 },
{ pincode: 573226, min_days: 2, max_days: 3 },
{ pincode: 573228, min_days: 2, max_days: 3 },
{ pincode: 573425, min_days: 3, max_days: 4 },
{ pincode: 573445, min_days: 3, max_days: 4 },
{ pincode: 573628, min_days: 2, max_days: 3 },
{ pincode: 574101, min_days: 2, max_days: 3 },
{ pincode: 574103, min_days: 2, max_days: 3 },
{ pincode: 574104, min_days: 2, max_days: 3 },
{ pincode: 574105, min_days: 2, max_days: 3 },
{ pincode: 574106, min_days: 2, max_days: 3 },
{ pincode: 574108, min_days: 2, max_days: 3 },
{ pincode: 574110, min_days: 2, max_days: 3 },
{ pincode: 574111, min_days: 2, max_days: 3 },
{ pincode: 574112, min_days: 2, max_days: 3 },
{ pincode: 574113, min_days: 2, max_days: 3 },
{ pincode: 574115, min_days: 2, max_days: 3 },
{ pincode: 574116, min_days: 2, max_days: 3 },
{ pincode: 574117, min_days: 2, max_days: 3 },
{ pincode: 574118, min_days: 2, max_days: 3 },
{ pincode: 574119, min_days: 2, max_days: 3 },
{ pincode: 574120, min_days: 2, max_days: 3 },
{ pincode: 574122, min_days: 2, max_days: 3 },
{ pincode: 574123, min_days: 2, max_days: 3 },
{ pincode: 574126, min_days: 2, max_days: 3 },
{ pincode: 574130, min_days: 2, max_days: 3 },
{ pincode: 574131, min_days: 2, max_days: 3 },
{ pincode: 574134, min_days: 2, max_days: 3 },
{ pincode: 574138, min_days: 2, max_days: 3 },
{ pincode: 574139, min_days: 2, max_days: 3 },
{ pincode: 574140, min_days: 2, max_days: 3 },
{ pincode: 574141, min_days: 2, max_days: 3 },
{ pincode: 574143, min_days: 3, max_days: 4 },
{ pincode: 574144, min_days: 2, max_days: 3 },
{ pincode: 574146, min_days: 2, max_days: 3 },
{ pincode: 574150, min_days: 2, max_days: 3 },
{ pincode: 574151, min_days: 2, max_days: 3 },
{ pincode: 574152, min_days: 2, max_days: 3 },
{ pincode: 574153, min_days: 2, max_days: 3 },
{ pincode: 574154, min_days: 2, max_days: 3 },
{ pincode: 574157, min_days: 2, max_days: 3 },
{ pincode: 574159, min_days: 2, max_days: 3 },
{ pincode: 574160, min_days: 2, max_days: 3 },
{ pincode: 574161, min_days: 2, max_days: 3 },
{ pincode: 574162, min_days: 2, max_days: 3 },
{ pincode: 574163, min_days: 2, max_days: 3 },
{ pincode: 574164, min_days: 2, max_days: 3 },
{ pincode: 574165, min_days: 2, max_days: 3 },
{ pincode: 574166, min_days: 2, max_days: 3 },
{ pincode: 574167, min_days: 2, max_days: 3 },
{ pincode: 574168, min_days: 2, max_days: 3 },
{ pincode: 574169, min_days: 3, max_days: 4 },
{ pincode: 574171, min_days: 2, max_days: 3 },
{ pincode: 574172, min_days: 2, max_days: 3 },
{ pincode: 574173, min_days: 2, max_days: 3 },
{ pincode: 574179, min_days: 2, max_days: 3 },
{ pincode: 574180, min_days: 2, max_days: 3 },
{ pincode: 574181, min_days: 2, max_days: 3 },
{ pincode: 574182, min_days: 2, max_days: 3 },
{ pincode: 574183, min_days: 2, max_days: 3 },
{ pincode: 574184, min_days: 2, max_days: 3 },
{ pincode: 574187, min_days: 3, max_days: 4 },
{ pincode: 574188, min_days: 3, max_days: 4 },
{ pincode: 574189, min_days: 2, max_days: 3 },
{ pincode: 574194, min_days: 2, max_days: 3 },
{ pincode: 574197, min_days: 2, max_days: 3 },
{ pincode: 574198, min_days: 3, max_days: 4 },
{ pincode: 574199, min_days: 2, max_days: 3 },
{ pincode: 574201, min_days: 3, max_days: 4 },
{ pincode: 574202, min_days: 3, max_days: 4 },
{ pincode: 574203, min_days: 3, max_days: 4 },
{ pincode: 574210, min_days: 3, max_days: 4 },
{ pincode: 574211, min_days: 3, max_days: 4 },
{ pincode: 574212, min_days: 3, max_days: 4 },
{ pincode: 574213, min_days: 2, max_days: 3 },
{ pincode: 574214, min_days: 3, max_days: 4 },
{ pincode: 574216, min_days: 3, max_days: 4 },
{ pincode: 574217, min_days: 3, max_days: 4 },
{ pincode: 574218, min_days: 3, max_days: 4 },
{ pincode: 574219, min_days: 3, max_days: 4 },
{ pincode: 574220, min_days: 3, max_days: 4 },
{ pincode: 574221, min_days: 3, max_days: 4 },
{ pincode: 574222, min_days: 3, max_days: 4 },
{ pincode: 574223, min_days: 3, max_days: 4 },
{ pincode: 574224, min_days: 3, max_days: 4 },
{ pincode: 574225, min_days: 2, max_days: 3 },
{ pincode: 574226, min_days: 2, max_days: 3 },
{ pincode: 574227, min_days: 2, max_days: 3 },
{ pincode: 574228, min_days: 3, max_days: 4 },
{ pincode: 574229, min_days: 3, max_days: 4 },
{ pincode: 574230, min_days: 3, max_days: 4 },
{ pincode: 574231, min_days: 3, max_days: 4 },
{ pincode: 574232, min_days: 3, max_days: 4 },
{ pincode: 574233, min_days: 3, max_days: 4 },
{ pincode: 574237, min_days: 2, max_days: 3 },
{ pincode: 574238, min_days: 3, max_days: 4 },
{ pincode: 574239, min_days: 3, max_days: 4 },
{ pincode: 574240, min_days: 3, max_days: 4 },
{ pincode: 574241, min_days: 3, max_days: 4 },
{ pincode: 574242, min_days: 3, max_days: 4 },
{ pincode: 574243, min_days: 3, max_days: 4 },
{ pincode: 574245, min_days: 3, max_days: 4 },
{ pincode: 574248, min_days: 3, max_days: 4 },
{ pincode: 574250, min_days: 3, max_days: 4 },
{ pincode: 574251, min_days: 3, max_days: 4 },
{ pincode: 574253, min_days: 3, max_days: 4 },
{ pincode: 574258, min_days: 3, max_days: 4 },
{ pincode: 574259, min_days: 3, max_days: 4 },
{ pincode: 574261, min_days: 3, max_days: 4 },
{ pincode: 574262, min_days: 3, max_days: 4 },
{ pincode: 574263, min_days: 3, max_days: 4 },
{ pincode: 574264, min_days: 3, max_days: 4 },
{ pincode: 574265, min_days: 3, max_days: 4 },
{ pincode: 574266, min_days: 2, max_days: 3 },
{ pincode: 574267, min_days: 2, max_days: 3 },
{ pincode: 574269, min_days: 3, max_days: 4 },
{ pincode: 574272, min_days: 2, max_days: 3 },
{ pincode: 574274, min_days: 2, max_days: 3 },
{ pincode: 574275, min_days: 2, max_days: 3 },
{ pincode: 574276, min_days: 3, max_days: 4 },
{ pincode: 574277, min_days: 2, max_days: 3 },
{ pincode: 574282, min_days: 3, max_days: 4 },
{ pincode: 574284, min_days: 3, max_days: 4 },
{ pincode: 574285, min_days: 3, max_days: 4 },
{ pincode: 574287, min_days: 3, max_days: 4 },
{ pincode: 574289, min_days: 3, max_days: 4 },
{ pincode: 574291, min_days: 3, max_days: 4 },
{ pincode: 574294, min_days: 3, max_days: 4 },
{ pincode: 574296, min_days: 3, max_days: 4 },
{ pincode: 574297, min_days: 3, max_days: 4 },
{ pincode: 574299, min_days: 3, max_days: 4 },
{ pincode: 574309, min_days: 3, max_days: 4 },
{ pincode: 574310, min_days: 3, max_days: 4 },
{ pincode: 574311, min_days: 3, max_days: 4 },
{ pincode: 574312, min_days: 3, max_days: 4 },
{ pincode: 574313, min_days: 3, max_days: 4 },
{ pincode: 574314, min_days: 3, max_days: 4 },
{ pincode: 574315, min_days: 3, max_days: 4 },
{ pincode: 574317, min_days: 2, max_days: 3 },
{ pincode: 574318, min_days: 3, max_days: 4 },
{ pincode: 574319, min_days: 3, max_days: 4 },
{ pincode: 574324, min_days: 3, max_days: 4 },
{ pincode: 574325, min_days: 3, max_days: 4 },
{ pincode: 574326, min_days: 3, max_days: 4 },
{ pincode: 574327, min_days: 3, max_days: 4 },
{ pincode: 574335, min_days: 3, max_days: 4 },
{ pincode: 574337, min_days: 3, max_days: 4 },
{ pincode: 574504, min_days: 2, max_days: 3 },
{ pincode: 574561, min_days: 2, max_days: 3 },
{ pincode: 575001, min_days: 2, max_days: 3 },
{ pincode: 575002, min_days: 2, max_days: 3 },
{ pincode: 575003, min_days: 2, max_days: 3 },
{ pincode: 575004, min_days: 2, max_days: 3 },
{ pincode: 575005, min_days: 2, max_days: 3 },
{ pincode: 575006, min_days: 2, max_days: 3 },
{ pincode: 575007, min_days: 2, max_days: 3 },
{ pincode: 575008, min_days: 2, max_days: 3 },
{ pincode: 575009, min_days: 2, max_days: 3 },
{ pincode: 575010, min_days: 2, max_days: 3 },
{ pincode: 575011, min_days: 2, max_days: 3 },
{ pincode: 575012, min_days: 2, max_days: 3 },
{ pincode: 575013, min_days: 2, max_days: 3 },
{ pincode: 575014, min_days: 2, max_days: 3 },
{ pincode: 575015, min_days: 2, max_days: 3 },
{ pincode: 575016, min_days: 2, max_days: 3 },
{ pincode: 575017, min_days: 2, max_days: 3 },
{ pincode: 575018, min_days: 2, max_days: 3 },
{ pincode: 575019, min_days: 2, max_days: 3 },
{ pincode: 575020, min_days: 2, max_days: 3 },
{ pincode: 575021, min_days: 2, max_days: 3 },
{ pincode: 575022, min_days: 2, max_days: 3 },
{ pincode: 575023, min_days: 2, max_days: 3 },
{ pincode: 575025, min_days: 2, max_days: 3 },
{ pincode: 575026, min_days: 2, max_days: 3 },
{ pincode: 575027, min_days: 2, max_days: 3 },
{ pincode: 575028, min_days: 2, max_days: 3 },
{ pincode: 575029, min_days: 2, max_days: 3 },
{ pincode: 575030, min_days: 2, max_days: 3 },
{ pincode: 575130, min_days: 3, max_days: 4 },
{ pincode: 575220, min_days: 2, max_days: 3 },
{ pincode: 575221, min_days: 2, max_days: 3 },
{ pincode: 575253, min_days: 3, max_days: 4 },
{ pincode: 575551, min_days: 2, max_days: 3 },
{ pincode: 575889, min_days: 2, max_days: 3 },
{ pincode: 576001, min_days: 2, max_days: 3 },
{ pincode: 576003, min_days: 2, max_days: 3 },
{ pincode: 576101, min_days: 2, max_days: 3 },
{ pincode: 576102, min_days: 2, max_days: 3 },
{ pincode: 576103, min_days: 2, max_days: 3 },
{ pincode: 576104, min_days: 2, max_days: 3 },
{ pincode: 576105, min_days: 2, max_days: 3 },
{ pincode: 576106, min_days: 2, max_days: 3 },
{ pincode: 576107, min_days: 2, max_days: 3 },
{ pincode: 576108, min_days: 2, max_days: 3 },
{ pincode: 576111, min_days: 2, max_days: 3 },
{ pincode: 576112, min_days: 2, max_days: 3 },
{ pincode: 576113, min_days: 2, max_days: 3 },
{ pincode: 576114, min_days: 2, max_days: 3 },
{ pincode: 576115, min_days: 2, max_days: 3 },
{ pincode: 576116, min_days: 2, max_days: 3 },
{ pincode: 576118, min_days: 2, max_days: 3 },
{ pincode: 576119, min_days: 2, max_days: 3 },
{ pincode: 576121, min_days: 2, max_days: 3 },
{ pincode: 576122, min_days: 2, max_days: 3 },
{ pincode: 576125, min_days: 2, max_days: 3 },
{ pincode: 576126, min_days: 2, max_days: 3 },
{ pincode: 576127, min_days: 2, max_days: 3 },
{ pincode: 576128, min_days: 2, max_days: 3 },
{ pincode: 576129, min_days: 2, max_days: 3 },
{ pincode: 576131, min_days: 2, max_days: 3 },
{ pincode: 576135, min_days: 2, max_days: 3 },
{ pincode: 576136, min_days: 2, max_days: 3 },
{ pincode: 576145, min_days: 2, max_days: 3 },
{ pincode: 576201, min_days: 2, max_days: 3 },
{ pincode: 576210, min_days: 2, max_days: 3 },
{ pincode: 576211, min_days: 2, max_days: 3 },
{ pincode: 576212, min_days: 2, max_days: 3 },
{ pincode: 576213, min_days: 2, max_days: 3 },
{ pincode: 576214, min_days: 3, max_days: 4 },
{ pincode: 576216, min_days: 2, max_days: 3 },
{ pincode: 576217, min_days: 2, max_days: 3 },
{ pincode: 576218, min_days: 2, max_days: 3 },
{ pincode: 576221, min_days: 2, max_days: 3 },
{ pincode: 576222, min_days: 2, max_days: 3 },
{ pincode: 576223, min_days: 2, max_days: 3 },
{ pincode: 576224, min_days: 2, max_days: 3 },
{ pincode: 576225, min_days: 2, max_days: 3 },
{ pincode: 576226, min_days: 2, max_days: 3 },
{ pincode: 576228, min_days: 3, max_days: 4 },
{ pincode: 576229, min_days: 2, max_days: 3 },
{ pincode: 576230, min_days: 2, max_days: 3 },
{ pincode: 576231, min_days: 2, max_days: 3 },
{ pincode: 576232, min_days: 3, max_days: 4 },
{ pincode: 576233, min_days: 2, max_days: 3 },
{ pincode: 576234, min_days: 2, max_days: 3 },
{ pincode: 576235, min_days: 2, max_days: 3 },
{ pincode: 576238, min_days: 2, max_days: 3 },
{ pincode: 576241, min_days: 2, max_days: 3 },
{ pincode: 576243, min_days: 2, max_days: 3 },
{ pincode: 576244, min_days: 3, max_days: 4 },
{ pincode: 576247, min_days: 2, max_days: 3 },
{ pincode: 576249, min_days: 2, max_days: 3 },
{ pincode: 576252, min_days: 2, max_days: 3 },
{ pincode: 576254, min_days: 2, max_days: 3 },
{ pincode: 576257, min_days: 2, max_days: 3 },
{ pincode: 576262, min_days: 2, max_days: 3 },
{ pincode: 576266, min_days: 2, max_days: 3 },
{ pincode: 576282, min_days: 2, max_days: 3 },
{ pincode: 576283, min_days: 2, max_days: 3 },
{ pincode: 576425, min_days: 2, max_days: 3 },
{ pincode: 576445, min_days: 3, max_days: 4 },
{ pincode: 577001, min_days: 2, max_days: 3 },
{ pincode: 577002, min_days: 2, max_days: 3 },
{ pincode: 577003, min_days: 2, max_days: 3 },
{ pincode: 577004, min_days: 2, max_days: 3 },
{ pincode: 577005, min_days: 2, max_days: 3 },
{ pincode: 577006, min_days: 2, max_days: 3 },
{ pincode: 577101, min_days: 2, max_days: 3 },
{ pincode: 577102, min_days: 2, max_days: 3 },
{ pincode: 577111, min_days: 3, max_days: 4 },
{ pincode: 577113, min_days: 3, max_days: 4 },
{ pincode: 577115, min_days: 2, max_days: 3 },
{ pincode: 577116, min_days: 3, max_days: 4 },
{ pincode: 577119, min_days: 3, max_days: 4 },
{ pincode: 577132, min_days: 3, max_days: 4 },
{ pincode: 577133, min_days: 2, max_days: 3 },
{ pincode: 577135, min_days: 3, max_days: 4 },
{ pincode: 577147, min_days: 3, max_days: 4 },
{ pincode: 577149, min_days: 2, max_days: 3 },
{ pincode: 577156, min_days: 2, max_days: 3 },
{ pincode: 577168, min_days: 2, max_days: 3 },
{ pincode: 577175, min_days: 3, max_days: 4 },
{ pincode: 577201, min_days: 2, max_days: 3 },
{ pincode: 577202, min_days: 2, max_days: 3 },
{ pincode: 577203, min_days: 2, max_days: 3 },
{ pincode: 577204, min_days: 2, max_days: 3 },
{ pincode: 577205, min_days: 2, max_days: 3 },
{ pincode: 577213, min_days: 2, max_days: 3 },
{ pincode: 577214, min_days: 2, max_days: 3 },
{ pincode: 577222, min_days: 2, max_days: 3 },
{ pincode: 577229, min_days: 2, max_days: 3 },
{ pincode: 577232, min_days: 2, max_days: 3 },
{ pincode: 577234, min_days: 2, max_days: 3 },
{ pincode: 577235, min_days: 2, max_days: 3 },
{ pincode: 577236, min_days: 2, max_days: 3 },
{ pincode: 577245, min_days: 2, max_days: 3 },
{ pincode: 577301, min_days: 2, max_days: 3 },
{ pincode: 577302, min_days: 2, max_days: 3 },
{ pincode: 577303, min_days: 2, max_days: 3 },
{ pincode: 577401, min_days: 2, max_days: 3 },
{ pincode: 577411, min_days: 2, max_days: 3 },
{ pincode: 577412, min_days: 2, max_days: 3 },
{ pincode: 577413, min_days: 2, max_days: 3 },
{ pincode: 577414, min_days: 2, max_days: 3 },
{ pincode: 577415, min_days: 2, max_days: 3 },
{ pincode: 577416, min_days: 2, max_days: 3 },
{ pincode: 577417, min_days: 2, max_days: 3 },
{ pincode: 577422, min_days: 2, max_days: 3 },
{ pincode: 577424, min_days: 2, max_days: 3 },
{ pincode: 577427, min_days: 2, max_days: 3 },
{ pincode: 577429, min_days: 2, max_days: 3 },
{ pincode: 577430, min_days: 2, max_days: 3 },
{ pincode: 577432, min_days: 2, max_days: 3 },
{ pincode: 577434, min_days: 2, max_days: 3 },
{ pincode: 577435, min_days: 2, max_days: 3 },
{ pincode: 577439, min_days: 2, max_days: 3 },
{ pincode: 577443, min_days: 2, max_days: 3 },
{ pincode: 577501, min_days: 3, max_days: 4 },
{ pincode: 577502, min_days: 3, max_days: 4 },
{ pincode: 577511, min_days: 3, max_days: 4 },
{ pincode: 577516, min_days: 2, max_days: 3 },
{ pincode: 577517, min_days: 3, max_days: 4 },
{ pincode: 577520, min_days: 3, max_days: 4 },
{ pincode: 577521, min_days: 3, max_days: 4 },
{ pincode: 577522, min_days: 3, max_days: 4 },
{ pincode: 577524, min_days: 3, max_days: 4 },
{ pincode: 577526, min_days: 2, max_days: 3 },
{ pincode: 577527, min_days: 2, max_days: 3 },
{ pincode: 577532, min_days: 3, max_days: 4 },
{ pincode: 577536, min_days: 3, max_days: 4 },
{ pincode: 577537, min_days: 3, max_days: 4 },
{ pincode: 577538, min_days: 3, max_days: 4 },
{ pincode: 577541, min_days: 3, max_days: 4 },
{ pincode: 577543, min_days: 3, max_days: 4 },
{ pincode: 577544, min_days: 2, max_days: 3 },
{ pincode: 577545, min_days: 3, max_days: 4 },
{ pincode: 577548, min_days: 3, max_days: 4 },
{ pincode: 577551, min_days: 2, max_days: 3 },
{ pincode: 577555, min_days: 3, max_days: 4 },
{ pincode: 577556, min_days: 2, max_days: 3 },
{ pincode: 577558, min_days: 3, max_days: 4 },
{ pincode: 577566, min_days: 2, max_days: 3 },
{ pincode: 577583, min_days: 2, max_days: 3 },
{ pincode: 577598, min_days: 3, max_days: 4 },
{ pincode: 577599, min_days: 3, max_days: 4 },
{ pincode: 577601, min_days: 2, max_days: 3 },
{ pincode: 577602, min_days: 2, max_days: 3 },
{ pincode: 580001, min_days: 2, max_days: 3 },
{ pincode: 580002, min_days: 2, max_days: 3 },
{ pincode: 580003, min_days: 2, max_days: 3 },
{ pincode: 580004, min_days: 2, max_days: 3 },
{ pincode: 580005, min_days: 2, max_days: 3 },
{ pincode: 580006, min_days: 2, max_days: 3 },
{ pincode: 580007, min_days: 2, max_days: 3 },
{ pincode: 580008, min_days: 2, max_days: 3 },
{ pincode: 580009, min_days: 2, max_days: 3 },
{ pincode: 580010, min_days: 2, max_days: 3 },
{ pincode: 580011, min_days: 2, max_days: 3 },
{ pincode: 580020, min_days: 2, max_days: 3 },
{ pincode: 580021, min_days: 2, max_days: 3 },
{ pincode: 580022, min_days: 2, max_days: 3 },
{ pincode: 580023, min_days: 2, max_days: 3 },
{ pincode: 580024, min_days: 2, max_days: 3 },
{ pincode: 580025, min_days: 2, max_days: 3 },
{ pincode: 580026, min_days: 2, max_days: 3 },
{ pincode: 580028, min_days: 2, max_days: 3 },
{ pincode: 580029, min_days: 2, max_days: 3 },
{ pincode: 580030, min_days: 2, max_days: 3 },
{ pincode: 580031, min_days: 2, max_days: 3 },
{ pincode: 580032, min_days: 2, max_days: 3 },
{ pincode: 580112, min_days: 2, max_days: 3 },
{ pincode: 580114, min_days: 2, max_days: 3 },
{ pincode: 580116, min_days: 2, max_days: 3 },
{ pincode: 580118, min_days: 2, max_days: 3 },
{ pincode: 580212, min_days: 2, max_days: 3 },
{ pincode: 580213, min_days: 2, max_days: 3 },
{ pincode: 580214, min_days: 2, max_days: 3 },
{ pincode: 581047, min_days: 2, max_days: 3 },
{ pincode: 581101, min_days: 2, max_days: 3 },
{ pincode: 581102, min_days: 2, max_days: 3 },
{ pincode: 581103, min_days: 2, max_days: 3 },
{ pincode: 581104, min_days: 2, max_days: 3 },
{ pincode: 581105, min_days: 2, max_days: 3 },
{ pincode: 581106, min_days: 2, max_days: 3 },
{ pincode: 581108, min_days: 2, max_days: 3 },
{ pincode: 581109, min_days: 2, max_days: 3 },
{ pincode: 581110, min_days: 2, max_days: 3 },
{ pincode: 581111, min_days: 2, max_days: 3 },
{ pincode: 581112, min_days: 2, max_days: 3 },
{ pincode: 581115, min_days: 2, max_days: 3 },
{ pincode: 581116, min_days: 2, max_days: 3 },
{ pincode: 581118, min_days: 2, max_days: 3 },
{ pincode: 581119, min_days: 2, max_days: 3 },
{ pincode: 581120, min_days: 2, max_days: 3 },
{ pincode: 581123, min_days: 2, max_days: 3 },
{ pincode: 581124, min_days: 2, max_days: 3 },
{ pincode: 581125, min_days: 2, max_days: 3 },
{ pincode: 581126, min_days: 2, max_days: 3 },
{ pincode: 581127, min_days: 2, max_days: 3 },
{ pincode: 581128, min_days: 2, max_days: 3 },
{ pincode: 581131, min_days: 2, max_days: 3 },
{ pincode: 581132, min_days: 2, max_days: 3 },
{ pincode: 581134, min_days: 2, max_days: 3 },
{ pincode: 581138, min_days: 2, max_days: 3 },
{ pincode: 581139, min_days: 2, max_days: 3 },
{ pincode: 581140, min_days: 2, max_days: 3 },
{ pincode: 581145, min_days: 2, max_days: 3 },
{ pincode: 581147, min_days: 2, max_days: 3 },
{ pincode: 581148, min_days: 2, max_days: 3 },
{ pincode: 581149, min_days: 2, max_days: 3 },
{ pincode: 581150, min_days: 2, max_days: 3 },
{ pincode: 581153, min_days: 2, max_days: 3 },
{ pincode: 581154, min_days: 2, max_days: 3 },
{ pincode: 581155, min_days: 2, max_days: 3 },
{ pincode: 581157, min_days: 3, max_days: 4 },
{ pincode: 581158, min_days: 3, max_days: 4 },
{ pincode: 581160, min_days: 2, max_days: 3 },
{ pincode: 581163, min_days: 2, max_days: 3 },
{ pincode: 581164, min_days: 2, max_days: 3 },
{ pincode: 581167, min_days: 2, max_days: 3 },
{ pincode: 581168, min_days: 3, max_days: 4 },
{ pincode: 581169, min_days: 2, max_days: 3 },
{ pincode: 581170, min_days: 2, max_days: 3 },
{ pincode: 581177, min_days: 3, max_days: 4 },
{ pincode: 581181, min_days: 2, max_days: 3 },
{ pincode: 581182, min_days: 2, max_days: 3 },
{ pincode: 581183, min_days: 2, max_days: 3 },
{ pincode: 581185, min_days: 3, max_days: 4 },
{ pincode: 581189, min_days: 2, max_days: 3 },
{ pincode: 581191, min_days: 4, max_days: 5 },
{ pincode: 581193, min_days: 4, max_days: 5 },
{ pincode: 581197, min_days: 4, max_days: 5 },
{ pincode: 581198, min_days: 2, max_days: 3 },
{ pincode: 581199, min_days: 2, max_days: 3 },
{ pincode: 581201, min_days: 2, max_days: 3 },
{ pincode: 581202, min_days: 4, max_days: 5 },
{ pincode: 581203, min_days: 2, max_days: 3 },
{ pincode: 581206, min_days: 2, max_days: 3 },
{ pincode: 581208, min_days: 2, max_days: 3 },
{ pincode: 581210, min_days: 2, max_days: 3 },
{ pincode: 581211, min_days: 2, max_days: 3 },
{ pincode: 581212, min_days: 4, max_days: 5 },
{ pincode: 581213, min_days: 2, max_days: 3 },
{ pincode: 581214, min_days: 4, max_days: 5 },
{ pincode: 581225, min_days: 2, max_days: 3 },
{ pincode: 581228, min_days: 4, max_days: 5 },
{ pincode: 581301, min_days: 3, max_days: 4 },
{ pincode: 581302, min_days: 3, max_days: 4 },
{ pincode: 581303, min_days: 3, max_days: 4 },
{ pincode: 581304, min_days: 3, max_days: 4 },
{ pincode: 581305, min_days: 3, max_days: 4 },
{ pincode: 581306, min_days: 3, max_days: 4 },
{ pincode: 581307, min_days: 3, max_days: 4 },
{ pincode: 581308, min_days: 3, max_days: 4 },
{ pincode: 581314, min_days: 3, max_days: 4 },
{ pincode: 581316, min_days: 3, max_days: 4 },
{ pincode: 581320, min_days: 3, max_days: 4 },
{ pincode: 581321, min_days: 3, max_days: 4 },
{ pincode: 581323, min_days: 3, max_days: 4 },
{ pincode: 581324, min_days: 3, max_days: 4 },
{ pincode: 581325, min_days: 2, max_days: 3 },
{ pincode: 581327, min_days: 3, max_days: 4 },
{ pincode: 581329, min_days: 2, max_days: 3 },
{ pincode: 581330, min_days: 3, max_days: 4 },
{ pincode: 581332, min_days: 3, max_days: 4 },
{ pincode: 581334, min_days: 3, max_days: 4 },
{ pincode: 581335, min_days: 3, max_days: 4 },
{ pincode: 581341, min_days: 3, max_days: 4 },
{ pincode: 581342, min_days: 3, max_days: 4 },
{ pincode: 581343, min_days: 3, max_days: 4 },
{ pincode: 581345, min_days: 3, max_days: 4 },
{ pincode: 581348, min_days: 3, max_days: 4 },
{ pincode: 581349, min_days: 4, max_days: 5 },
{ pincode: 581350, min_days: 3, max_days: 4 },
{ pincode: 581351, min_days: 3, max_days: 4 },
{ pincode: 581352, min_days: 3, max_days: 4 },
{ pincode: 581353, min_days: 3, max_days: 4 },
{ pincode: 581354, min_days: 3, max_days: 4 },
{ pincode: 581357, min_days: 3, max_days: 4 },
{ pincode: 581360, min_days: 3, max_days: 4 },
{ pincode: 581361, min_days: 3, max_days: 4 },
{ pincode: 581362, min_days: 3, max_days: 4 },
{ pincode: 581396, min_days: 3, max_days: 4 },
{ pincode: 581400, min_days: 3, max_days: 4 },
{ pincode: 581401, min_days: 4, max_days: 5 },
{ pincode: 581402, min_days: 4, max_days: 5 },
{ pincode: 581405, min_days: 4, max_days: 5 },
{ pincode: 581411, min_days: 4, max_days: 5 },
{ pincode: 581421, min_days: 3, max_days: 4 },
{ pincode: 582101, min_days: 3, max_days: 4 },
{ pincode: 582102, min_days: 3, max_days: 4 },
{ pincode: 582103, min_days: 3, max_days: 4 },
{ pincode: 582121, min_days: 3, max_days: 4 },
{ pincode: 582122, min_days: 2, max_days: 3 },
{ pincode: 582123, min_days: 3, max_days: 4 },
{ pincode: 582201, min_days: 3, max_days: 4 },
{ pincode: 582205, min_days: 3, max_days: 4 },
{ pincode: 582214, min_days: 3, max_days: 4 },
{ pincode: 582218, min_days: 2, max_days: 3 },
{ pincode: 582225, min_days: 3, max_days: 4 },
{ pincode: 582227, min_days: 2, max_days: 3 },
{ pincode: 582231, min_days: 3, max_days: 4 },
{ pincode: 582234, min_days: 3, max_days: 4 },
{ pincode: 582243, min_days: 3, max_days: 4 },
{ pincode: 583101, min_days: 3, max_days: 4 },
{ pincode: 583102, min_days: 3, max_days: 4 },
{ pincode: 583103, min_days: 3, max_days: 4 },
{ pincode: 583104, min_days: 3, max_days: 4 },
{ pincode: 583105, min_days: 3, max_days: 4 },
{ pincode: 583111, min_days: 3, max_days: 4 },
{ pincode: 583113, min_days: 3, max_days: 4 },
{ pincode: 583114, min_days: 3, max_days: 4 },
{ pincode: 583115, min_days: 3, max_days: 4 },
{ pincode: 583116, min_days: 3, max_days: 4 },
{ pincode: 583117, min_days: 3, max_days: 4 },
{ pincode: 583120, min_days: 3, max_days: 4 },
{ pincode: 583121, min_days: 3, max_days: 4 },
{ pincode: 583122, min_days: 3, max_days: 4 },
{ pincode: 583123, min_days: 3, max_days: 4 },
{ pincode: 583129, min_days: 3, max_days: 4 },
{ pincode: 583132, min_days: 3, max_days: 4 },
{ pincode: 583138, min_days: 3, max_days: 4 },
{ pincode: 583144, min_days: 3, max_days: 4 },
{ pincode: 583147, min_days: 3, max_days: 4 },
{ pincode: 583152, min_days: 3, max_days: 4 },
{ pincode: 583201, min_days: 3, max_days: 4 },
{ pincode: 583202, min_days: 3, max_days: 4 },
{ pincode: 583203, min_days: 3, max_days: 4 },
{ pincode: 583204, min_days: 3, max_days: 4 },
{ pincode: 583211, min_days: 3, max_days: 4 },
{ pincode: 583215, min_days: 3, max_days: 4 },
{ pincode: 583221, min_days: 3, max_days: 4 },
{ pincode: 583222, min_days: 3, max_days: 4 },
{ pincode: 583223, min_days: 3, max_days: 4 },
{ pincode: 583225, min_days: 3, max_days: 4 },
{ pincode: 583227, min_days: 3, max_days: 4 },
{ pincode: 583228, min_days: 3, max_days: 4 },
{ pincode: 583229, min_days: 3, max_days: 4 },
{ pincode: 583230, min_days: 3, max_days: 4 },
{ pincode: 583231, min_days: 3, max_days: 4 },
{ pincode: 583233, min_days: 3, max_days: 4 },
{ pincode: 583234, min_days: 3, max_days: 4 },
{ pincode: 583238, min_days: 3, max_days: 4 },
{ pincode: 583239, min_days: 3, max_days: 4 },
{ pincode: 583245, min_days: 3, max_days: 4 },
{ pincode: 583250, min_days: 3, max_days: 4 },
{ pincode: 583253, min_days: 3, max_days: 4 },
{ pincode: 583255, min_days: 3, max_days: 4 },
{ pincode: 583263, min_days: 3, max_days: 4 },
{ pincode: 583268, min_days: 3, max_days: 4 },
{ pincode: 583271, min_days: 3, max_days: 4 },
{ pincode: 583272, min_days: 3, max_days: 4 },
{ pincode: 583273, min_days: 3, max_days: 4 },
{ pincode: 583275, min_days: 3, max_days: 4 },
{ pincode: 583276, min_days: 3, max_days: 4 },
{ pincode: 583286, min_days: 3, max_days: 4 },
{ pincode: 584101, min_days: 3, max_days: 4 },
{ pincode: 584102, min_days: 3, max_days: 4 },
{ pincode: 584103, min_days: 3, max_days: 4 },
{ pincode: 584104, min_days: 3, max_days: 4 },
{ pincode: 584115, min_days: 3, max_days: 4 },
{ pincode: 584118, min_days: 3, max_days: 4 },
{ pincode: 584122, min_days: 3, max_days: 4 },
{ pincode: 584123, min_days: 3, max_days: 4 },
{ pincode: 584124, min_days: 3, max_days: 4 },
{ pincode: 584125, min_days: 3, max_days: 4 },
{ pincode: 584128, min_days: 3, max_days: 4 },
{ pincode: 584129, min_days: 3, max_days: 4 },
{ pincode: 584131, min_days: 3, max_days: 4 },
{ pincode: 584132, min_days: 3, max_days: 4 },
{ pincode: 584134, min_days: 3, max_days: 4 },
{ pincode: 584135, min_days: 3, max_days: 4 },
{ pincode: 584138, min_days: 3, max_days: 4 },
{ pincode: 584142, min_days: 3, max_days: 4 },
{ pincode: 584143, min_days: 3, max_days: 4 },
{ pincode: 584167, min_days: 3, max_days: 4 },
{ pincode: 584170, min_days: 3, max_days: 4 },
{ pincode: 584202, min_days: 3, max_days: 4 },
{ pincode: 585101, min_days: 3, max_days: 4 },
{ pincode: 585102, min_days: 3, max_days: 4 },
{ pincode: 585103, min_days: 3, max_days: 4 },
{ pincode: 585104, min_days: 3, max_days: 4 },
{ pincode: 585105, min_days: 3, max_days: 4 },
{ pincode: 585201, min_days: 3, max_days: 4 },
{ pincode: 585202, min_days: 3, max_days: 4 },
{ pincode: 585211, min_days: 3, max_days: 4 },
{ pincode: 585221, min_days: 3, max_days: 4 },
{ pincode: 585222, min_days: 3, max_days: 4 },
{ pincode: 585223, min_days: 3, max_days: 4 },
{ pincode: 585225, min_days: 3, max_days: 4 },
{ pincode: 585287, min_days: 3, max_days: 4 },
{ pincode: 585292, min_days: 3, max_days: 4 },
{ pincode: 585306, min_days: 3, max_days: 4 },
{ pincode: 585313, min_days: 4, max_days: 5 },
{ pincode: 585327, min_days: 4, max_days: 5 },
{ pincode: 585330, min_days: 4, max_days: 5 },
{ pincode: 585401, min_days: 4, max_days: 5 },
{ pincode: 585402, min_days: 4, max_days: 5 },
{ pincode: 585403, min_days: 4, max_days: 5 },
{ pincode: 586101, min_days: 3, max_days: 4 },
{ pincode: 586102, min_days: 3, max_days: 4 },
{ pincode: 586103, min_days: 3, max_days: 4 },
{ pincode: 586104, min_days: 3, max_days: 4 },
{ pincode: 586105, min_days: 3, max_days: 4 },
{ pincode: 586106, min_days: 3, max_days: 4 },
{ pincode: 586107, min_days: 3, max_days: 4 },
{ pincode: 586108, min_days: 3, max_days: 4 },
{ pincode: 586109, min_days: 3, max_days: 4 },
{ pincode: 586126, min_days: 3, max_days: 4 },
{ pincode: 586128, min_days: 3, max_days: 4 },
{ pincode: 586130, min_days: 3, max_days: 4 },
{ pincode: 586144, min_days: 3, max_days: 4 },
{ pincode: 586148, min_days: 3, max_days: 4 },
{ pincode: 586149, min_days: 3, max_days: 4 },
{ pincode: 586169, min_days: 3, max_days: 4 },
{ pincode: 586202, min_days: 3, max_days: 4 },
{ pincode: 586209, min_days: 3, max_days: 4 },
{ pincode: 586212, min_days: 3, max_days: 4 },
{ pincode: 586245, min_days: 3, max_days: 4 },
{ pincode: 587101, min_days: 3, max_days: 4 },
{ pincode: 587102, min_days: 3, max_days: 4 },
{ pincode: 587103, min_days: 3, max_days: 4 },
{ pincode: 587104, min_days: 3, max_days: 4 },
{ pincode: 587111, min_days: 3, max_days: 4 },
{ pincode: 587113, min_days: 3, max_days: 4 },
{ pincode: 587114, min_days: 3, max_days: 4 },
{ pincode: 587116, min_days: 3, max_days: 4 },
{ pincode: 587118, min_days: 3, max_days: 4 },
{ pincode: 587119, min_days: 3, max_days: 4 },
{ pincode: 587122, min_days: 3, max_days: 4 },
{ pincode: 587124, min_days: 3, max_days: 4 },
{ pincode: 587125, min_days: 3, max_days: 4 },
{ pincode: 587126, min_days: 3, max_days: 4 },
{ pincode: 587143, min_days: 2, max_days: 3 },
{ pincode: 587145, min_days: 3, max_days: 4 },
{ pincode: 587154, min_days: 3, max_days: 4 },
{ pincode: 587201, min_days: 3, max_days: 4 },
{ pincode: 587203, min_days: 3, max_days: 4 },
{ pincode: 587204, min_days: 3, max_days: 4 },
{ pincode: 587205, min_days: 3, max_days: 4 },
{ pincode: 587212, min_days: 3, max_days: 4 },
{ pincode: 587213, min_days: 3, max_days: 4 },
{ pincode: 587301, min_days: 3, max_days: 4 },
{ pincode: 587302, min_days: 3, max_days: 4 },
{ pincode: 587311, min_days: 3, max_days: 4 },
{ pincode: 587312, min_days: 3, max_days: 4 },
{ pincode: 587313, min_days: 3, max_days: 4 },
{ pincode: 587314, min_days: 3, max_days: 4 },
{ pincode: 587315, min_days: 3, max_days: 4 },
{ pincode: 587316, min_days: 3, max_days: 4 },
{ pincode: 587320, min_days: 3, max_days: 4 },
{ pincode: 587322, min_days: 3, max_days: 4 },
{ pincode: 590001, min_days: 2, max_days: 3 },
{ pincode: 590002, min_days: 2, max_days: 3 },
{ pincode: 590003, min_days: 2, max_days: 3 },
{ pincode: 590004, min_days: 2, max_days: 3 },
{ pincode: 590005, min_days: 2, max_days: 3 },
{ pincode: 590006, min_days: 2, max_days: 3 },
{ pincode: 590007, min_days: 2, max_days: 3 },
{ pincode: 590008, min_days: 2, max_days: 3 },
{ pincode: 590009, min_days: 2, max_days: 3 },
{ pincode: 590010, min_days: 2, max_days: 3 },
{ pincode: 590011, min_days: 2, max_days: 3 },
{ pincode: 590012, min_days: 2, max_days: 3 },
{ pincode: 590013, min_days: 2, max_days: 3 },
{ pincode: 590014, min_days: 2, max_days: 3 },
{ pincode: 590015, min_days: 2, max_days: 3 },
{ pincode: 590016, min_days: 2, max_days: 3 },
{ pincode: 590017, min_days: 2, max_days: 3 },
{ pincode: 590018, min_days: 2, max_days: 3 },
{ pincode: 590019, min_days: 2, max_days: 3 },
{ pincode: 590543, min_days: 2, max_days: 3 },
{ pincode: 591102, min_days: 3, max_days: 4 },
{ pincode: 591104, min_days: 3, max_days: 4 },
{ pincode: 591107, min_days: 3, max_days: 4 },
{ pincode: 591108, min_days: 2, max_days: 3 },
{ pincode: 591112, min_days: 3, max_days: 4 },
{ pincode: 591113, min_days: 2, max_days: 3 },
{ pincode: 591115, min_days: 3, max_days: 4 },
{ pincode: 591118, min_days: 3, max_days: 4 },
{ pincode: 591121, min_days: 3, max_days: 4 },
{ pincode: 591124, min_days: 2, max_days: 3 },
{ pincode: 591125, min_days: 3, max_days: 4 },
{ pincode: 591126, min_days: 3, max_days: 4 },
{ pincode: 591153, min_days: 3, max_days: 4 },
{ pincode: 591181, min_days: 2, max_days: 3 },
{ pincode: 591201, min_days: 3, max_days: 4 },
{ pincode: 591211, min_days: 3, max_days: 4 },
{ pincode: 591212, min_days: 3, max_days: 4 },
{ pincode: 591214, min_days: 3, max_days: 4 },
{ pincode: 591218, min_days: 3, max_days: 4 },
{ pincode: 591219, min_days: 3, max_days: 4 },
{ pincode: 591220, min_days: 3, max_days: 4 },
{ pincode: 591224, min_days: 3, max_days: 4 },
{ pincode: 591227, min_days: 3, max_days: 4 },
{ pincode: 591229, min_days: 3, max_days: 4 },
{ pincode: 591230, min_days: 3, max_days: 4 },
{ pincode: 591232, min_days: 3, max_days: 4 },
{ pincode: 591233, min_days: 3, max_days: 4 },
{ pincode: 591237, min_days: 3, max_days: 4 },
{ pincode: 591239, min_days: 3, max_days: 4 },
{ pincode: 591241, min_days: 3, max_days: 4 },
{ pincode: 591242, min_days: 3, max_days: 4 },
{ pincode: 591244, min_days: 3, max_days: 4 },
{ pincode: 591247, min_days: 3, max_days: 4 },
{ pincode: 591261, min_days: 3, max_days: 4 },
{ pincode: 591263, min_days: 3, max_days: 4 },
{ pincode: 591304, min_days: 3, max_days: 4 },
{ pincode: 591306, min_days: 3, max_days: 4 },
{ pincode: 591307, min_days: 3, max_days: 4 },
{ pincode: 591308, min_days: 3, max_days: 4 },
{ pincode: 591312, min_days: 3, max_days: 4 },
{ pincode: 591344, min_days: 3, max_days: 4 },
{ pincode: 591513, min_days: 3, max_days: 4 },
{ pincode: 599991, min_days: 2, max_days: 3 },
{ pincode: 600000, min_days: 2, max_days: 3 },
{ pincode: 600001, min_days: 2, max_days: 3 },
{ pincode: 600002, min_days: 2, max_days: 3 },
{ pincode: 600003, min_days: 2, max_days: 3 },
{ pincode: 600004, min_days: 2, max_days: 3 },
{ pincode: 600005, min_days: 2, max_days: 3 },
{ pincode: 600006, min_days: 2, max_days: 3 },
{ pincode: 600007, min_days: 2, max_days: 3 },
{ pincode: 600008, min_days: 2, max_days: 3 },
{ pincode: 600009, min_days: 2, max_days: 3 },
{ pincode: 600010, min_days: 2, max_days: 3 },
{ pincode: 600011, min_days: 2, max_days: 3 },
{ pincode: 600012, min_days: 2, max_days: 3 },
{ pincode: 600013, min_days: 2, max_days: 3 },
{ pincode: 600014, min_days: 2, max_days: 3 },
{ pincode: 600015, min_days: 2, max_days: 3 },
{ pincode: 600016, min_days: 2, max_days: 3 },
{ pincode: 600017, min_days: 2, max_days: 3 },
{ pincode: 600018, min_days: 2, max_days: 3 },
{ pincode: 600019, min_days: 2, max_days: 3 },
{ pincode: 600020, min_days: 2, max_days: 3 },
{ pincode: 600021, min_days: 2, max_days: 3 },
{ pincode: 600022, min_days: 2, max_days: 3 },
{ pincode: 600023, min_days: 2, max_days: 3 },
{ pincode: 600024, min_days: 2, max_days: 3 },
{ pincode: 600025, min_days: 2, max_days: 3 },
{ pincode: 600026, min_days: 2, max_days: 3 },
{ pincode: 600027, min_days: 2, max_days: 3 },
{ pincode: 600028, min_days: 2, max_days: 3 },
{ pincode: 600029, min_days: 2, max_days: 3 },
{ pincode: 600030, min_days: 2, max_days: 3 },
{ pincode: 600031, min_days: 2, max_days: 3 },
{ pincode: 600032, min_days: 2, max_days: 3 },
{ pincode: 600033, min_days: 2, max_days: 3 },
{ pincode: 600034, min_days: 2, max_days: 3 },
{ pincode: 600035, min_days: 2, max_days: 3 },
{ pincode: 600036, min_days: 2, max_days: 3 },
{ pincode: 600037, min_days: 2, max_days: 3 },
{ pincode: 600038, min_days: 2, max_days: 3 },
{ pincode: 600039, min_days: 2, max_days: 3 },
{ pincode: 600040, min_days: 2, max_days: 3 },
{ pincode: 600041, min_days: 2, max_days: 3 },
{ pincode: 600042, min_days: 2, max_days: 3 },
{ pincode: 600043, min_days: 2, max_days: 3 },
{ pincode: 600044, min_days: 2, max_days: 3 },
{ pincode: 600045, min_days: 2, max_days: 3 },
{ pincode: 600046, min_days: 2, max_days: 3 },
{ pincode: 600047, min_days: 2, max_days: 3 },
{ pincode: 600048, min_days: 3, max_days: 4 },
{ pincode: 600049, min_days: 2, max_days: 3 },
{ pincode: 600050, min_days: 2, max_days: 3 },
{ pincode: 600051, min_days: 2, max_days: 3 },
{ pincode: 600052, min_days: 3, max_days: 4 },
{ pincode: 600053, min_days: 2, max_days: 3 },
{ pincode: 600054, min_days: 2, max_days: 3 },
{ pincode: 600055, min_days: 2, max_days: 3 },
{ pincode: 600056, min_days: 2, max_days: 3 },
{ pincode: 600057, min_days: 2, max_days: 3 },
{ pincode: 600058, min_days: 2, max_days: 3 },
{ pincode: 600059, min_days: 2, max_days: 3 },
{ pincode: 600060, min_days: 2, max_days: 3 },
{ pincode: 600061, min_days: 2, max_days: 3 },
{ pincode: 600062, min_days: 2, max_days: 3 },
{ pincode: 600063, min_days: 2, max_days: 3 },
{ pincode: 600064, min_days: 2, max_days: 3 },
{ pincode: 600065, min_days: 2, max_days: 3 },
{ pincode: 600066, min_days: 2, max_days: 3 },
{ pincode: 600067, min_days: 3, max_days: 4 },
{ pincode: 600068, min_days: 2, max_days: 3 },
{ pincode: 600069, min_days: 3, max_days: 4 },
{ pincode: 600070, min_days: 2, max_days: 3 },
{ pincode: 600071, min_days: 2, max_days: 3 },
{ pincode: 600072, min_days: 3, max_days: 4 },
{ pincode: 600073, min_days: 2, max_days: 3 },
{ pincode: 600074, min_days: 2, max_days: 3 },
{ pincode: 600075, min_days: 2, max_days: 3 },
{ pincode: 600076, min_days: 2, max_days: 3 },
{ pincode: 600077, min_days: 2, max_days: 3 },
{ pincode: 600078, min_days: 2, max_days: 3 },
{ pincode: 600079, min_days: 2, max_days: 3 },
{ pincode: 600080, min_days: 2, max_days: 3 },
{ pincode: 600081, min_days: 2, max_days: 3 },
{ pincode: 600082, min_days: 2, max_days: 3 },
{ pincode: 600083, min_days: 2, max_days: 3 },
{ pincode: 600084, min_days: 2, max_days: 3 },
{ pincode: 600085, min_days: 2, max_days: 3 },
{ pincode: 600086, min_days: 2, max_days: 3 },
{ pincode: 600087, min_days: 2, max_days: 3 },
{ pincode: 600088, min_days: 2, max_days: 3 },
{ pincode: 600089, min_days: 2, max_days: 3 },
{ pincode: 600090, min_days: 2, max_days: 3 },
{ pincode: 600091, min_days: 2, max_days: 3 },
{ pincode: 600092, min_days: 2, max_days: 3 },
{ pincode: 600093, min_days: 2, max_days: 3 },
{ pincode: 600094, min_days: 2, max_days: 3 },
{ pincode: 600095, min_days: 2, max_days: 3 },
{ pincode: 600096, min_days: 2, max_days: 3 },
{ pincode: 600097, min_days: 2, max_days: 3 },
{ pincode: 600098, min_days: 2, max_days: 3 },
{ pincode: 600099, min_days: 2, max_days: 3 },
{ pincode: 600100, min_days: 2, max_days: 3 },
{ pincode: 600101, min_days: 2, max_days: 3 },
{ pincode: 600102, min_days: 2, max_days: 3 },
{ pincode: 600103, min_days: 2, max_days: 3 },
{ pincode: 600104, min_days: 2, max_days: 3 },
{ pincode: 600105, min_days: 2, max_days: 3 },
{ pincode: 600106, min_days: 2, max_days: 3 },
{ pincode: 600107, min_days: 2, max_days: 3 },
{ pincode: 600108, min_days: 2, max_days: 3 },
{ pincode: 600109, min_days: 2, max_days: 3 },
{ pincode: 600110, min_days: 2, max_days: 3 },
{ pincode: 600111, min_days: 2, max_days: 3 },
{ pincode: 600112, min_days: 2, max_days: 3 },
{ pincode: 600113, min_days: 2, max_days: 3 },
{ pincode: 600114, min_days: 2, max_days: 3 },
{ pincode: 600115, min_days: 2, max_days: 3 },
{ pincode: 600116, min_days: 2, max_days: 3 },
{ pincode: 600117, min_days: 2, max_days: 3 },
{ pincode: 600118, min_days: 2, max_days: 3 },
{ pincode: 600119, min_days: 3, max_days: 4 },
{ pincode: 600120, min_days: 3, max_days: 4 },
{ pincode: 600122, min_days: 3, max_days: 4 },
{ pincode: 600123, min_days: 3, max_days: 4 },
{ pincode: 600124, min_days: 3, max_days: 4 },
{ pincode: 600125, min_days: 2, max_days: 3 },
{ pincode: 600126, min_days: 2, max_days: 3 },
{ pincode: 600127, min_days: 3, max_days: 4 },
{ pincode: 600128, min_days: 3, max_days: 4 },
{ pincode: 600129, min_days: 2, max_days: 3 },
{ pincode: 600130, min_days: 3, max_days: 4 },
{ pincode: 600132, min_days: 2, max_days: 3 },
{ pincode: 600222, min_days: 2, max_days: 3 },
{ pincode: 600704, min_days: 2, max_days: 3 },
{ pincode: 601101, min_days: 3, max_days: 4 },
{ pincode: 601102, min_days: 3, max_days: 4 },
{ pincode: 601103, min_days: 3, max_days: 4 },
{ pincode: 601201, min_days: 3, max_days: 4 },
{ pincode: 601202, min_days: 2, max_days: 3 },
{ pincode: 601203, min_days: 3, max_days: 4 },
{ pincode: 601204, min_days: 3, max_days: 4 },
{ pincode: 601205, min_days: 2, max_days: 3 },
{ pincode: 601206, min_days: 2, max_days: 3 },
{ pincode: 601301, min_days: 3, max_days: 4 },
{ pincode: 602000, min_days: 3, max_days: 4 },
{ pincode: 602001, min_days: 3, max_days: 4 },
{ pincode: 602002, min_days: 3, max_days: 4 },
{ pincode: 602003, min_days: 3, max_days: 4 },
{ pincode: 602004, min_days: 3, max_days: 4 },
{ pincode: 602010, min_days: 2, max_days: 3 },
{ pincode: 602017, min_days: 2, max_days: 3 },
{ pincode: 602021, min_days: 3, max_days: 4 },
{ pincode: 602023, min_days: 3, max_days: 4 },
{ pincode: 602024, min_days: 3, max_days: 4 },
{ pincode: 602025, min_days: 3, max_days: 4 },
{ pincode: 602026, min_days: 3, max_days: 4 },
{ pincode: 602105, min_days: 3, max_days: 4 },
{ pincode: 602106, min_days: 3, max_days: 4 },
{ pincode: 602108, min_days: 3, max_days: 4 },
{ pincode: 602117, min_days: 3, max_days: 4 },
{ pincode: 602204, min_days: 2, max_days: 3 },
{ pincode: 602205, min_days: 2, max_days: 3 },
{ pincode: 603001, min_days: 3, max_days: 4 },
{ pincode: 603002, min_days: 3, max_days: 4 },
{ pincode: 603003, min_days: 3, max_days: 4 },
{ pincode: 603004, min_days: 3, max_days: 4 },
{ pincode: 603101, min_days: 3, max_days: 4 },
{ pincode: 603103, min_days: 3, max_days: 4 },
{ pincode: 603104, min_days: 3, max_days: 4 },
{ pincode: 603105, min_days: 3, max_days: 4 },
{ pincode: 603109, min_days: 3, max_days: 4 },
{ pincode: 603110, min_days: 3, max_days: 4 },
{ pincode: 603111, min_days: 3, max_days: 4 },
{ pincode: 603112, min_days: 3, max_days: 4 },
{ pincode: 603127, min_days: 3, max_days: 4 },
{ pincode: 603201, min_days: 3, max_days: 4 },
{ pincode: 603202, min_days: 3, max_days: 4 },
{ pincode: 603203, min_days: 3, max_days: 4 },
{ pincode: 603204, min_days: 3, max_days: 4 },
{ pincode: 603209, min_days: 3, max_days: 4 },
{ pincode: 603210, min_days: 3, max_days: 4 },
{ pincode: 603211, min_days: 3, max_days: 4 },
{ pincode: 603301, min_days: 3, max_days: 4 },
{ pincode: 603302, min_days: 3, max_days: 4 },
{ pincode: 603303, min_days: 3, max_days: 4 },
{ pincode: 603304, min_days: 3, max_days: 4 },
{ pincode: 603306, min_days: 3, max_days: 4 },
{ pincode: 603309, min_days: 3, max_days: 4 },
{ pincode: 603310, min_days: 3, max_days: 4 },
{ pincode: 603311, min_days: 3, max_days: 4 },
{ pincode: 603313, min_days: 3, max_days: 4 },
{ pincode: 603319, min_days: 3, max_days: 4 },
{ pincode: 603401, min_days: 3, max_days: 4 },
{ pincode: 604001, min_days: 3, max_days: 4 },
{ pincode: 604002, min_days: 3, max_days: 4 },
{ pincode: 604151, min_days: 3, max_days: 4 },
{ pincode: 604152, min_days: 3, max_days: 4 },
{ pincode: 604153, min_days: 3, max_days: 4 },
{ pincode: 604201, min_days: 3, max_days: 4 },
{ pincode: 604202, min_days: 3, max_days: 4 },
{ pincode: 604204, min_days: 3, max_days: 4 },
{ pincode: 604205, min_days: 3, max_days: 4 },
{ pincode: 604210, min_days: 3, max_days: 4 },
{ pincode: 604303, min_days: 3, max_days: 4 },
{ pincode: 604503, min_days: 3, max_days: 4 },
{ pincode: 604504, min_days: 3, max_days: 4 },
{ pincode: 604601, min_days: 3, max_days: 4 },
{ pincode: 605001, min_days: 3, max_days: 4 },
{ pincode: 605002, min_days: 3, max_days: 4 },
{ pincode: 605003, min_days: 3, max_days: 4 },
{ pincode: 605004, min_days: 3, max_days: 4 },
{ pincode: 605005, min_days: 3, max_days: 4 },
{ pincode: 605006, min_days: 3, max_days: 4 },
{ pincode: 605007, min_days: 3, max_days: 4 },
{ pincode: 605008, min_days: 3, max_days: 4 },
{ pincode: 605009, min_days: 3, max_days: 4 },
{ pincode: 605010, min_days: 3, max_days: 4 },
{ pincode: 605011, min_days: 3, max_days: 4 },
{ pincode: 605012, min_days: 3, max_days: 4 },
{ pincode: 605013, min_days: 3, max_days: 4 },
{ pincode: 605014, min_days: 3, max_days: 4 },
{ pincode: 605101, min_days: 3, max_days: 4 },
{ pincode: 605102, min_days: 3, max_days: 4 },
{ pincode: 605104, min_days: 3, max_days: 4 },
{ pincode: 605105, min_days: 3, max_days: 4 },
{ pincode: 605106, min_days: 3, max_days: 4 },
{ pincode: 605107, min_days: 3, max_days: 4 },
{ pincode: 605108, min_days: 3, max_days: 4 },
{ pincode: 605109, min_days: 3, max_days: 4 },
{ pincode: 605110, min_days: 3, max_days: 4 },
{ pincode: 605111, min_days: 3, max_days: 4 },
{ pincode: 605201, min_days: 3, max_days: 4 },
{ pincode: 605401, min_days: 3, max_days: 4 },
{ pincode: 605501, min_days: 3, max_days: 4 },
{ pincode: 605502, min_days: 3, max_days: 4 },
{ pincode: 605602, min_days: 3, max_days: 4 },
{ pincode: 605604, min_days: 3, max_days: 4 },
{ pincode: 605606, min_days: 3, max_days: 4 },
{ pincode: 605701, min_days: 3, max_days: 4 },
{ pincode: 605751, min_days: 3, max_days: 4 },
{ pincode: 605752, min_days: 3, max_days: 4 },
{ pincode: 605754, min_days: 3, max_days: 4 },
{ pincode: 605755, min_days: 3, max_days: 4 },
{ pincode: 605756, min_days: 3, max_days: 4 },
{ pincode: 605757, min_days: 3, max_days: 4 },
{ pincode: 605758, min_days: 3, max_days: 4 },
{ pincode: 605759, min_days: 3, max_days: 4 },
{ pincode: 605766, min_days: 3, max_days: 4 },
{ pincode: 605802, min_days: 3, max_days: 4 },
{ pincode: 605803, min_days: 3, max_days: 4 },
{ pincode: 606001, min_days: 3, max_days: 4 },
{ pincode: 606003, min_days: 3, max_days: 4 },
{ pincode: 606102, min_days: 3, max_days: 4 },
{ pincode: 606103, min_days: 3, max_days: 4 },
{ pincode: 606104, min_days: 3, max_days: 4 },
{ pincode: 606105, min_days: 3, max_days: 4 },
{ pincode: 606106, min_days: 3, max_days: 4 },
{ pincode: 606107, min_days: 3, max_days: 4 },
{ pincode: 606108, min_days: 3, max_days: 4 },
{ pincode: 606109, min_days: 2, max_days: 3 },
{ pincode: 606110, min_days: 3, max_days: 4 },
{ pincode: 606111, min_days: 3, max_days: 4 },
{ pincode: 606115, min_days: 3, max_days: 4 },
{ pincode: 606202, min_days: 3, max_days: 4 },
{ pincode: 606207, min_days: 2, max_days: 3 },
{ pincode: 606301, min_days: 2, max_days: 3 },
{ pincode: 606302, min_days: 3, max_days: 4 },
{ pincode: 606304, min_days: 3, max_days: 4 },
{ pincode: 606601, min_days: 3, max_days: 4 },
{ pincode: 606602, min_days: 3, max_days: 4 },
{ pincode: 606603, min_days: 3, max_days: 4 },
{ pincode: 606604, min_days: 3, max_days: 4 },
{ pincode: 606611, min_days: 3, max_days: 4 },
{ pincode: 606701, min_days: 3, max_days: 4 },
{ pincode: 606702, min_days: 3, max_days: 4 },
{ pincode: 606703, min_days: 3, max_days: 4 },
{ pincode: 606704, min_days: 3, max_days: 4 },
{ pincode: 606705, min_days: 3, max_days: 4 },
{ pincode: 606706, min_days: 3, max_days: 4 },
{ pincode: 606709, min_days: 3, max_days: 4 },
{ pincode: 606710, min_days: 3, max_days: 4 },
{ pincode: 606752, min_days: 3, max_days: 4 },
{ pincode: 606801, min_days: 3, max_days: 4 },
{ pincode: 606804, min_days: 3, max_days: 4 },
{ pincode: 606806, min_days: 3, max_days: 4 },
{ pincode: 606808, min_days: 3, max_days: 4 },
{ pincode: 606811, min_days: 3, max_days: 4 },
{ pincode: 606902, min_days: 3, max_days: 4 },
{ pincode: 606903, min_days: 3, max_days: 4 },
{ pincode: 606905, min_days: 3, max_days: 4 },
{ pincode: 606907, min_days: 3, max_days: 4 },
{ pincode: 606908, min_days: 3, max_days: 4 },
{ pincode: 607001, min_days: 3, max_days: 4 },
{ pincode: 607002, min_days: 3, max_days: 4 },
{ pincode: 607003, min_days: 3, max_days: 4 },
{ pincode: 607004, min_days: 3, max_days: 4 },
{ pincode: 607005, min_days: 3, max_days: 4 },
{ pincode: 607006, min_days: 3, max_days: 4 },
{ pincode: 607102, min_days: 3, max_days: 4 },
{ pincode: 607103, min_days: 3, max_days: 4 },
{ pincode: 607104, min_days: 3, max_days: 4 },
{ pincode: 607105, min_days: 3, max_days: 4 },
{ pincode: 607106, min_days: 3, max_days: 4 },
{ pincode: 607108, min_days: 3, max_days: 4 },
{ pincode: 607109, min_days: 3, max_days: 4 },
{ pincode: 607112, min_days: 3, max_days: 4 },
{ pincode: 607201, min_days: 3, max_days: 4 },
{ pincode: 607202, min_days: 3, max_days: 4 },
{ pincode: 607204, min_days: 3, max_days: 4 },
{ pincode: 607301, min_days: 3, max_days: 4 },
{ pincode: 607302, min_days: 3, max_days: 4 },
{ pincode: 607303, min_days: 3, max_days: 4 },
{ pincode: 607308, min_days: 3, max_days: 4 },
{ pincode: 607401, min_days: 3, max_days: 4 },
{ pincode: 607402, min_days: 3, max_days: 4 },
{ pincode: 607403, min_days: 3, max_days: 4 },
{ pincode: 607801, min_days: 3, max_days: 4 },
{ pincode: 607802, min_days: 3, max_days: 4 },
{ pincode: 607803, min_days: 3, max_days: 4 },
{ pincode: 607804, min_days: 3, max_days: 4 },
{ pincode: 607805, min_days: 3, max_days: 4 },
{ pincode: 607807, min_days: 3, max_days: 4 },
{ pincode: 608001, min_days: 3, max_days: 4 },
{ pincode: 608002, min_days: 3, max_days: 4 },
{ pincode: 608102, min_days: 3, max_days: 4 },
{ pincode: 608201, min_days: 3, max_days: 4 },
{ pincode: 608301, min_days: 3, max_days: 4 },
{ pincode: 608302, min_days: 3, max_days: 4 },
{ pincode: 608303, min_days: 3, max_days: 4 },
{ pincode: 608305, min_days: 3, max_days: 4 },
{ pincode: 608401, min_days: 3, max_days: 4 },
{ pincode: 608501, min_days: 3, max_days: 4 },
{ pincode: 608502, min_days: 3, max_days: 4 },
{ pincode: 608601, min_days: 3, max_days: 4 },
{ pincode: 608602, min_days: 3, max_days: 4 },
{ pincode: 608701, min_days: 3, max_days: 4 },
{ pincode: 608702, min_days: 3, max_days: 4 },
{ pincode: 608704, min_days: 3, max_days: 4 },
{ pincode: 609001, min_days: 3, max_days: 4 },
{ pincode: 609002, min_days: 3, max_days: 4 },
{ pincode: 609003, min_days: 3, max_days: 4 },
{ pincode: 609101, min_days: 3, max_days: 4 },
{ pincode: 609102, min_days: 3, max_days: 4 },
{ pincode: 609104, min_days: 3, max_days: 4 },
{ pincode: 609105, min_days: 3, max_days: 4 },
{ pincode: 609106, min_days: 3, max_days: 4 },
{ pincode: 609107, min_days: 3, max_days: 4 },
{ pincode: 609108, min_days: 3, max_days: 4 },
{ pincode: 609109, min_days: 3, max_days: 4 },
{ pincode: 609110, min_days: 3, max_days: 4 },
{ pincode: 609111, min_days: 3, max_days: 4 },
{ pincode: 609112, min_days: 3, max_days: 4 },
{ pincode: 609113, min_days: 3, max_days: 4 },
{ pincode: 609115, min_days: 3, max_days: 4 },
{ pincode: 609116, min_days: 3, max_days: 4 },
{ pincode: 609301, min_days: 3, max_days: 4 },
{ pincode: 609302, min_days: 3, max_days: 4 },
{ pincode: 609303, min_days: 3, max_days: 4 },
{ pincode: 609304, min_days: 3, max_days: 4 },
{ pincode: 609306, min_days: 3, max_days: 4 },
{ pincode: 609307, min_days: 3, max_days: 4 },
{ pincode: 609309, min_days: 3, max_days: 4 },
{ pincode: 609310, min_days: 3, max_days: 4 },
{ pincode: 609311, min_days: 3, max_days: 4 },
{ pincode: 609312, min_days: 3, max_days: 4 },
{ pincode: 609313, min_days: 3, max_days: 4 },
{ pincode: 609314, min_days: 3, max_days: 4 },
{ pincode: 609402, min_days: 3, max_days: 4 },
{ pincode: 609503, min_days: 4, max_days: 5 },
{ pincode: 609601, min_days: 3, max_days: 4 },
{ pincode: 609602, min_days: 3, max_days: 4 },
{ pincode: 609603, min_days: 3, max_days: 4 },
{ pincode: 609604, min_days: 3, max_days: 4 },
{ pincode: 609605, min_days: 3, max_days: 4 },
{ pincode: 609606, min_days: 3, max_days: 4 },
{ pincode: 609607, min_days: 3, max_days: 4 },
{ pincode: 609609, min_days: 3, max_days: 4 },
{ pincode: 609701, min_days: 3, max_days: 4 },
{ pincode: 609702, min_days: 3, max_days: 4 },
{ pincode: 609703, min_days: 3, max_days: 4 },
{ pincode: 609704, min_days: 3, max_days: 4 },
{ pincode: 610001, min_days: 4, max_days: 5 },
{ pincode: 610002, min_days: 4, max_days: 5 },
{ pincode: 610003, min_days: 4, max_days: 5 },
{ pincode: 610004, min_days: 4, max_days: 5 },
{ pincode: 610005, min_days: 4, max_days: 5 },
{ pincode: 610051, min_days: 4, max_days: 5 },
{ pincode: 610101, min_days: 4, max_days: 5 },
{ pincode: 610103, min_days: 4, max_days: 5 },
{ pincode: 610105, min_days: 4, max_days: 5 },
{ pincode: 610106, min_days: 4, max_days: 5 },
{ pincode: 610109, min_days: 4, max_days: 5 },
{ pincode: 610202, min_days: 4, max_days: 5 },
{ pincode: 610203, min_days: 4, max_days: 5 },
{ pincode: 610207, min_days: 4, max_days: 5 },
{ pincode: 610210, min_days: 4, max_days: 5 },
{ pincode: 610211, min_days: 4, max_days: 5 },
{ pincode: 611001, min_days: 3, max_days: 4 },
{ pincode: 611002, min_days: 3, max_days: 4 },
{ pincode: 611003, min_days: 3, max_days: 4 },
{ pincode: 611006, min_days: 3, max_days: 4 },
{ pincode: 611101, min_days: 4, max_days: 5 },
{ pincode: 611104, min_days: 3, max_days: 4 },
{ pincode: 611105, min_days: 4, max_days: 5 },
{ pincode: 611106, min_days: 3, max_days: 4 },
{ pincode: 611108, min_days: 3, max_days: 4 },
{ pincode: 611109, min_days: 3, max_days: 4 },
{ pincode: 611111, min_days: 3, max_days: 4 },
{ pincode: 611112, min_days: 4, max_days: 5 },
{ pincode: 612001, min_days: 3, max_days: 4 },
{ pincode: 612002, min_days: 3, max_days: 4 },
{ pincode: 612101, min_days: 3, max_days: 4 },
{ pincode: 612103, min_days: 3, max_days: 4 },
{ pincode: 612104, min_days: 3, max_days: 4 },
{ pincode: 612105, min_days: 3, max_days: 4 },
{ pincode: 612107, min_days: 3, max_days: 4 },
{ pincode: 612108, min_days: 3, max_days: 4 },
{ pincode: 612204, min_days: 3, max_days: 4 },
{ pincode: 612206, min_days: 3, max_days: 4 },
{ pincode: 612301, min_days: 3, max_days: 4 },
{ pincode: 612303, min_days: 3, max_days: 4 },
{ pincode: 612602, min_days: 3, max_days: 4 },
{ pincode: 612702, min_days: 3, max_days: 4 },
{ pincode: 612703, min_days: 3, max_days: 4 },
{ pincode: 612803, min_days: 3, max_days: 4 },
{ pincode: 612804, min_days: 3, max_days: 4 },
{ pincode: 612901, min_days: 3, max_days: 4 },
{ pincode: 612902, min_days: 3, max_days: 4 },
{ pincode: 612903, min_days: 3, max_days: 4 },
{ pincode: 613001, min_days: 3, max_days: 4 },
{ pincode: 613002, min_days: 3, max_days: 4 },
{ pincode: 613003, min_days: 3, max_days: 4 },
{ pincode: 613004, min_days: 3, max_days: 4 },
{ pincode: 613005, min_days: 3, max_days: 4 },
{ pincode: 613006, min_days: 3, max_days: 4 },
{ pincode: 613007, min_days: 3, max_days: 4 },
{ pincode: 613008, min_days: 3, max_days: 4 },
{ pincode: 613009, min_days: 3, max_days: 4 },
{ pincode: 613010, min_days: 3, max_days: 4 },
{ pincode: 613101, min_days: 3, max_days: 4 },
{ pincode: 613104, min_days: 3, max_days: 4 },
{ pincode: 613205, min_days: 3, max_days: 4 },
{ pincode: 613303, min_days: 3, max_days: 4 },
{ pincode: 613401, min_days: 3, max_days: 4 },
{ pincode: 613403, min_days: 3, max_days: 4 },
{ pincode: 613601, min_days: 3, max_days: 4 },
{ pincode: 613704, min_days: 4, max_days: 5 },
{ pincode: 614001, min_days: 3, max_days: 4 },
{ pincode: 614010, min_days: 3, max_days: 4 },
{ pincode: 614013, min_days: 3, max_days: 4 },
{ pincode: 614014, min_days: 3, max_days: 4 },
{ pincode: 614015, min_days: 3, max_days: 4 },
{ pincode: 614016, min_days: 3, max_days: 4 },
{ pincode: 614017, min_days: 3, max_days: 4 },
{ pincode: 614018, min_days: 3, max_days: 4 },
{ pincode: 614020, min_days: 3, max_days: 4 },
{ pincode: 614024, min_days: 3, max_days: 4 },
{ pincode: 614028, min_days: 3, max_days: 4 },
{ pincode: 614101, min_days: 3, max_days: 4 },
{ pincode: 614201, min_days: 3, max_days: 4 },
{ pincode: 614202, min_days: 3, max_days: 4 },
{ pincode: 614203, min_days: 3, max_days: 4 },
{ pincode: 614205, min_days: 3, max_days: 4 },
{ pincode: 614206, min_days: 3, max_days: 4 },
{ pincode: 614207, min_days: 3, max_days: 4 },
{ pincode: 614208, min_days: 3, max_days: 4 },
{ pincode: 614209, min_days: 3, max_days: 4 },
{ pincode: 614302, min_days: 3, max_days: 4 },
{ pincode: 614303, min_days: 3, max_days: 4 },
{ pincode: 614403, min_days: 3, max_days: 4 },
{ pincode: 614404, min_days: 3, max_days: 4 },
{ pincode: 614601, min_days: 3, max_days: 4 },
{ pincode: 614602, min_days: 3, max_days: 4 },
{ pincode: 614615, min_days: 3, max_days: 4 },
{ pincode: 614616, min_days: 3, max_days: 4 },
{ pincode: 614623, min_days: 3, max_days: 4 },
{ pincode: 614624, min_days: 3, max_days: 4 },
{ pincode: 614701, min_days: 3, max_days: 4 },
{ pincode: 614704, min_days: 3, max_days: 4 },
{ pincode: 614708, min_days: 4, max_days: 5 },
{ pincode: 614713, min_days: 4, max_days: 5 },
{ pincode: 614714, min_days: 4, max_days: 5 },
{ pincode: 614717, min_days: 3, max_days: 4 },
{ pincode: 614722, min_days: 3, max_days: 4 },
{ pincode: 614804, min_days: 3, max_days: 4 },
{ pincode: 614901, min_days: 3, max_days: 4 },
{ pincode: 614906, min_days: 3, max_days: 4 },
{ pincode: 620001, min_days: 2, max_days: 3 },
{ pincode: 620002, min_days: 4, max_days: 5 },
{ pincode: 620003, min_days: 4, max_days: 5 },
{ pincode: 620004, min_days: 2, max_days: 3 },
{ pincode: 620005, min_days: 4, max_days: 5 },
{ pincode: 620006, min_days: 4, max_days: 5 },
{ pincode: 620007, min_days: 2, max_days: 3 },
{ pincode: 620008, min_days: 4, max_days: 5 },
{ pincode: 620009, min_days: 2, max_days: 3 },
{ pincode: 620010, min_days: 4, max_days: 5 },
{ pincode: 620011, min_days: 4, max_days: 5 },
{ pincode: 620012, min_days: 2, max_days: 3 },
{ pincode: 620013, min_days: 3, max_days: 4 },
{ pincode: 620014, min_days: 3, max_days: 4 },
{ pincode: 620015, min_days: 3, max_days: 4 },
{ pincode: 620016, min_days: 2, max_days: 3 },
{ pincode: 620017, min_days: 4, max_days: 5 },
{ pincode: 620018, min_days: 4, max_days: 5 },
{ pincode: 620019, min_days: 3, max_days: 4 },
{ pincode: 620020, min_days: 2, max_days: 3 },
{ pincode: 620021, min_days: 2, max_days: 3 },
{ pincode: 620022, min_days: 3, max_days: 4 },
{ pincode: 620023, min_days: 2, max_days: 3 },
{ pincode: 620024, min_days: 2, max_days: 3 },
{ pincode: 620025, min_days: 2, max_days: 3 },
{ pincode: 620026, min_days: 2, max_days: 3 },
{ pincode: 620052, min_days: 3, max_days: 4 },
{ pincode: 620101, min_days: 4, max_days: 5 },
{ pincode: 620102, min_days: 4, max_days: 5 },
{ pincode: 620114, min_days: 2, max_days: 3 },
{ pincode: 621005, min_days: 2, max_days: 3 },
{ pincode: 621008, min_days: 4, max_days: 5 },
{ pincode: 621010, min_days: 4, max_days: 5 },
{ pincode: 621012, min_days: 4, max_days: 5 },
{ pincode: 621014, min_days: 4, max_days: 5 },
{ pincode: 621016, min_days: 4, max_days: 5 },
{ pincode: 621018, min_days: 4, max_days: 5 },
{ pincode: 621022, min_days: 4, max_days: 5 },
{ pincode: 621103, min_days: 3, max_days: 4 },
{ pincode: 621104, min_days: 3, max_days: 4 },
{ pincode: 621105, min_days: 2, max_days: 3 },
{ pincode: 621108, min_days: 3, max_days: 4 },
{ pincode: 621110, min_days: 2, max_days: 3 },
{ pincode: 621112, min_days: 2, max_days: 3 },
{ pincode: 621113, min_days: 3, max_days: 4 },
{ pincode: 621115, min_days: 3, max_days: 4 },
{ pincode: 621117, min_days: 3, max_days: 4 },
{ pincode: 621126, min_days: 3, max_days: 4 },
{ pincode: 621127, min_days: 3, max_days: 4 },
{ pincode: 621132, min_days: 2, max_days: 3 },
{ pincode: 621201, min_days: 3, max_days: 4 },
{ pincode: 621202, min_days: 3, max_days: 4 },
{ pincode: 621203, min_days: 3, max_days: 4 },
{ pincode: 621206, min_days: 4, max_days: 5 },
{ pincode: 621207, min_days: 3, max_days: 4 },
{ pincode: 621209, min_days: 3, max_days: 4 },
{ pincode: 621211, min_days: 3, max_days: 4 },
{ pincode: 621212, min_days: 3, max_days: 4 },
{ pincode: 621213, min_days: 2, max_days: 3 },
{ pincode: 621214, min_days: 3, max_days: 4 },
{ pincode: 621215, min_days: 3, max_days: 4 },
{ pincode: 621216, min_days: 2, max_days: 3 },
{ pincode: 621218, min_days: 2, max_days: 3 },
{ pincode: 621219, min_days: 3, max_days: 4 },
{ pincode: 621220, min_days: 3, max_days: 4 },
{ pincode: 621221, min_days: 3, max_days: 4 },
{ pincode: 621229, min_days: 3, max_days: 4 },
{ pincode: 621306, min_days: 3, max_days: 4 },
{ pincode: 621307, min_days: 3, max_days: 4 },
{ pincode: 621312, min_days: 3, max_days: 4 },
{ pincode: 621314, min_days: 3, max_days: 4 },
{ pincode: 621316, min_days: 3, max_days: 4 },
{ pincode: 621516, min_days: 3, max_days: 4 },
{ pincode: 621591, min_days: 3, max_days: 4 },
{ pincode: 621601, min_days: 2, max_days: 3 },
{ pincode: 621651, min_days: 3, max_days: 4 },
{ pincode: 621704, min_days: 3, max_days: 4 },
{ pincode: 621707, min_days: 3, max_days: 4 },
{ pincode: 621710, min_days: 3, max_days: 4 },
{ pincode: 621713, min_days: 3, max_days: 4 },
{ pincode: 621801, min_days: 3, max_days: 4 },
{ pincode: 621802, min_days: 3, max_days: 4 },
{ pincode: 621803, min_days: 3, max_days: 4 },
{ pincode: 621804, min_days: 3, max_days: 4 },
{ pincode: 621806, min_days: 3, max_days: 4 },
{ pincode: 622001, min_days: 3, max_days: 4 },
{ pincode: 622002, min_days: 3, max_days: 4 },
{ pincode: 622003, min_days: 3, max_days: 4 },
{ pincode: 622054, min_days: 3, max_days: 4 },
{ pincode: 622301, min_days: 3, max_days: 4 },
{ pincode: 622302, min_days: 3, max_days: 4 },
{ pincode: 622515, min_days: 2, max_days: 3 },
{ pincode: 623115, min_days: 3, max_days: 4 },
{ pincode: 623135, min_days: 3, max_days: 4 },
{ pincode: 623215, min_days: 3, max_days: 4 },
{ pincode: 623309, min_days: 3, max_days: 4 },
{ pincode: 623315, min_days: 3, max_days: 4 },
{ pincode: 623402, min_days: 3, max_days: 4 },
{ pincode: 623403, min_days: 3, max_days: 4 },
{ pincode: 623404, min_days: 3, max_days: 4 },
{ pincode: 623406, min_days: 3, max_days: 4 },
{ pincode: 623407, min_days: 3, max_days: 4 },
{ pincode: 623409, min_days: 3, max_days: 4 },
{ pincode: 623501, min_days: 3, max_days: 4 },
{ pincode: 623503, min_days: 3, max_days: 4 },
{ pincode: 623504, min_days: 3, max_days: 4 },
{ pincode: 623513, min_days: 3, max_days: 4 },
{ pincode: 623514, min_days: 3, max_days: 4 },
{ pincode: 623515, min_days: 3, max_days: 4 },
{ pincode: 623517, min_days: 3, max_days: 4 },
{ pincode: 623518, min_days: 3, max_days: 4 },
{ pincode: 623519, min_days: 3, max_days: 4 },
{ pincode: 623520, min_days: 3, max_days: 4 },
{ pincode: 623521, min_days: 3, max_days: 4 },
{ pincode: 623522, min_days: 3, max_days: 4 },
{ pincode: 623523, min_days: 3, max_days: 4 },
{ pincode: 623525, min_days: 3, max_days: 4 },
{ pincode: 623526, min_days: 3, max_days: 4 },
{ pincode: 623529, min_days: 3, max_days: 4 },
{ pincode: 623530, min_days: 3, max_days: 4 },
{ pincode: 623532, min_days: 3, max_days: 4 },
{ pincode: 623533, min_days: 3, max_days: 4 },
{ pincode: 623534, min_days: 3, max_days: 4 },
{ pincode: 623536, min_days: 3, max_days: 4 },
{ pincode: 623538, min_days: 3, max_days: 4 },
{ pincode: 623539, min_days: 3, max_days: 4 },
{ pincode: 623544, min_days: 3, max_days: 4 },
{ pincode: 623566, min_days: 3, max_days: 4 },
{ pincode: 623603, min_days: 3, max_days: 4 },
{ pincode: 623604, min_days: 3, max_days: 4 },
{ pincode: 623605, min_days: 3, max_days: 4 },
{ pincode: 623701, min_days: 3, max_days: 4 },
{ pincode: 623704, min_days: 3, max_days: 4 },
{ pincode: 623705, min_days: 3, max_days: 4 },
{ pincode: 623707, min_days: 3, max_days: 4 },
{ pincode: 623708, min_days: 3, max_days: 4 },
{ pincode: 623711, min_days: 3, max_days: 4 },
{ pincode: 623712, min_days: 3, max_days: 4 },
{ pincode: 623719, min_days: 3, max_days: 4 },
{ pincode: 623801, min_days: 3, max_days: 4 },
{ pincode: 623802, min_days: 3, max_days: 4 },
{ pincode: 623804, min_days: 3, max_days: 4 },
{ pincode: 623806, min_days: 3, max_days: 4 },
{ pincode: 623807, min_days: 3, max_days: 4 },
{ pincode: 623808, min_days: 3, max_days: 4 },
{ pincode: 624001, min_days: 3, max_days: 4 },
{ pincode: 624002, min_days: 3, max_days: 4 },
{ pincode: 624003, min_days: 3, max_days: 4 },
{ pincode: 624004, min_days: 3, max_days: 4 },
{ pincode: 624005, min_days: 3, max_days: 4 },
{ pincode: 624006, min_days: 3, max_days: 4 },
{ pincode: 624007, min_days: 3, max_days: 4 },
{ pincode: 624008, min_days: 3, max_days: 4 },
{ pincode: 624009, min_days: 3, max_days: 4 },
{ pincode: 624010, min_days: 3, max_days: 4 },
{ pincode: 624054, min_days: 3, max_days: 4 },
{ pincode: 624101, min_days: 4, max_days: 5 },
{ pincode: 624102, min_days: 4, max_days: 5 },
{ pincode: 624103, min_days: 4, max_days: 5 },
{ pincode: 624201, min_days: 3, max_days: 4 },
{ pincode: 624202, min_days: 3, max_days: 4 },
{ pincode: 624204, min_days: 3, max_days: 4 },
{ pincode: 624206, min_days: 3, max_days: 4 },
{ pincode: 624208, min_days: 3, max_days: 4 },
{ pincode: 624211, min_days: 3, max_days: 4 },
{ pincode: 624212, min_days: 3, max_days: 4 },
{ pincode: 624213, min_days: 3, max_days: 4 },
{ pincode: 624215, min_days: 3, max_days: 4 },
{ pincode: 624216, min_days: 3, max_days: 4 },
{ pincode: 624219, min_days: 3, max_days: 4 },
{ pincode: 624220, min_days: 3, max_days: 4 },
{ pincode: 624224, min_days: 3, max_days: 4 },
{ pincode: 624228, min_days: 3, max_days: 4 },
{ pincode: 624301, min_days: 3, max_days: 4 },
{ pincode: 624302, min_days: 3, max_days: 4 },
{ pincode: 624304, min_days: 3, max_days: 4 },
{ pincode: 624306, min_days: 3, max_days: 4 },
{ pincode: 624307, min_days: 3, max_days: 4 },
{ pincode: 624308, min_days: 3, max_days: 4 },
{ pincode: 624312, min_days: 3, max_days: 4 },
{ pincode: 624314, min_days: 3, max_days: 4 },
{ pincode: 624316, min_days: 3, max_days: 4 },
{ pincode: 624401, min_days: 3, max_days: 4 },
{ pincode: 624402, min_days: 3, max_days: 4 },
{ pincode: 624403, min_days: 3, max_days: 4 },
{ pincode: 624404, min_days: 3, max_days: 4 },
{ pincode: 624601, min_days: 3, max_days: 4 },
{ pincode: 624610, min_days: 3, max_days: 4 },
{ pincode: 624612, min_days: 3, max_days: 4 },
{ pincode: 624614, min_days: 3, max_days: 4 },
{ pincode: 624615, min_days: 3, max_days: 4 },
{ pincode: 624616, min_days: 3, max_days: 4 },
{ pincode: 624619, min_days: 3, max_days: 4 },
{ pincode: 624620, min_days: 3, max_days: 4 },
{ pincode: 624622, min_days: 3, max_days: 4 },
{ pincode: 624624, min_days: 3, max_days: 4 },
{ pincode: 624701, min_days: 3, max_days: 4 },
{ pincode: 624702, min_days: 3, max_days: 4 },
{ pincode: 624703, min_days: 3, max_days: 4 },
{ pincode: 624704, min_days: 3, max_days: 4 },
{ pincode: 624705, min_days: 3, max_days: 4 },
{ pincode: 624706, min_days: 3, max_days: 4 },
{ pincode: 624707, min_days: 3, max_days: 4 },
{ pincode: 624708, min_days: 3, max_days: 4 },
{ pincode: 624709, min_days: 3, max_days: 4 },
{ pincode: 624710, min_days: 3, max_days: 4 },
{ pincode: 624711, min_days: 3, max_days: 4 },
{ pincode: 624712, min_days: 3, max_days: 4 },
{ pincode: 624714, min_days: 3, max_days: 4 },
{ pincode: 624771, min_days: 3, max_days: 4 },
{ pincode: 624801, min_days: 3, max_days: 4 },
{ pincode: 624802, min_days: 3, max_days: 4 },
{ pincode: 624803, min_days: 3, max_days: 4 },
{ pincode: 624881, min_days: 3, max_days: 4 },
{ pincode: 624885, min_days: 3, max_days: 4 },
{ pincode: 624890, min_days: 3, max_days: 4 },
{ pincode: 625001, min_days: 2, max_days: 3 },
{ pincode: 625002, min_days: 2, max_days: 3 },
{ pincode: 625003, min_days: 2, max_days: 3 },
{ pincode: 625004, min_days: 2, max_days: 3 },
{ pincode: 625005, min_days: 2, max_days: 3 },
{ pincode: 625006, min_days: 2, max_days: 3 },
{ pincode: 625007, min_days: 2, max_days: 3 },
{ pincode: 625008, min_days: 2, max_days: 3 },
{ pincode: 625009, min_days: 2, max_days: 3 },
{ pincode: 625010, min_days: 2, max_days: 3 },
{ pincode: 625011, min_days: 2, max_days: 3 },
{ pincode: 625012, min_days: 2, max_days: 3 },
{ pincode: 625013, min_days: 2, max_days: 3 },
{ pincode: 625014, min_days: 2, max_days: 3 },
{ pincode: 625015, min_days: 2, max_days: 3 },
{ pincode: 625016, min_days: 2, max_days: 3 },
{ pincode: 625017, min_days: 2, max_days: 3 },
{ pincode: 625018, min_days: 2, max_days: 3 },
{ pincode: 625019, min_days: 2, max_days: 3 },
{ pincode: 625020, min_days: 2, max_days: 3 },
{ pincode: 625021, min_days: 2, max_days: 3 },
{ pincode: 625022, min_days: 2, max_days: 3 },
{ pincode: 625023, min_days: 2, max_days: 3 },
{ pincode: 625104, min_days: 2, max_days: 3 },
{ pincode: 625106, min_days: 3, max_days: 4 },
{ pincode: 625107, min_days: 2, max_days: 3 },
{ pincode: 625122, min_days: 3, max_days: 4 },
{ pincode: 625209, min_days: 3, max_days: 4 },
{ pincode: 625217, min_days: 3, max_days: 4 },
{ pincode: 625218, min_days: 3, max_days: 4 },
{ pincode: 625221, min_days: 3, max_days: 4 },
{ pincode: 625234, min_days: 3, max_days: 4 },
{ pincode: 625301, min_days: 2, max_days: 3 },
{ pincode: 625401, min_days: 2, max_days: 3 },
{ pincode: 625402, min_days: 2, max_days: 3 },
{ pincode: 625501, min_days: 3, max_days: 4 },
{ pincode: 625502, min_days: 3, max_days: 4 },
{ pincode: 625503, min_days: 3, max_days: 4 },
{ pincode: 625512, min_days: 3, max_days: 4 },
{ pincode: 625513, min_days: 3, max_days: 4 },
{ pincode: 625514, min_days: 3, max_days: 4 },
{ pincode: 625515, min_days: 3, max_days: 4 },
{ pincode: 625516, min_days: 3, max_days: 4 },
{ pincode: 625518, min_days: 3, max_days: 4 },
{ pincode: 625521, min_days: 3, max_days: 4 },
{ pincode: 625522, min_days: 3, max_days: 4 },
{ pincode: 625524, min_days: 3, max_days: 4 },
{ pincode: 625525, min_days: 3, max_days: 4 },
{ pincode: 625526, min_days: 3, max_days: 4 },
{ pincode: 625528, min_days: 3, max_days: 4 },
{ pincode: 625529, min_days: 3, max_days: 4 },
{ pincode: 625530, min_days: 3, max_days: 4 },
{ pincode: 625531, min_days: 3, max_days: 4 },
{ pincode: 625532, min_days: 3, max_days: 4 },
{ pincode: 625533, min_days: 3, max_days: 4 },
{ pincode: 625534, min_days: 3, max_days: 4 },
{ pincode: 625535, min_days: 3, max_days: 4 },
{ pincode: 625536, min_days: 3, max_days: 4 },
{ pincode: 625537, min_days: 3, max_days: 4 },
{ pincode: 625547, min_days: 3, max_days: 4 },
{ pincode: 625552, min_days: 3, max_days: 4 },
{ pincode: 625556, min_days: 3, max_days: 4 },
{ pincode: 625566, min_days: 3, max_days: 4 },
{ pincode: 625572, min_days: 3, max_days: 4 },
{ pincode: 625589, min_days: 3, max_days: 4 },
{ pincode: 625621, min_days: 3, max_days: 4 },
{ pincode: 625701, min_days: 3, max_days: 4 },
{ pincode: 625702, min_days: 3, max_days: 4 },
{ pincode: 625703, min_days: 3, max_days: 4 },
{ pincode: 625704, min_days: 3, max_days: 4 },
{ pincode: 625705, min_days: 3, max_days: 4 },
{ pincode: 625706, min_days: 3, max_days: 4 },
{ pincode: 625707, min_days: 3, max_days: 4 },
{ pincode: 625708, min_days: 3, max_days: 4 },
{ pincode: 626001, min_days: 3, max_days: 4 },
{ pincode: 626002, min_days: 3, max_days: 4 },
{ pincode: 626003, min_days: 3, max_days: 4 },
{ pincode: 626004, min_days: 3, max_days: 4 },
{ pincode: 626005, min_days: 3, max_days: 4 },
{ pincode: 626008, min_days: 3, max_days: 4 },
{ pincode: 626053, min_days: 3, max_days: 4 },
{ pincode: 626100, min_days: 3, max_days: 4 },
{ pincode: 626101, min_days: 3, max_days: 4 },
{ pincode: 626102, min_days: 3, max_days: 4 },
{ pincode: 626103, min_days: 3, max_days: 4 },
{ pincode: 626105, min_days: 3, max_days: 4 },
{ pincode: 626107, min_days: 3, max_days: 4 },
{ pincode: 626109, min_days: 3, max_days: 4 },
{ pincode: 626110, min_days: 3, max_days: 4 },
{ pincode: 626112, min_days: 3, max_days: 4 },
{ pincode: 626114, min_days: 3, max_days: 4 },
{ pincode: 626116, min_days: 3, max_days: 4 },
{ pincode: 626117, min_days: 3, max_days: 4 },
{ pincode: 626119, min_days: 3, max_days: 4 },
{ pincode: 626123, min_days: 3, max_days: 4 },
{ pincode: 626124, min_days: 3, max_days: 4 },
{ pincode: 626125, min_days: 3, max_days: 4 },
{ pincode: 626126, min_days: 3, max_days: 4 },
{ pincode: 626128, min_days: 3, max_days: 4 },
{ pincode: 626130, min_days: 3, max_days: 4 },
{ pincode: 626132, min_days: 3, max_days: 4 },
{ pincode: 626135, min_days: 3, max_days: 4 },
{ pincode: 626138, min_days: 3, max_days: 4 },
{ pincode: 626141, min_days: 3, max_days: 4 },
{ pincode: 626143, min_days: 3, max_days: 4 },
{ pincode: 626149, min_days: 3, max_days: 4 },
{ pincode: 626150, min_days: 3, max_days: 4 },
{ pincode: 626154, min_days: 3, max_days: 4 },
{ pincode: 626159, min_days: 3, max_days: 4 },
{ pincode: 626169, min_days: 3, max_days: 4 },
{ pincode: 626188, min_days: 3, max_days: 4 },
{ pincode: 626189, min_days: 3, max_days: 4 },
{ pincode: 626190, min_days: 3, max_days: 4 },
{ pincode: 626202, min_days: 3, max_days: 4 },
{ pincode: 626203, min_days: 3, max_days: 4 },
{ pincode: 626204, min_days: 3, max_days: 4 },
{ pincode: 626881, min_days: 3, max_days: 4 },
{ pincode: 627001, min_days: 4, max_days: 5 },
{ pincode: 627002, min_days: 4, max_days: 5 },
{ pincode: 627003, min_days: 4, max_days: 5 },
{ pincode: 627004, min_days: 4, max_days: 5 },
{ pincode: 627005, min_days: 4, max_days: 5 },
{ pincode: 627006, min_days: 4, max_days: 5 },
{ pincode: 627007, min_days: 4, max_days: 5 },
{ pincode: 627008, min_days: 4, max_days: 5 },
{ pincode: 627009, min_days: 4, max_days: 5 },
{ pincode: 627010, min_days: 4, max_days: 5 },
{ pincode: 627011, min_days: 4, max_days: 5 },
{ pincode: 627012, min_days: 4, max_days: 5 },
{ pincode: 627051, min_days: 4, max_days: 5 },
{ pincode: 627105, min_days: 4, max_days: 5 },
{ pincode: 627109, min_days: 4, max_days: 5 },
{ pincode: 627116, min_days: 4, max_days: 5 },
{ pincode: 627117, min_days: 4, max_days: 5 },
{ pincode: 627131, min_days: 4, max_days: 5 },
{ pincode: 627151, min_days: 4, max_days: 5 },
{ pincode: 627152, min_days: 4, max_days: 5 },
{ pincode: 627201, min_days: 4, max_days: 5 },
{ pincode: 627252, min_days: 4, max_days: 5 },
{ pincode: 627351, min_days: 4, max_days: 5 },
{ pincode: 627352, min_days: 4, max_days: 5 },
{ pincode: 627353, min_days: 4, max_days: 5 },
{ pincode: 627356, min_days: 4, max_days: 5 },
{ pincode: 627357, min_days: 4, max_days: 5 },
{ pincode: 627358, min_days: 4, max_days: 5 },
{ pincode: 627359, min_days: 4, max_days: 5 },
{ pincode: 627361, min_days: 4, max_days: 5 },
{ pincode: 627401, min_days: 3, max_days: 4 },
{ pincode: 627412, min_days: 3, max_days: 4 },
{ pincode: 627413, min_days: 3, max_days: 4 },
{ pincode: 627414, min_days: 3, max_days: 4 },
{ pincode: 627415, min_days: 3, max_days: 4 },
{ pincode: 627416, min_days: 3, max_days: 4 },
{ pincode: 627417, min_days: 3, max_days: 4 },
{ pincode: 627418, min_days: 3, max_days: 4 },
{ pincode: 627420, min_days: 3, max_days: 4 },
{ pincode: 627421, min_days: 3, max_days: 4 },
{ pincode: 627422, min_days: 3, max_days: 4 },
{ pincode: 627423, min_days: 3, max_days: 4 },
{ pincode: 627424, min_days: 3, max_days: 4 },
{ pincode: 627425, min_days: 3, max_days: 4 },
{ pincode: 627426, min_days: 3, max_days: 4 },
{ pincode: 627427, min_days: 3, max_days: 4 },
{ pincode: 627428, min_days: 3, max_days: 4 },
{ pincode: 627431, min_days: 3, max_days: 4 },
{ pincode: 627435, min_days: 3, max_days: 4 },
{ pincode: 627436, min_days: 3, max_days: 4 },
{ pincode: 627451, min_days: 4, max_days: 5 },
{ pincode: 627452, min_days: 3, max_days: 4 },
{ pincode: 627453, min_days: 3, max_days: 4 },
{ pincode: 627551, min_days: 3, max_days: 4 },
{ pincode: 627601, min_days: 3, max_days: 4 },
{ pincode: 627602, min_days: 3, max_days: 4 },
{ pincode: 627603, min_days: 3, max_days: 4 },
{ pincode: 627604, min_days: 4, max_days: 5 },
{ pincode: 627659, min_days: 4, max_days: 5 },
{ pincode: 627719, min_days: 3, max_days: 4 },
{ pincode: 627724, min_days: 3, max_days: 4 },
{ pincode: 627751, min_days: 3, max_days: 4 },
{ pincode: 627753, min_days: 3, max_days: 4 },
{ pincode: 627754, min_days: 3, max_days: 4 },
{ pincode: 627755, min_days: 3, max_days: 4 },
{ pincode: 627756, min_days: 3, max_days: 4 },
{ pincode: 627758, min_days: 3, max_days: 4 },
{ pincode: 627759, min_days: 3, max_days: 4 },
{ pincode: 627760, min_days: 3, max_days: 4 },
{ pincode: 627761, min_days: 3, max_days: 4 },
{ pincode: 627764, min_days: 3, max_days: 4 },
{ pincode: 627765, min_days: 3, max_days: 4 },
{ pincode: 627773, min_days: 3, max_days: 4 },
{ pincode: 627778, min_days: 3, max_days: 4 },
{ pincode: 627802, min_days: 3, max_days: 4 },
{ pincode: 627803, min_days: 3, max_days: 4 },
{ pincode: 627804, min_days: 3, max_days: 4 },
{ pincode: 627805, min_days: 3, max_days: 4 },
{ pincode: 627806, min_days: 3, max_days: 4 },
{ pincode: 627807, min_days: 3, max_days: 4 },
{ pincode: 627808, min_days: 3, max_days: 4 },
{ pincode: 627809, min_days: 3, max_days: 4 },
{ pincode: 627810, min_days: 3, max_days: 4 },
{ pincode: 627811, min_days: 3, max_days: 4 },
{ pincode: 627812, min_days: 3, max_days: 4 },
{ pincode: 627813, min_days: 3, max_days: 4 },
{ pincode: 627814, min_days: 3, max_days: 4 },
{ pincode: 627817, min_days: 3, max_days: 4 },
{ pincode: 627818, min_days: 3, max_days: 4 },
{ pincode: 627821, min_days: 3, max_days: 4 },
{ pincode: 627851, min_days: 3, max_days: 4 },
{ pincode: 627852, min_days: 3, max_days: 4 },
{ pincode: 627855, min_days: 3, max_days: 4 },
{ pincode: 627856, min_days: 3, max_days: 4 },
{ pincode: 627858, min_days: 3, max_days: 4 },
{ pincode: 627859, min_days: 3, max_days: 4 },
{ pincode: 627862, min_days: 3, max_days: 4 },
{ pincode: 627907, min_days: 3, max_days: 4 },
{ pincode: 627909, min_days: 3, max_days: 4 },
{ pincode: 627953, min_days: 3, max_days: 4 },
{ pincode: 627956, min_days: 3, max_days: 4 },
{ pincode: 628001, min_days: 3, max_days: 4 },
{ pincode: 628002, min_days: 3, max_days: 4 },
{ pincode: 628003, min_days: 3, max_days: 4 },
{ pincode: 628004, min_days: 3, max_days: 4 },
{ pincode: 628005, min_days: 3, max_days: 4 },
{ pincode: 628006, min_days: 3, max_days: 4 },
{ pincode: 628007, min_days: 3, max_days: 4 },
{ pincode: 628008, min_days: 3, max_days: 4 },
{ pincode: 628101, min_days: 3, max_days: 4 },
{ pincode: 628102, min_days: 3, max_days: 4 },
{ pincode: 628103, min_days: 3, max_days: 4 },
{ pincode: 628105, min_days: 3, max_days: 4 },
{ pincode: 628151, min_days: 3, max_days: 4 },
{ pincode: 628152, min_days: 3, max_days: 4 },
{ pincode: 628155, min_days: 3, max_days: 4 },
{ pincode: 628202, min_days: 3, max_days: 4 },
{ pincode: 628203, min_days: 3, max_days: 4 },
{ pincode: 628204, min_days: 3, max_days: 4 },
{ pincode: 628215, min_days: 3, max_days: 4 },
{ pincode: 628223, min_days: 3, max_days: 4 },
{ pincode: 628251, min_days: 3, max_days: 4 },
{ pincode: 628252, min_days: 4, max_days: 5 },
{ pincode: 628253, min_days: 4, max_days: 5 },
{ pincode: 628303, min_days: 4, max_days: 5 },
{ pincode: 628304, min_days: 3, max_days: 4 },
{ pincode: 628313, min_days: 4, max_days: 5 },
{ pincode: 628501, min_days: 3, max_days: 4 },
{ pincode: 628502, min_days: 3, max_days: 4 },
{ pincode: 628552, min_days: 3, max_days: 4 },
{ pincode: 628616, min_days: 3, max_days: 4 },
{ pincode: 628617, min_days: 3, max_days: 4 },
{ pincode: 628722, min_days: 3, max_days: 4 },
{ pincode: 628801, min_days: 3, max_days: 4 },
{ pincode: 628809, min_days: 4, max_days: 5 },
{ pincode: 628851, min_days: 4, max_days: 5 },
{ pincode: 628907, min_days: 3, max_days: 4 },
{ pincode: 629001, min_days: 4, max_days: 5 },
{ pincode: 629002, min_days: 4, max_days: 5 },
{ pincode: 629003, min_days: 4, max_days: 5 },
{ pincode: 629004, min_days: 4, max_days: 5 },
{ pincode: 629051, min_days: 4, max_days: 5 },
{ pincode: 629058, min_days: 4, max_days: 5 },
{ pincode: 629151, min_days: 4, max_days: 5 },
{ pincode: 629153, min_days: 4, max_days: 5 },
{ pincode: 629154, min_days: 4, max_days: 5 },
{ pincode: 629157, min_days: 4, max_days: 5 },
{ pincode: 629160, min_days: 4, max_days: 5 },
{ pincode: 629163, min_days: 4, max_days: 5 },
{ pincode: 629165, min_days: 4, max_days: 5 },
{ pincode: 629167, min_days: 4, max_days: 5 },
{ pincode: 629171, min_days: 4, max_days: 5 },
{ pincode: 629172, min_days: 4, max_days: 5 },
{ pincode: 629174, min_days: 4, max_days: 5 },
{ pincode: 629175, min_days: 4, max_days: 5 },
{ pincode: 629176, min_days: 4, max_days: 5 },
{ pincode: 629177, min_days: 4, max_days: 5 },
{ pincode: 629180, min_days: 4, max_days: 5 },
{ pincode: 629187, min_days: 4, max_days: 5 },
{ pincode: 629190, min_days: 4, max_days: 5 },
{ pincode: 629191, min_days: 4, max_days: 5 },
{ pincode: 629194, min_days: 4, max_days: 5 },
{ pincode: 629195, min_days: 4, max_days: 5 },
{ pincode: 629251, min_days: 4, max_days: 5 },
{ pincode: 629252, min_days: 4, max_days: 5 },
{ pincode: 629302, min_days: 4, max_days: 5 },
{ pincode: 629303, min_days: 4, max_days: 5 },
{ pincode: 629305, min_days: 4, max_days: 5 },
{ pincode: 629401, min_days: 4, max_days: 5 },
{ pincode: 629402, min_days: 4, max_days: 5 },
{ pincode: 629403, min_days: 4, max_days: 5 },
{ pincode: 629501, min_days: 4, max_days: 5 },
{ pincode: 629502, min_days: 4, max_days: 5 },
{ pincode: 629504, min_days: 4, max_days: 5 },
{ pincode: 629551, min_days: 4, max_days: 5 },
{ pincode: 629601, min_days: 4, max_days: 5 },
{ pincode: 629602, min_days: 4, max_days: 5 },
{ pincode: 629603, min_days: 4, max_days: 5 },
{ pincode: 629701, min_days: 4, max_days: 5 },
{ pincode: 629702, min_days: 4, max_days: 5 },
{ pincode: 629703, min_days: 4, max_days: 5 },
{ pincode: 629708, min_days: 4, max_days: 5 },
{ pincode: 629801, min_days: 4, max_days: 5 },
{ pincode: 629802, min_days: 4, max_days: 5 },
{ pincode: 629805, min_days: 4, max_days: 5 },
{ pincode: 629806, min_days: 4, max_days: 5 },
{ pincode: 629807, min_days: 4, max_days: 5 },
{ pincode: 629852, min_days: 4, max_days: 5 },
{ pincode: 629854, min_days: 4, max_days: 5 },
{ pincode: 629901, min_days: 4, max_days: 5 },
{ pincode: 629902, min_days: 4, max_days: 5 },
{ pincode: 630001, min_days: 3, max_days: 4 },
{ pincode: 630002, min_days: 3, max_days: 4 },
{ pincode: 630003, min_days: 3, max_days: 4 },
{ pincode: 630004, min_days: 3, max_days: 4 },
{ pincode: 630005, min_days: 3, max_days: 4 },
{ pincode: 630006, min_days: 3, max_days: 4 },
{ pincode: 630010, min_days: 3, max_days: 4 },
{ pincode: 630101, min_days: 3, max_days: 4 },
{ pincode: 630102, min_days: 3, max_days: 4 },
{ pincode: 630103, min_days: 3, max_days: 4 },
{ pincode: 630104, min_days: 3, max_days: 4 },
{ pincode: 630106, min_days: 3, max_days: 4 },
{ pincode: 630107, min_days: 3, max_days: 4 },
{ pincode: 630108, min_days: 3, max_days: 4 },
{ pincode: 630202, min_days: 3, max_days: 4 },
{ pincode: 630206, min_days: 3, max_days: 4 },
{ pincode: 630207, min_days: 3, max_days: 4 },
{ pincode: 630208, min_days: 3, max_days: 4 },
{ pincode: 630211, min_days: 3, max_days: 4 },
{ pincode: 630214, min_days: 3, max_days: 4 },
{ pincode: 630301, min_days: 3, max_days: 4 },
{ pincode: 630302, min_days: 3, max_days: 4 },
{ pincode: 630303, min_days: 3, max_days: 4 },
{ pincode: 630306, min_days: 3, max_days: 4 },
{ pincode: 630307, min_days: 3, max_days: 4 },
{ pincode: 630311, min_days: 3, max_days: 4 },
{ pincode: 630312, min_days: 3, max_days: 4 },
{ pincode: 630314, min_days: 3, max_days: 4 },
{ pincode: 630317, min_days: 3, max_days: 4 },
{ pincode: 630318, min_days: 3, max_days: 4 },
{ pincode: 630407, min_days: 3, max_days: 4 },
{ pincode: 630409, min_days: 3, max_days: 4 },
{ pincode: 630411, min_days: 3, max_days: 4 },
{ pincode: 630551, min_days: 3, max_days: 4 },
{ pincode: 630552, min_days: 3, max_days: 4 },
{ pincode: 630555, min_days: 3, max_days: 4 },
{ pincode: 630556, min_days: 3, max_days: 4 },
{ pincode: 630557, min_days: 3, max_days: 4 },
{ pincode: 630558, min_days: 3, max_days: 4 },
{ pincode: 630560, min_days: 3, max_days: 4 },
{ pincode: 630561, min_days: 3, max_days: 4 },
{ pincode: 630562, min_days: 3, max_days: 4 },
{ pincode: 630605, min_days: 3, max_days: 4 },
{ pincode: 630606, min_days: 3, max_days: 4 },
{ pincode: 630611, min_days: 3, max_days: 4 },
{ pincode: 630702, min_days: 3, max_days: 4 },
{ pincode: 630709, min_days: 3, max_days: 4 },
{ pincode: 631001, min_days: 3, max_days: 4 },
{ pincode: 631002, min_days: 3, max_days: 4 },
{ pincode: 631003, min_days: 3, max_days: 4 },
{ pincode: 631005, min_days: 3, max_days: 4 },
{ pincode: 631006, min_days: 3, max_days: 4 },
{ pincode: 631051, min_days: 3, max_days: 4 },
{ pincode: 631102, min_days: 4, max_days: 5 },
{ pincode: 631122, min_days: 2, max_days: 3 },
{ pincode: 631151, min_days: 3, max_days: 4 },
{ pincode: 631202, min_days: 3, max_days: 4 },
{ pincode: 631203, min_days: 3, max_days: 4 },
{ pincode: 631207, min_days: 3, max_days: 4 },
{ pincode: 631208, min_days: 3, max_days: 4 },
{ pincode: 631209, min_days: 3, max_days: 4 },
{ pincode: 631301, min_days: 4, max_days: 5 },
{ pincode: 631302, min_days: 4, max_days: 5 },
{ pincode: 631303, min_days: 4, max_days: 5 },
{ pincode: 631402, min_days: 3, max_days: 4 },
{ pincode: 631501, min_days: 3, max_days: 4 },
{ pincode: 631502, min_days: 3, max_days: 4 },
{ pincode: 631503, min_days: 3, max_days: 4 },
{ pincode: 631561, min_days: 3, max_days: 4 },
{ pincode: 631601, min_days: 3, max_days: 4 },
{ pincode: 631604, min_days: 2, max_days: 3 },
{ pincode: 631605, min_days: 3, max_days: 4 },
{ pincode: 631701, min_days: 3, max_days: 4 },
{ pincode: 632001, min_days: 3, max_days: 4 },
{ pincode: 632002, min_days: 3, max_days: 4 },
{ pincode: 632003, min_days: 3, max_days: 4 },
{ pincode: 632004, min_days: 3, max_days: 4 },
{ pincode: 632005, min_days: 3, max_days: 4 },
{ pincode: 632006, min_days: 3, max_days: 4 },
{ pincode: 632007, min_days: 3, max_days: 4 },
{ pincode: 632008, min_days: 3, max_days: 4 },
{ pincode: 632009, min_days: 3, max_days: 4 },
{ pincode: 632010, min_days: 3, max_days: 4 },
{ pincode: 632011, min_days: 3, max_days: 4 },
{ pincode: 632012, min_days: 3, max_days: 4 },
{ pincode: 632013, min_days: 3, max_days: 4 },
{ pincode: 632014, min_days: 3, max_days: 4 },
{ pincode: 632055, min_days: 3, max_days: 4 },
{ pincode: 632057, min_days: 3, max_days: 4 },
{ pincode: 632058, min_days: 3, max_days: 4 },
{ pincode: 632059, min_days: 3, max_days: 4 },
{ pincode: 632101, min_days: 3, max_days: 4 },
{ pincode: 632102, min_days: 3, max_days: 4 },
{ pincode: 632104, min_days: 3, max_days: 4 },
{ pincode: 632105, min_days: 3, max_days: 4 },
{ pincode: 632106, min_days: 3, max_days: 4 },
{ pincode: 632107, min_days: 4, max_days: 5 },
{ pincode: 632113, min_days: 3, max_days: 4 },
{ pincode: 632114, min_days: 3, max_days: 4 },
{ pincode: 632115, min_days: 3, max_days: 4 },
{ pincode: 632116, min_days: 3, max_days: 4 },
{ pincode: 632201, min_days: 3, max_days: 4 },
{ pincode: 632202, min_days: 3, max_days: 4 },
{ pincode: 632203, min_days: 3, max_days: 4 },
{ pincode: 632204, min_days: 3, max_days: 4 },
{ pincode: 632209, min_days: 4, max_days: 5 },
{ pincode: 632301, min_days: 3, max_days: 4 },
{ pincode: 632311, min_days: 3, max_days: 4 },
{ pincode: 632312, min_days: 3, max_days: 4 },
{ pincode: 632314, min_days: 3, max_days: 4 },
{ pincode: 632315, min_days: 3, max_days: 4 },
{ pincode: 632316, min_days: 3, max_days: 4 },
{ pincode: 632317, min_days: 3, max_days: 4 },
{ pincode: 632318, min_days: 3, max_days: 4 },
{ pincode: 632319, min_days: 3, max_days: 4 },
{ pincode: 632320, min_days: 3, max_days: 4 },
{ pincode: 632326, min_days: 3, max_days: 4 },
{ pincode: 632401, min_days: 3, max_days: 4 },
{ pincode: 632402, min_days: 3, max_days: 4 },
{ pincode: 632403, min_days: 3, max_days: 4 },
{ pincode: 632404, min_days: 3, max_days: 4 },
{ pincode: 632405, min_days: 3, max_days: 4 },
{ pincode: 632406, min_days: 3, max_days: 4 },
{ pincode: 632408, min_days: 3, max_days: 4 },
{ pincode: 632416, min_days: 3, max_days: 4 },
{ pincode: 632442, min_days: 3, max_days: 4 },
{ pincode: 632501, min_days: 3, max_days: 4 },
{ pincode: 632503, min_days: 3, max_days: 4 },
{ pincode: 632504, min_days: 3, max_days: 4 },
{ pincode: 632505, min_days: 4, max_days: 5 },
{ pincode: 632506, min_days: 3, max_days: 4 },
{ pincode: 632507, min_days: 3, max_days: 4 },
{ pincode: 632508, min_days: 3, max_days: 4 },
{ pincode: 632509, min_days: 3, max_days: 4 },
{ pincode: 632512, min_days: 3, max_days: 4 },
{ pincode: 632513, min_days: 3, max_days: 4 },
{ pincode: 632514, min_days: 3, max_days: 4 },
{ pincode: 632515, min_days: 3, max_days: 4 },
{ pincode: 632516, min_days: 3, max_days: 4 },
{ pincode: 632517, min_days: 3, max_days: 4 },
{ pincode: 632519, min_days: 3, max_days: 4 },
{ pincode: 632520, min_days: 3, max_days: 4 },
{ pincode: 632521, min_days: 3, max_days: 4 },
{ pincode: 632524, min_days: 3, max_days: 4 },
{ pincode: 632601, min_days: 4, max_days: 5 },
{ pincode: 632602, min_days: 3, max_days: 4 },
{ pincode: 632603, min_days: 4, max_days: 5 },
{ pincode: 632604, min_days: 4, max_days: 5 },
{ pincode: 632605, min_days: 3, max_days: 4 },
{ pincode: 635001, min_days: 3, max_days: 4 },
{ pincode: 635002, min_days: 3, max_days: 4 },
{ pincode: 635101, min_days: 3, max_days: 4 },
{ pincode: 635103, min_days: 2, max_days: 3 },
{ pincode: 635104, min_days: 3, max_days: 4 },
{ pincode: 635108, min_days: 3, max_days: 4 },
{ pincode: 635109, min_days: 2, max_days: 3 },
{ pincode: 635110, min_days: 2, max_days: 3 },
{ pincode: 635111, min_days: 3, max_days: 4 },
{ pincode: 635112, min_days: 3, max_days: 4 },
{ pincode: 635113, min_days: 3, max_days: 4 },
{ pincode: 635114, min_days: 2, max_days: 3 },
{ pincode: 635115, min_days: 3, max_days: 4 },
{ pincode: 635117, min_days: 3, max_days: 4 },
{ pincode: 635119, min_days: 3, max_days: 4 },
{ pincode: 635120, min_days: 3, max_days: 4 },
{ pincode: 635123, min_days: 3, max_days: 4 },
{ pincode: 635124, min_days: 3, max_days: 4 },
{ pincode: 635125, min_days: 2, max_days: 3 },
{ pincode: 635126, min_days: 2, max_days: 3 },
{ pincode: 635201, min_days: 3, max_days: 4 },
{ pincode: 635202, min_days: 3, max_days: 4 },
{ pincode: 635203, min_days: 3, max_days: 4 },
{ pincode: 635204, min_days: 3, max_days: 4 },
{ pincode: 635206, min_days: 3, max_days: 4 },
{ pincode: 635208, min_days: 3, max_days: 4 },
{ pincode: 635301, min_days: 2, max_days: 3 },
{ pincode: 635302, min_days: 2, max_days: 3 },
{ pincode: 635303, min_days: 2, max_days: 3 },
{ pincode: 635304, min_days: 3, max_days: 4 },
{ pincode: 635305, min_days: 2, max_days: 3 },
{ pincode: 635313, min_days: 2, max_days: 3 },
{ pincode: 635601, min_days: 4, max_days: 5 },
{ pincode: 635602, min_days: 4, max_days: 5 },
{ pincode: 635701, min_days: 4, max_days: 5 },
{ pincode: 635702, min_days: 4, max_days: 5 },
{ pincode: 635710, min_days: 4, max_days: 5 },
{ pincode: 635751, min_days: 3, max_days: 4 },
{ pincode: 635752, min_days: 4, max_days: 5 },
{ pincode: 635754, min_days: 4, max_days: 5 },
{ pincode: 635801, min_days: 4, max_days: 5 },
{ pincode: 635802, min_days: 3, max_days: 4 },
{ pincode: 635803, min_days: 3, max_days: 4 },
{ pincode: 635804, min_days: 4, max_days: 5 },
{ pincode: 635805, min_days: 3, max_days: 4 },
{ pincode: 635806, min_days: 4, max_days: 5 },
{ pincode: 635807, min_days: 4, max_days: 5 },
{ pincode: 635808, min_days: 3, max_days: 4 },
{ pincode: 635809, min_days: 4, max_days: 5 },
{ pincode: 635810, min_days: 3, max_days: 4 },
{ pincode: 635811, min_days: 3, max_days: 4 },
{ pincode: 635813, min_days: 4, max_days: 5 },
{ pincode: 635814, min_days: 3, max_days: 4 },
{ pincode: 635815, min_days: 4, max_days: 5 },
{ pincode: 635851, min_days: 4, max_days: 5 },
{ pincode: 635852, min_days: 4, max_days: 5 },
{ pincode: 635853, min_days: 4, max_days: 5 },
{ pincode: 636001, min_days: 2, max_days: 3 },
{ pincode: 636002, min_days: 2, max_days: 3 },
{ pincode: 636003, min_days: 2, max_days: 3 },
{ pincode: 636004, min_days: 2, max_days: 3 },
{ pincode: 636005, min_days: 2, max_days: 3 },
{ pincode: 636006, min_days: 2, max_days: 3 },
{ pincode: 636007, min_days: 2, max_days: 3 },
{ pincode: 636008, min_days: 2, max_days: 3 },
{ pincode: 636009, min_days: 2, max_days: 3 },
{ pincode: 636010, min_days: 2, max_days: 3 },
{ pincode: 636011, min_days: 2, max_days: 3 },
{ pincode: 636012, min_days: 2, max_days: 3 },
{ pincode: 636013, min_days: 2, max_days: 3 },
{ pincode: 636014, min_days: 2, max_days: 3 },
{ pincode: 636015, min_days: 2, max_days: 3 },
{ pincode: 636016, min_days: 2, max_days: 3 },
{ pincode: 636017, min_days: 2, max_days: 3 },
{ pincode: 636030, min_days: 2, max_days: 3 },
{ pincode: 636101, min_days: 2, max_days: 3 },
{ pincode: 636102, min_days: 2, max_days: 3 },
{ pincode: 636103, min_days: 2, max_days: 3 },
{ pincode: 636104, min_days: 3, max_days: 4 },
{ pincode: 636105, min_days: 2, max_days: 3 },
{ pincode: 636106, min_days: 2, max_days: 3 },
{ pincode: 636107, min_days: 2, max_days: 3 },
{ pincode: 636108, min_days: 2, max_days: 3 },
{ pincode: 636109, min_days: 2, max_days: 3 },
{ pincode: 636110, min_days: 2, max_days: 3 },
{ pincode: 636111, min_days: 3, max_days: 4 },
{ pincode: 636112, min_days: 2, max_days: 3 },
{ pincode: 636113, min_days: 2, max_days: 3 },
{ pincode: 636114, min_days: 3, max_days: 4 },
{ pincode: 636115, min_days: 3, max_days: 4 },
{ pincode: 636116, min_days: 2, max_days: 3 },
{ pincode: 636117, min_days: 3, max_days: 4 },
{ pincode: 636118, min_days: 2, max_days: 3 },
{ pincode: 636119, min_days: 3, max_days: 4 },
{ pincode: 636121, min_days: 2, max_days: 3 },
{ pincode: 636122, min_days: 2, max_days: 3 },
{ pincode: 636124, min_days: 2, max_days: 3 },
{ pincode: 636130, min_days: 2, max_days: 3 },
{ pincode: 636138, min_days: 3, max_days: 4 },
{ pincode: 636139, min_days: 3, max_days: 4 },
{ pincode: 636140, min_days: 2, max_days: 3 },
{ pincode: 636141, min_days: 2, max_days: 3 },
{ pincode: 636142, min_days: 2, max_days: 3 },
{ pincode: 636201, min_days: 2, max_days: 3 },
{ pincode: 636202, min_days: 2, max_days: 3 },
{ pincode: 636203, min_days: 2, max_days: 3 },
{ pincode: 636204, min_days: 2, max_days: 3 },
{ pincode: 636301, min_days: 2, max_days: 3 },
{ pincode: 636302, min_days: 2, max_days: 3 },
{ pincode: 636304, min_days: 2, max_days: 3 },
{ pincode: 636307, min_days: 2, max_days: 3 },
{ pincode: 636308, min_days: 2, max_days: 3 },
{ pincode: 636309, min_days: 2, max_days: 3 },
{ pincode: 636354, min_days: 2, max_days: 3 },
{ pincode: 636400, min_days: 2, max_days: 3 },
{ pincode: 636401, min_days: 2, max_days: 3 },
{ pincode: 636402, min_days: 2, max_days: 3 },
{ pincode: 636403, min_days: 2, max_days: 3 },
{ pincode: 636404, min_days: 2, max_days: 3 },
{ pincode: 636407, min_days: 2, max_days: 3 },
{ pincode: 636453, min_days: 2, max_days: 3 },
{ pincode: 636455, min_days: 2, max_days: 3 },
{ pincode: 636502, min_days: 2, max_days: 3 },
{ pincode: 636601, min_days: 2, max_days: 3 },
{ pincode: 636602, min_days: 2, max_days: 3 },
{ pincode: 636604, min_days: 2, max_days: 3 },
{ pincode: 636701, min_days: 3, max_days: 4 },
{ pincode: 636702, min_days: 3, max_days: 4 },
{ pincode: 636703, min_days: 3, max_days: 4 },
{ pincode: 636704, min_days: 3, max_days: 4 },
{ pincode: 636705, min_days: 3, max_days: 4 },
{ pincode: 636801, min_days: 3, max_days: 4 },
{ pincode: 636802, min_days: 3, max_days: 4 },
{ pincode: 636803, min_days: 3, max_days: 4 },
{ pincode: 636805, min_days: 3, max_days: 4 },
{ pincode: 636806, min_days: 3, max_days: 4 },
{ pincode: 636808, min_days: 3, max_days: 4 },
{ pincode: 636809, min_days: 3, max_days: 4 },
{ pincode: 636810, min_days: 3, max_days: 4 },
{ pincode: 636813, min_days: 3, max_days: 4 },
{ pincode: 636905, min_days: 2, max_days: 3 },
{ pincode: 637001, min_days: 2, max_days: 3 },
{ pincode: 637002, min_days: 2, max_days: 3 },
{ pincode: 637003, min_days: 2, max_days: 3 },
{ pincode: 637013, min_days: 2, max_days: 3 },
{ pincode: 637014, min_days: 2, max_days: 3 },
{ pincode: 637018, min_days: 2, max_days: 3 },
{ pincode: 637101, min_days: 3, max_days: 4 },
{ pincode: 637102, min_days: 2, max_days: 3 },
{ pincode: 637103, min_days: 2, max_days: 3 },
{ pincode: 637104, min_days: 3, max_days: 4 },
{ pincode: 637105, min_days: 3, max_days: 4 },
{ pincode: 637209, min_days: 3, max_days: 4 },
{ pincode: 637211, min_days: 3, max_days: 4 },
{ pincode: 637215, min_days: 3, max_days: 4 },
{ pincode: 637301, min_days: 3, max_days: 4 },
{ pincode: 637302, min_days: 3, max_days: 4 },
{ pincode: 637303, min_days: 3, max_days: 4 },
{ pincode: 637401, min_days: 2, max_days: 3 },
{ pincode: 637402, min_days: 2, max_days: 3 },
{ pincode: 637403, min_days: 2, max_days: 3 },
{ pincode: 637406, min_days: 2, max_days: 3 },
{ pincode: 637407, min_days: 2, max_days: 3 },
{ pincode: 637408, min_days: 2, max_days: 3 },
{ pincode: 637410, min_days: 2, max_days: 3 },
{ pincode: 637411, min_days: 2, max_days: 3 },
{ pincode: 637412, min_days: 2, max_days: 3 },
{ pincode: 637501, min_days: 2, max_days: 3 },
{ pincode: 637502, min_days: 2, max_days: 3 },
{ pincode: 637503, min_days: 2, max_days: 3 },
{ pincode: 637504, min_days: 2, max_days: 3 },
{ pincode: 637505, min_days: 2, max_days: 3 },
{ pincode: 638001, min_days: 3, max_days: 4 },
{ pincode: 638002, min_days: 3, max_days: 4 },
{ pincode: 638003, min_days: 3, max_days: 4 },
{ pincode: 638004, min_days: 3, max_days: 4 },
{ pincode: 638005, min_days: 3, max_days: 4 },
{ pincode: 638006, min_days: 3, max_days: 4 },
{ pincode: 638007, min_days: 3, max_days: 4 },
{ pincode: 638008, min_days: 3, max_days: 4 },
{ pincode: 638009, min_days: 3, max_days: 4 },
{ pincode: 638010, min_days: 3, max_days: 4 },
{ pincode: 638011, min_days: 3, max_days: 4 },
{ pincode: 638012, min_days: 3, max_days: 4 },
{ pincode: 638051, min_days: 4, max_days: 5 },
{ pincode: 638052, min_days: 4, max_days: 5 },
{ pincode: 638053, min_days: 4, max_days: 5 },
{ pincode: 638054, min_days: 3, max_days: 4 },
{ pincode: 638056, min_days: 4, max_days: 5 },
{ pincode: 638058, min_days: 4, max_days: 5 },
{ pincode: 638101, min_days: 3, max_days: 4 },
{ pincode: 638102, min_days: 3, max_days: 4 },
{ pincode: 638103, min_days: 3, max_days: 4 },
{ pincode: 638104, min_days: 3, max_days: 4 },
{ pincode: 638105, min_days: 3, max_days: 4 },
{ pincode: 638106, min_days: 3, max_days: 4 },
{ pincode: 638107, min_days: 3, max_days: 4 },
{ pincode: 638108, min_days: 3, max_days: 4 },
{ pincode: 638111, min_days: 3, max_days: 4 },
{ pincode: 638112, min_days: 3, max_days: 4 },
{ pincode: 638115, min_days: 3, max_days: 4 },
{ pincode: 638153, min_days: 3, max_days: 4 },
{ pincode: 638154, min_days: 3, max_days: 4 },
{ pincode: 638182, min_days: 3, max_days: 4 },
{ pincode: 638183, min_days: 3, max_days: 4 },
{ pincode: 638201, min_days: 3, max_days: 4 },
{ pincode: 638301, min_days: 3, max_days: 4 },
{ pincode: 638302, min_days: 3, max_days: 4 },
{ pincode: 638307, min_days: 3, max_days: 4 },
{ pincode: 638308, min_days: 3, max_days: 4 },
{ pincode: 638311, min_days: 3, max_days: 4 },
{ pincode: 638312, min_days: 3, max_days: 4 },
{ pincode: 638314, min_days: 3, max_days: 4 },
{ pincode: 638315, min_days: 3, max_days: 4 },
{ pincode: 638316, min_days: 3, max_days: 4 },
{ pincode: 638327, min_days: 3, max_days: 4 },
{ pincode: 638401, min_days: 4, max_days: 5 },
{ pincode: 638402, min_days: 4, max_days: 5 },
{ pincode: 638451, min_days: 4, max_days: 5 },
{ pincode: 638452, min_days: 3, max_days: 4 },
{ pincode: 638455, min_days: 3, max_days: 4 },
{ pincode: 638458, min_days: 3, max_days: 4 },
{ pincode: 638476, min_days: 3, max_days: 4 },
{ pincode: 638501, min_days: 3, max_days: 4 },
{ pincode: 638502, min_days: 3, max_days: 4 },
{ pincode: 638503, min_days: 4, max_days: 5 },
{ pincode: 638504, min_days: 3, max_days: 4 },
{ pincode: 638649, min_days: 3, max_days: 4 },
{ pincode: 638653, min_days: 3, max_days: 4 },
{ pincode: 638656, min_days: 3, max_days: 4 },
{ pincode: 638657, min_days: 3, max_days: 4 },
{ pincode: 638660, min_days: 3, max_days: 4 },
{ pincode: 638661, min_days: 3, max_days: 4 },
{ pincode: 638672, min_days: 3, max_days: 4 },
{ pincode: 638673, min_days: 3, max_days: 4 },
{ pincode: 638697, min_days: 3, max_days: 4 },
{ pincode: 638701, min_days: 3, max_days: 4 },
{ pincode: 638702, min_days: 3, max_days: 4 },
{ pincode: 638703, min_days: 3, max_days: 4 },
{ pincode: 638706, min_days: 3, max_days: 4 },
{ pincode: 639001, min_days: 3, max_days: 4 },
{ pincode: 639002, min_days: 3, max_days: 4 },
{ pincode: 639003, min_days: 3, max_days: 4 },
{ pincode: 639004, min_days: 3, max_days: 4 },
{ pincode: 639005, min_days: 3, max_days: 4 },
{ pincode: 639006, min_days: 3, max_days: 4 },
{ pincode: 639007, min_days: 3, max_days: 4 },
{ pincode: 639008, min_days: 3, max_days: 4 },
{ pincode: 639101, min_days: 4, max_days: 5 },
{ pincode: 639103, min_days: 3, max_days: 4 },
{ pincode: 639104, min_days: 3, max_days: 4 },
{ pincode: 639105, min_days: 3, max_days: 4 },
{ pincode: 639107, min_days: 3, max_days: 4 },
{ pincode: 639109, min_days: 3, max_days: 4 },
{ pincode: 639110, min_days: 3, max_days: 4 },
{ pincode: 639111, min_days: 3, max_days: 4 },
{ pincode: 639112, min_days: 3, max_days: 4 },
{ pincode: 639114, min_days: 3, max_days: 4 },
{ pincode: 639117, min_days: 3, max_days: 4 },
{ pincode: 639118, min_days: 3, max_days: 4 },
{ pincode: 639136, min_days: 3, max_days: 4 },
{ pincode: 639201, min_days: 3, max_days: 4 },
{ pincode: 639202, min_days: 3, max_days: 4 },
{ pincode: 639203, min_days: 3, max_days: 4 },
{ pincode: 639204, min_days: 3, max_days: 4 },
{ pincode: 639205, min_days: 3, max_days: 4 },
{ pincode: 639207, min_days: 3, max_days: 4 },
{ pincode: 641001, min_days: 2, max_days: 3 },
{ pincode: 641002, min_days: 2, max_days: 3 },
{ pincode: 641003, min_days: 2, max_days: 3 },
{ pincode: 641004, min_days: 2, max_days: 3 },
{ pincode: 641005, min_days: 2, max_days: 3 },
{ pincode: 641006, min_days: 2, max_days: 3 },
{ pincode: 641007, min_days: 2, max_days: 3 },
{ pincode: 641008, min_days: 2, max_days: 3 },
{ pincode: 641009, min_days: 2, max_days: 3 },
{ pincode: 641010, min_days: 2, max_days: 3 },
{ pincode: 641011, min_days: 2, max_days: 3 },
{ pincode: 641012, min_days: 2, max_days: 3 },
{ pincode: 641013, min_days: 2, max_days: 3 },
{ pincode: 641014, min_days: 2, max_days: 3 },
{ pincode: 641015, min_days: 2, max_days: 3 },
{ pincode: 641016, min_days: 2, max_days: 3 },
{ pincode: 641017, min_days: 2, max_days: 3 },
{ pincode: 641018, min_days: 2, max_days: 3 },
{ pincode: 641019, min_days: 3, max_days: 4 },
{ pincode: 641020, min_days: 3, max_days: 4 },
{ pincode: 641021, min_days: 2, max_days: 3 },
{ pincode: 641022, min_days: 2, max_days: 3 },
{ pincode: 641023, min_days: 2, max_days: 3 },
{ pincode: 641024, min_days: 2, max_days: 3 },
{ pincode: 641025, min_days: 2, max_days: 3 },
{ pincode: 641026, min_days: 2, max_days: 3 },
{ pincode: 641027, min_days: 2, max_days: 3 },
{ pincode: 641028, min_days: 2, max_days: 3 },
{ pincode: 641029, min_days: 2, max_days: 3 },
{ pincode: 641030, min_days: 2, max_days: 3 },
{ pincode: 641031, min_days: 3, max_days: 4 },
{ pincode: 641032, min_days: 3, max_days: 4 },
{ pincode: 641033, min_days: 2, max_days: 3 },
{ pincode: 641034, min_days: 2, max_days: 3 },
{ pincode: 641035, min_days: 3, max_days: 4 },
{ pincode: 641036, min_days: 2, max_days: 3 },
{ pincode: 641037, min_days: 2, max_days: 3 },
{ pincode: 641038, min_days: 2, max_days: 3 },
{ pincode: 641039, min_days: 2, max_days: 3 },
{ pincode: 641040, min_days: 2, max_days: 3 },
{ pincode: 641041, min_days: 2, max_days: 3 },
{ pincode: 641042, min_days: 2, max_days: 3 },
{ pincode: 641043, min_days: 2, max_days: 3 },
{ pincode: 641044, min_days: 2, max_days: 3 },
{ pincode: 641045, min_days: 2, max_days: 3 },
{ pincode: 641046, min_days: 2, max_days: 3 },
{ pincode: 641047, min_days: 3, max_days: 4 },
{ pincode: 641048, min_days: 2, max_days: 3 },
{ pincode: 641049, min_days: 3, max_days: 4 },
{ pincode: 641050, min_days: 2, max_days: 3 },
{ pincode: 641062, min_days: 2, max_days: 3 },
{ pincode: 641065, min_days: 2, max_days: 3 },
{ pincode: 641101, min_days: 2, max_days: 3 },
{ pincode: 641103, min_days: 2, max_days: 3 },
{ pincode: 641104, min_days: 3, max_days: 4 },
{ pincode: 641105, min_days: 2, max_days: 3 },
{ pincode: 641106, min_days: 3, max_days: 4 },
{ pincode: 641107, min_days: 3, max_days: 4 },
{ pincode: 641108, min_days: 2, max_days: 3 },
{ pincode: 641109, min_days: 2, max_days: 3 },
{ pincode: 641110, min_days: 3, max_days: 4 },
{ pincode: 641111, min_days: 2, max_days: 3 },
{ pincode: 641112, min_days: 2, max_days: 3 },
{ pincode: 641113, min_days: 3, max_days: 4 },
{ pincode: 641114, min_days: 2, max_days: 3 },
{ pincode: 641201, min_days: 3, max_days: 4 },
{ pincode: 641202, min_days: 3, max_days: 4 },
{ pincode: 641221, min_days: 3, max_days: 4 },
{ pincode: 641301, min_days: 3, max_days: 4 },
{ pincode: 641305, min_days: 3, max_days: 4 },
{ pincode: 641401, min_days: 3, max_days: 4 },
{ pincode: 641402, min_days: 3, max_days: 4 },
{ pincode: 641404, min_days: 3, max_days: 4 },
{ pincode: 641406, min_days: 2, max_days: 3 },
{ pincode: 641407, min_days: 2, max_days: 3 },
{ pincode: 641601, min_days: 2, max_days: 3 },
{ pincode: 641602, min_days: 2, max_days: 3 },
{ pincode: 641603, min_days: 2, max_days: 3 },
{ pincode: 641604, min_days: 2, max_days: 3 },
{ pincode: 641605, min_days: 3, max_days: 4 },
{ pincode: 641606, min_days: 2, max_days: 3 },
{ pincode: 641607, min_days: 2, max_days: 3 },
{ pincode: 641608, min_days: 2, max_days: 3 },
{ pincode: 641652, min_days: 2, max_days: 3 },
{ pincode: 641653, min_days: 3, max_days: 4 },
{ pincode: 641654, min_days: 3, max_days: 4 },
{ pincode: 641655, min_days: 3, max_days: 4 },
{ pincode: 641659, min_days: 3, max_days: 4 },
{ pincode: 641662, min_days: 3, max_days: 4 },
{ pincode: 641663, min_days: 3, max_days: 4 },
{ pincode: 641664, min_days: 3, max_days: 4 },
{ pincode: 641665, min_days: 3, max_days: 4 },
{ pincode: 641666, min_days: 2, max_days: 3 },
{ pincode: 641667, min_days: 3, max_days: 4 },
{ pincode: 641668, min_days: 3, max_days: 4 },
{ pincode: 641670, min_days: 3, max_days: 4 },
{ pincode: 641671, min_days: 3, max_days: 4 },
{ pincode: 641687, min_days: 2, max_days: 3 },
{ pincode: 642001, min_days: 3, max_days: 4 },
{ pincode: 642002, min_days: 3, max_days: 4 },
{ pincode: 642003, min_days: 3, max_days: 4 },
{ pincode: 642004, min_days: 3, max_days: 4 },
{ pincode: 642005, min_days: 3, max_days: 4 },
{ pincode: 642006, min_days: 3, max_days: 4 },
{ pincode: 642007, min_days: 3, max_days: 4 },
{ pincode: 642054, min_days: 3, max_days: 4 },
{ pincode: 642101, min_days: 3, max_days: 4 },
{ pincode: 642103, min_days: 3, max_days: 4 },
{ pincode: 642104, min_days: 3, max_days: 4 },
{ pincode: 642105, min_days: 3, max_days: 4 },
{ pincode: 642106, min_days: 3, max_days: 4 },
{ pincode: 642107, min_days: 3, max_days: 4 },
{ pincode: 642108, min_days: 3, max_days: 4 },
{ pincode: 642109, min_days: 3, max_days: 4 },
{ pincode: 642110, min_days: 3, max_days: 4 },
{ pincode: 642114, min_days: 3, max_days: 4 },
{ pincode: 642117, min_days: 3, max_days: 4 },
{ pincode: 642120, min_days: 3, max_days: 4 },
{ pincode: 642123, min_days: 3, max_days: 4 },
{ pincode: 642126, min_days: 3, max_days: 4 },
{ pincode: 642127, min_days: 3, max_days: 4 },
{ pincode: 642129, min_days: 3, max_days: 4 },
{ pincode: 642130, min_days: 3, max_days: 4 },
{ pincode: 642133, min_days: 3, max_days: 4 },
{ pincode: 642134, min_days: 3, max_days: 4 },
{ pincode: 642140, min_days: 3, max_days: 4 },
{ pincode: 642142, min_days: 3, max_days: 4 },
{ pincode: 642143, min_days: 3, max_days: 4 },
{ pincode: 642144, min_days: 3, max_days: 4 },
{ pincode: 642145, min_days: 3, max_days: 4 },
{ pincode: 642147, min_days: 3, max_days: 4 },
{ pincode: 642148, min_days: 3, max_days: 4 },
{ pincode: 642149, min_days: 3, max_days: 4 },
{ pincode: 642154, min_days: 3, max_days: 4 },
{ pincode: 642202, min_days: 3, max_days: 4 },
{ pincode: 642207, min_days: 3, max_days: 4 },
{ pincode: 643001, min_days: 3, max_days: 4 },
{ pincode: 643002, min_days: 3, max_days: 4 },
{ pincode: 643003, min_days: 3, max_days: 4 },
{ pincode: 643004, min_days: 3, max_days: 4 },
{ pincode: 643053, min_days: 3, max_days: 4 },
{ pincode: 643054, min_days: 3, max_days: 4 },
{ pincode: 643101, min_days: 3, max_days: 4 },
{ pincode: 643102, min_days: 3, max_days: 4 },
{ pincode: 643103, min_days: 3, max_days: 4 },
{ pincode: 643104, min_days: 3, max_days: 4 },
{ pincode: 643105, min_days: 3, max_days: 4 },
{ pincode: 643106, min_days: 3, max_days: 4 },
{ pincode: 643201, min_days: 3, max_days: 4 },
{ pincode: 643202, min_days: 3, max_days: 4 },
{ pincode: 643204, min_days: 3, max_days: 4 },
{ pincode: 643207, min_days: 4, max_days: 5 },
{ pincode: 643211, min_days: 4, max_days: 5 },
{ pincode: 643212, min_days: 4, max_days: 5 },
{ pincode: 643213, min_days: 3, max_days: 4 },
{ pincode: 643214, min_days: 3, max_days: 4 },
{ pincode: 643216, min_days: 3, max_days: 4 },
{ pincode: 643217, min_days: 3, max_days: 4 },
{ pincode: 643218, min_days: 3, max_days: 4 },
{ pincode: 643231, min_days: 3, max_days: 4 },
{ pincode: 643232, min_days: 3, max_days: 4 },
{ pincode: 643234, min_days: 3, max_days: 4 },
{ pincode: 643242, min_days: 3, max_days: 4 },
{ pincode: 643244, min_days: 3, max_days: 4 },
{ pincode: 643245, min_days: 3, max_days: 4 },
{ pincode: 643249, min_days: 3, max_days: 4 },
{ pincode: 643251, min_days: 4, max_days: 5 },
{ pincode: 643257, min_days: 3, max_days: 4 },
{ pincode: 643260, min_days: 3, max_days: 4 },
{ pincode: 643264, min_days: 3, max_days: 4 },
{ pincode: 643266, min_days: 3, max_days: 4 },
{ pincode: 643267, min_days: 4, max_days: 5 },
{ pincode: 643270, min_days: 4, max_days: 5 },
{ pincode: 643271, min_days: 3, max_days: 4 },
{ pincode: 643277, min_days: 3, max_days: 4 },
{ pincode: 643278, min_days: 3, max_days: 4 },
{ pincode: 666664, min_days: 2, max_days: 3 },
{ pincode: 666666, min_days: 2, max_days: 3 },
{ pincode: 666677, min_days: 2, max_days: 3 },
{ pincode: 666688, min_days: 2, max_days: 3 },
{ pincode: 666699, min_days: 2, max_days: 3 },
{ pincode: 666777, min_days: 3, max_days: 4 },
{ pincode: 670001, min_days: 3, max_days: 4 },
{ pincode: 670002, min_days: 3, max_days: 4 },
{ pincode: 670003, min_days: 3, max_days: 4 },
{ pincode: 670004, min_days: 3, max_days: 4 },
{ pincode: 670005, min_days: 3, max_days: 4 },
{ pincode: 670006, min_days: 3, max_days: 4 },
{ pincode: 670007, min_days: 3, max_days: 4 },
{ pincode: 670008, min_days: 3, max_days: 4 },
{ pincode: 670010, min_days: 3, max_days: 4 },
{ pincode: 670011, min_days: 3, max_days: 4 },
{ pincode: 670012, min_days: 3, max_days: 4 },
{ pincode: 670013, min_days: 3, max_days: 4 },
{ pincode: 670014, min_days: 3, max_days: 4 },
{ pincode: 670015, min_days: 3, max_days: 4 },
{ pincode: 670016, min_days: 3, max_days: 4 },
{ pincode: 670017, min_days: 3, max_days: 4 },
{ pincode: 670018, min_days: 3, max_days: 4 },
{ pincode: 670101, min_days: 3, max_days: 4 },
{ pincode: 670102, min_days: 3, max_days: 4 },
{ pincode: 670104, min_days: 3, max_days: 4 },
{ pincode: 670105, min_days: 3, max_days: 4 },
{ pincode: 670106, min_days: 3, max_days: 4 },
{ pincode: 670141, min_days: 3, max_days: 4 },
{ pincode: 670301, min_days: 3, max_days: 4 },
{ pincode: 670307, min_days: 3, max_days: 4 },
{ pincode: 670501, min_days: 3, max_days: 4 },
{ pincode: 670561, min_days: 3, max_days: 4 },
{ pincode: 670565, min_days: 3, max_days: 4 },
{ pincode: 670566, min_days: 3, max_days: 4 },
{ pincode: 670567, min_days: 3, max_days: 4 },
{ pincode: 670591, min_days: 3, max_days: 4 },
{ pincode: 670592, min_days: 3, max_days: 4 },
{ pincode: 670594, min_days: 3, max_days: 4 },
{ pincode: 670597, min_days: 3, max_days: 4 },
{ pincode: 670642, min_days: 4, max_days: 5 },
{ pincode: 670643, min_days: 4, max_days: 5 },
{ pincode: 670691, min_days: 4, max_days: 5 },
{ pincode: 670694, min_days: 3, max_days: 4 },
{ pincode: 670701, min_days: 4, max_days: 5 },
{ pincode: 670741, min_days: 4, max_days: 5 },
{ pincode: 671121, min_days: 4, max_days: 5 },
{ pincode: 671122, min_days: 4, max_days: 5 },
{ pincode: 671123, min_days: 4, max_days: 5 },
{ pincode: 671315, min_days: 4, max_days: 5 },
{ pincode: 671317, min_days: 4, max_days: 5 },
{ pincode: 671319, min_days: 4, max_days: 5 },
{ pincode: 671531, min_days: 4, max_days: 5 },
{ pincode: 673001, min_days: 3, max_days: 4 },
{ pincode: 673002, min_days: 3, max_days: 4 },
{ pincode: 673003, min_days: 3, max_days: 4 },
{ pincode: 673004, min_days: 3, max_days: 4 },
{ pincode: 673005, min_days: 3, max_days: 4 },
{ pincode: 673006, min_days: 3, max_days: 4 },
{ pincode: 673007, min_days: 3, max_days: 4 },
{ pincode: 673008, min_days: 3, max_days: 4 },
{ pincode: 673009, min_days: 3, max_days: 4 },
{ pincode: 673010, min_days: 3, max_days: 4 },
{ pincode: 673011, min_days: 3, max_days: 4 },
{ pincode: 673012, min_days: 3, max_days: 4 },
{ pincode: 673013, min_days: 3, max_days: 4 },
{ pincode: 673014, min_days: 3, max_days: 4 },
{ pincode: 673015, min_days: 3, max_days: 4 },
{ pincode: 673016, min_days: 3, max_days: 4 },
{ pincode: 673017, min_days: 3, max_days: 4 },
{ pincode: 673018, min_days: 3, max_days: 4 },
{ pincode: 673019, min_days: 3, max_days: 4 },
{ pincode: 673020, min_days: 3, max_days: 4 },
{ pincode: 673021, min_days: 3, max_days: 4 },
{ pincode: 673024, min_days: 3, max_days: 4 },
{ pincode: 673025, min_days: 3, max_days: 4 },
{ pincode: 673026, min_days: 3, max_days: 4 },
{ pincode: 673027, min_days: 3, max_days: 4 },
{ pincode: 673028, min_days: 3, max_days: 4 },
{ pincode: 673029, min_days: 3, max_days: 4 },
{ pincode: 673031, min_days: 3, max_days: 4 },
{ pincode: 673032, min_days: 3, max_days: 4 },
{ pincode: 673037, min_days: 3, max_days: 4 },
{ pincode: 673101, min_days: 3, max_days: 4 },
{ pincode: 673103, min_days: 3, max_days: 4 },
{ pincode: 673104, min_days: 3, max_days: 4 },
{ pincode: 673106, min_days: 3, max_days: 4 },
{ pincode: 673121, min_days: 4, max_days: 5 },
{ pincode: 673122, min_days: 4, max_days: 5 },
{ pincode: 673303, min_days: 3, max_days: 4 },
{ pincode: 673304, min_days: 3, max_days: 4 },
{ pincode: 673305, min_days: 3, max_days: 4 },
{ pincode: 673306, min_days: 3, max_days: 4 },
{ pincode: 673315, min_days: 3, max_days: 4 },
{ pincode: 673317, min_days: 3, max_days: 4 },
{ pincode: 673323, min_days: 3, max_days: 4 },
{ pincode: 673507, min_days: 3, max_days: 4 },
{ pincode: 673508, min_days: 3, max_days: 4 },
{ pincode: 673570, min_days: 3, max_days: 4 },
{ pincode: 673571, min_days: 3, max_days: 4 },
{ pincode: 673573, min_days: 3, max_days: 4 },
{ pincode: 673576, min_days: 4, max_days: 5 },
{ pincode: 673577, min_days: 4, max_days: 5 },
{ pincode: 673585, min_days: 3, max_days: 4 },
{ pincode: 673591, min_days: 5, max_days: 6 },
{ pincode: 673592, min_days: 5, max_days: 6 },
{ pincode: 673593, min_days: 5, max_days: 6 },
{ pincode: 673595, min_days: 5, max_days: 6 },
{ pincode: 673601, min_days: 3, max_days: 4 },
{ pincode: 673602, min_days: 4, max_days: 5 },
{ pincode: 673611, min_days: 3, max_days: 4 },
{ pincode: 673613, min_days: 3, max_days: 4 },
{ pincode: 673614, min_days: 3, max_days: 4 },
{ pincode: 673616, min_days: 3, max_days: 4 },
{ pincode: 673620, min_days: 3, max_days: 4 },
{ pincode: 673632, min_days: 3, max_days: 4 },
{ pincode: 673633, min_days: 3, max_days: 4 },
{ pincode: 673634, min_days: 3, max_days: 4 },
{ pincode: 673635, min_days: 3, max_days: 4 },
{ pincode: 673639, min_days: 4, max_days: 5 },
{ pincode: 673640, min_days: 4, max_days: 5 },
{ pincode: 673641, min_days: 4, max_days: 5 },
{ pincode: 673645, min_days: 4, max_days: 5 },
{ pincode: 676101, min_days: 3, max_days: 4 },
{ pincode: 676102, min_days: 3, max_days: 4 },
{ pincode: 676103, min_days: 3, max_days: 4 },
{ pincode: 676104, min_days: 3, max_days: 4 },
{ pincode: 676105, min_days: 3, max_days: 4 },
{ pincode: 676107, min_days: 3, max_days: 4 },
{ pincode: 676108, min_days: 3, max_days: 4 },
{ pincode: 676109, min_days: 3, max_days: 4 },
{ pincode: 676121, min_days: 4, max_days: 5 },
{ pincode: 676301, min_days: 4, max_days: 5 },
{ pincode: 676502, min_days: 3, max_days: 4 },
{ pincode: 676503, min_days: 3, max_days: 4 },
{ pincode: 676505, min_days: 4, max_days: 5 },
{ pincode: 676519, min_days: 4, max_days: 5 },
{ pincode: 676541, min_days: 4, max_days: 5 },
{ pincode: 676551, min_days: 4, max_days: 5 },
{ pincode: 676552, min_days: 4, max_days: 5 },
{ pincode: 676561, min_days: 3, max_days: 4 },
{ pincode: 676562, min_days: 3, max_days: 4 },
{ pincode: 678001, min_days: 3, max_days: 4 },
{ pincode: 678002, min_days: 3, max_days: 4 },
{ pincode: 678003, min_days: 3, max_days: 4 },
{ pincode: 678004, min_days: 3, max_days: 4 },
{ pincode: 678005, min_days: 3, max_days: 4 },
{ pincode: 678006, min_days: 3, max_days: 4 },
{ pincode: 678007, min_days: 3, max_days: 4 },
{ pincode: 678008, min_days: 3, max_days: 4 },
{ pincode: 678009, min_days: 3, max_days: 4 },
{ pincode: 678010, min_days: 3, max_days: 4 },
{ pincode: 678011, min_days: 3, max_days: 4 },
{ pincode: 678012, min_days: 3, max_days: 4 },
{ pincode: 678013, min_days: 3, max_days: 4 },
{ pincode: 678014, min_days: 3, max_days: 4 },
{ pincode: 678015, min_days: 3, max_days: 4 },
{ pincode: 678017, min_days: 3, max_days: 4 },
{ pincode: 678018, min_days: 3, max_days: 4 },
{ pincode: 678019, min_days: 3, max_days: 4 },
{ pincode: 678020, min_days: 3, max_days: 4 },
{ pincode: 678101, min_days: 4, max_days: 5 },
{ pincode: 678102, min_days: 4, max_days: 5 },
{ pincode: 678103, min_days: 4, max_days: 5 },
{ pincode: 678104, min_days: 4, max_days: 5 },
{ pincode: 678501, min_days: 4, max_days: 5 },
{ pincode: 678503, min_days: 4, max_days: 5 },
{ pincode: 678504, min_days: 4, max_days: 5 },
{ pincode: 678506, min_days: 4, max_days: 5 },
{ pincode: 678531, min_days: 4, max_days: 5 },
{ pincode: 678532, min_days: 4, max_days: 5 },
{ pincode: 678541, min_days: 4, max_days: 5 },
{ pincode: 678542, min_days: 4, max_days: 5 },
{ pincode: 678543, min_days: 4, max_days: 5 },
{ pincode: 678545, min_days: 4, max_days: 5 },
{ pincode: 678546, min_days: 4, max_days: 5 },
{ pincode: 678551, min_days: 3, max_days: 4 },
{ pincode: 678552, min_days: 4, max_days: 5 },
{ pincode: 678553, min_days: 4, max_days: 5 },
{ pincode: 678554, min_days: 4, max_days: 5 },
{ pincode: 678557, min_days: 3, max_days: 4 },
{ pincode: 678559, min_days: 3, max_days: 4 },
{ pincode: 678582, min_days: 4, max_days: 5 },
{ pincode: 678583, min_days: 4, max_days: 5 },
{ pincode: 678593, min_days: 4, max_days: 5 },
{ pincode: 678595, min_days: 4, max_days: 5 },
{ pincode: 678596, min_days: 4, max_days: 5 },
{ pincode: 678597, min_days: 4, max_days: 5 },
{ pincode: 678598, min_days: 4, max_days: 5 },
{ pincode: 678613, min_days: 4, max_days: 5 },
{ pincode: 678621, min_days: 3, max_days: 4 },
{ pincode: 678623, min_days: 3, max_days: 4 },
{ pincode: 678633, min_days: 4, max_days: 5 },
{ pincode: 678642, min_days: 4, max_days: 5 },
{ pincode: 678681, min_days: 4, max_days: 5 },
{ pincode: 678701, min_days: 3, max_days: 4 },
{ pincode: 678731, min_days: 3, max_days: 4 },
{ pincode: 678762, min_days: 4, max_days: 5 },
{ pincode: 679101, min_days: 4, max_days: 5 },
{ pincode: 679102, min_days: 4, max_days: 5 },
{ pincode: 679103, min_days: 4, max_days: 5 },
{ pincode: 679104, min_days: 4, max_days: 5 },
{ pincode: 679105, min_days: 4, max_days: 5 },
{ pincode: 679106, min_days: 4, max_days: 5 },
{ pincode: 679121, min_days: 4, max_days: 5 },
{ pincode: 679122, min_days: 4, max_days: 5 },
{ pincode: 679123, min_days: 4, max_days: 5 },
{ pincode: 679301, min_days: 4, max_days: 5 },
{ pincode: 679302, min_days: 4, max_days: 5 },
{ pincode: 679304, min_days: 4, max_days: 5 },
{ pincode: 679306, min_days: 4, max_days: 5 },
{ pincode: 679308, min_days: 4, max_days: 5 },
{ pincode: 679313, min_days: 4, max_days: 5 },
{ pincode: 679321, min_days: 3, max_days: 4 },
{ pincode: 679322, min_days: 3, max_days: 4 },
{ pincode: 679328, min_days: 4, max_days: 5 },
{ pincode: 679329, min_days: 4, max_days: 5 },
{ pincode: 679335, min_days: 4, max_days: 5 },
{ pincode: 679340, min_days: 3, max_days: 4 },
{ pincode: 679357, min_days: 3, max_days: 4 },
{ pincode: 679501, min_days: 4, max_days: 5 },
{ pincode: 679502, min_days: 4, max_days: 5 },
{ pincode: 679503, min_days: 4, max_days: 5 },
{ pincode: 679504, min_days: 4, max_days: 5 },
{ pincode: 679505, min_days: 4, max_days: 5 },
{ pincode: 679506, min_days: 4, max_days: 5 },
{ pincode: 679511, min_days: 4, max_days: 5 },
{ pincode: 679512, min_days: 4, max_days: 5 },
{ pincode: 679513, min_days: 4, max_days: 5 },
{ pincode: 679514, min_days: 4, max_days: 5 },
{ pincode: 679515, min_days: 4, max_days: 5 },
{ pincode: 679516, min_days: 4, max_days: 5 },
{ pincode: 679521, min_days: 4, max_days: 5 },
{ pincode: 679522, min_days: 4, max_days: 5 },
{ pincode: 679523, min_days: 4, max_days: 5 },
{ pincode: 679531, min_days: 4, max_days: 5 },
{ pincode: 679551, min_days: 3, max_days: 4 },
{ pincode: 679552, min_days: 3, max_days: 4 },
{ pincode: 679553, min_days: 3, max_days: 4 },
{ pincode: 679554, min_days: 3, max_days: 4 },
{ pincode: 679564, min_days: 3, max_days: 4 },
{ pincode: 679571, min_days: 4, max_days: 5 },
{ pincode: 679572, min_days: 4, max_days: 5 },
{ pincode: 679574, min_days: 3, max_days: 4 },
{ pincode: 679576, min_days: 3, max_days: 4 },
{ pincode: 679577, min_days: 3, max_days: 4 },
{ pincode: 679578, min_days: 3, max_days: 4 },
{ pincode: 679582, min_days: 3, max_days: 4 },
{ pincode: 679583, min_days: 3, max_days: 4 },
{ pincode: 679585, min_days: 3, max_days: 4 },
{ pincode: 679586, min_days: 3, max_days: 4 },
{ pincode: 680001, min_days: 3, max_days: 4 },
{ pincode: 680002, min_days: 3, max_days: 4 },
{ pincode: 680003, min_days: 3, max_days: 4 },
{ pincode: 680004, min_days: 3, max_days: 4 },
{ pincode: 680005, min_days: 3, max_days: 4 },
{ pincode: 680006, min_days: 3, max_days: 4 },
{ pincode: 680007, min_days: 4, max_days: 5 },
{ pincode: 680008, min_days: 3, max_days: 4 },
{ pincode: 680009, min_days: 3, max_days: 4 },
{ pincode: 680010, min_days: 3, max_days: 4 },
{ pincode: 680011, min_days: 3, max_days: 4 },
{ pincode: 680012, min_days: 3, max_days: 4 },
{ pincode: 680013, min_days: 3, max_days: 4 },
{ pincode: 680014, min_days: 4, max_days: 5 },
{ pincode: 680015, min_days: 4, max_days: 5 },
{ pincode: 680018, min_days: 3, max_days: 4 },
{ pincode: 680020, min_days: 3, max_days: 4 },
{ pincode: 680021, min_days: 3, max_days: 4 },
{ pincode: 680022, min_days: 3, max_days: 4 },
{ pincode: 680026, min_days: 4, max_days: 5 },
{ pincode: 680027, min_days: 4, max_days: 5 },
{ pincode: 680101, min_days: 3, max_days: 4 },
{ pincode: 680121, min_days: 4, max_days: 5 },
{ pincode: 680125, min_days: 4, max_days: 5 },
{ pincode: 680301, min_days: 3, max_days: 4 },
{ pincode: 680302, min_days: 3, max_days: 4 },
{ pincode: 680303, min_days: 3, max_days: 4 },
{ pincode: 680305, min_days: 3, max_days: 4 },
{ pincode: 680306, min_days: 3, max_days: 4 },
{ pincode: 680307, min_days: 3, max_days: 4 },
{ pincode: 680308, min_days: 3, max_days: 4 },
{ pincode: 680309, min_days: 3, max_days: 4 },
{ pincode: 680310, min_days: 4, max_days: 5 },
{ pincode: 680311, min_days: 3, max_days: 4 },
{ pincode: 680313, min_days: 3, max_days: 4 },
{ pincode: 680314, min_days: 3, max_days: 4 },
{ pincode: 680322, min_days: 3, max_days: 4 },
{ pincode: 680501, min_days: 3, max_days: 4 },
{ pincode: 680506, min_days: 3, max_days: 4 },
{ pincode: 680507, min_days: 3, max_days: 4 },
{ pincode: 680516, min_days: 3, max_days: 4 },
{ pincode: 680518, min_days: 3, max_days: 4 },
{ pincode: 680522, min_days: 3, max_days: 4 },
{ pincode: 680541, min_days: 3, max_days: 4 },
{ pincode: 680545, min_days: 3, max_days: 4 },
{ pincode: 680546, min_days: 3, max_days: 4 },
{ pincode: 680551, min_days: 3, max_days: 4 },
{ pincode: 680552, min_days: 3, max_days: 4 },
{ pincode: 680553, min_days: 3, max_days: 4 },
{ pincode: 680555, min_days: 3, max_days: 4 },
{ pincode: 680562, min_days: 4, max_days: 5 },
{ pincode: 680563, min_days: 4, max_days: 5 },
{ pincode: 680566, min_days: 4, max_days: 5 },
{ pincode: 680567, min_days: 4, max_days: 5 },
{ pincode: 680568, min_days: 4, max_days: 5 },
{ pincode: 680569, min_days: 4, max_days: 5 },
{ pincode: 680581, min_days: 3, max_days: 4 },
{ pincode: 680588, min_days: 4, max_days: 5 },
{ pincode: 680594, min_days: 4, max_days: 5 },
{ pincode: 680611, min_days: 3, max_days: 4 },
{ pincode: 680618, min_days: 3, max_days: 4 },
{ pincode: 680620, min_days: 3, max_days: 4 },
{ pincode: 680631, min_days: 3, max_days: 4 },
{ pincode: 680641, min_days: 4, max_days: 5 },
{ pincode: 680663, min_days: 3, max_days: 4 },
{ pincode: 680664, min_days: 3, max_days: 4 },
{ pincode: 680666, min_days: 3, max_days: 4 },
{ pincode: 680667, min_days: 3, max_days: 4 },
{ pincode: 680669, min_days: 3, max_days: 4 },
{ pincode: 680670, min_days: 3, max_days: 4 },
{ pincode: 680671, min_days: 3, max_days: 4 },
{ pincode: 680682, min_days: 3, max_days: 4 },
{ pincode: 680683, min_days: 3, max_days: 4 },
{ pincode: 680689, min_days: 3, max_days: 4 },
{ pincode: 680697, min_days: 3, max_days: 4 },
{ pincode: 680699, min_days: 3, max_days: 4 },
{ pincode: 680711, min_days: 4, max_days: 5 },
{ pincode: 680712, min_days: 4, max_days: 5 },
{ pincode: 680731, min_days: 3, max_days: 4 },
{ pincode: 680732, min_days: 3, max_days: 4 },
{ pincode: 680733, min_days: 3, max_days: 4 },
{ pincode: 680734, min_days: 3, max_days: 4 },
{ pincode: 680741, min_days: 3, max_days: 4 },
{ pincode: 682000, min_days: 3, max_days: 4 },
{ pincode: 682001, min_days: 3, max_days: 4 },
{ pincode: 682002, min_days: 3, max_days: 4 },
{ pincode: 682003, min_days: 3, max_days: 4 },
{ pincode: 682005, min_days: 3, max_days: 4 },
{ pincode: 682006, min_days: 3, max_days: 4 },
{ pincode: 682007, min_days: 3, max_days: 4 },
{ pincode: 682008, min_days: 3, max_days: 4 },
{ pincode: 682009, min_days: 3, max_days: 4 },
{ pincode: 682010, min_days: 3, max_days: 4 },
{ pincode: 682011, min_days: 3, max_days: 4 },
{ pincode: 682012, min_days: 3, max_days: 4 },
{ pincode: 682013, min_days: 3, max_days: 4 },
{ pincode: 682014, min_days: 3, max_days: 4 },
{ pincode: 682015, min_days: 3, max_days: 4 },
{ pincode: 682016, min_days: 3, max_days: 4 },
{ pincode: 682017, min_days: 3, max_days: 4 },
{ pincode: 682018, min_days: 3, max_days: 4 },
{ pincode: 682019, min_days: 3, max_days: 4 },
{ pincode: 682020, min_days: 3, max_days: 4 },
{ pincode: 682021, min_days: 3, max_days: 4 },
{ pincode: 682022, min_days: 3, max_days: 4 },
{ pincode: 682023, min_days: 3, max_days: 4 },
{ pincode: 682024, min_days: 3, max_days: 4 },
{ pincode: 682025, min_days: 3, max_days: 4 },
{ pincode: 682026, min_days: 3, max_days: 4 },
{ pincode: 682027, min_days: 3, max_days: 4 },
{ pincode: 682028, min_days: 3, max_days: 4 },
{ pincode: 682029, min_days: 3, max_days: 4 },
{ pincode: 682030, min_days: 3, max_days: 4 },
{ pincode: 682031, min_days: 3, max_days: 4 },
{ pincode: 682032, min_days: 3, max_days: 4 },
{ pincode: 682033, min_days: 3, max_days: 4 },
{ pincode: 682034, min_days: 3, max_days: 4 },
{ pincode: 682035, min_days: 3, max_days: 4 },
{ pincode: 682036, min_days: 3, max_days: 4 },
{ pincode: 682037, min_days: 3, max_days: 4 },
{ pincode: 682038, min_days: 4, max_days: 5 },
{ pincode: 682039, min_days: 3, max_days: 4 },
{ pincode: 682040, min_days: 3, max_days: 4 },
{ pincode: 682041, min_days: 3, max_days: 4 },
{ pincode: 682042, min_days: 3, max_days: 4 },
{ pincode: 682222, min_days: 3, max_days: 4 },
{ pincode: 682301, min_days: 3, max_days: 4 },
{ pincode: 682302, min_days: 3, max_days: 4 },
{ pincode: 682303, min_days: 3, max_days: 4 },
{ pincode: 682304, min_days: 4, max_days: 5 },
{ pincode: 682305, min_days: 3, max_days: 4 },
{ pincode: 682306, min_days: 3, max_days: 4 },
{ pincode: 682307, min_days: 3, max_days: 4 },
{ pincode: 682308, min_days: 3, max_days: 4 },
{ pincode: 682309, min_days: 3, max_days: 4 },
{ pincode: 682310, min_days: 3, max_days: 4 },
{ pincode: 682311, min_days: 3, max_days: 4 },
{ pincode: 682312, min_days: 3, max_days: 4 },
{ pincode: 682313, min_days: 3, max_days: 4 },
{ pincode: 682314, min_days: 3, max_days: 4 },
{ pincode: 682315, min_days: 3, max_days: 4 },
{ pincode: 682316, min_days: 3, max_days: 4 },
{ pincode: 682319, min_days: 3, max_days: 4 },
{ pincode: 682501, min_days: 3, max_days: 4 },
{ pincode: 682502, min_days: 3, max_days: 4 },
{ pincode: 682503, min_days: 3, max_days: 4 },
{ pincode: 682504, min_days: 3, max_days: 4 },
{ pincode: 682505, min_days: 3, max_days: 4 },
{ pincode: 682506, min_days: 3, max_days: 4 },
{ pincode: 682507, min_days: 3, max_days: 4 },
{ pincode: 682508, min_days: 3, max_days: 4 },
{ pincode: 682509, min_days: 3, max_days: 4 },
{ pincode: 682511, min_days: 3, max_days: 4 },
{ pincode: 683101, min_days: 3, max_days: 4 },
{ pincode: 683102, min_days: 3, max_days: 4 },
{ pincode: 683103, min_days: 3, max_days: 4 },
{ pincode: 683104, min_days: 3, max_days: 4 },
{ pincode: 683105, min_days: 3, max_days: 4 },
{ pincode: 683106, min_days: 3, max_days: 4 },
{ pincode: 683108, min_days: 3, max_days: 4 },
{ pincode: 683109, min_days: 3, max_days: 4 },
{ pincode: 683110, min_days: 3, max_days: 4 },
{ pincode: 683111, min_days: 3, max_days: 4 },
{ pincode: 683112, min_days: 3, max_days: 4 },
{ pincode: 683501, min_days: 3, max_days: 4 },
{ pincode: 683502, min_days: 3, max_days: 4 },
{ pincode: 683511, min_days: 3, max_days: 4 },
{ pincode: 683512, min_days: 3, max_days: 4 },
{ pincode: 683513, min_days: 3, max_days: 4 },
{ pincode: 683517, min_days: 3, max_days: 4 },
{ pincode: 683518, min_days: 3, max_days: 4 },
{ pincode: 683519, min_days: 3, max_days: 4 },
{ pincode: 683520, min_days: 3, max_days: 4 },
{ pincode: 683541, min_days: 3, max_days: 4 },
{ pincode: 683542, min_days: 3, max_days: 4 },
{ pincode: 683543, min_days: 3, max_days: 4 },
{ pincode: 683544, min_days: 3, max_days: 4 },
{ pincode: 683556, min_days: 3, max_days: 4 },
{ pincode: 683561, min_days: 3, max_days: 4 },
{ pincode: 683562, min_days: 3, max_days: 4 },
{ pincode: 683563, min_days: 3, max_days: 4 },
{ pincode: 683564, min_days: 3, max_days: 4 },
{ pincode: 683572, min_days: 3, max_days: 4 },
{ pincode: 683573, min_days: 3, max_days: 4 },
{ pincode: 683574, min_days: 3, max_days: 4 },
{ pincode: 683576, min_days: 3, max_days: 4 },
{ pincode: 683577, min_days: 3, max_days: 4 },
{ pincode: 683578, min_days: 3, max_days: 4 },
{ pincode: 683579, min_days: 3, max_days: 4 },
{ pincode: 683582, min_days: 3, max_days: 4 },
{ pincode: 683584, min_days: 3, max_days: 4 },
{ pincode: 683585, min_days: 3, max_days: 4 },
{ pincode: 683586, min_days: 3, max_days: 4 },
{ pincode: 683587, min_days: 3, max_days: 4 },
{ pincode: 683589, min_days: 3, max_days: 4 },
{ pincode: 683591, min_days: 3, max_days: 4 },
{ pincode: 683592, min_days: 3, max_days: 4 },
{ pincode: 683594, min_days: 3, max_days: 4 },
{ pincode: 685584, min_days: 3, max_days: 4 },
{ pincode: 685585, min_days: 3, max_days: 4 },
{ pincode: 685587, min_days: 3, max_days: 4 },
{ pincode: 685605, min_days: 3, max_days: 4 },
{ pincode: 685608, min_days: 3, max_days: 4 },
{ pincode: 686001, min_days: 3, max_days: 4 },
{ pincode: 686002, min_days: 3, max_days: 4 },
{ pincode: 686003, min_days: 3, max_days: 4 },
{ pincode: 686004, min_days: 3, max_days: 4 },
{ pincode: 686005, min_days: 3, max_days: 4 },
{ pincode: 686006, min_days: 3, max_days: 4 },
{ pincode: 686007, min_days: 3, max_days: 4 },
{ pincode: 686008, min_days: 3, max_days: 4 },
{ pincode: 686009, min_days: 3, max_days: 4 },
{ pincode: 686010, min_days: 3, max_days: 4 },
{ pincode: 686011, min_days: 3, max_days: 4 },
{ pincode: 686012, min_days: 3, max_days: 4 },
{ pincode: 686013, min_days: 3, max_days: 4 },
{ pincode: 686014, min_days: 3, max_days: 4 },
{ pincode: 686015, min_days: 3, max_days: 4 },
{ pincode: 686016, min_days: 3, max_days: 4 },
{ pincode: 686017, min_days: 3, max_days: 4 },
{ pincode: 686018, min_days: 3, max_days: 4 },
{ pincode: 686019, min_days: 3, max_days: 4 },
{ pincode: 686020, min_days: 3, max_days: 4 },
{ pincode: 686021, min_days: 4, max_days: 5 },
{ pincode: 686022, min_days: 3, max_days: 4 },
{ pincode: 686023, min_days: 3, max_days: 4 },
{ pincode: 686024, min_days: 3, max_days: 4 },
{ pincode: 686025, min_days: 3, max_days: 4 },
{ pincode: 686026, min_days: 3, max_days: 4 },
{ pincode: 686029, min_days: 3, max_days: 4 },
{ pincode: 686030, min_days: 3, max_days: 4 },
{ pincode: 686032, min_days: 3, max_days: 4 },
{ pincode: 686033, min_days: 3, max_days: 4 },
{ pincode: 686035, min_days: 3, max_days: 4 },
{ pincode: 686036, min_days: 3, max_days: 4 },
{ pincode: 686037, min_days: 3, max_days: 4 },
{ pincode: 686038, min_days: 3, max_days: 4 },
{ pincode: 686039, min_days: 3, max_days: 4 },
{ pincode: 686041, min_days: 3, max_days: 4 },
{ pincode: 686101, min_days: 4, max_days: 5 },
{ pincode: 686102, min_days: 4, max_days: 5 },
{ pincode: 686103, min_days: 4, max_days: 5 },
{ pincode: 686104, min_days: 4, max_days: 5 },
{ pincode: 686105, min_days: 4, max_days: 5 },
{ pincode: 686106, min_days: 4, max_days: 5 },
{ pincode: 686107, min_days: 4, max_days: 5 },
{ pincode: 686121, min_days: 3, max_days: 4 },
{ pincode: 686141, min_days: 4, max_days: 5 },
{ pincode: 686501, min_days: 4, max_days: 5 },
{ pincode: 686502, min_days: 4, max_days: 5 },
{ pincode: 686503, min_days: 3, max_days: 4 },
{ pincode: 686504, min_days: 3, max_days: 4 },
{ pincode: 686505, min_days: 3, max_days: 4 },
{ pincode: 686506, min_days: 3, max_days: 4 },
{ pincode: 686507, min_days: 3, max_days: 4 },
{ pincode: 686508, min_days: 3, max_days: 4 },
{ pincode: 686509, min_days: 3, max_days: 4 },
{ pincode: 686512, min_days: 3, max_days: 4 },
{ pincode: 686515, min_days: 3, max_days: 4 },
{ pincode: 686517, min_days: 3, max_days: 4 },
{ pincode: 686518, min_days: 3, max_days: 4 },
{ pincode: 686519, min_days: 3, max_days: 4 },
{ pincode: 686521, min_days: 4, max_days: 5 },
{ pincode: 686522, min_days: 3, max_days: 4 },
{ pincode: 686531, min_days: 4, max_days: 5 },
{ pincode: 686536, min_days: 4, max_days: 5 },
{ pincode: 686539, min_days: 4, max_days: 5 },
{ pincode: 686540, min_days: 4, max_days: 5 },
{ pincode: 686541, min_days: 4, max_days: 5 },
{ pincode: 686542, min_days: 4, max_days: 5 },
{ pincode: 686545, min_days: 4, max_days: 5 },
{ pincode: 686546, min_days: 4, max_days: 5 },
{ pincode: 686552, min_days: 3, max_days: 4 },
{ pincode: 686560, min_days: 3, max_days: 4 },
{ pincode: 686561, min_days: 3, max_days: 4 },
{ pincode: 686562, min_days: 4, max_days: 5 },
{ pincode: 686572, min_days: 4, max_days: 5 },
{ pincode: 686573, min_days: 3, max_days: 4 },
{ pincode: 686574, min_days: 3, max_days: 4 },
{ pincode: 686575, min_days: 3, max_days: 4 },
{ pincode: 686576, min_days: 3, max_days: 4 },
{ pincode: 686578, min_days: 3, max_days: 4 },
{ pincode: 686583, min_days: 4, max_days: 5 },
{ pincode: 686585, min_days: 3, max_days: 4 },
{ pincode: 686587, min_days: 4, max_days: 5 },
{ pincode: 686601, min_days: 4, max_days: 5 },
{ pincode: 686602, min_days: 4, max_days: 5 },
{ pincode: 686603, min_days: 4, max_days: 5 },
{ pincode: 686604, min_days: 4, max_days: 5 },
{ pincode: 686605, min_days: 4, max_days: 5 },
{ pincode: 686609, min_days: 4, max_days: 5 },
{ pincode: 686610, min_days: 4, max_days: 5 },
{ pincode: 686611, min_days: 4, max_days: 5 },
{ pincode: 686612, min_days: 4, max_days: 5 },
{ pincode: 686613, min_days: 4, max_days: 5 },
{ pincode: 686616, min_days: 4, max_days: 5 },
{ pincode: 686619, min_days: 4, max_days: 5 },
{ pincode: 686630, min_days: 4, max_days: 5 },
{ pincode: 686631, min_days: 4, max_days: 5 },
{ pincode: 686632, min_days: 4, max_days: 5 },
{ pincode: 686633, min_days: 4, max_days: 5 },
{ pincode: 686634, min_days: 3, max_days: 4 },
{ pincode: 686636, min_days: 3, max_days: 4 },
{ pincode: 686637, min_days: 4, max_days: 5 },
{ pincode: 686661, min_days: 3, max_days: 4 },
{ pincode: 686662, min_days: 3, max_days: 4 },
{ pincode: 686663, min_days: 3, max_days: 4 },
{ pincode: 686664, min_days: 3, max_days: 4 },
{ pincode: 686665, min_days: 3, max_days: 4 },
{ pincode: 686666, min_days: 3, max_days: 4 },
{ pincode: 686667, min_days: 3, max_days: 4 },
{ pincode: 686669, min_days: 3, max_days: 4 },
{ pincode: 686674, min_days: 3, max_days: 4 },
{ pincode: 686676, min_days: 3, max_days: 4 },
{ pincode: 686677, min_days: 3, max_days: 4 },
{ pincode: 686680, min_days: 4, max_days: 5 },
{ pincode: 686689, min_days: 3, max_days: 4 },
{ pincode: 688001, min_days: 3, max_days: 4 },
{ pincode: 688002, min_days: 3, max_days: 4 },
{ pincode: 688003, min_days: 3, max_days: 4 },
{ pincode: 688004, min_days: 3, max_days: 4 },
{ pincode: 688005, min_days: 3, max_days: 4 },
{ pincode: 688006, min_days: 3, max_days: 4 },
{ pincode: 688007, min_days: 3, max_days: 4 },
{ pincode: 688008, min_days: 3, max_days: 4 },
{ pincode: 688009, min_days: 3, max_days: 4 },
{ pincode: 688010, min_days: 3, max_days: 4 },
{ pincode: 688011, min_days: 3, max_days: 4 },
{ pincode: 688012, min_days: 3, max_days: 4 },
{ pincode: 688013, min_days: 3, max_days: 4 },
{ pincode: 688014, min_days: 3, max_days: 4 },
{ pincode: 688501, min_days: 3, max_days: 4 },
{ pincode: 688502, min_days: 3, max_days: 4 },
{ pincode: 688503, min_days: 3, max_days: 4 },
{ pincode: 688505, min_days: 3, max_days: 4 },
{ pincode: 688521, min_days: 3, max_days: 4 },
{ pincode: 688522, min_days: 3, max_days: 4 },
{ pincode: 688523, min_days: 3, max_days: 4 },
{ pincode: 688524, min_days: 3, max_days: 4 },
{ pincode: 688525, min_days: 3, max_days: 4 },
{ pincode: 688526, min_days: 3, max_days: 4 },
{ pincode: 688527, min_days: 3, max_days: 4 },
{ pincode: 688528, min_days: 3, max_days: 4 },
{ pincode: 688529, min_days: 3, max_days: 4 },
{ pincode: 688530, min_days: 3, max_days: 4 },
{ pincode: 688531, min_days: 3, max_days: 4 },
{ pincode: 688532, min_days: 3, max_days: 4 },
{ pincode: 688533, min_days: 3, max_days: 4 },
{ pincode: 688534, min_days: 3, max_days: 4 },
{ pincode: 688535, min_days: 3, max_days: 4 },
{ pincode: 688536, min_days: 3, max_days: 4 },
{ pincode: 688537, min_days: 3, max_days: 4 },
{ pincode: 688538, min_days: 3, max_days: 4 },
{ pincode: 688539, min_days: 3, max_days: 4 },
{ pincode: 688540, min_days: 3, max_days: 4 },
{ pincode: 688541, min_days: 3, max_days: 4 },
{ pincode: 688542, min_days: 3, max_days: 4 },
{ pincode: 688543, min_days: 3, max_days: 4 },
{ pincode: 688544, min_days: 3, max_days: 4 },
{ pincode: 688545, min_days: 3, max_days: 4 },
{ pincode: 688546, min_days: 3, max_days: 4 },
{ pincode: 688549, min_days: 3, max_days: 4 },
{ pincode: 688554, min_days: 3, max_days: 4 },
{ pincode: 688555, min_days: 3, max_days: 4 },
{ pincode: 688561, min_days: 3, max_days: 4 },
{ pincode: 688562, min_days: 3, max_days: 4 },
{ pincode: 688564, min_days: 3, max_days: 4 },
{ pincode: 688565, min_days: 3, max_days: 4 },
{ pincode: 688582, min_days: 3, max_days: 4 },
{ pincode: 688583, min_days: 3, max_days: 4 },
{ pincode: 689101, min_days: 4, max_days: 5 },
{ pincode: 689102, min_days: 4, max_days: 5 },
{ pincode: 689103, min_days: 4, max_days: 5 },
{ pincode: 689104, min_days: 4, max_days: 5 },
{ pincode: 689105, min_days: 4, max_days: 5 },
{ pincode: 689106, min_days: 4, max_days: 5 },
{ pincode: 689107, min_days: 4, max_days: 5 },
{ pincode: 689108, min_days: 4, max_days: 5 },
{ pincode: 689109, min_days: 4, max_days: 5 },
{ pincode: 689110, min_days: 4, max_days: 5 },
{ pincode: 689111, min_days: 4, max_days: 5 },
{ pincode: 689112, min_days: 4, max_days: 5 },
{ pincode: 689113, min_days: 4, max_days: 5 },
{ pincode: 689115, min_days: 4, max_days: 5 },
{ pincode: 689121, min_days: 4, max_days: 5 },
{ pincode: 689122, min_days: 4, max_days: 5 },
{ pincode: 689123, min_days: 4, max_days: 5 },
{ pincode: 689124, min_days: 4, max_days: 5 },
{ pincode: 689126, min_days: 4, max_days: 5 },
{ pincode: 689501, min_days: 4, max_days: 5 },
{ pincode: 689502, min_days: 4, max_days: 5 },
{ pincode: 689504, min_days: 4, max_days: 5 },
{ pincode: 689505, min_days: 4, max_days: 5 },
{ pincode: 689506, min_days: 4, max_days: 5 },
{ pincode: 689508, min_days: 4, max_days: 5 },
{ pincode: 689509, min_days: 4, max_days: 5 },
{ pincode: 689510, min_days: 4, max_days: 5 },
{ pincode: 689511, min_days: 3, max_days: 4 },
{ pincode: 689512, min_days: 4, max_days: 5 },
{ pincode: 689513, min_days: 4, max_days: 5 },
{ pincode: 689520, min_days: 4, max_days: 5 },
{ pincode: 689542, min_days: 4, max_days: 5 },
{ pincode: 689543, min_days: 4, max_days: 5 },
{ pincode: 689544, min_days: 4, max_days: 5 },
{ pincode: 689546, min_days: 4, max_days: 5 },
{ pincode: 689547, min_days: 4, max_days: 5 },
{ pincode: 689549, min_days: 4, max_days: 5 },
{ pincode: 689550, min_days: 4, max_days: 5 },
{ pincode: 689551, min_days: 4, max_days: 5 },
{ pincode: 689572, min_days: 3, max_days: 4 },
{ pincode: 689573, min_days: 3, max_days: 4 },
{ pincode: 689584, min_days: 4, max_days: 5 },
{ pincode: 689585, min_days: 4, max_days: 5 },
{ pincode: 689586, min_days: 4, max_days: 5 },
{ pincode: 689587, min_days: 4, max_days: 5 },
{ pincode: 689589, min_days: 4, max_days: 5 },
{ pincode: 689591, min_days: 4, max_days: 5 },
{ pincode: 689595, min_days: 3, max_days: 4 },
{ pincode: 689597, min_days: 4, max_days: 5 },
{ pincode: 689602, min_days: 4, max_days: 5 },
{ pincode: 689621, min_days: 4, max_days: 5 },
{ pincode: 689622, min_days: 3, max_days: 4 },
{ pincode: 689624, min_days: 3, max_days: 4 },
{ pincode: 689626, min_days: 4, max_days: 5 },
{ pincode: 689641, min_days: 4, max_days: 5 },
{ pincode: 689644, min_days: 4, max_days: 5 },
{ pincode: 689645, min_days: 4, max_days: 5 },
{ pincode: 689647, min_days: 4, max_days: 5 },
{ pincode: 689648, min_days: 4, max_days: 5 },
{ pincode: 689652, min_days: 4, max_days: 5 },
{ pincode: 689653, min_days: 4, max_days: 5 },
{ pincode: 689654, min_days: 4, max_days: 5 },
{ pincode: 689661, min_days: 4, max_days: 5 },
{ pincode: 689666, min_days: 4, max_days: 5 },
{ pincode: 689668, min_days: 4, max_days: 5 },
{ pincode: 689671, min_days: 4, max_days: 5 },
{ pincode: 689678, min_days: 4, max_days: 5 },
{ pincode: 690101, min_days: 3, max_days: 4 },
{ pincode: 690102, min_days: 3, max_days: 4 },
{ pincode: 690103, min_days: 3, max_days: 4 },
{ pincode: 690104, min_days: 3, max_days: 4 },
{ pincode: 690105, min_days: 3, max_days: 4 },
{ pincode: 690106, min_days: 3, max_days: 4 },
{ pincode: 690107, min_days: 3, max_days: 4 },
{ pincode: 690108, min_days: 3, max_days: 4 },
{ pincode: 690110, min_days: 3, max_days: 4 },
{ pincode: 690502, min_days: 3, max_days: 4 },
{ pincode: 690503, min_days: 3, max_days: 4 },
{ pincode: 690506, min_days: 3, max_days: 4 },
{ pincode: 690507, min_days: 3, max_days: 4 },
{ pincode: 690510, min_days: 3, max_days: 4 },
{ pincode: 690513, min_days: 3, max_days: 4 },
{ pincode: 690514, min_days: 3, max_days: 4 },
{ pincode: 690515, min_days: 3, max_days: 4 },
{ pincode: 690516, min_days: 3, max_days: 4 },
{ pincode: 690518, min_days: 4, max_days: 5 },
{ pincode: 690519, min_days: 4, max_days: 5 },
{ pincode: 690523, min_days: 4, max_days: 5 },
{ pincode: 690524, min_days: 4, max_days: 5 },
{ pincode: 690525, min_days: 4, max_days: 5 },
{ pincode: 690526, min_days: 4, max_days: 5 },
{ pincode: 690528, min_days: 4, max_days: 5 },
{ pincode: 690531, min_days: 3, max_days: 4 },
{ pincode: 690532, min_days: 3, max_days: 4 },
{ pincode: 690533, min_days: 3, max_days: 4 },
{ pincode: 690535, min_days: 3, max_days: 4 },
{ pincode: 690536, min_days: 4, max_days: 5 },
{ pincode: 690539, min_days: 4, max_days: 5 },
{ pincode: 690542, min_days: 4, max_days: 5 },
{ pincode: 690544, min_days: 4, max_days: 5 },
{ pincode: 690546, min_days: 4, max_days: 5 },
{ pincode: 690547, min_days: 4, max_days: 5 },
{ pincode: 690552, min_days: 3, max_days: 4 },
{ pincode: 690558, min_days: 3, max_days: 4 },
{ pincode: 690570, min_days: 3, max_days: 4 },
{ pincode: 690571, min_days: 3, max_days: 4 },
{ pincode: 690572, min_days: 3, max_days: 4 },
{ pincode: 690573, min_days: 4, max_days: 5 },
{ pincode: 691001, min_days: 4, max_days: 5 },
{ pincode: 691002, min_days: 4, max_days: 5 },
{ pincode: 691003, min_days: 4, max_days: 5 },
{ pincode: 691004, min_days: 4, max_days: 5 },
{ pincode: 691005, min_days: 4, max_days: 5 },
{ pincode: 691006, min_days: 4, max_days: 5 },
{ pincode: 691007, min_days: 4, max_days: 5 },
{ pincode: 691008, min_days: 4, max_days: 5 },
{ pincode: 691009, min_days: 4, max_days: 5 },
{ pincode: 691010, min_days: 4, max_days: 5 },
{ pincode: 691011, min_days: 4, max_days: 5 },
{ pincode: 691012, min_days: 4, max_days: 5 },
{ pincode: 691013, min_days: 4, max_days: 5 },
{ pincode: 691014, min_days: 4, max_days: 5 },
{ pincode: 691015, min_days: 4, max_days: 5 },
{ pincode: 691016, min_days: 4, max_days: 5 },
{ pincode: 691017, min_days: 4, max_days: 5 },
{ pincode: 691018, min_days: 4, max_days: 5 },
{ pincode: 691019, min_days: 4, max_days: 5 },
{ pincode: 691020, min_days: 4, max_days: 5 },
{ pincode: 691021, min_days: 4, max_days: 5 },
{ pincode: 691301, min_days: 4, max_days: 5 },
{ pincode: 691302, min_days: 4, max_days: 5 },
{ pincode: 691305, min_days: 4, max_days: 5 },
{ pincode: 691306, min_days: 4, max_days: 5 },
{ pincode: 691315, min_days: 4, max_days: 5 },
{ pincode: 691318, min_days: 4, max_days: 5 },
{ pincode: 691319, min_days: 4, max_days: 5 },
{ pincode: 691320, min_days: 4, max_days: 5 },
{ pincode: 691321, min_days: 4, max_days: 5 },
{ pincode: 691324, min_days: 4, max_days: 5 },
{ pincode: 691325, min_days: 4, max_days: 5 },
{ pincode: 691331, min_days: 4, max_days: 5 },
{ pincode: 691333, min_days: 4, max_days: 5 },
{ pincode: 691378, min_days: 4, max_days: 5 },
{ pincode: 691501, min_days: 4, max_days: 5 },
{ pincode: 691504, min_days: 4, max_days: 5 },
{ pincode: 691505, min_days: 4, max_days: 5 },
{ pincode: 691506, min_days: 4, max_days: 5 },
{ pincode: 691507, min_days: 4, max_days: 5 },
{ pincode: 691511, min_days: 4, max_days: 5 },
{ pincode: 691512, min_days: 4, max_days: 5 },
{ pincode: 691523, min_days: 4, max_days: 5 },
{ pincode: 691530, min_days: 4, max_days: 5 },
{ pincode: 691531, min_days: 4, max_days: 5 },
{ pincode: 691532, min_days: 4, max_days: 5 },
{ pincode: 691533, min_days: 4, max_days: 5 },
{ pincode: 691536, min_days: 4, max_days: 5 },
{ pincode: 691538, min_days: 4, max_days: 5 },
{ pincode: 691542, min_days: 4, max_days: 5 },
{ pincode: 691557, min_days: 4, max_days: 5 },
{ pincode: 691560, min_days: 4, max_days: 5 },
{ pincode: 691566, min_days: 4, max_days: 5 },
{ pincode: 691571, min_days: 4, max_days: 5 },
{ pincode: 691574, min_days: 4, max_days: 5 },
{ pincode: 691577, min_days: 4, max_days: 5 },
{ pincode: 691581, min_days: 4, max_days: 5 },
{ pincode: 691582, min_days: 4, max_days: 5 },
{ pincode: 691583, min_days: 4, max_days: 5 },
{ pincode: 691584, min_days: 4, max_days: 5 },
{ pincode: 691588, min_days: 4, max_days: 5 },
{ pincode: 691589, min_days: 4, max_days: 5 },
{ pincode: 691590, min_days: 4, max_days: 5 },
{ pincode: 691601, min_days: 4, max_days: 5 },
{ pincode: 691602, min_days: 4, max_days: 5 },
{ pincode: 691604, min_days: 4, max_days: 5 },
{ pincode: 691605, min_days: 4, max_days: 5 },
{ pincode: 694582, min_days: 4, max_days: 5 },
{ pincode: 695001, min_days: 4, max_days: 5 },
{ pincode: 695002, min_days: 4, max_days: 5 },
{ pincode: 695003, min_days: 3, max_days: 4 },
{ pincode: 695004, min_days: 3, max_days: 4 },
{ pincode: 695005, min_days: 3, max_days: 4 },
{ pincode: 695006, min_days: 4, max_days: 5 },
{ pincode: 695007, min_days: 3, max_days: 4 },
{ pincode: 695008, min_days: 4, max_days: 5 },
{ pincode: 695009, min_days: 4, max_days: 5 },
{ pincode: 695010, min_days: 4, max_days: 5 },
{ pincode: 695011, min_days: 3, max_days: 4 },
{ pincode: 695012, min_days: 4, max_days: 5 },
{ pincode: 695013, min_days: 4, max_days: 5 },
{ pincode: 695014, min_days: 4, max_days: 5 },
{ pincode: 695015, min_days: 3, max_days: 4 },
{ pincode: 695016, min_days: 3, max_days: 4 },
{ pincode: 695017, min_days: 3, max_days: 4 },
{ pincode: 695018, min_days: 4, max_days: 5 },
{ pincode: 695019, min_days: 4, max_days: 5 },
{ pincode: 695020, min_days: 4, max_days: 5 },
{ pincode: 695021, min_days: 3, max_days: 4 },
{ pincode: 695022, min_days: 3, max_days: 4 },
{ pincode: 695023, min_days: 4, max_days: 5 },
{ pincode: 695024, min_days: 3, max_days: 4 },
{ pincode: 695025, min_days: 3, max_days: 4 },
{ pincode: 695026, min_days: 4, max_days: 5 },
{ pincode: 695027, min_days: 4, max_days: 5 },
{ pincode: 695028, min_days: 4, max_days: 5 },
{ pincode: 695029, min_days: 3, max_days: 4 },
{ pincode: 695030, min_days: 4, max_days: 5 },
{ pincode: 695031, min_days: 3, max_days: 4 },
{ pincode: 695032, min_days: 4, max_days: 5 },
{ pincode: 695033, min_days: 4, max_days: 5 },
{ pincode: 695034, min_days: 4, max_days: 5 },
{ pincode: 695035, min_days: 4, max_days: 5 },
{ pincode: 695036, min_days: 4, max_days: 5 },
{ pincode: 695037, min_days: 3, max_days: 4 },
{ pincode: 695038, min_days: 4, max_days: 5 },
{ pincode: 695039, min_days: 4, max_days: 5 },
{ pincode: 695040, min_days: 4, max_days: 5 },
{ pincode: 695041, min_days: 4, max_days: 5 },
{ pincode: 695042, min_days: 4, max_days: 5 },
{ pincode: 695043, min_days: 3, max_days: 4 },
{ pincode: 695044, min_days: 3, max_days: 4 },
{ pincode: 695049, min_days: 4, max_days: 5 },
{ pincode: 695099, min_days: 3, max_days: 4 },
{ pincode: 695101, min_days: 4, max_days: 5 },
{ pincode: 695102, min_days: 4, max_days: 5 },
{ pincode: 695103, min_days: 4, max_days: 5 },
{ pincode: 695104, min_days: 4, max_days: 5 },
{ pincode: 695121, min_days: 4, max_days: 5 },
{ pincode: 695122, min_days: 4, max_days: 5 },
{ pincode: 695123, min_days: 4, max_days: 5 },
{ pincode: 695124, min_days: 4, max_days: 5 },
{ pincode: 695125, min_days: 4, max_days: 5 },
{ pincode: 695126, min_days: 4, max_days: 5 },
{ pincode: 695132, min_days: 4, max_days: 5 },
{ pincode: 695133, min_days: 4, max_days: 5 },
{ pincode: 695134, min_days: 4, max_days: 5 },
{ pincode: 695141, min_days: 4, max_days: 5 },
{ pincode: 695142, min_days: 4, max_days: 5 },
{ pincode: 695143, min_days: 4, max_days: 5 },
{ pincode: 695144, min_days: 4, max_days: 5 },
{ pincode: 695145, min_days: 4, max_days: 5 },
{ pincode: 695301, min_days: 4, max_days: 5 },
{ pincode: 695302, min_days: 4, max_days: 5 },
{ pincode: 695303, min_days: 4, max_days: 5 },
{ pincode: 695304, min_days: 4, max_days: 5 },
{ pincode: 695305, min_days: 4, max_days: 5 },
{ pincode: 695306, min_days: 4, max_days: 5 },
{ pincode: 695308, min_days: 4, max_days: 5 },
{ pincode: 695311, min_days: 4, max_days: 5 },
{ pincode: 695312, min_days: 4, max_days: 5 },
{ pincode: 695316, min_days: 4, max_days: 5 },
{ pincode: 695317, min_days: 4, max_days: 5 },
{ pincode: 695318, min_days: 4, max_days: 5 },
{ pincode: 695501, min_days: 4, max_days: 5 },
{ pincode: 695502, min_days: 4, max_days: 5 },
{ pincode: 695503, min_days: 4, max_days: 5 },
{ pincode: 695504, min_days: 4, max_days: 5 },
{ pincode: 695505, min_days: 4, max_days: 5 },
{ pincode: 695506, min_days: 4, max_days: 5 },
{ pincode: 695507, min_days: 4, max_days: 5 },
{ pincode: 695508, min_days: 4, max_days: 5 },
{ pincode: 695512, min_days: 4, max_days: 5 },
{ pincode: 695513, min_days: 4, max_days: 5 },
{ pincode: 695521, min_days: 4, max_days: 5 },
{ pincode: 695522, min_days: 4, max_days: 5 },
{ pincode: 695523, min_days: 4, max_days: 5 },
{ pincode: 695525, min_days: 4, max_days: 5 },
{ pincode: 695526, min_days: 4, max_days: 5 },
{ pincode: 695527, min_days: 4, max_days: 5 },
{ pincode: 695541, min_days: 4, max_days: 5 },
{ pincode: 695543, min_days: 4, max_days: 5 },
{ pincode: 695547, min_days: 4, max_days: 5 },
{ pincode: 695561, min_days: 4, max_days: 5 },
{ pincode: 695562, min_days: 4, max_days: 5 },
{ pincode: 695564, min_days: 4, max_days: 5 },
{ pincode: 695568, min_days: 4, max_days: 5 },
{ pincode: 695571, min_days: 4, max_days: 5 },
{ pincode: 695573, min_days: 4, max_days: 5 },
{ pincode: 695575, min_days: 4, max_days: 5 },
{ pincode: 695581, min_days: 3, max_days: 4 },
{ pincode: 695582, min_days: 3, max_days: 4 },
{ pincode: 695583, min_days: 3, max_days: 4 },
{ pincode: 695584, min_days: 4, max_days: 5 },
{ pincode: 695585, min_days: 4, max_days: 5 },
{ pincode: 695586, min_days: 4, max_days: 5 },
{ pincode: 695587, min_days: 4, max_days: 5 },
{ pincode: 695588, min_days: 4, max_days: 5 },
{ pincode: 695589, min_days: 4, max_days: 5 },
{ pincode: 695601, min_days: 4, max_days: 5 },
{ pincode: 695603, min_days: 4, max_days: 5 },
{ pincode: 695606, min_days: 4, max_days: 5 },
{ pincode: 695607, min_days: 4, max_days: 5 },
{ pincode: 695608, min_days: 4, max_days: 5 },
{ pincode: 695611, min_days: 4, max_days: 5 },
{ pincode: 695612, min_days: 4, max_days: 5 },
{ pincode: 695614, min_days: 4, max_days: 5 },
{ pincode: 695615, min_days: 4, max_days: 5 },
{ pincode: 700000, min_days: 2, max_days: 3 },
{ pincode: 700001, min_days: 2, max_days: 3 },
{ pincode: 700002, min_days: 2, max_days: 3 },
{ pincode: 700003, min_days: 2, max_days: 3 },
{ pincode: 700004, min_days: 2, max_days: 3 },
{ pincode: 700005, min_days: 2, max_days: 3 },
{ pincode: 700006, min_days: 2, max_days: 3 },
{ pincode: 700007, min_days: 2, max_days: 3 },
{ pincode: 700008, min_days: 2, max_days: 3 },
{ pincode: 700009, min_days: 2, max_days: 3 },
{ pincode: 700010, min_days: 2, max_days: 3 },
{ pincode: 700011, min_days: 2, max_days: 3 },
{ pincode: 700012, min_days: 2, max_days: 3 },
{ pincode: 700013, min_days: 2, max_days: 3 },
{ pincode: 700014, min_days: 2, max_days: 3 },
{ pincode: 700015, min_days: 2, max_days: 3 },
{ pincode: 700016, min_days: 2, max_days: 3 },
{ pincode: 700017, min_days: 2, max_days: 3 },
{ pincode: 700018, min_days: 2, max_days: 3 },
{ pincode: 700019, min_days: 2, max_days: 3 },
{ pincode: 700020, min_days: 2, max_days: 3 },
{ pincode: 700021, min_days: 2, max_days: 3 },
{ pincode: 700022, min_days: 2, max_days: 3 },
{ pincode: 700023, min_days: 2, max_days: 3 },
{ pincode: 700024, min_days: 2, max_days: 3 },
{ pincode: 700025, min_days: 2, max_days: 3 },
{ pincode: 700026, min_days: 2, max_days: 3 },
{ pincode: 700027, min_days: 2, max_days: 3 },
{ pincode: 700028, min_days: 2, max_days: 3 },
{ pincode: 700029, min_days: 2, max_days: 3 },
{ pincode: 700030, min_days: 2, max_days: 3 },
{ pincode: 700031, min_days: 2, max_days: 3 },
{ pincode: 700032, min_days: 2, max_days: 3 },
{ pincode: 700033, min_days: 2, max_days: 3 },
{ pincode: 700034, min_days: 2, max_days: 3 },
{ pincode: 700035, min_days: 2, max_days: 3 },
{ pincode: 700036, min_days: 2, max_days: 3 },
{ pincode: 700037, min_days: 2, max_days: 3 },
{ pincode: 700038, min_days: 2, max_days: 3 },
{ pincode: 700039, min_days: 2, max_days: 3 },
{ pincode: 700040, min_days: 2, max_days: 3 },
{ pincode: 700041, min_days: 2, max_days: 3 },
{ pincode: 700042, min_days: 2, max_days: 3 },
{ pincode: 700043, min_days: 2, max_days: 3 },
{ pincode: 700044, min_days: 2, max_days: 3 },
{ pincode: 700045, min_days: 2, max_days: 3 },
{ pincode: 700046, min_days: 2, max_days: 3 },
{ pincode: 700047, min_days: 2, max_days: 3 },
{ pincode: 700048, min_days: 2, max_days: 3 },
{ pincode: 700049, min_days: 2, max_days: 3 },
{ pincode: 700050, min_days: 2, max_days: 3 },
{ pincode: 700051, min_days: 2, max_days: 3 },
{ pincode: 700052, min_days: 2, max_days: 3 },
{ pincode: 700053, min_days: 2, max_days: 3 },
{ pincode: 700054, min_days: 2, max_days: 3 },
{ pincode: 700055, min_days: 2, max_days: 3 },
{ pincode: 700056, min_days: 2, max_days: 3 },
{ pincode: 700057, min_days: 2, max_days: 3 },
{ pincode: 700058, min_days: 2, max_days: 3 },
{ pincode: 700059, min_days: 2, max_days: 3 },
{ pincode: 700060, min_days: 2, max_days: 3 },
{ pincode: 700061, min_days: 2, max_days: 3 },
{ pincode: 700062, min_days: 2, max_days: 3 },
{ pincode: 700063, min_days: 2, max_days: 3 },
{ pincode: 700064, min_days: 2, max_days: 3 },
{ pincode: 700065, min_days: 2, max_days: 3 },
{ pincode: 700066, min_days: 2, max_days: 3 },
{ pincode: 700067, min_days: 2, max_days: 3 },
{ pincode: 700068, min_days: 2, max_days: 3 },
{ pincode: 700069, min_days: 2, max_days: 3 },
{ pincode: 700070, min_days: 2, max_days: 3 },
{ pincode: 700071, min_days: 2, max_days: 3 },
{ pincode: 700072, min_days: 2, max_days: 3 },
{ pincode: 700073, min_days: 2, max_days: 3 },
{ pincode: 700074, min_days: 2, max_days: 3 },
{ pincode: 700075, min_days: 2, max_days: 3 },
{ pincode: 700076, min_days: 2, max_days: 3 },
{ pincode: 700077, min_days: 2, max_days: 3 },
{ pincode: 700078, min_days: 2, max_days: 3 },
{ pincode: 700079, min_days: 2, max_days: 3 },
{ pincode: 700080, min_days: 2, max_days: 3 },
{ pincode: 700081, min_days: 2, max_days: 3 },
{ pincode: 700082, min_days: 2, max_days: 3 },
{ pincode: 700083, min_days: 2, max_days: 3 },
{ pincode: 700084, min_days: 2, max_days: 3 },
{ pincode: 700085, min_days: 2, max_days: 3 },
{ pincode: 700086, min_days: 2, max_days: 3 },
{ pincode: 700087, min_days: 2, max_days: 3 },
{ pincode: 700088, min_days: 2, max_days: 3 },
{ pincode: 700089, min_days: 2, max_days: 3 },
{ pincode: 700090, min_days: 2, max_days: 3 },
{ pincode: 700091, min_days: 2, max_days: 3 },
{ pincode: 700092, min_days: 2, max_days: 3 },
{ pincode: 700093, min_days: 2, max_days: 3 },
{ pincode: 700094, min_days: 2, max_days: 3 },
{ pincode: 700095, min_days: 2, max_days: 3 },
{ pincode: 700096, min_days: 2, max_days: 3 },
{ pincode: 700097, min_days: 2, max_days: 3 },
{ pincode: 700098, min_days: 2, max_days: 3 },
{ pincode: 700099, min_days: 2, max_days: 3 },
{ pincode: 700100, min_days: 2, max_days: 3 },
{ pincode: 700101, min_days: 2, max_days: 3 },
{ pincode: 700102, min_days: 2, max_days: 3 },
{ pincode: 700103, min_days: 3, max_days: 4 },
{ pincode: 700104, min_days: 3, max_days: 4 },
{ pincode: 700105, min_days: 2, max_days: 3 },
{ pincode: 700106, min_days: 2, max_days: 3 },
{ pincode: 700107, min_days: 2, max_days: 3 },
{ pincode: 700108, min_days: 2, max_days: 3 },
{ pincode: 700109, min_days: 3, max_days: 4 },
{ pincode: 700110, min_days: 3, max_days: 4 },
{ pincode: 700111, min_days: 3, max_days: 4 },
{ pincode: 700112, min_days: 3, max_days: 4 },
{ pincode: 700113, min_days: 3, max_days: 4 },
{ pincode: 700114, min_days: 3, max_days: 4 },
{ pincode: 700115, min_days: 3, max_days: 4 },
{ pincode: 700116, min_days: 3, max_days: 4 },
{ pincode: 700117, min_days: 3, max_days: 4 },
{ pincode: 700118, min_days: 3, max_days: 4 },
{ pincode: 700119, min_days: 3, max_days: 4 },
{ pincode: 700120, min_days: 3, max_days: 4 },
{ pincode: 700121, min_days: 3, max_days: 4 },
{ pincode: 700122, min_days: 3, max_days: 4 },
{ pincode: 700123, min_days: 3, max_days: 4 },
{ pincode: 700124, min_days: 2, max_days: 3 },
{ pincode: 700125, min_days: 2, max_days: 3 },
{ pincode: 700126, min_days: 2, max_days: 3 },
{ pincode: 700127, min_days: 2, max_days: 3 },
{ pincode: 700128, min_days: 2, max_days: 3 },
{ pincode: 700129, min_days: 2, max_days: 3 },
{ pincode: 700130, min_days: 2, max_days: 3 },
{ pincode: 700131, min_days: 2, max_days: 3 },
{ pincode: 700132, min_days: 2, max_days: 3 },
{ pincode: 700133, min_days: 2, max_days: 3 },
{ pincode: 700134, min_days: 2, max_days: 3 },
{ pincode: 700135, min_days: 2, max_days: 3 },
{ pincode: 700136, min_days: 2, max_days: 3 },
{ pincode: 700137, min_days: 2, max_days: 3 },
{ pincode: 700138, min_days: 2, max_days: 3 },
{ pincode: 700139, min_days: 2, max_days: 3 },
{ pincode: 700140, min_days: 2, max_days: 3 },
{ pincode: 700141, min_days: 2, max_days: 3 },
{ pincode: 700142, min_days: 2, max_days: 3 },
{ pincode: 700143, min_days: 2, max_days: 3 },
{ pincode: 700144, min_days: 3, max_days: 4 },
{ pincode: 700145, min_days: 3, max_days: 4 },
{ pincode: 700146, min_days: 3, max_days: 4 },
{ pincode: 700147, min_days: 3, max_days: 4 },
{ pincode: 700148, min_days: 3, max_days: 4 },
{ pincode: 700149, min_days: 3, max_days: 4 },
{ pincode: 700150, min_days: 3, max_days: 4 },
{ pincode: 700151, min_days: 3, max_days: 4 },
{ pincode: 700152, min_days: 3, max_days: 4 },
{ pincode: 700153, min_days: 3, max_days: 4 },
{ pincode: 700154, min_days: 3, max_days: 4 },
{ pincode: 700155, min_days: 2, max_days: 3 },
{ pincode: 700156, min_days: 2, max_days: 3 },
{ pincode: 700157, min_days: 2, max_days: 3 },
{ pincode: 700158, min_days: 2, max_days: 3 },
{ pincode: 700159, min_days: 2, max_days: 3 },
{ pincode: 700160, min_days: 2, max_days: 3 },
{ pincode: 700161, min_days: 2, max_days: 3 },
{ pincode: 700162, min_days: 2, max_days: 3 },
{ pincode: 701111, min_days: 2, max_days: 3 },
{ pincode: 711101, min_days: 2, max_days: 3 },
{ pincode: 711102, min_days: 2, max_days: 3 },
{ pincode: 711103, min_days: 2, max_days: 3 },
{ pincode: 711104, min_days: 2, max_days: 3 },
{ pincode: 711105, min_days: 2, max_days: 3 },
{ pincode: 711106, min_days: 2, max_days: 3 },
{ pincode: 711107, min_days: 2, max_days: 3 },
{ pincode: 711108, min_days: 2, max_days: 3 },
{ pincode: 711109, min_days: 2, max_days: 3 },
{ pincode: 711110, min_days: 2, max_days: 3 },
{ pincode: 711111, min_days: 2, max_days: 3 },
{ pincode: 711112, min_days: 2, max_days: 3 },
{ pincode: 711113, min_days: 2, max_days: 3 },
{ pincode: 711114, min_days: 2, max_days: 3 },
{ pincode: 711115, min_days: 2, max_days: 3 },
{ pincode: 711201, min_days: 3, max_days: 4 },
{ pincode: 711202, min_days: 3, max_days: 4 },
{ pincode: 711203, min_days: 3, max_days: 4 },
{ pincode: 711204, min_days: 3, max_days: 4 },
{ pincode: 711205, min_days: 3, max_days: 4 },
{ pincode: 711206, min_days: 3, max_days: 4 },
{ pincode: 711225, min_days: 3, max_days: 4 },
{ pincode: 711226, min_days: 3, max_days: 4 },
{ pincode: 711227, min_days: 3, max_days: 4 },
{ pincode: 711301, min_days: 3, max_days: 4 },
{ pincode: 711302, min_days: 2, max_days: 3 },
{ pincode: 711303, min_days: 3, max_days: 4 },
{ pincode: 711304, min_days: 2, max_days: 3 },
{ pincode: 711305, min_days: 3, max_days: 4 },
{ pincode: 711306, min_days: 3, max_days: 4 },
{ pincode: 711307, min_days: 3, max_days: 4 },
{ pincode: 711308, min_days: 3, max_days: 4 },
{ pincode: 711309, min_days: 2, max_days: 3 },
{ pincode: 711310, min_days: 3, max_days: 4 },
{ pincode: 711312, min_days: 3, max_days: 4 },
{ pincode: 711313, min_days: 2, max_days: 3 },
{ pincode: 711314, min_days: 3, max_days: 4 },
{ pincode: 711315, min_days: 3, max_days: 4 },
{ pincode: 711316, min_days: 3, max_days: 4 },
{ pincode: 711317, min_days: 2, max_days: 3 },
{ pincode: 711320, min_days: 2, max_days: 3 },
{ pincode: 711322, min_days: 3, max_days: 4 },
{ pincode: 711401, min_days: 3, max_days: 4 },
{ pincode: 711403, min_days: 2, max_days: 3 },
{ pincode: 711404, min_days: 3, max_days: 4 },
{ pincode: 711405, min_days: 2, max_days: 3 },
{ pincode: 711408, min_days: 3, max_days: 4 },
{ pincode: 711409, min_days: 2, max_days: 3 },
{ pincode: 711410, min_days: 3, max_days: 4 },
{ pincode: 711411, min_days: 2, max_days: 3 },
{ pincode: 711412, min_days: 3, max_days: 4 },
{ pincode: 711413, min_days: 3, max_days: 4 },
{ pincode: 711414, min_days: 3, max_days: 4 },
{ pincode: 712101, min_days: 3, max_days: 4 },
{ pincode: 712102, min_days: 3, max_days: 4 },
{ pincode: 712103, min_days: 3, max_days: 4 },
{ pincode: 712104, min_days: 3, max_days: 4 },
{ pincode: 712105, min_days: 3, max_days: 4 },
{ pincode: 712121, min_days: 3, max_days: 4 },
{ pincode: 712122, min_days: 3, max_days: 4 },
{ pincode: 712123, min_days: 3, max_days: 4 },
{ pincode: 712124, min_days: 3, max_days: 4 },
{ pincode: 712125, min_days: 3, max_days: 4 },
{ pincode: 712134, min_days: 3, max_days: 4 },
{ pincode: 712135, min_days: 3, max_days: 4 },
{ pincode: 712136, min_days: 3, max_days: 4 },
{ pincode: 712137, min_days: 3, max_days: 4 },
{ pincode: 712138, min_days: 3, max_days: 4 },
{ pincode: 712139, min_days: 3, max_days: 4 },
{ pincode: 712147, min_days: 3, max_days: 4 },
{ pincode: 712148, min_days: 3, max_days: 4 },
{ pincode: 712149, min_days: 3, max_days: 4 },
{ pincode: 712152, min_days: 3, max_days: 4 },
{ pincode: 712201, min_days: 3, max_days: 4 },
{ pincode: 712202, min_days: 3, max_days: 4 },
{ pincode: 712203, min_days: 3, max_days: 4 },
{ pincode: 712204, min_days: 3, max_days: 4 },
{ pincode: 712221, min_days: 3, max_days: 4 },
{ pincode: 712222, min_days: 3, max_days: 4 },
{ pincode: 712223, min_days: 3, max_days: 4 },
{ pincode: 712232, min_days: 3, max_days: 4 },
{ pincode: 712233, min_days: 3, max_days: 4 },
{ pincode: 712234, min_days: 3, max_days: 4 },
{ pincode: 712235, min_days: 3, max_days: 4 },
{ pincode: 712245, min_days: 3, max_days: 4 },
{ pincode: 712246, min_days: 3, max_days: 4 },
{ pincode: 712247, min_days: 3, max_days: 4 },
{ pincode: 712248, min_days: 3, max_days: 4 },
{ pincode: 712249, min_days: 3, max_days: 4 },
{ pincode: 712250, min_days: 3, max_days: 4 },
{ pincode: 712258, min_days: 3, max_days: 4 },
{ pincode: 712301, min_days: 3, max_days: 4 },
{ pincode: 712302, min_days: 3, max_days: 4 },
{ pincode: 712303, min_days: 3, max_days: 4 },
{ pincode: 712304, min_days: 3, max_days: 4 },
{ pincode: 712305, min_days: 3, max_days: 4 },
{ pincode: 712306, min_days: 3, max_days: 4 },
{ pincode: 712308, min_days: 3, max_days: 4 },
{ pincode: 712310, min_days: 3, max_days: 4 },
{ pincode: 712311, min_days: 3, max_days: 4 },
{ pincode: 712344, min_days: 2, max_days: 3 },
{ pincode: 712401, min_days: 3, max_days: 4 },
{ pincode: 712402, min_days: 3, max_days: 4 },
{ pincode: 712403, min_days: 3, max_days: 4 },
{ pincode: 712404, min_days: 3, max_days: 4 },
{ pincode: 712405, min_days: 3, max_days: 4 },
{ pincode: 712406, min_days: 3, max_days: 4 },
{ pincode: 712407, min_days: 3, max_days: 4 },
{ pincode: 712409, min_days: 3, max_days: 4 },
{ pincode: 712410, min_days: 3, max_days: 4 },
{ pincode: 712412, min_days: 3, max_days: 4 },
{ pincode: 712413, min_days: 3, max_days: 4 },
{ pincode: 712414, min_days: 3, max_days: 4 },
{ pincode: 712415, min_days: 3, max_days: 4 },
{ pincode: 712416, min_days: 3, max_days: 4 },
{ pincode: 712417, min_days: 3, max_days: 4 },
{ pincode: 712502, min_days: 3, max_days: 4 },
{ pincode: 712503, min_days: 3, max_days: 4 },
{ pincode: 712504, min_days: 3, max_days: 4 },
{ pincode: 712513, min_days: 3, max_days: 4 },
{ pincode: 712514, min_days: 3, max_days: 4 },
{ pincode: 712515, min_days: 3, max_days: 4 },
{ pincode: 712601, min_days: 3, max_days: 4 },
{ pincode: 712602, min_days: 3, max_days: 4 },
{ pincode: 712611, min_days: 3, max_days: 4 },
{ pincode: 712612, min_days: 3, max_days: 4 },
{ pincode: 712613, min_days: 3, max_days: 4 },
{ pincode: 712614, min_days: 3, max_days: 4 },
{ pincode: 712615, min_days: 3, max_days: 4 },
{ pincode: 712616, min_days: 3, max_days: 4 },
{ pincode: 712617, min_days: 3, max_days: 4 },
{ pincode: 712701, min_days: 3, max_days: 4 },
{ pincode: 712702, min_days: 3, max_days: 4 },
{ pincode: 712704, min_days: 3, max_days: 4 },
{ pincode: 712706, min_days: 3, max_days: 4 },
{ pincode: 713101, min_days: 3, max_days: 4 },
{ pincode: 713102, min_days: 3, max_days: 4 },
{ pincode: 713103, min_days: 3, max_days: 4 },
{ pincode: 713104, min_days: 3, max_days: 4 },
{ pincode: 713122, min_days: 3, max_days: 4 },
{ pincode: 713123, min_days: 3, max_days: 4 },
{ pincode: 713124, min_days: 3, max_days: 4 },
{ pincode: 713125, min_days: 3, max_days: 4 },
{ pincode: 713126, min_days: 3, max_days: 4 },
{ pincode: 713127, min_days: 3, max_days: 4 },
{ pincode: 713128, min_days: 3, max_days: 4 },
{ pincode: 713129, min_days: 3, max_days: 4 },
{ pincode: 713130, min_days: 3, max_days: 4 },
{ pincode: 713131, min_days: 3, max_days: 4 },
{ pincode: 713140, min_days: 3, max_days: 4 },
{ pincode: 713141, min_days: 3, max_days: 4 },
{ pincode: 713142, min_days: 3, max_days: 4 },
{ pincode: 713143, min_days: 3, max_days: 4 },
{ pincode: 713145, min_days: 3, max_days: 4 },
{ pincode: 713146, min_days: 3, max_days: 4 },
{ pincode: 713147, min_days: 3, max_days: 4 },
{ pincode: 713148, min_days: 3, max_days: 4 },
{ pincode: 713149, min_days: 3, max_days: 4 },
{ pincode: 713150, min_days: 3, max_days: 4 },
{ pincode: 713151, min_days: 3, max_days: 4 },
{ pincode: 713154, min_days: 3, max_days: 4 },
{ pincode: 713156, min_days: 3, max_days: 4 },
{ pincode: 713157, min_days: 3, max_days: 4 },
{ pincode: 713158, min_days: 3, max_days: 4 },
{ pincode: 713165, min_days: 3, max_days: 4 },
{ pincode: 713166, min_days: 3, max_days: 4 },
{ pincode: 713168, min_days: 3, max_days: 4 },
{ pincode: 713170, min_days: 3, max_days: 4 },
{ pincode: 713173, min_days: 3, max_days: 4 },
{ pincode: 713201, min_days: 3, max_days: 4 },
{ pincode: 713202, min_days: 3, max_days: 4 },
{ pincode: 713203, min_days: 3, max_days: 4 },
{ pincode: 713204, min_days: 3, max_days: 4 },
{ pincode: 713205, min_days: 3, max_days: 4 },
{ pincode: 713206, min_days: 3, max_days: 4 },
{ pincode: 713207, min_days: 3, max_days: 4 },
{ pincode: 713208, min_days: 3, max_days: 4 },
{ pincode: 713209, min_days: 3, max_days: 4 },
{ pincode: 713210, min_days: 3, max_days: 4 },
{ pincode: 713211, min_days: 3, max_days: 4 },
{ pincode: 713212, min_days: 3, max_days: 4 },
{ pincode: 713213, min_days: 3, max_days: 4 },
{ pincode: 713214, min_days: 3, max_days: 4 },
{ pincode: 713215, min_days: 3, max_days: 4 },
{ pincode: 713216, min_days: 3, max_days: 4 },
{ pincode: 713217, min_days: 3, max_days: 4 },
{ pincode: 713218, min_days: 3, max_days: 4 },
{ pincode: 713219, min_days: 3, max_days: 4 },
{ pincode: 713301, min_days: 3, max_days: 4 },
{ pincode: 713302, min_days: 3, max_days: 4 },
{ pincode: 713303, min_days: 3, max_days: 4 },
{ pincode: 713304, min_days: 3, max_days: 4 },
{ pincode: 713305, min_days: 4, max_days: 5 },
{ pincode: 713315, min_days: 3, max_days: 4 },
{ pincode: 713321, min_days: 3, max_days: 4 },
{ pincode: 713322, min_days: 3, max_days: 4 },
{ pincode: 713323, min_days: 3, max_days: 4 },
{ pincode: 713324, min_days: 3, max_days: 4 },
{ pincode: 713325, min_days: 3, max_days: 4 },
{ pincode: 713326, min_days: 3, max_days: 4 },
{ pincode: 713330, min_days: 3, max_days: 4 },
{ pincode: 713331, min_days: 3, max_days: 4 },
{ pincode: 713332, min_days: 3, max_days: 4 },
{ pincode: 713333, min_days: 3, max_days: 4 },
{ pincode: 713334, min_days: 3, max_days: 4 },
{ pincode: 713335, min_days: 3, max_days: 4 },
{ pincode: 713336, min_days: 3, max_days: 4 },
{ pincode: 713337, min_days: 3, max_days: 4 },
{ pincode: 713338, min_days: 3, max_days: 4 },
{ pincode: 713339, min_days: 3, max_days: 4 },
{ pincode: 713340, min_days: 3, max_days: 4 },
{ pincode: 713341, min_days: 3, max_days: 4 },
{ pincode: 713342, min_days: 3, max_days: 4 },
{ pincode: 713343, min_days: 3, max_days: 4 },
{ pincode: 713346, min_days: 3, max_days: 4 },
{ pincode: 713347, min_days: 3, max_days: 4 },
{ pincode: 713357, min_days: 3, max_days: 4 },
{ pincode: 713358, min_days: 3, max_days: 4 },
{ pincode: 713359, min_days: 3, max_days: 4 },
{ pincode: 713360, min_days: 3, max_days: 4 },
{ pincode: 713361, min_days: 3, max_days: 4 },
{ pincode: 713362, min_days: 3, max_days: 4 },
{ pincode: 713363, min_days: 3, max_days: 4 },
{ pincode: 713365, min_days: 3, max_days: 4 },
{ pincode: 713369, min_days: 3, max_days: 4 },
{ pincode: 713371, min_days: 3, max_days: 4 },
{ pincode: 713372, min_days: 3, max_days: 4 },
{ pincode: 713373, min_days: 3, max_days: 4 },
{ pincode: 713376, min_days: 3, max_days: 4 },
{ pincode: 713378, min_days: 3, max_days: 4 },
{ pincode: 713380, min_days: 3, max_days: 4 },
{ pincode: 713381, min_days: 3, max_days: 4 },
{ pincode: 713384, min_days: 3, max_days: 4 },
{ pincode: 713385, min_days: 3, max_days: 4 },
{ pincode: 713386, min_days: 3, max_days: 4 },
{ pincode: 713401, min_days: 3, max_days: 4 },
{ pincode: 713402, min_days: 3, max_days: 4 },
{ pincode: 713403, min_days: 3, max_days: 4 },
{ pincode: 713404, min_days: 3, max_days: 4 },
{ pincode: 713405, min_days: 3, max_days: 4 },
{ pincode: 713406, min_days: 3, max_days: 4 },
{ pincode: 713407, min_days: 3, max_days: 4 },
{ pincode: 713408, min_days: 3, max_days: 4 },
{ pincode: 713409, min_days: 3, max_days: 4 },
{ pincode: 713420, min_days: 3, max_days: 4 },
{ pincode: 713422, min_days: 3, max_days: 4 },
{ pincode: 713425, min_days: 3, max_days: 4 },
{ pincode: 713426, min_days: 3, max_days: 4 },
{ pincode: 713428, min_days: 3, max_days: 4 },
{ pincode: 713429, min_days: 3, max_days: 4 },
{ pincode: 713430, min_days: 3, max_days: 4 },
{ pincode: 713433, min_days: 3, max_days: 4 },
{ pincode: 713501, min_days: 3, max_days: 4 },
{ pincode: 713502, min_days: 3, max_days: 4 },
{ pincode: 713512, min_days: 3, max_days: 4 },
{ pincode: 713513, min_days: 3, max_days: 4 },
{ pincode: 713514, min_days: 3, max_days: 4 },
{ pincode: 713515, min_days: 3, max_days: 4 },
{ pincode: 713516, min_days: 3, max_days: 4 },
{ pincode: 713517, min_days: 3, max_days: 4 },
{ pincode: 713519, min_days: 3, max_days: 4 },
{ pincode: 713520, min_days: 3, max_days: 4 },
{ pincode: 721101, min_days: 3, max_days: 4 },
{ pincode: 721121, min_days: 3, max_days: 4 },
{ pincode: 721123, min_days: 3, max_days: 4 },
{ pincode: 721124, min_days: 3, max_days: 4 },
{ pincode: 721126, min_days: 3, max_days: 4 },
{ pincode: 721127, min_days: 3, max_days: 4 },
{ pincode: 721128, min_days: 3, max_days: 4 },
{ pincode: 721129, min_days: 3, max_days: 4 },
{ pincode: 721130, min_days: 3, max_days: 4 },
{ pincode: 721131, min_days: 3, max_days: 4 },
{ pincode: 721132, min_days: 3, max_days: 4 },
{ pincode: 721133, min_days: 3, max_days: 4 },
{ pincode: 721134, min_days: 3, max_days: 4 },
{ pincode: 721135, min_days: 3, max_days: 4 },
{ pincode: 721136, min_days: 3, max_days: 4 },
{ pincode: 721137, min_days: 3, max_days: 4 },
{ pincode: 721139, min_days: 3, max_days: 4 },
{ pincode: 721140, min_days: 3, max_days: 4 },
{ pincode: 721144, min_days: 3, max_days: 4 },
{ pincode: 721145, min_days: 3, max_days: 4 },
{ pincode: 721146, min_days: 3, max_days: 4 },
{ pincode: 721147, min_days: 3, max_days: 4 },
{ pincode: 721148, min_days: 3, max_days: 4 },
{ pincode: 721149, min_days: 3, max_days: 4 },
{ pincode: 721150, min_days: 3, max_days: 4 },
{ pincode: 721151, min_days: 3, max_days: 4 },
{ pincode: 721152, min_days: 3, max_days: 4 },
{ pincode: 721153, min_days: 3, max_days: 4 },
{ pincode: 721154, min_days: 3, max_days: 4 },
{ pincode: 721156, min_days: 3, max_days: 4 },
{ pincode: 721157, min_days: 3, max_days: 4 },
{ pincode: 721158, min_days: 3, max_days: 4 },
{ pincode: 721159, min_days: 3, max_days: 4 },
{ pincode: 721160, min_days: 3, max_days: 4 },
{ pincode: 721166, min_days: 3, max_days: 4 },
{ pincode: 721167, min_days: 3, max_days: 4 },
{ pincode: 721168, min_days: 3, max_days: 4 },
{ pincode: 721171, min_days: 3, max_days: 4 },
{ pincode: 721172, min_days: 3, max_days: 4 },
{ pincode: 721201, min_days: 3, max_days: 4 },
{ pincode: 721211, min_days: 3, max_days: 4 },
{ pincode: 721212, min_days: 3, max_days: 4 },
{ pincode: 721222, min_days: 3, max_days: 4 },
{ pincode: 721232, min_days: 3, max_days: 4 },
{ pincode: 721252, min_days: 3, max_days: 4 },
{ pincode: 721253, min_days: 3, max_days: 4 },
{ pincode: 721257, min_days: 3, max_days: 4 },
{ pincode: 721258, min_days: 3, max_days: 4 },
{ pincode: 721260, min_days: 3, max_days: 4 },
{ pincode: 721301, min_days: 3, max_days: 4 },
{ pincode: 721302, min_days: 3, max_days: 4 },
{ pincode: 721303, min_days: 3, max_days: 4 },
{ pincode: 721304, min_days: 3, max_days: 4 },
{ pincode: 721305, min_days: 3, max_days: 4 },
{ pincode: 721306, min_days: 3, max_days: 4 },
{ pincode: 721401, min_days: 3, max_days: 4 },
{ pincode: 721420, min_days: 3, max_days: 4 },
{ pincode: 721422, min_days: 3, max_days: 4 },
{ pincode: 721423, min_days: 3, max_days: 4 },
{ pincode: 721424, min_days: 3, max_days: 4 },
{ pincode: 721425, min_days: 3, max_days: 4 },
{ pincode: 721426, min_days: 3, max_days: 4 },
{ pincode: 721428, min_days: 3, max_days: 4 },
{ pincode: 721429, min_days: 3, max_days: 4 },
{ pincode: 721430, min_days: 3, max_days: 4 },
{ pincode: 721431, min_days: 3, max_days: 4 },
{ pincode: 721432, min_days: 3, max_days: 4 },
{ pincode: 721433, min_days: 3, max_days: 4 },
{ pincode: 721434, min_days: 3, max_days: 4 },
{ pincode: 721435, min_days: 3, max_days: 4 },
{ pincode: 721436, min_days: 3, max_days: 4 },
{ pincode: 721437, min_days: 3, max_days: 4 },
{ pincode: 721438, min_days: 3, max_days: 4 },
{ pincode: 721439, min_days: 3, max_days: 4 },
{ pincode: 721440, min_days: 3, max_days: 4 },
{ pincode: 721441, min_days: 3, max_days: 4 },
{ pincode: 721442, min_days: 3, max_days: 4 },
{ pincode: 721443, min_days: 3, max_days: 4 },
{ pincode: 721444, min_days: 3, max_days: 4 },
{ pincode: 721445, min_days: 3, max_days: 4 },
{ pincode: 721446, min_days: 3, max_days: 4 },
{ pincode: 721449, min_days: 3, max_days: 4 },
{ pincode: 721450, min_days: 3, max_days: 4 },
{ pincode: 721451, min_days: 3, max_days: 4 },
{ pincode: 721452, min_days: 3, max_days: 4 },
{ pincode: 721454, min_days: 3, max_days: 4 },
{ pincode: 721455, min_days: 3, max_days: 4 },
{ pincode: 721457, min_days: 3, max_days: 4 },
{ pincode: 721463, min_days: 3, max_days: 4 },
{ pincode: 721467, min_days: 3, max_days: 4 },
{ pincode: 721503, min_days: 3, max_days: 4 },
{ pincode: 721504, min_days: 3, max_days: 4 },
{ pincode: 721505, min_days: 3, max_days: 4 },
{ pincode: 721507, min_days: 3, max_days: 4 },
{ pincode: 721513, min_days: 3, max_days: 4 },
{ pincode: 721514, min_days: 3, max_days: 4 },
{ pincode: 721515, min_days: 3, max_days: 4 },
{ pincode: 721517, min_days: 3, max_days: 4 },
{ pincode: 721602, min_days: 3, max_days: 4 },
{ pincode: 721603, min_days: 3, max_days: 4 },
{ pincode: 721604, min_days: 3, max_days: 4 },
{ pincode: 721605, min_days: 3, max_days: 4 },
{ pincode: 721606, min_days: 3, max_days: 4 },
{ pincode: 721607, min_days: 3, max_days: 4 },
{ pincode: 721625, min_days: 3, max_days: 4 },
{ pincode: 721627, min_days: 3, max_days: 4 },
{ pincode: 721628, min_days: 3, max_days: 4 },
{ pincode: 721629, min_days: 3, max_days: 4 },
{ pincode: 721632, min_days: 3, max_days: 4 },
{ pincode: 721633, min_days: 3, max_days: 4 },
{ pincode: 721634, min_days: 3, max_days: 4 },
{ pincode: 721635, min_days: 3, max_days: 4 },
{ pincode: 721636, min_days: 3, max_days: 4 },
{ pincode: 721641, min_days: 3, max_days: 4 },
{ pincode: 721642, min_days: 3, max_days: 4 },
{ pincode: 721643, min_days: 3, max_days: 4 },
{ pincode: 721644, min_days: 3, max_days: 4 },
{ pincode: 721645, min_days: 3, max_days: 4 },
{ pincode: 721646, min_days: 3, max_days: 4 },
{ pincode: 721647, min_days: 3, max_days: 4 },
{ pincode: 721648, min_days: 3, max_days: 4 },
{ pincode: 721649, min_days: 3, max_days: 4 },
{ pincode: 721652, min_days: 3, max_days: 4 },
{ pincode: 721653, min_days: 3, max_days: 4 },
{ pincode: 721654, min_days: 3, max_days: 4 },
{ pincode: 721657, min_days: 3, max_days: 4 },
{ pincode: 721664, min_days: 3, max_days: 4 },
{ pincode: 722101, min_days: 3, max_days: 4 },
{ pincode: 722102, min_days: 3, max_days: 4 },
{ pincode: 722107, min_days: 3, max_days: 4 },
{ pincode: 722110, min_days: 3, max_days: 4 },
{ pincode: 722111, min_days: 3, max_days: 4 },
{ pincode: 722112, min_days: 3, max_days: 4 },
{ pincode: 722121, min_days: 3, max_days: 4 },
{ pincode: 722122, min_days: 3, max_days: 4 },
{ pincode: 722132, min_days: 3, max_days: 4 },
{ pincode: 722133, min_days: 3, max_days: 4 },
{ pincode: 722135, min_days: 3, max_days: 4 },
{ pincode: 722136, min_days: 3, max_days: 4 },
{ pincode: 722137, min_days: 3, max_days: 4 },
{ pincode: 722138, min_days: 3, max_days: 4 },
{ pincode: 722139, min_days: 3, max_days: 4 },
{ pincode: 722140, min_days: 3, max_days: 4 },
{ pincode: 722144, min_days: 3, max_days: 4 },
{ pincode: 722145, min_days: 3, max_days: 4 },
{ pincode: 722146, min_days: 3, max_days: 4 },
{ pincode: 722147, min_days: 3, max_days: 4 },
{ pincode: 722148, min_days: 3, max_days: 4 },
{ pincode: 722149, min_days: 3, max_days: 4 },
{ pincode: 722151, min_days: 3, max_days: 4 },
{ pincode: 722152, min_days: 3, max_days: 4 },
{ pincode: 722154, min_days: 3, max_days: 4 },
{ pincode: 722155, min_days: 3, max_days: 4 },
{ pincode: 722156, min_days: 3, max_days: 4 },
{ pincode: 722157, min_days: 3, max_days: 4 },
{ pincode: 722158, min_days: 3, max_days: 4 },
{ pincode: 722160, min_days: 3, max_days: 4 },
{ pincode: 722162, min_days: 3, max_days: 4 },
{ pincode: 722163, min_days: 3, max_days: 4 },
{ pincode: 722164, min_days: 3, max_days: 4 },
{ pincode: 722165, min_days: 3, max_days: 4 },
{ pincode: 722169, min_days: 3, max_days: 4 },
{ pincode: 722170, min_days: 3, max_days: 4 },
{ pincode: 722171, min_days: 3, max_days: 4 },
{ pincode: 722172, min_days: 3, max_days: 4 },
{ pincode: 722173, min_days: 3, max_days: 4 },
{ pincode: 722174, min_days: 3, max_days: 4 },
{ pincode: 722175, min_days: 3, max_days: 4 },
{ pincode: 722176, min_days: 3, max_days: 4 },
{ pincode: 722178, min_days: 3, max_days: 4 },
{ pincode: 722179, min_days: 3, max_days: 4 },
{ pincode: 722180, min_days: 3, max_days: 4 },
{ pincode: 722181, min_days: 3, max_days: 4 },
{ pincode: 722182, min_days: 3, max_days: 4 },
{ pincode: 722183, min_days: 3, max_days: 4 },
{ pincode: 722203, min_days: 3, max_days: 4 },
{ pincode: 722204, min_days: 3, max_days: 4 },
{ pincode: 722206, min_days: 3, max_days: 4 },
{ pincode: 722207, min_days: 3, max_days: 4 },
{ pincode: 722208, min_days: 3, max_days: 4 },
{ pincode: 722209, min_days: 3, max_days: 4 },
{ pincode: 723101, min_days: 3, max_days: 4 },
{ pincode: 723102, min_days: 3, max_days: 4 },
{ pincode: 723103, min_days: 3, max_days: 4 },
{ pincode: 723104, min_days: 3, max_days: 4 },
{ pincode: 723121, min_days: 3, max_days: 4 },
{ pincode: 723126, min_days: 3, max_days: 4 },
{ pincode: 723127, min_days: 3, max_days: 4 },
{ pincode: 723129, min_days: 3, max_days: 4 },
{ pincode: 723130, min_days: 3, max_days: 4 },
{ pincode: 723131, min_days: 3, max_days: 4 },
{ pincode: 723132, min_days: 3, max_days: 4 },
{ pincode: 723133, min_days: 3, max_days: 4 },
{ pincode: 723142, min_days: 3, max_days: 4 },
{ pincode: 723143, min_days: 3, max_days: 4 },
{ pincode: 723145, min_days: 3, max_days: 4 },
{ pincode: 723146, min_days: 3, max_days: 4 },
{ pincode: 723147, min_days: 3, max_days: 4 },
{ pincode: 723148, min_days: 3, max_days: 4 },
{ pincode: 723149, min_days: 3, max_days: 4 },
{ pincode: 723151, min_days: 3, max_days: 4 },
{ pincode: 723153, min_days: 3, max_days: 4 },
{ pincode: 723155, min_days: 3, max_days: 4 },
{ pincode: 723156, min_days: 3, max_days: 4 },
{ pincode: 723158, min_days: 3, max_days: 4 },
{ pincode: 723161, min_days: 3, max_days: 4 },
{ pincode: 723162, min_days: 3, max_days: 4 },
{ pincode: 723168, min_days: 3, max_days: 4 },
{ pincode: 723201, min_days: 3, max_days: 4 },
{ pincode: 727120, min_days: 3, max_days: 4 },
{ pincode: 731101, min_days: 3, max_days: 4 },
{ pincode: 731102, min_days: 3, max_days: 4 },
{ pincode: 731103, min_days: 3, max_days: 4 },
{ pincode: 731104, min_days: 3, max_days: 4 },
{ pincode: 731121, min_days: 3, max_days: 4 },
{ pincode: 731123, min_days: 3, max_days: 4 },
{ pincode: 731126, min_days: 3, max_days: 4 },
{ pincode: 731127, min_days: 3, max_days: 4 },
{ pincode: 731129, min_days: 3, max_days: 4 },
{ pincode: 731130, min_days: 3, max_days: 4 },
{ pincode: 731132, min_days: 3, max_days: 4 },
{ pincode: 731201, min_days: 3, max_days: 4 },
{ pincode: 731202, min_days: 3, max_days: 4 },
{ pincode: 731204, min_days: 3, max_days: 4 },
{ pincode: 731215, min_days: 3, max_days: 4 },
{ pincode: 731216, min_days: 3, max_days: 4 },
{ pincode: 731219, min_days: 3, max_days: 4 },
{ pincode: 731220, min_days: 3, max_days: 4 },
{ pincode: 731223, min_days: 3, max_days: 4 },
{ pincode: 731224, min_days: 3, max_days: 4 },
{ pincode: 731233, min_days: 3, max_days: 4 },
{ pincode: 731234, min_days: 3, max_days: 4 },
{ pincode: 731235, min_days: 3, max_days: 4 },
{ pincode: 731236, min_days: 3, max_days: 4 },
{ pincode: 731237, min_days: 3, max_days: 4 },
{ pincode: 731238, min_days: 3, max_days: 4 },
{ pincode: 731240, min_days: 3, max_days: 4 },
{ pincode: 731241, min_days: 3, max_days: 4 },
{ pincode: 731242, min_days: 3, max_days: 4 },
{ pincode: 731243, min_days: 3, max_days: 4 },
{ pincode: 731244, min_days: 3, max_days: 4 },
{ pincode: 731245, min_days: 3, max_days: 4 },
{ pincode: 731301, min_days: 3, max_days: 4 },
{ pincode: 731302, min_days: 3, max_days: 4 },
{ pincode: 731303, min_days: 3, max_days: 4 },
{ pincode: 731304, min_days: 3, max_days: 4 },
{ pincode: 732101, min_days: 3, max_days: 4 },
{ pincode: 732102, min_days: 3, max_days: 4 },
{ pincode: 732103, min_days: 3, max_days: 4 },
{ pincode: 732121, min_days: 3, max_days: 4 },
{ pincode: 732122, min_days: 3, max_days: 4 },
{ pincode: 732123, min_days: 4, max_days: 5 },
{ pincode: 732124, min_days: 4, max_days: 5 },
{ pincode: 732125, min_days: 4, max_days: 5 },
{ pincode: 732126, min_days: 4, max_days: 5 },
{ pincode: 732127, min_days: 4, max_days: 5 },
{ pincode: 732128, min_days: 3, max_days: 4 },
{ pincode: 732138, min_days: 4, max_days: 5 },
{ pincode: 732139, min_days: 4, max_days: 5 },
{ pincode: 732140, min_days: 4, max_days: 5 },
{ pincode: 732141, min_days: 3, max_days: 4 },
{ pincode: 732142, min_days: 3, max_days: 4 },
{ pincode: 732143, min_days: 3, max_days: 4 },
{ pincode: 732144, min_days: 3, max_days: 4 },
{ pincode: 732147, min_days: 4, max_days: 5 },
{ pincode: 732150, min_days: 4, max_days: 5 },
{ pincode: 732201, min_days: 3, max_days: 4 },
{ pincode: 732202, min_days: 3, max_days: 4 },
{ pincode: 732203, min_days: 3, max_days: 4 },
{ pincode: 732204, min_days: 4, max_days: 5 },
{ pincode: 732205, min_days: 4, max_days: 5 },
{ pincode: 732206, min_days: 3, max_days: 4 },
{ pincode: 732207, min_days: 3, max_days: 4 },
{ pincode: 732208, min_days: 3, max_days: 4 },
{ pincode: 732209, min_days: 3, max_days: 4 },
{ pincode: 732210, min_days: 4, max_days: 5 },
{ pincode: 732211, min_days: 3, max_days: 4 },
{ pincode: 732212, min_days: 3, max_days: 4 },
{ pincode: 732213, min_days: 4, max_days: 5 },
{ pincode: 732214, min_days: 4, max_days: 5 },
{ pincode: 732215, min_days: 4, max_days: 5 },
{ pincode: 732216, min_days: 3, max_days: 4 },
{ pincode: 733101, min_days: 4, max_days: 5 },
{ pincode: 733102, min_days: 4, max_days: 5 },
{ pincode: 733103, min_days: 4, max_days: 5 },
{ pincode: 733121, min_days: 4, max_days: 5 },
{ pincode: 733123, min_days: 4, max_days: 5 },
{ pincode: 733124, min_days: 4, max_days: 5 },
{ pincode: 733125, min_days: 4, max_days: 5 },
{ pincode: 733126, min_days: 4, max_days: 5 },
{ pincode: 733127, min_days: 4, max_days: 5 },
{ pincode: 733128, min_days: 4, max_days: 5 },
{ pincode: 733129, min_days: 4, max_days: 5 },
{ pincode: 733130, min_days: 4, max_days: 5 },
{ pincode: 733131, min_days: 4, max_days: 5 },
{ pincode: 733132, min_days: 4, max_days: 5 },
{ pincode: 733133, min_days: 4, max_days: 5 },
{ pincode: 733134, min_days: 4, max_days: 5 },
{ pincode: 733140, min_days: 4, max_days: 5 },
{ pincode: 733141, min_days: 4, max_days: 5 },
{ pincode: 733142, min_days: 4, max_days: 5 },
{ pincode: 733143, min_days: 4, max_days: 5 },
{ pincode: 733145, min_days: 4, max_days: 5 },
{ pincode: 733151, min_days: 4, max_days: 5 },
{ pincode: 733153, min_days: 4, max_days: 5 },
{ pincode: 733155, min_days: 4, max_days: 5 },
{ pincode: 733156, min_days: 4, max_days: 5 },
{ pincode: 733158, min_days: 4, max_days: 5 },
{ pincode: 733201, min_days: 4, max_days: 5 },
{ pincode: 733202, min_days: 4, max_days: 5 },
{ pincode: 733207, min_days: 4, max_days: 5 },
{ pincode: 733208, min_days: 4, max_days: 5 },
{ pincode: 733209, min_days: 4, max_days: 5 },
{ pincode: 733210, min_days: 4, max_days: 5 },
{ pincode: 733214, min_days: 4, max_days: 5 },
{ pincode: 733215, min_days: 4, max_days: 5 },
{ pincode: 733216, min_days: 4, max_days: 5 },
{ pincode: 734001, min_days: 3, max_days: 4 },
{ pincode: 734002, min_days: 3, max_days: 4 },
{ pincode: 734003, min_days: 3, max_days: 4 },
{ pincode: 734004, min_days: 3, max_days: 4 },
{ pincode: 734005, min_days: 3, max_days: 4 },
{ pincode: 734006, min_days: 3, max_days: 4 },
{ pincode: 734007, min_days: 3, max_days: 4 },
{ pincode: 734008, min_days: 3, max_days: 4 },
{ pincode: 734009, min_days: 4, max_days: 5 },
{ pincode: 734010, min_days: 4, max_days: 5 },
{ pincode: 734011, min_days: 4, max_days: 5 },
{ pincode: 734012, min_days: 4, max_days: 5 },
{ pincode: 734013, min_days: 4, max_days: 5 },
{ pincode: 734014, min_days: 4, max_days: 5 },
{ pincode: 734015, min_days: 3, max_days: 4 },
{ pincode: 734101, min_days: 4, max_days: 5 },
{ pincode: 734102, min_days: 4, max_days: 5 },
{ pincode: 734103, min_days: 4, max_days: 5 },
{ pincode: 734104, min_days: 4, max_days: 5 },
{ pincode: 734105, min_days: 4, max_days: 5 },
{ pincode: 734121, min_days: 4, max_days: 5 },
{ pincode: 734123, min_days: 4, max_days: 5 },
{ pincode: 734124, min_days: 4, max_days: 5 },
{ pincode: 734201, min_days: 4, max_days: 5 },
{ pincode: 734203, min_days: 5, max_days: 6 },
{ pincode: 734209, min_days: 4, max_days: 5 },
{ pincode: 734216, min_days: 4, max_days: 5 },
{ pincode: 734219, min_days: 4, max_days: 5 },
{ pincode: 734221, min_days: 4, max_days: 5 },
{ pincode: 734224, min_days: 4, max_days: 5 },
{ pincode: 734301, min_days: 4, max_days: 5 },
{ pincode: 734333, min_days: 4, max_days: 5 },
{ pincode: 734401, min_days: 3, max_days: 4 },
{ pincode: 734403, min_days: 3, max_days: 4 },
{ pincode: 734404, min_days: 3, max_days: 4 },
{ pincode: 734405, min_days: 3, max_days: 4 },
{ pincode: 734421, min_days: 4, max_days: 5 },
{ pincode: 734422, min_days: 4, max_days: 5 },
{ pincode: 734423, min_days: 4, max_days: 5 },
{ pincode: 734424, min_days: 4, max_days: 5 },
{ pincode: 734426, min_days: 4, max_days: 5 },
{ pincode: 734427, min_days: 4, max_days: 5 },
{ pincode: 734429, min_days: 4, max_days: 5 },
{ pincode: 734431, min_days: 4, max_days: 5 },
{ pincode: 734434, min_days: 4, max_days: 5 },
{ pincode: 734436, min_days: 4, max_days: 5 },
{ pincode: 734501, min_days: 4, max_days: 5 },
{ pincode: 735101, min_days: 4, max_days: 5 },
{ pincode: 735102, min_days: 4, max_days: 5 },
{ pincode: 735121, min_days: 4, max_days: 5 },
{ pincode: 735122, min_days: 4, max_days: 5 },
{ pincode: 735132, min_days: 4, max_days: 5 },
{ pincode: 735133, min_days: 4, max_days: 5 },
{ pincode: 735134, min_days: 4, max_days: 5 },
{ pincode: 735135, min_days: 3, max_days: 4 },
{ pincode: 735139, min_days: 4, max_days: 5 },
{ pincode: 735140, min_days: 4, max_days: 5 },
{ pincode: 735202, min_days: 4, max_days: 5 },
{ pincode: 735203, min_days: 4, max_days: 5 },
{ pincode: 735204, min_days: 5, max_days: 6 },
{ pincode: 735205, min_days: 4, max_days: 5 },
{ pincode: 735206, min_days: 4, max_days: 5 },
{ pincode: 735207, min_days: 4, max_days: 5 },
{ pincode: 735208, min_days: 5, max_days: 6 },
{ pincode: 735209, min_days: 4, max_days: 5 },
{ pincode: 735210, min_days: 4, max_days: 5 },
{ pincode: 735211, min_days: 4, max_days: 5 },
{ pincode: 735212, min_days: 4, max_days: 5 },
{ pincode: 735213, min_days: 4, max_days: 5 },
{ pincode: 735214, min_days: 4, max_days: 5 },
{ pincode: 735215, min_days: 4, max_days: 5 },
{ pincode: 735216, min_days: 4, max_days: 5 },
{ pincode: 735217, min_days: 4, max_days: 5 },
{ pincode: 735218, min_days: 4, max_days: 5 },
{ pincode: 735219, min_days: 4, max_days: 5 },
{ pincode: 735220, min_days: 4, max_days: 5 },
{ pincode: 735221, min_days: 4, max_days: 5 },
{ pincode: 735222, min_days: 4, max_days: 5 },
{ pincode: 735223, min_days: 4, max_days: 5 },
{ pincode: 735224, min_days: 4, max_days: 5 },
{ pincode: 735225, min_days: 4, max_days: 5 },
{ pincode: 735226, min_days: 4, max_days: 5 },
{ pincode: 735227, min_days: 4, max_days: 5 },
{ pincode: 735228, min_days: 4, max_days: 5 },
{ pincode: 735229, min_days: 4, max_days: 5 },
{ pincode: 735230, min_days: 4, max_days: 5 },
{ pincode: 735232, min_days: 4, max_days: 5 },
{ pincode: 735233, min_days: 4, max_days: 5 },
{ pincode: 735234, min_days: 4, max_days: 5 },
{ pincode: 735301, min_days: 4, max_days: 5 },
{ pincode: 735302, min_days: 4, max_days: 5 },
{ pincode: 735304, min_days: 4, max_days: 5 },
{ pincode: 735305, min_days: 4, max_days: 5 },
{ pincode: 736101, min_days: 4, max_days: 5 },
{ pincode: 736121, min_days: 4, max_days: 5 },
{ pincode: 736122, min_days: 4, max_days: 5 },
{ pincode: 736123, min_days: 4, max_days: 5 },
{ pincode: 736133, min_days: 4, max_days: 5 },
{ pincode: 736134, min_days: 4, max_days: 5 },
{ pincode: 736135, min_days: 5, max_days: 6 },
{ pincode: 736145, min_days: 4, max_days: 5 },
{ pincode: 736146, min_days: 4, max_days: 5 },
{ pincode: 736156, min_days: 4, max_days: 5 },
{ pincode: 736157, min_days: 4, max_days: 5 },
{ pincode: 736158, min_days: 4, max_days: 5 },
{ pincode: 736159, min_days: 4, max_days: 5 },
{ pincode: 736160, min_days: 4, max_days: 5 },
{ pincode: 736169, min_days: 4, max_days: 5 },
{ pincode: 736170, min_days: 4, max_days: 5 },
{ pincode: 736171, min_days: 4, max_days: 5 },
{ pincode: 736172, min_days: 4, max_days: 5 },
{ pincode: 736179, min_days: 4, max_days: 5 },
{ pincode: 736182, min_days: 5, max_days: 6 },
{ pincode: 736206, min_days: 4, max_days: 5 },
{ pincode: 736208, min_days: 4, max_days: 5 },
{ pincode: 737101, min_days: 5, max_days: 6 },
{ pincode: 737102, min_days: 5, max_days: 6 },
{ pincode: 737103, min_days: 5, max_days: 6 },
{ pincode: 737121, min_days: 4, max_days: 5 },
{ pincode: 737132, min_days: 4, max_days: 5 },
{ pincode: 737134, min_days: 4, max_days: 5 },
{ pincode: 737135, min_days: 5, max_days: 6 },
{ pincode: 737136, min_days: 4, max_days: 5 },
{ pincode: 741101, min_days: 3, max_days: 4 },
{ pincode: 741102, min_days: 3, max_days: 4 },
{ pincode: 741103, min_days: 3, max_days: 4 },
{ pincode: 741121, min_days: 3, max_days: 4 },
{ pincode: 741122, min_days: 3, max_days: 4 },
{ pincode: 741123, min_days: 3, max_days: 4 },
{ pincode: 741124, min_days: 3, max_days: 4 },
{ pincode: 741125, min_days: 3, max_days: 4 },
{ pincode: 741126, min_days: 3, max_days: 4 },
{ pincode: 741127, min_days: 3, max_days: 4 },
{ pincode: 741137, min_days: 3, max_days: 4 },
{ pincode: 741138, min_days: 3, max_days: 4 },
{ pincode: 741139, min_days: 3, max_days: 4 },
{ pincode: 741140, min_days: 3, max_days: 4 },
{ pincode: 741150, min_days: 3, max_days: 4 },
{ pincode: 741151, min_days: 3, max_days: 4 },
{ pincode: 741152, min_days: 3, max_days: 4 },
{ pincode: 741153, min_days: 3, max_days: 4 },
{ pincode: 741154, min_days: 3, max_days: 4 },
{ pincode: 741155, min_days: 3, max_days: 4 },
{ pincode: 741156, min_days: 3, max_days: 4 },
{ pincode: 741157, min_days: 3, max_days: 4 },
{ pincode: 741159, min_days: 3, max_days: 4 },
{ pincode: 741160, min_days: 3, max_days: 4 },
{ pincode: 741161, min_days: 3, max_days: 4 },
{ pincode: 741162, min_days: 3, max_days: 4 },
{ pincode: 741163, min_days: 3, max_days: 4 },
{ pincode: 741164, min_days: 3, max_days: 4 },
{ pincode: 741165, min_days: 3, max_days: 4 },
{ pincode: 741166, min_days: 3, max_days: 4 },
{ pincode: 741181, min_days: 3, max_days: 4 },
{ pincode: 741201, min_days: 3, max_days: 4 },
{ pincode: 741202, min_days: 3, max_days: 4 },
{ pincode: 741221, min_days: 3, max_days: 4 },
{ pincode: 741222, min_days: 3, max_days: 4 },
{ pincode: 741223, min_days: 3, max_days: 4 },
{ pincode: 741225, min_days: 3, max_days: 4 },
{ pincode: 741232, min_days: 3, max_days: 4 },
{ pincode: 741234, min_days: 3, max_days: 4 },
{ pincode: 741235, min_days: 3, max_days: 4 },
{ pincode: 741238, min_days: 3, max_days: 4 },
{ pincode: 741245, min_days: 3, max_days: 4 },
{ pincode: 741246, min_days: 3, max_days: 4 },
{ pincode: 741247, min_days: 3, max_days: 4 },
{ pincode: 741248, min_days: 3, max_days: 4 },
{ pincode: 741249, min_days: 3, max_days: 4 },
{ pincode: 741250, min_days: 3, max_days: 4 },
{ pincode: 741251, min_days: 3, max_days: 4 },
{ pincode: 741252, min_days: 3, max_days: 4 },
{ pincode: 741253, min_days: 3, max_days: 4 },
{ pincode: 741254, min_days: 3, max_days: 4 },
{ pincode: 741255, min_days: 3, max_days: 4 },
{ pincode: 741256, min_days: 3, max_days: 4 },
{ pincode: 741257, min_days: 3, max_days: 4 },
{ pincode: 741301, min_days: 3, max_days: 4 },
{ pincode: 741302, min_days: 3, max_days: 4 },
{ pincode: 741313, min_days: 3, max_days: 4 },
{ pincode: 741315, min_days: 3, max_days: 4 },
{ pincode: 741316, min_days: 3, max_days: 4 },
{ pincode: 741317, min_days: 3, max_days: 4 },
{ pincode: 741319, min_days: 3, max_days: 4 },
{ pincode: 741401, min_days: 3, max_days: 4 },
{ pincode: 741402, min_days: 3, max_days: 4 },
{ pincode: 741404, min_days: 3, max_days: 4 },
{ pincode: 741501, min_days: 3, max_days: 4 },
{ pincode: 741502, min_days: 3, max_days: 4 },
{ pincode: 741504, min_days: 3, max_days: 4 },
{ pincode: 741505, min_days: 3, max_days: 4 },
{ pincode: 741506, min_days: 3, max_days: 4 },
{ pincode: 741507, min_days: 3, max_days: 4 },
{ pincode: 741508, min_days: 3, max_days: 4 },
{ pincode: 741509, min_days: 3, max_days: 4 },
{ pincode: 742101, min_days: 3, max_days: 4 },
{ pincode: 742102, min_days: 3, max_days: 4 },
{ pincode: 742103, min_days: 3, max_days: 4 },
{ pincode: 742104, min_days: 3, max_days: 4 },
{ pincode: 742113, min_days: 3, max_days: 4 },
{ pincode: 742122, min_days: 3, max_days: 4 },
{ pincode: 742123, min_days: 3, max_days: 4 },
{ pincode: 742132, min_days: 3, max_days: 4 },
{ pincode: 742133, min_days: 3, max_days: 4 },
{ pincode: 742134, min_days: 3, max_days: 4 },
{ pincode: 742136, min_days: 3, max_days: 4 },
{ pincode: 742137, min_days: 3, max_days: 4 },
{ pincode: 742138, min_days: 3, max_days: 4 },
{ pincode: 742140, min_days: 3, max_days: 4 },
{ pincode: 742147, min_days: 3, max_days: 4 },
{ pincode: 742148, min_days: 3, max_days: 4 },
{ pincode: 742149, min_days: 3, max_days: 4 },
{ pincode: 742151, min_days: 3, max_days: 4 },
{ pincode: 742159, min_days: 3, max_days: 4 },
{ pincode: 742160, min_days: 3, max_days: 4 },
{ pincode: 742161, min_days: 3, max_days: 4 },
{ pincode: 742163, min_days: 3, max_days: 4 },
{ pincode: 742164, min_days: 3, max_days: 4 },
{ pincode: 742165, min_days: 3, max_days: 4 },
{ pincode: 742166, min_days: 3, max_days: 4 },
{ pincode: 742168, min_days: 3, max_days: 4 },
{ pincode: 742174, min_days: 3, max_days: 4 },
{ pincode: 742175, min_days: 3, max_days: 4 },
{ pincode: 742187, min_days: 3, max_days: 4 },
{ pincode: 742201, min_days: 3, max_days: 4 },
{ pincode: 742202, min_days: 3, max_days: 4 },
{ pincode: 742212, min_days: 4, max_days: 5 },
{ pincode: 742213, min_days: 3, max_days: 4 },
{ pincode: 742223, min_days: 3, max_days: 4 },
{ pincode: 742224, min_days: 3, max_days: 4 },
{ pincode: 742225, min_days: 3, max_days: 4 },
{ pincode: 742226, min_days: 3, max_days: 4 },
{ pincode: 742227, min_days: 3, max_days: 4 },
{ pincode: 742229, min_days: 3, max_days: 4 },
{ pincode: 742235, min_days: 3, max_days: 4 },
{ pincode: 742236, min_days: 4, max_days: 5 },
{ pincode: 742237, min_days: 3, max_days: 4 },
{ pincode: 742238, min_days: 3, max_days: 4 },
{ pincode: 742301, min_days: 3, max_days: 4 },
{ pincode: 742302, min_days: 3, max_days: 4 },
{ pincode: 742303, min_days: 3, max_days: 4 },
{ pincode: 742304, min_days: 3, max_days: 4 },
{ pincode: 742305, min_days: 3, max_days: 4 },
{ pincode: 742306, min_days: 3, max_days: 4 },
{ pincode: 742308, min_days: 3, max_days: 4 },
{ pincode: 742401, min_days: 3, max_days: 4 },
{ pincode: 742402, min_days: 3, max_days: 4 },
{ pincode: 742404, min_days: 3, max_days: 4 },
{ pincode: 742405, min_days: 3, max_days: 4 },
{ pincode: 742406, min_days: 3, max_days: 4 },
{ pincode: 742407, min_days: 3, max_days: 4 },
{ pincode: 742408, min_days: 3, max_days: 4 },
{ pincode: 742409, min_days: 3, max_days: 4 },
{ pincode: 743101, min_days: 3, max_days: 4 },
{ pincode: 743102, min_days: 3, max_days: 4 },
{ pincode: 743120, min_days: 3, max_days: 4 },
{ pincode: 743121, min_days: 3, max_days: 4 },
{ pincode: 743122, min_days: 3, max_days: 4 },
{ pincode: 743123, min_days: 3, max_days: 4 },
{ pincode: 743125, min_days: 3, max_days: 4 },
{ pincode: 743126, min_days: 3, max_days: 4 },
{ pincode: 743127, min_days: 3, max_days: 4 },
{ pincode: 743128, min_days: 3, max_days: 4 },
{ pincode: 743129, min_days: 3, max_days: 4 },
{ pincode: 743133, min_days: 3, max_days: 4 },
{ pincode: 743134, min_days: 3, max_days: 4 },
{ pincode: 743135, min_days: 3, max_days: 4 },
{ pincode: 743136, min_days: 3, max_days: 4 },
{ pincode: 743144, min_days: 3, max_days: 4 },
{ pincode: 743145, min_days: 3, max_days: 4 },
{ pincode: 743155, min_days: 3, max_days: 4 },
{ pincode: 743165, min_days: 3, max_days: 4 },
{ pincode: 743166, min_days: 3, max_days: 4 },
{ pincode: 743170, min_days: 3, max_days: 4 },
{ pincode: 743175, min_days: 3, max_days: 4 },
{ pincode: 743176, min_days: 3, max_days: 4 },
{ pincode: 743177, min_days: 3, max_days: 4 },
{ pincode: 743178, min_days: 3, max_days: 4 },
{ pincode: 743179, min_days: 3, max_days: 4 },
{ pincode: 743180, min_days: 3, max_days: 4 },
{ pincode: 743186, min_days: 3, max_days: 4 },
{ pincode: 743187, min_days: 3, max_days: 4 },
{ pincode: 743188, min_days: 3, max_days: 4 },
{ pincode: 743193, min_days: 3, max_days: 4 },
{ pincode: 743194, min_days: 3, max_days: 4 },
{ pincode: 743195, min_days: 3, max_days: 4 },
{ pincode: 743221, min_days: 2, max_days: 3 },
{ pincode: 743222, min_days: 3, max_days: 4 },
{ pincode: 743223, min_days: 3, max_days: 4 },
{ pincode: 743232, min_days: 3, max_days: 4 },
{ pincode: 743233, min_days: 3, max_days: 4 },
{ pincode: 743234, min_days: 3, max_days: 4 },
{ pincode: 743235, min_days: 3, max_days: 4 },
{ pincode: 743245, min_days: 3, max_days: 4 },
{ pincode: 743247, min_days: 3, max_days: 4 },
{ pincode: 743248, min_days: 2, max_days: 3 },
{ pincode: 743249, min_days: 3, max_days: 4 },
{ pincode: 743251, min_days: 3, max_days: 4 },
{ pincode: 743252, min_days: 3, max_days: 4 },
{ pincode: 743262, min_days: 3, max_days: 4 },
{ pincode: 743263, min_days: 3, max_days: 4 },
{ pincode: 743268, min_days: 3, max_days: 4 },
{ pincode: 743269, min_days: 3, max_days: 4 },
{ pincode: 743270, min_days: 3, max_days: 4 },
{ pincode: 743271, min_days: 3, max_days: 4 },
{ pincode: 743272, min_days: 3, max_days: 4 },
{ pincode: 743273, min_days: 3, max_days: 4 },
{ pincode: 743286, min_days: 3, max_days: 4 },
{ pincode: 743287, min_days: 3, max_days: 4 },
{ pincode: 743289, min_days: 3, max_days: 4 },
{ pincode: 743290, min_days: 3, max_days: 4 },
{ pincode: 743291, min_days: 3, max_days: 4 },
{ pincode: 743292, min_days: 3, max_days: 4 },
{ pincode: 743293, min_days: 3, max_days: 4 },
{ pincode: 743294, min_days: 2, max_days: 3 },
{ pincode: 743297, min_days: 3, max_days: 4 },
{ pincode: 743313, min_days: 2, max_days: 3 },
{ pincode: 743318, min_days: 3, max_days: 4 },
{ pincode: 743329, min_days: 4, max_days: 5 },
{ pincode: 743330, min_days: 3, max_days: 4 },
{ pincode: 743331, min_days: 3, max_days: 4 },
{ pincode: 743332, min_days: 3, max_days: 4 },
{ pincode: 743336, min_days: 3, max_days: 4 },
{ pincode: 743337, min_days: 3, max_days: 4 },
{ pincode: 743338, min_days: 3, max_days: 4 },
{ pincode: 743345, min_days: 3, max_days: 4 },
{ pincode: 743348, min_days: 4, max_days: 5 },
{ pincode: 743351, min_days: 3, max_days: 4 },
{ pincode: 743354, min_days: 3, max_days: 4 },
{ pincode: 743355, min_days: 3, max_days: 4 },
{ pincode: 743368, min_days: 3, max_days: 4 },
{ pincode: 743372, min_days: 3, max_days: 4 },
{ pincode: 743375, min_days: 3, max_days: 4 },
{ pincode: 743376, min_days: 4, max_days: 5 },
{ pincode: 743377, min_days: 3, max_days: 4 },
{ pincode: 743385, min_days: 3, max_days: 4 },
{ pincode: 743387, min_days: 3, max_days: 4 },
{ pincode: 743391, min_days: 3, max_days: 4 },
{ pincode: 743395, min_days: 3, max_days: 4 },
{ pincode: 743396, min_days: 3, max_days: 4 },
{ pincode: 743398, min_days: 3, max_days: 4 },
{ pincode: 743401, min_days: 3, max_days: 4 },
{ pincode: 743405, min_days: 3, max_days: 4 },
{ pincode: 743411, min_days: 3, max_days: 4 },
{ pincode: 743412, min_days: 3, max_days: 4 },
{ pincode: 743422, min_days: 3, max_days: 4 },
{ pincode: 743423, min_days: 2, max_days: 3 },
{ pincode: 743424, min_days: 3, max_days: 4 },
{ pincode: 743425, min_days: 3, max_days: 4 },
{ pincode: 743426, min_days: 3, max_days: 4 },
{ pincode: 743427, min_days: 3, max_days: 4 },
{ pincode: 743428, min_days: 3, max_days: 4 },
{ pincode: 743429, min_days: 3, max_days: 4 },
{ pincode: 743437, min_days: 3, max_days: 4 },
{ pincode: 743438, min_days: 3, max_days: 4 },
{ pincode: 743445, min_days: 3, max_days: 4 },
{ pincode: 743456, min_days: 3, max_days: 4 },
{ pincode: 743502, min_days: 3, max_days: 4 },
{ pincode: 743503, min_days: 3, max_days: 4 },
{ pincode: 743504, min_days: 3, max_days: 4 },
{ pincode: 743507, min_days: 3, max_days: 4 },
{ pincode: 743513, min_days: 3, max_days: 4 },
{ pincode: 743601, min_days: 3, max_days: 4 },
{ pincode: 743609, min_days: 3, max_days: 4 },
{ pincode: 743610, min_days: 3, max_days: 4 },
{ pincode: 743613, min_days: 3, max_days: 4 },
{ pincode: 743701, min_days: 3, max_days: 4 },
{ pincode: 743702, min_days: 3, max_days: 4 },
{ pincode: 743704, min_days: 3, max_days: 4 },
{ pincode: 743710, min_days: 3, max_days: 4 },
{ pincode: 743711, min_days: 3, max_days: 4 },
{ pincode: 744101, min_days: 7, max_days: 8 },
{ pincode: 744102, min_days: 7, max_days: 8 },
{ pincode: 744103, min_days: 7, max_days: 8 },
{ pincode: 744104, min_days: 7, max_days: 8 },
{ pincode: 744105, min_days: 7, max_days: 8 },
{ pincode: 744106, min_days: 7, max_days: 8 },
{ pincode: 744112, min_days: 7, max_days: 8 },
{ pincode: 751001, min_days: 3, max_days: 4 },
{ pincode: 751002, min_days: 3, max_days: 4 },
{ pincode: 751003, min_days: 3, max_days: 4 },
{ pincode: 751004, min_days: 3, max_days: 4 },
{ pincode: 751005, min_days: 3, max_days: 4 },
{ pincode: 751006, min_days: 3, max_days: 4 },
{ pincode: 751007, min_days: 3, max_days: 4 },
{ pincode: 751008, min_days: 3, max_days: 4 },
{ pincode: 751009, min_days: 3, max_days: 4 },
{ pincode: 751010, min_days: 3, max_days: 4 },
{ pincode: 751011, min_days: 3, max_days: 4 },
{ pincode: 751012, min_days: 3, max_days: 4 },
{ pincode: 751013, min_days: 3, max_days: 4 },
{ pincode: 751014, min_days: 3, max_days: 4 },
{ pincode: 751015, min_days: 3, max_days: 4 },
{ pincode: 751016, min_days: 3, max_days: 4 },
{ pincode: 751017, min_days: 3, max_days: 4 },
{ pincode: 751018, min_days: 3, max_days: 4 },
{ pincode: 751019, min_days: 3, max_days: 4 },
{ pincode: 751020, min_days: 3, max_days: 4 },
{ pincode: 751021, min_days: 3, max_days: 4 },
{ pincode: 751022, min_days: 3, max_days: 4 },
{ pincode: 751023, min_days: 3, max_days: 4 },
{ pincode: 751024, min_days: 3, max_days: 4 },
{ pincode: 751025, min_days: 3, max_days: 4 },
{ pincode: 751026, min_days: 3, max_days: 4 },
{ pincode: 751027, min_days: 3, max_days: 4 },
{ pincode: 751029, min_days: 3, max_days: 4 },
{ pincode: 751030, min_days: 3, max_days: 4 },
{ pincode: 751031, min_days: 3, max_days: 4 },
{ pincode: 751062, min_days: 3, max_days: 4 },
{ pincode: 752001, min_days: 3, max_days: 4 },
{ pincode: 752002, min_days: 3, max_days: 4 },
{ pincode: 752003, min_days: 3, max_days: 4 },
{ pincode: 752010, min_days: 3, max_days: 4 },
{ pincode: 752011, min_days: 3, max_days: 4 },
{ pincode: 752012, min_days: 3, max_days: 4 },
{ pincode: 752013, min_days: 3, max_days: 4 },
{ pincode: 752014, min_days: 3, max_days: 4 },
{ pincode: 752015, min_days: 3, max_days: 4 },
{ pincode: 752017, min_days: 3, max_days: 4 },
{ pincode: 752018, min_days: 3, max_days: 4 },
{ pincode: 752019, min_days: 3, max_days: 4 },
{ pincode: 752020, min_days: 3, max_days: 4 },
{ pincode: 752021, min_days: 3, max_days: 4 },
{ pincode: 752022, min_days: 3, max_days: 4 },
{ pincode: 752023, min_days: 3, max_days: 4 },
{ pincode: 752024, min_days: 3, max_days: 4 },
{ pincode: 752025, min_days: 3, max_days: 4 },
{ pincode: 752026, min_days: 3, max_days: 4 },
{ pincode: 752030, min_days: 3, max_days: 4 },
{ pincode: 752031, min_days: 3, max_days: 4 },
{ pincode: 752034, min_days: 3, max_days: 4 },
{ pincode: 752035, min_days: 3, max_days: 4 },
{ pincode: 752037, min_days: 3, max_days: 4 },
{ pincode: 752038, min_days: 3, max_days: 4 },
{ pincode: 752045, min_days: 3, max_days: 4 },
{ pincode: 752050, min_days: 3, max_days: 4 },
{ pincode: 752054, min_days: 3, max_days: 4 },
{ pincode: 752055, min_days: 3, max_days: 4 },
{ pincode: 752056, min_days: 3, max_days: 4 },
{ pincode: 752057, min_days: 3, max_days: 4 },
{ pincode: 752060, min_days: 3, max_days: 4 },
{ pincode: 752061, min_days: 3, max_days: 4 },
{ pincode: 752062, min_days: 3, max_days: 4 },
{ pincode: 752063, min_days: 3, max_days: 4 },
{ pincode: 752064, min_days: 3, max_days: 4 },
{ pincode: 752065, min_days: 3, max_days: 4 },
{ pincode: 752066, min_days: 3, max_days: 4 },
{ pincode: 752068, min_days: 3, max_days: 4 },
{ pincode: 752069, min_days: 3, max_days: 4 },
{ pincode: 752070, min_days: 3, max_days: 4 },
{ pincode: 752077, min_days: 3, max_days: 4 },
{ pincode: 752078, min_days: 3, max_days: 4 },
{ pincode: 752079, min_days: 3, max_days: 4 },
{ pincode: 752080, min_days: 3, max_days: 4 },
{ pincode: 752081, min_days: 3, max_days: 4 },
{ pincode: 752092, min_days: 3, max_days: 4 },
{ pincode: 752094, min_days: 3, max_days: 4 },
{ pincode: 752100, min_days: 3, max_days: 4 },
{ pincode: 752101, min_days: 4, max_days: 5 },
{ pincode: 752104, min_days: 3, max_days: 4 },
{ pincode: 752105, min_days: 3, max_days: 4 },
{ pincode: 752106, min_days: 3, max_days: 4 },
{ pincode: 752108, min_days: 3, max_days: 4 },
{ pincode: 752109, min_days: 3, max_days: 4 },
{ pincode: 752110, min_days: 3, max_days: 4 },
{ pincode: 752111, min_days: 3, max_days: 4 },
{ pincode: 752114, min_days: 3, max_days: 4 },
{ pincode: 753001, min_days: 3, max_days: 4 },
{ pincode: 753002, min_days: 3, max_days: 4 },
{ pincode: 753003, min_days: 3, max_days: 4 },
{ pincode: 753004, min_days: 3, max_days: 4 },
{ pincode: 753005, min_days: 3, max_days: 4 },
{ pincode: 753006, min_days: 3, max_days: 4 },
{ pincode: 753007, min_days: 3, max_days: 4 },
{ pincode: 753008, min_days: 3, max_days: 4 },
{ pincode: 753009, min_days: 3, max_days: 4 },
{ pincode: 753010, min_days: 3, max_days: 4 },
{ pincode: 753011, min_days: 3, max_days: 4 },
{ pincode: 753012, min_days: 3, max_days: 4 },
{ pincode: 753013, min_days: 3, max_days: 4 },
{ pincode: 753014, min_days: 3, max_days: 4 },
{ pincode: 753015, min_days: 3, max_days: 4 },
{ pincode: 753051, min_days: 3, max_days: 4 },
{ pincode: 754001, min_days: 3, max_days: 4 },
{ pincode: 754004, min_days: 3, max_days: 4 },
{ pincode: 754005, min_days: 3, max_days: 4 },
{ pincode: 754006, min_days: 3, max_days: 4 },
{ pincode: 754008, min_days: 3, max_days: 4 },
{ pincode: 754011, min_days: 3, max_days: 4 },
{ pincode: 754018, min_days: 3, max_days: 4 },
{ pincode: 754021, min_days: 3, max_days: 4 },
{ pincode: 754022, min_days: 3, max_days: 4 },
{ pincode: 754023, min_days: 3, max_days: 4 },
{ pincode: 754024, min_days: 3, max_days: 4 },
{ pincode: 754025, min_days: 3, max_days: 4 },
{ pincode: 754027, min_days: 3, max_days: 4 },
{ pincode: 754028, min_days: 3, max_days: 4 },
{ pincode: 754029, min_days: 3, max_days: 4 },
{ pincode: 754030, min_days: 3, max_days: 4 },
{ pincode: 754031, min_days: 3, max_days: 4 },
{ pincode: 754032, min_days: 3, max_days: 4 },
{ pincode: 754037, min_days: 3, max_days: 4 },
{ pincode: 754071, min_days: 3, max_days: 4 },
{ pincode: 754082, min_days: 3, max_days: 4 },
{ pincode: 754102, min_days: 3, max_days: 4 },
{ pincode: 754103, min_days: 3, max_days: 4 },
{ pincode: 754104, min_days: 3, max_days: 4 },
{ pincode: 754106, min_days: 3, max_days: 4 },
{ pincode: 754107, min_days: 3, max_days: 4 },
{ pincode: 754108, min_days: 3, max_days: 4 },
{ pincode: 754109, min_days: 3, max_days: 4 },
{ pincode: 754110, min_days: 3, max_days: 4 },
{ pincode: 754111, min_days: 3, max_days: 4 },
{ pincode: 754113, min_days: 3, max_days: 4 },
{ pincode: 754114, min_days: 3, max_days: 4 },
{ pincode: 754119, min_days: 3, max_days: 4 },
{ pincode: 754120, min_days: 3, max_days: 4 },
{ pincode: 754130, min_days: 3, max_days: 4 },
{ pincode: 754131, min_days: 3, max_days: 4 },
{ pincode: 754132, min_days: 3, max_days: 4 },
{ pincode: 754133, min_days: 3, max_days: 4 },
{ pincode: 754134, min_days: 3, max_days: 4 },
{ pincode: 754136, min_days: 3, max_days: 4 },
{ pincode: 754137, min_days: 3, max_days: 4 },
{ pincode: 754140, min_days: 3, max_days: 4 },
{ pincode: 754141, min_days: 3, max_days: 4 },
{ pincode: 754142, min_days: 3, max_days: 4 },
{ pincode: 754143, min_days: 3, max_days: 4 },
{ pincode: 754145, min_days: 3, max_days: 4 },
{ pincode: 754153, min_days: 3, max_days: 4 },
{ pincode: 754160, min_days: 3, max_days: 4 },
{ pincode: 754162, min_days: 3, max_days: 4 },
{ pincode: 754200, min_days: 3, max_days: 4 },
{ pincode: 754201, min_days: 3, max_days: 4 },
{ pincode: 754202, min_days: 3, max_days: 4 },
{ pincode: 754203, min_days: 3, max_days: 4 },
{ pincode: 754204, min_days: 3, max_days: 4 },
{ pincode: 754205, min_days: 3, max_days: 4 },
{ pincode: 754210, min_days: 3, max_days: 4 },
{ pincode: 754211, min_days: 3, max_days: 4 },
{ pincode: 754212, min_days: 3, max_days: 4 },
{ pincode: 754213, min_days: 3, max_days: 4 },
{ pincode: 754214, min_days: 3, max_days: 4 },
{ pincode: 754215, min_days: 3, max_days: 4 },
{ pincode: 754216, min_days: 3, max_days: 4 },
{ pincode: 754217, min_days: 3, max_days: 4 },
{ pincode: 754218, min_days: 3, max_days: 4 },
{ pincode: 754219, min_days: 3, max_days: 4 },
{ pincode: 754220, min_days: 3, max_days: 4 },
{ pincode: 754222, min_days: 3, max_days: 4 },
{ pincode: 754223, min_days: 3, max_days: 4 },
{ pincode: 754224, min_days: 3, max_days: 4 },
{ pincode: 754228, min_days: 3, max_days: 4 },
{ pincode: 754231, min_days: 3, max_days: 4 },
{ pincode: 754239, min_days: 3, max_days: 4 },
{ pincode: 754240, min_days: 3, max_days: 4 },
{ pincode: 754244, min_days: 3, max_days: 4 },
{ pincode: 754245, min_days: 3, max_days: 4 },
{ pincode: 754246, min_days: 3, max_days: 4 },
{ pincode: 754250, min_days: 3, max_days: 4 },
{ pincode: 754253, min_days: 3, max_days: 4 },
{ pincode: 754289, min_days: 3, max_days: 4 },
{ pincode: 754292, min_days: 3, max_days: 4 },
{ pincode: 754295, min_days: 3, max_days: 4 },
{ pincode: 754296, min_days: 3, max_days: 4 },
{ pincode: 755001, min_days: 4, max_days: 5 },
{ pincode: 755003, min_days: 3, max_days: 4 },
{ pincode: 755004, min_days: 3, max_days: 4 },
{ pincode: 755005, min_days: 3, max_days: 4 },
{ pincode: 755006, min_days: 3, max_days: 4 },
{ pincode: 755007, min_days: 4, max_days: 5 },
{ pincode: 755008, min_days: 3, max_days: 4 },
{ pincode: 755009, min_days: 3, max_days: 4 },
{ pincode: 755010, min_days: 3, max_days: 4 },
{ pincode: 755011, min_days: 3, max_days: 4 },
{ pincode: 755012, min_days: 3, max_days: 4 },
{ pincode: 755013, min_days: 3, max_days: 4 },
{ pincode: 755014, min_days: 3, max_days: 4 },
{ pincode: 755015, min_days: 4, max_days: 5 },
{ pincode: 755016, min_days: 3, max_days: 4 },
{ pincode: 755017, min_days: 3, max_days: 4 },
{ pincode: 755019, min_days: 4, max_days: 5 },
{ pincode: 755020, min_days: 4, max_days: 5 },
{ pincode: 755022, min_days: 4, max_days: 5 },
{ pincode: 755023, min_days: 3, max_days: 4 },
{ pincode: 755024, min_days: 3, max_days: 4 },
{ pincode: 755026, min_days: 3, max_days: 4 },
{ pincode: 755027, min_days: 3, max_days: 4 },
{ pincode: 755036, min_days: 3, max_days: 4 },
{ pincode: 755040, min_days: 4, max_days: 5 },
{ pincode: 755043, min_days: 4, max_days: 5 },
{ pincode: 755044, min_days: 3, max_days: 4 },
{ pincode: 755049, min_days: 3, max_days: 4 },
{ pincode: 755050, min_days: 3, max_days: 4 },
{ pincode: 755061, min_days: 3, max_days: 4 },
{ pincode: 755062, min_days: 3, max_days: 4 },
{ pincode: 756001, min_days: 3, max_days: 4 },
{ pincode: 756002, min_days: 3, max_days: 4 },
{ pincode: 756003, min_days: 3, max_days: 4 },
{ pincode: 756019, min_days: 3, max_days: 4 },
{ pincode: 756020, min_days: 3, max_days: 4 },
{ pincode: 756023, min_days: 3, max_days: 4 },
{ pincode: 756024, min_days: 3, max_days: 4 },
{ pincode: 756025, min_days: 3, max_days: 4 },
{ pincode: 756026, min_days: 3, max_days: 4 },
{ pincode: 756027, min_days: 3, max_days: 4 },
{ pincode: 756029, min_days: 3, max_days: 4 },
{ pincode: 756030, min_days: 3, max_days: 4 },
{ pincode: 756032, min_days: 3, max_days: 4 },
{ pincode: 756034, min_days: 3, max_days: 4 },
{ pincode: 756035, min_days: 3, max_days: 4 },
{ pincode: 756036, min_days: 3, max_days: 4 },
{ pincode: 756038, min_days: 3, max_days: 4 },
{ pincode: 756039, min_days: 3, max_days: 4 },
{ pincode: 756040, min_days: 3, max_days: 4 },
{ pincode: 756042, min_days: 3, max_days: 4 },
{ pincode: 756043, min_days: 3, max_days: 4 },
{ pincode: 756045, min_days: 3, max_days: 4 },
{ pincode: 756046, min_days: 3, max_days: 4 },
{ pincode: 756056, min_days: 3, max_days: 4 },
{ pincode: 756058, min_days: 3, max_days: 4 },
{ pincode: 756060, min_days: 3, max_days: 4 },
{ pincode: 756079, min_days: 3, max_days: 4 },
{ pincode: 756080, min_days: 3, max_days: 4 },
{ pincode: 756081, min_days: 3, max_days: 4 },
{ pincode: 756083, min_days: 3, max_days: 4 },
{ pincode: 756084, min_days: 3, max_days: 4 },
{ pincode: 756085, min_days: 3, max_days: 4 },
{ pincode: 756086, min_days: 3, max_days: 4 },
{ pincode: 756087, min_days: 3, max_days: 4 },
{ pincode: 756100, min_days: 4, max_days: 5 },
{ pincode: 756101, min_days: 4, max_days: 5 },
{ pincode: 756111, min_days: 3, max_days: 4 },
{ pincode: 756112, min_days: 3, max_days: 4 },
{ pincode: 756113, min_days: 3, max_days: 4 },
{ pincode: 756116, min_days: 3, max_days: 4 },
{ pincode: 756118, min_days: 3, max_days: 4 },
{ pincode: 756119, min_days: 3, max_days: 4 },
{ pincode: 756124, min_days: 3, max_days: 4 },
{ pincode: 756125, min_days: 3, max_days: 4 },
{ pincode: 756127, min_days: 3, max_days: 4 },
{ pincode: 756128, min_days: 3, max_days: 4 },
{ pincode: 756129, min_days: 3, max_days: 4 },
{ pincode: 756130, min_days: 3, max_days: 4 },
{ pincode: 756131, min_days: 3, max_days: 4 },
{ pincode: 756132, min_days: 3, max_days: 4 },
{ pincode: 756133, min_days: 3, max_days: 4 },
{ pincode: 756139, min_days: 3, max_days: 4 },
{ pincode: 756163, min_days: 3, max_days: 4 },
{ pincode: 756164, min_days: 3, max_days: 4 },
{ pincode: 756165, min_days: 3, max_days: 4 },
{ pincode: 756181, min_days: 4, max_days: 5 },
{ pincode: 757001, min_days: 3, max_days: 4 },
{ pincode: 757002, min_days: 3, max_days: 4 },
{ pincode: 757003, min_days: 3, max_days: 4 },
{ pincode: 757017, min_days: 3, max_days: 4 },
{ pincode: 757019, min_days: 3, max_days: 4 },
{ pincode: 757020, min_days: 3, max_days: 4 },
{ pincode: 757021, min_days: 3, max_days: 4 },
{ pincode: 757022, min_days: 3, max_days: 4 },
{ pincode: 757023, min_days: 3, max_days: 4 },
{ pincode: 757024, min_days: 3, max_days: 4 },
{ pincode: 757025, min_days: 3, max_days: 4 },
{ pincode: 757026, min_days: 3, max_days: 4 },
{ pincode: 757027, min_days: 3, max_days: 4 },
{ pincode: 757029, min_days: 3, max_days: 4 },
{ pincode: 757030, min_days: 3, max_days: 4 },
{ pincode: 757040, min_days: 3, max_days: 4 },
{ pincode: 757041, min_days: 3, max_days: 4 },
{ pincode: 757049, min_days: 3, max_days: 4 },
{ pincode: 757075, min_days: 3, max_days: 4 },
{ pincode: 757077, min_days: 3, max_days: 4 },
{ pincode: 757079, min_days: 3, max_days: 4 },
{ pincode: 757084, min_days: 3, max_days: 4 },
{ pincode: 757085, min_days: 3, max_days: 4 },
{ pincode: 757087, min_days: 3, max_days: 4 },
{ pincode: 757101, min_days: 3, max_days: 4 },
{ pincode: 757103, min_days: 3, max_days: 4 },
{ pincode: 757104, min_days: 3, max_days: 4 },
{ pincode: 757105, min_days: 3, max_days: 4 },
{ pincode: 757107, min_days: 3, max_days: 4 },
{ pincode: 758001, min_days: 3, max_days: 4 },
{ pincode: 758002, min_days: 3, max_days: 4 },
{ pincode: 758013, min_days: 3, max_days: 4 },
{ pincode: 758014, min_days: 3, max_days: 4 },
{ pincode: 758018, min_days: 3, max_days: 4 },
{ pincode: 758031, min_days: 3, max_days: 4 },
{ pincode: 758034, min_days: 3, max_days: 4 },
{ pincode: 758035, min_days: 3, max_days: 4 },
{ pincode: 758037, min_days: 3, max_days: 4 },
{ pincode: 758038, min_days: 3, max_days: 4 },
{ pincode: 758041, min_days: 3, max_days: 4 },
{ pincode: 758046, min_days: 3, max_days: 4 },
{ pincode: 758079, min_days: 3, max_days: 4 },
{ pincode: 758087, min_days: 3, max_days: 4 },
{ pincode: 759001, min_days: 3, max_days: 4 },
{ pincode: 759013, min_days: 3, max_days: 4 },
{ pincode: 759015, min_days: 3, max_days: 4 },
{ pincode: 759024, min_days: 3, max_days: 4 },
{ pincode: 759025, min_days: 3, max_days: 4 },
{ pincode: 759027, min_days: 3, max_days: 4 },
{ pincode: 759037, min_days: 3, max_days: 4 },
{ pincode: 759100, min_days: 3, max_days: 4 },
{ pincode: 759101, min_days: 3, max_days: 4 },
{ pincode: 759102, min_days: 3, max_days: 4 },
{ pincode: 759104, min_days: 3, max_days: 4 },
{ pincode: 759106, min_days: 3, max_days: 4 },
{ pincode: 759107, min_days: 3, max_days: 4 },
{ pincode: 759111, min_days: 3, max_days: 4 },
{ pincode: 759116, min_days: 3, max_days: 4 },
{ pincode: 759121, min_days: 3, max_days: 4 },
{ pincode: 759122, min_days: 3, max_days: 4 },
{ pincode: 759123, min_days: 3, max_days: 4 },
{ pincode: 759124, min_days: 3, max_days: 4 },
{ pincode: 759125, min_days: 3, max_days: 4 },
{ pincode: 759126, min_days: 3, max_days: 4 },
{ pincode: 759128, min_days: 3, max_days: 4 },
{ pincode: 759130, min_days: 3, max_days: 4 },
{ pincode: 759143, min_days: 4, max_days: 5 },
{ pincode: 759145, min_days: 4, max_days: 5 },
{ pincode: 759146, min_days: 3, max_days: 4 },
{ pincode: 760001, min_days: 4, max_days: 5 },
{ pincode: 760002, min_days: 4, max_days: 5 },
{ pincode: 760003, min_days: 4, max_days: 5 },
{ pincode: 760004, min_days: 4, max_days: 5 },
{ pincode: 760005, min_days: 4, max_days: 5 },
{ pincode: 760006, min_days: 4, max_days: 5 },
{ pincode: 760007, min_days: 4, max_days: 5 },
{ pincode: 760008, min_days: 4, max_days: 5 },
{ pincode: 760009, min_days: 4, max_days: 5 },
{ pincode: 760010, min_days: 4, max_days: 5 },
{ pincode: 760011, min_days: 4, max_days: 5 },
{ pincode: 761001, min_days: 3, max_days: 4 },
{ pincode: 761002, min_days: 3, max_days: 4 },
{ pincode: 761003, min_days: 3, max_days: 4 },
{ pincode: 761004, min_days: 3, max_days: 4 },
{ pincode: 761008, min_days: 3, max_days: 4 },
{ pincode: 761009, min_days: 3, max_days: 4 },
{ pincode: 761010, min_days: 3, max_days: 4 },
{ pincode: 761020, min_days: 3, max_days: 4 },
{ pincode: 761025, min_days: 3, max_days: 4 },
{ pincode: 761032, min_days: 3, max_days: 4 },
{ pincode: 761041, min_days: 3, max_days: 4 },
{ pincode: 761045, min_days: 3, max_days: 4 },
{ pincode: 761052, min_days: 3, max_days: 4 },
{ pincode: 761100, min_days: 3, max_days: 4 },
{ pincode: 761101, min_days: 3, max_days: 4 },
{ pincode: 761102, min_days: 3, max_days: 4 },
{ pincode: 761103, min_days: 3, max_days: 4 },
{ pincode: 761104, min_days: 3, max_days: 4 },
{ pincode: 761106, min_days: 3, max_days: 4 },
{ pincode: 761107, min_days: 3, max_days: 4 },
{ pincode: 761108, min_days: 3, max_days: 4 },
{ pincode: 761110, min_days: 3, max_days: 4 },
{ pincode: 761114, min_days: 3, max_days: 4 },
{ pincode: 761115, min_days: 3, max_days: 4 },
{ pincode: 761116, min_days: 3, max_days: 4 },
{ pincode: 761117, min_days: 3, max_days: 4 },
{ pincode: 761118, min_days: 3, max_days: 4 },
{ pincode: 761122, min_days: 3, max_days: 4 },
{ pincode: 761123, min_days: 3, max_days: 4 },
{ pincode: 761124, min_days: 3, max_days: 4 },
{ pincode: 761133, min_days: 3, max_days: 4 },
{ pincode: 761146, min_days: 3, max_days: 4 },
{ pincode: 761200, min_days: 3, max_days: 4 },
{ pincode: 761201, min_days: 3, max_days: 4 },
{ pincode: 761206, min_days: 3, max_days: 4 },
{ pincode: 761208, min_days: 3, max_days: 4 },
{ pincode: 761210, min_days: 3, max_days: 4 },
{ pincode: 761211, min_days: 3, max_days: 4 },
{ pincode: 762001, min_days: 4, max_days: 5 },
{ pincode: 762002, min_days: 4, max_days: 5 },
{ pincode: 762010, min_days: 4, max_days: 5 },
{ pincode: 762012, min_days: 4, max_days: 5 },
{ pincode: 762013, min_days: 3, max_days: 4 },
{ pincode: 762014, min_days: 3, max_days: 4 },
{ pincode: 762019, min_days: 4, max_days: 5 },
{ pincode: 762029, min_days: 4, max_days: 5 },
{ pincode: 762100, min_days: 4, max_days: 5 },
{ pincode: 762103, min_days: 5, max_days: 6 },
{ pincode: 763001, min_days: 4, max_days: 5 },
{ pincode: 763002, min_days: 4, max_days: 5 },
{ pincode: 763003, min_days: 4, max_days: 5 },
{ pincode: 763004, min_days: 4, max_days: 5 },
{ pincode: 763008, min_days: 4, max_days: 5 },
{ pincode: 764001, min_days: 4, max_days: 5 },
{ pincode: 764003, min_days: 4, max_days: 5 },
{ pincode: 764004, min_days: 4, max_days: 5 },
{ pincode: 764005, min_days: 4, max_days: 5 },
{ pincode: 764006, min_days: 4, max_days: 5 },
{ pincode: 764011, min_days: 4, max_days: 5 },
{ pincode: 764020, min_days: 4, max_days: 5 },
{ pincode: 764021, min_days: 4, max_days: 5 },
{ pincode: 764036, min_days: 4, max_days: 5 },
{ pincode: 764043, min_days: 4, max_days: 5 },
{ pincode: 764044, min_days: 4, max_days: 5 },
{ pincode: 764045, min_days: 4, max_days: 5 },
{ pincode: 764048, min_days: 4, max_days: 5 },
{ pincode: 764049, min_days: 4, max_days: 5 },
{ pincode: 764051, min_days: 4, max_days: 5 },
{ pincode: 764056, min_days: 4, max_days: 5 },
{ pincode: 764058, min_days: 5, max_days: 6 },
{ pincode: 764059, min_days: 4, max_days: 5 },
{ pincode: 764063, min_days: 4, max_days: 5 },
{ pincode: 764070, min_days: 4, max_days: 5 },
{ pincode: 764071, min_days: 4, max_days: 5 },
{ pincode: 764078, min_days: 4, max_days: 5 },
{ pincode: 764085, min_days: 4, max_days: 5 },
{ pincode: 765001, min_days: 3, max_days: 4 },
{ pincode: 765002, min_days: 3, max_days: 4 },
{ pincode: 765017, min_days: 3, max_days: 4 },
{ pincode: 765018, min_days: 3, max_days: 4 },
{ pincode: 766001, min_days: 4, max_days: 5 },
{ pincode: 766002, min_days: 4, max_days: 5 },
{ pincode: 766014, min_days: 4, max_days: 5 },
{ pincode: 766020, min_days: 4, max_days: 5 },
{ pincode: 766027, min_days: 4, max_days: 5 },
{ pincode: 766104, min_days: 4, max_days: 5 },
{ pincode: 766105, min_days: 4, max_days: 5 },
{ pincode: 766107, min_days: 4, max_days: 5 },
{ pincode: 767001, min_days: 3, max_days: 4 },
{ pincode: 767002, min_days: 3, max_days: 4 },
{ pincode: 767016, min_days: 3, max_days: 4 },
{ pincode: 767017, min_days: 3, max_days: 4 },
{ pincode: 767018, min_days: 3, max_days: 4 },
{ pincode: 767019, min_days: 3, max_days: 4 },
{ pincode: 767020, min_days: 3, max_days: 4 },
{ pincode: 767033, min_days: 4, max_days: 5 },
{ pincode: 767039, min_days: 4, max_days: 5 },
{ pincode: 767040, min_days: 4, max_days: 5 },
{ pincode: 767065, min_days: 3, max_days: 4 },
{ pincode: 767066, min_days: 4, max_days: 5 },
{ pincode: 767067, min_days: 3, max_days: 4 },
{ pincode: 767070, min_days: 4, max_days: 5 },
{ pincode: 767071, min_days: 3, max_days: 4 },
{ pincode: 768001, min_days: 4, max_days: 5 },
{ pincode: 768002, min_days: 4, max_days: 5 },
{ pincode: 768003, min_days: 4, max_days: 5 },
{ pincode: 768004, min_days: 3, max_days: 4 },
{ pincode: 768005, min_days: 3, max_days: 4 },
{ pincode: 768006, min_days: 4, max_days: 5 },
{ pincode: 768016, min_days: 3, max_days: 4 },
{ pincode: 768017, min_days: 3, max_days: 4 },
{ pincode: 768018, min_days: 3, max_days: 4 },
{ pincode: 768019, min_days: 3, max_days: 4 },
{ pincode: 768020, min_days: 3, max_days: 4 },
{ pincode: 768027, min_days: 3, max_days: 4 },
{ pincode: 768028, min_days: 3, max_days: 4 },
{ pincode: 768040, min_days: 3, max_days: 4 },
{ pincode: 768106, min_days: 3, max_days: 4 },
{ pincode: 768108, min_days: 3, max_days: 4 },
{ pincode: 768109, min_days: 3, max_days: 4 },
{ pincode: 768118, min_days: 3, max_days: 4 },
{ pincode: 768119, min_days: 3, max_days: 4 },
{ pincode: 768201, min_days: 4, max_days: 5 },
{ pincode: 768202, min_days: 4, max_days: 5 },
{ pincode: 768203, min_days: 4, max_days: 5 },
{ pincode: 768204, min_days: 4, max_days: 5 },
{ pincode: 768210, min_days: 3, max_days: 4 },
{ pincode: 768211, min_days: 3, max_days: 4 },
{ pincode: 768216, min_days: 3, max_days: 4 },
{ pincode: 768217, min_days: 3, max_days: 4 },
{ pincode: 768218, min_days: 3, max_days: 4 },
{ pincode: 768224, min_days: 3, max_days: 4 },
{ pincode: 768225, min_days: 3, max_days: 4 },
{ pincode: 768233, min_days: 3, max_days: 4 },
{ pincode: 768234, min_days: 3, max_days: 4 },
{ pincode: 769001, min_days: 4, max_days: 5 },
{ pincode: 769002, min_days: 4, max_days: 5 },
{ pincode: 769003, min_days: 4, max_days: 5 },
{ pincode: 769004, min_days: 4, max_days: 5 },
{ pincode: 769005, min_days: 4, max_days: 5 },
{ pincode: 769006, min_days: 4, max_days: 5 },
{ pincode: 769007, min_days: 4, max_days: 5 },
{ pincode: 769008, min_days: 4, max_days: 5 },
{ pincode: 769009, min_days: 4, max_days: 5 },
{ pincode: 769010, min_days: 3, max_days: 4 },
{ pincode: 769011, min_days: 4, max_days: 5 },
{ pincode: 769012, min_days: 4, max_days: 5 },
{ pincode: 769013, min_days: 3, max_days: 4 },
{ pincode: 769014, min_days: 4, max_days: 5 },
{ pincode: 769015, min_days: 4, max_days: 5 },
{ pincode: 769016, min_days: 3, max_days: 4 },
{ pincode: 769042, min_days: 4, max_days: 5 },
{ pincode: 770001, min_days: 3, max_days: 4 },
{ pincode: 770002, min_days: 3, max_days: 4 },
{ pincode: 770016, min_days: 3, max_days: 4 },
{ pincode: 770017, min_days: 3, max_days: 4 },
{ pincode: 770018, min_days: 3, max_days: 4 },
{ pincode: 770025, min_days: 3, max_days: 4 },
{ pincode: 770031, min_days: 3, max_days: 4 },
{ pincode: 770034, min_days: 3, max_days: 4 },
{ pincode: 770070, min_days: 3, max_days: 4 },
{ pincode: 770072, min_days: 3, max_days: 4 },
{ pincode: 777888, min_days: 2, max_days: 3 },
{ pincode: 781001, min_days: 2, max_days: 3 },
{ pincode: 781002, min_days: 2, max_days: 3 },
{ pincode: 781003, min_days: 2, max_days: 3 },
{ pincode: 781004, min_days: 2, max_days: 3 },
{ pincode: 781005, min_days: 2, max_days: 3 },
{ pincode: 781006, min_days: 2, max_days: 3 },
{ pincode: 781007, min_days: 2, max_days: 3 },
{ pincode: 781008, min_days: 2, max_days: 3 },
{ pincode: 781009, min_days: 2, max_days: 3 },
{ pincode: 781010, min_days: 2, max_days: 3 },
{ pincode: 781011, min_days: 2, max_days: 3 },
{ pincode: 781012, min_days: 2, max_days: 3 },
{ pincode: 781013, min_days: 2, max_days: 3 },
{ pincode: 781014, min_days: 2, max_days: 3 },
{ pincode: 781015, min_days: 2, max_days: 3 },
{ pincode: 781016, min_days: 2, max_days: 3 },
{ pincode: 781017, min_days: 2, max_days: 3 },
{ pincode: 781018, min_days: 2, max_days: 3 },
{ pincode: 781019, min_days: 2, max_days: 3 },
{ pincode: 781020, min_days: 2, max_days: 3 },
{ pincode: 781021, min_days: 2, max_days: 3 },
{ pincode: 781022, min_days: 2, max_days: 3 },
{ pincode: 781023, min_days: 2, max_days: 3 },
{ pincode: 781024, min_days: 2, max_days: 3 },
{ pincode: 781025, min_days: 2, max_days: 3 },
{ pincode: 781026, min_days: 2, max_days: 3 },
{ pincode: 781027, min_days: 2, max_days: 3 },
{ pincode: 781028, min_days: 2, max_days: 3 },
{ pincode: 781029, min_days: 2, max_days: 3 },
{ pincode: 781030, min_days: 3, max_days: 4 },
{ pincode: 781031, min_days: 3, max_days: 4 },
{ pincode: 781032, min_days: 2, max_days: 3 },
{ pincode: 781033, min_days: 2, max_days: 3 },
{ pincode: 781034, min_days: 2, max_days: 3 },
{ pincode: 781035, min_days: 2, max_days: 3 },
{ pincode: 781036, min_days: 2, max_days: 3 },
{ pincode: 781037, min_days: 2, max_days: 3 },
{ pincode: 781038, min_days: 2, max_days: 3 },
{ pincode: 781039, min_days: 4, max_days: 5 },
{ pincode: 781040, min_days: 2, max_days: 3 },
{ pincode: 781071, min_days: 2, max_days: 3 },
{ pincode: 781101, min_days: 3, max_days: 4 },
{ pincode: 781102, min_days: 3, max_days: 4 },
{ pincode: 781103, min_days: 3, max_days: 4 },
{ pincode: 781104, min_days: 3, max_days: 4 },
{ pincode: 781121, min_days: 3, max_days: 4 },
{ pincode: 781122, min_days: 3, max_days: 4 },
{ pincode: 781123, min_days: 3, max_days: 4 },
{ pincode: 781124, min_days: 3, max_days: 4 },
{ pincode: 781125, min_days: 2, max_days: 3 },
{ pincode: 781128, min_days: 2, max_days: 3 },
{ pincode: 781131, min_days: 2, max_days: 3 },
{ pincode: 781132, min_days: 3, max_days: 4 },
{ pincode: 781133, min_days: 4, max_days: 5 },
{ pincode: 781134, min_days: 3, max_days: 4 },
{ pincode: 781150, min_days: 2, max_days: 3 },
{ pincode: 781171, min_days: 2, max_days: 3 },
{ pincode: 781301, min_days: 3, max_days: 4 },
{ pincode: 781303, min_days: 3, max_days: 4 },
{ pincode: 781304, min_days: 3, max_days: 4 },
{ pincode: 781306, min_days: 3, max_days: 4 },
{ pincode: 781309, min_days: 3, max_days: 4 },
{ pincode: 781310, min_days: 3, max_days: 4 },
{ pincode: 781313, min_days: 3, max_days: 4 },
{ pincode: 781314, min_days: 3, max_days: 4 },
{ pincode: 781315, min_days: 4, max_days: 5 },
{ pincode: 781316, min_days: 3, max_days: 4 },
{ pincode: 781317, min_days: 4, max_days: 5 },
{ pincode: 781318, min_days: 3, max_days: 4 },
{ pincode: 781319, min_days: 3, max_days: 4 },
{ pincode: 781325, min_days: 4, max_days: 5 },
{ pincode: 781326, min_days: 3, max_days: 4 },
{ pincode: 781334, min_days: 3, max_days: 4 },
{ pincode: 781335, min_days: 3, max_days: 4 },
{ pincode: 781337, min_days: 3, max_days: 4 },
{ pincode: 781338, min_days: 3, max_days: 4 },
{ pincode: 781339, min_days: 3, max_days: 4 },
{ pincode: 781340, min_days: 3, max_days: 4 },
{ pincode: 781341, min_days: 3, max_days: 4 },
{ pincode: 781346, min_days: 3, max_days: 4 },
{ pincode: 781347, min_days: 3, max_days: 4 },
{ pincode: 781348, min_days: 3, max_days: 4 },
{ pincode: 781349, min_days: 3, max_days: 4 },
{ pincode: 781351, min_days: 3, max_days: 4 },
{ pincode: 781352, min_days: 3, max_days: 4 },
{ pincode: 781353, min_days: 3, max_days: 4 },
{ pincode: 781354, min_days: 4, max_days: 5 },
{ pincode: 781360, min_days: 4, max_days: 5 },
{ pincode: 781365, min_days: 3, max_days: 4 },
{ pincode: 781366, min_days: 3, max_days: 4 },
{ pincode: 781367, min_days: 4, max_days: 5 },
{ pincode: 781369, min_days: 3, max_days: 4 },
{ pincode: 781370, min_days: 3, max_days: 4 },
{ pincode: 781371, min_days: 3, max_days: 4 },
{ pincode: 781374, min_days: 3, max_days: 4 },
{ pincode: 781376, min_days: 3, max_days: 4 },
{ pincode: 781378, min_days: 3, max_days: 4 },
{ pincode: 781380, min_days: 4, max_days: 5 },
{ pincode: 781381, min_days: 4, max_days: 5 },
{ pincode: 781382, min_days: 3, max_days: 4 },
{ pincode: 782001, min_days: 4, max_days: 5 },
{ pincode: 782002, min_days: 4, max_days: 5 },
{ pincode: 782003, min_days: 4, max_days: 5 },
{ pincode: 782102, min_days: 3, max_days: 4 },
{ pincode: 782105, min_days: 3, max_days: 4 },
{ pincode: 782120, min_days: 3, max_days: 4 },
{ pincode: 782135, min_days: 3, max_days: 4 },
{ pincode: 782136, min_days: 3, max_days: 4 },
{ pincode: 782137, min_days: 3, max_days: 4 },
{ pincode: 782138, min_days: 3, max_days: 4 },
{ pincode: 782139, min_days: 3, max_days: 4 },
{ pincode: 782140, min_days: 3, max_days: 4 },
{ pincode: 782141, min_days: 3, max_days: 4 },
{ pincode: 782142, min_days: 3, max_days: 4 },
{ pincode: 782143, min_days: 3, max_days: 4 },
{ pincode: 782402, min_days: 3, max_days: 4 },
{ pincode: 782410, min_days: 3, max_days: 4 },
{ pincode: 782429, min_days: 3, max_days: 4 },
{ pincode: 782439, min_days: 3, max_days: 4 },
{ pincode: 782440, min_days: 3, max_days: 4 },
{ pincode: 782442, min_days: 3, max_days: 4 },
{ pincode: 782445, min_days: 3, max_days: 4 },
{ pincode: 782446, min_days: 3, max_days: 4 },
{ pincode: 782447, min_days: 4, max_days: 5 },
{ pincode: 782460, min_days: 4, max_days: 5 },
{ pincode: 782461, min_days: 4, max_days: 5 },
{ pincode: 782462, min_days: 4, max_days: 5 },
{ pincode: 782480, min_days: 3, max_days: 4 },
{ pincode: 783101, min_days: 3, max_days: 4 },
{ pincode: 783120, min_days: 3, max_days: 4 },
{ pincode: 783121, min_days: 3, max_days: 4 },
{ pincode: 783122, min_days: 3, max_days: 4 },
{ pincode: 783124, min_days: 3, max_days: 4 },
{ pincode: 783125, min_days: 3, max_days: 4 },
{ pincode: 783126, min_days: 3, max_days: 4 },
{ pincode: 783133, min_days: 3, max_days: 4 },
{ pincode: 783134, min_days: 3, max_days: 4 },
{ pincode: 783301, min_days: 3, max_days: 4 },
{ pincode: 783333, min_days: 3, max_days: 4 },
{ pincode: 783336, min_days: 3, max_days: 4 },
{ pincode: 783337, min_days: 3, max_days: 4 },
{ pincode: 783345, min_days: 3, max_days: 4 },
{ pincode: 783346, min_days: 3, max_days: 4 },
{ pincode: 783347, min_days: 3, max_days: 4 },
{ pincode: 783354, min_days: 3, max_days: 4 },
{ pincode: 783360, min_days: 3, max_days: 4 },
{ pincode: 783361, min_days: 3, max_days: 4 },
{ pincode: 783369, min_days: 3, max_days: 4 },
{ pincode: 783370, min_days: 3, max_days: 4 },
{ pincode: 783373, min_days: 3, max_days: 4 },
{ pincode: 783375, min_days: 3, max_days: 4 },
{ pincode: 783376, min_days: 3, max_days: 4 },
{ pincode: 783380, min_days: 3, max_days: 4 },
{ pincode: 783381, min_days: 3, max_days: 4 },
{ pincode: 783385, min_days: 3, max_days: 4 },
{ pincode: 783390, min_days: 3, max_days: 4 },
{ pincode: 783391, min_days: 3, max_days: 4 },
{ pincode: 783392, min_days: 3, max_days: 4 },
{ pincode: 783394, min_days: 3, max_days: 4 },
{ pincode: 784001, min_days: 3, max_days: 4 },
{ pincode: 784010, min_days: 3, max_days: 4 },
{ pincode: 784025, min_days: 3, max_days: 4 },
{ pincode: 784026, min_days: 3, max_days: 4 },
{ pincode: 784027, min_days: 3, max_days: 4 },
{ pincode: 784028, min_days: 3, max_days: 4 },
{ pincode: 784101, min_days: 3, max_days: 4 },
{ pincode: 784104, min_days: 4, max_days: 5 },
{ pincode: 784105, min_days: 3, max_days: 4 },
{ pincode: 784110, min_days: 3, max_days: 4 },
{ pincode: 784115, min_days: 3, max_days: 4 },
{ pincode: 784117, min_days: 3, max_days: 4 },
{ pincode: 784125, min_days: 3, max_days: 4 },
{ pincode: 784145, min_days: 3, max_days: 4 },
{ pincode: 784149, min_days: 3, max_days: 4 },
{ pincode: 784150, min_days: 3, max_days: 4 },
{ pincode: 784153, min_days: 3, max_days: 4 },
{ pincode: 784154, min_days: 3, max_days: 4 },
{ pincode: 784160, min_days: 3, max_days: 4 },
{ pincode: 784161, min_days: 3, max_days: 4 },
{ pincode: 784163, min_days: 3, max_days: 4 },
{ pincode: 784164, min_days: 3, max_days: 4 },
{ pincode: 784168, min_days: 3, max_days: 4 },
{ pincode: 784169, min_days: 3, max_days: 4 },
{ pincode: 784170, min_days: 3, max_days: 4 },
{ pincode: 784171, min_days: 3, max_days: 4 },
{ pincode: 784172, min_days: 3, max_days: 4 },
{ pincode: 784174, min_days: 3, max_days: 4 },
{ pincode: 784175, min_days: 3, max_days: 4 },
{ pincode: 784176, min_days: 3, max_days: 4 },
{ pincode: 784177, min_days: 3, max_days: 4 },
{ pincode: 784178, min_days: 3, max_days: 4 },
{ pincode: 784180, min_days: 3, max_days: 4 },
{ pincode: 784189, min_days: 3, max_days: 4 },
{ pincode: 784501, min_days: 4, max_days: 5 },
{ pincode: 784502, min_days: 3, max_days: 4 },
{ pincode: 784504, min_days: 3, max_days: 4 },
{ pincode: 784505, min_days: 3, max_days: 4 },
{ pincode: 784506, min_days: 3, max_days: 4 },
{ pincode: 784521, min_days: 3, max_days: 4 },
{ pincode: 784525, min_days: 3, max_days: 4 },
{ pincode: 785001, min_days: 4, max_days: 5 },
{ pincode: 785002, min_days: 4, max_days: 5 },
{ pincode: 785004, min_days: 4, max_days: 5 },
{ pincode: 785005, min_days: 4, max_days: 5 },
{ pincode: 785006, min_days: 4, max_days: 5 },
{ pincode: 785007, min_days: 4, max_days: 5 },
{ pincode: 785008, min_days: 4, max_days: 5 },
{ pincode: 785009, min_days: 4, max_days: 5 },
{ pincode: 785010, min_days: 4, max_days: 5 },
{ pincode: 785013, min_days: 4, max_days: 5 },
{ pincode: 785101, min_days: 4, max_days: 5 },
{ pincode: 785102, min_days: 3, max_days: 4 },
{ pincode: 785107, min_days: 4, max_days: 5 },
{ pincode: 785108, min_days: 3, max_days: 4 },
{ pincode: 785111, min_days: 3, max_days: 4 },
{ pincode: 785112, min_days: 3, max_days: 4 },
{ pincode: 785609, min_days: 3, max_days: 4 },
{ pincode: 785610, min_days: 3, max_days: 4 },
{ pincode: 785612, min_days: 3, max_days: 4 },
{ pincode: 785613, min_days: 4, max_days: 5 },
{ pincode: 785615, min_days: 4, max_days: 5 },
{ pincode: 785618, min_days: 3, max_days: 4 },
{ pincode: 785619, min_days: 4, max_days: 5 },
{ pincode: 785621, min_days: 4, max_days: 5 },
{ pincode: 785622, min_days: 3, max_days: 4 },
{ pincode: 785625, min_days: 3, max_days: 4 },
{ pincode: 785626, min_days: 3, max_days: 4 },
{ pincode: 785630, min_days: 3, max_days: 4 },
{ pincode: 785636, min_days: 3, max_days: 4 },
{ pincode: 785640, min_days: 3, max_days: 4 },
{ pincode: 785661, min_days: 3, max_days: 4 },
{ pincode: 785662, min_days: 3, max_days: 4 },
{ pincode: 785665, min_days: 3, max_days: 4 },
{ pincode: 785669, min_days: 3, max_days: 4 },
{ pincode: 785670, min_days: 3, max_days: 4 },
{ pincode: 785671, min_days: 3, max_days: 4 },
{ pincode: 785672, min_days: 3, max_days: 4 },
{ pincode: 785680, min_days: 3, max_days: 4 },
{ pincode: 785681, min_days: 3, max_days: 4 },
{ pincode: 785682, min_days: 3, max_days: 4 },
{ pincode: 785683, min_days: 3, max_days: 4 },
{ pincode: 785684, min_days: 3, max_days: 4 },
{ pincode: 785685, min_days: 4, max_days: 5 },
{ pincode: 785686, min_days: 4, max_days: 5 },
{ pincode: 785687, min_days: 3, max_days: 4 },
{ pincode: 785688, min_days: 4, max_days: 5 },
{ pincode: 785689, min_days: 4, max_days: 5 },
{ pincode: 785690, min_days: 4, max_days: 5 },
{ pincode: 785691, min_days: 4, max_days: 5 },
{ pincode: 785692, min_days: 4, max_days: 5 },
{ pincode: 785696, min_days: 3, max_days: 4 },
{ pincode: 785699, min_days: 3, max_days: 4 },
{ pincode: 785700, min_days: 3, max_days: 4 },
{ pincode: 785701, min_days: 4, max_days: 5 },
{ pincode: 785702, min_days: 3, max_days: 4 },
{ pincode: 785703, min_days: 3, max_days: 4 },
{ pincode: 785704, min_days: 3, max_days: 4 },
{ pincode: 785705, min_days: 4, max_days: 5 },
{ pincode: 786001, min_days: 3, max_days: 4 },
{ pincode: 786002, min_days: 3, max_days: 4 },
{ pincode: 786003, min_days: 3, max_days: 4 },
{ pincode: 786004, min_days: 3, max_days: 4 },
{ pincode: 786005, min_days: 3, max_days: 4 },
{ pincode: 786006, min_days: 3, max_days: 4 },
{ pincode: 786007, min_days: 3, max_days: 4 },
{ pincode: 786008, min_days: 3, max_days: 4 },
{ pincode: 786010, min_days: 3, max_days: 4 },
{ pincode: 786012, min_days: 3, max_days: 4 },
{ pincode: 786102, min_days: 3, max_days: 4 },
{ pincode: 786125, min_days: 3, max_days: 4 },
{ pincode: 786126, min_days: 3, max_days: 4 },
{ pincode: 786145, min_days: 3, max_days: 4 },
{ pincode: 786146, min_days: 3, max_days: 4 },
{ pincode: 786147, min_days: 3, max_days: 4 },
{ pincode: 786148, min_days: 3, max_days: 4 },
{ pincode: 786150, min_days: 4, max_days: 5 },
{ pincode: 786151, min_days: 4, max_days: 5 },
{ pincode: 786152, min_days: 4, max_days: 5 },
{ pincode: 786153, min_days: 4, max_days: 5 },
{ pincode: 786156, min_days: 4, max_days: 5 },
{ pincode: 786159, min_days: 4, max_days: 5 },
{ pincode: 786160, min_days: 4, max_days: 5 },
{ pincode: 786170, min_days: 3, max_days: 4 },
{ pincode: 786171, min_days: 3, max_days: 4 },
{ pincode: 786173, min_days: 3, max_days: 4 },
{ pincode: 786179, min_days: 4, max_days: 5 },
{ pincode: 786181, min_days: 3, max_days: 4 },
{ pincode: 786182, min_days: 4, max_days: 5 },
{ pincode: 786183, min_days: 3, max_days: 4 },
{ pincode: 786184, min_days: 3, max_days: 4 },
{ pincode: 786187, min_days: 3, max_days: 4 },
{ pincode: 786188, min_days: 4, max_days: 5 },
{ pincode: 786189, min_days: 3, max_days: 4 },
{ pincode: 786190, min_days: 4, max_days: 5 },
{ pincode: 786191, min_days: 3, max_days: 4 },
{ pincode: 786192, min_days: 3, max_days: 4 },
{ pincode: 786601, min_days: 3, max_days: 4 },
{ pincode: 786602, min_days: 3, max_days: 4 },
{ pincode: 786610, min_days: 3, max_days: 4 },
{ pincode: 786611, min_days: 3, max_days: 4 },
{ pincode: 786612, min_days: 3, max_days: 4 },
{ pincode: 786614, min_days: 3, max_days: 4 },
{ pincode: 786621, min_days: 3, max_days: 4 },
{ pincode: 786622, min_days: 3, max_days: 4 },
{ pincode: 786623, min_days: 3, max_days: 4 },
{ pincode: 786692, min_days: 3, max_days: 4 },
{ pincode: 787001, min_days: 5, max_days: 6 },
{ pincode: 787023, min_days: 5, max_days: 6 },
{ pincode: 787026, min_days: 3, max_days: 4 },
{ pincode: 787031, min_days: 5, max_days: 6 },
{ pincode: 787032, min_days: 5, max_days: 6 },
{ pincode: 787034, min_days: 3, max_days: 4 },
{ pincode: 787035, min_days: 3, max_days: 4 },
{ pincode: 787051, min_days: 5, max_days: 6 },
{ pincode: 787053, min_days: 3, max_days: 4 },
{ pincode: 787054, min_days: 3, max_days: 4 },
{ pincode: 787055, min_days: 3, max_days: 4 },
{ pincode: 787056, min_days: 3, max_days: 4 },
{ pincode: 787057, min_days: 3, max_days: 4 },
{ pincode: 787059, min_days: 3, max_days: 4 },
{ pincode: 787060, min_days: 3, max_days: 4 },
{ pincode: 787061, min_days: 3, max_days: 4 },
{ pincode: 787110, min_days: 3, max_days: 4 },
{ pincode: 788001, min_days: 4, max_days: 5 },
{ pincode: 788002, min_days: 4, max_days: 5 },
{ pincode: 788003, min_days: 4, max_days: 5 },
{ pincode: 788004, min_days: 4, max_days: 5 },
{ pincode: 788005, min_days: 4, max_days: 5 },
{ pincode: 788006, min_days: 4, max_days: 5 },
{ pincode: 788007, min_days: 4, max_days: 5 },
{ pincode: 788009, min_days: 4, max_days: 5 },
{ pincode: 788010, min_days: 4, max_days: 5 },
{ pincode: 788011, min_days: 4, max_days: 5 },
{ pincode: 788014, min_days: 4, max_days: 5 },
{ pincode: 788015, min_days: 4, max_days: 5 },
{ pincode: 788150, min_days: 5, max_days: 6 },
{ pincode: 788151, min_days: 5, max_days: 6 },
{ pincode: 788152, min_days: 5, max_days: 6 },
{ pincode: 788155, min_days: 5, max_days: 6 },
{ pincode: 788160, min_days: 5, max_days: 6 },
{ pincode: 788163, min_days: 5, max_days: 6 },
{ pincode: 788164, min_days: 5, max_days: 6 },
{ pincode: 788165, min_days: 5, max_days: 6 },
{ pincode: 788166, min_days: 5, max_days: 6 },
{ pincode: 788168, min_days: 5, max_days: 6 },
{ pincode: 788709, min_days: 5, max_days: 6 },
{ pincode: 788710, min_days: 5, max_days: 6 },
{ pincode: 788711, min_days: 5, max_days: 6 },
{ pincode: 788712, min_days: 5, max_days: 6 },
{ pincode: 788713, min_days: 5, max_days: 6 },
{ pincode: 788719, min_days: 5, max_days: 6 },
{ pincode: 788720, min_days: 5, max_days: 6 },
{ pincode: 788722, min_days: 5, max_days: 6 },
{ pincode: 788781, min_days: 5, max_days: 6 },
{ pincode: 788819, min_days: 5, max_days: 6 },
{ pincode: 788820, min_days: 5, max_days: 6 },
{ pincode: 791102, min_days: 3, max_days: 4 },
{ pincode: 791110, min_days: 3, max_days: 4 },
{ pincode: 791111, min_days: 3, max_days: 4 },
{ pincode: 791113, min_days: 3, max_days: 4 },
{ pincode: 791120, min_days: 4, max_days: 5 },
{ pincode: 791123, min_days: 3, max_days: 4 },
{ pincode: 792110, min_days: 4, max_days: 5 },
{ pincode: 793001, min_days: 3, max_days: 4 },
{ pincode: 793002, min_days: 3, max_days: 4 },
{ pincode: 793003, min_days: 3, max_days: 4 },
{ pincode: 793004, min_days: 3, max_days: 4 },
{ pincode: 793005, min_days: 3, max_days: 4 },
{ pincode: 793006, min_days: 3, max_days: 4 },
{ pincode: 793007, min_days: 3, max_days: 4 },
{ pincode: 793008, min_days: 3, max_days: 4 },
{ pincode: 793010, min_days: 3, max_days: 4 },
{ pincode: 793011, min_days: 3, max_days: 4 },
{ pincode: 793014, min_days: 3, max_days: 4 },
{ pincode: 793017, min_days: 3, max_days: 4 },
{ pincode: 793018, min_days: 3, max_days: 4 },
{ pincode: 793019, min_days: 3, max_days: 4 },
{ pincode: 793022, min_days: 3, max_days: 4 },
{ pincode: 793150, min_days: 4, max_days: 5 },
{ pincode: 793160, min_days: 3, max_days: 4 },
{ pincode: 793200, min_days: 3, max_days: 4 },
{ pincode: 793210, min_days: 3, max_days: 4 },
{ pincode: 794001, min_days: 3, max_days: 4 },
{ pincode: 795001, min_days: 4, max_days: 5 },
{ pincode: 795002, min_days: 4, max_days: 5 },
{ pincode: 795003, min_days: 4, max_days: 5 },
{ pincode: 795004, min_days: 4, max_days: 5 },
{ pincode: 795005, min_days: 4, max_days: 5 },
{ pincode: 795008, min_days: 4, max_days: 5 },
{ pincode: 795009, min_days: 4, max_days: 5 },
{ pincode: 795011, min_days: 4, max_days: 5 },
{ pincode: 795103, min_days: 5, max_days: 6 },
{ pincode: 795126, min_days: 4, max_days: 5 },
{ pincode: 795134, min_days: 4, max_days: 5 },
{ pincode: 795138, min_days: 5, max_days: 6 },
{ pincode: 795140, min_days: 4, max_days: 5 },
{ pincode: 796001, min_days: 4, max_days: 5 },
{ pincode: 796004, min_days: 4, max_days: 5 },
{ pincode: 796005, min_days: 4, max_days: 5 },
{ pincode: 796007, min_days: 4, max_days: 5 },
{ pincode: 796008, min_days: 4, max_days: 5 },
{ pincode: 796009, min_days: 4, max_days: 5 },
{ pincode: 796012, min_days: 4, max_days: 5 },
{ pincode: 796014, min_days: 4, max_days: 5 },
{ pincode: 796691, min_days: 5, max_days: 6 },
{ pincode: 796701, min_days: 5, max_days: 6 },
{ pincode: 797001, min_days: 3, max_days: 4 },
{ pincode: 797004, min_days: 3, max_days: 4 },
{ pincode: 797103, min_days: 3, max_days: 4 },
{ pincode: 797111, min_days: 4, max_days: 5 },
{ pincode: 797112, min_days: 4, max_days: 5 },
{ pincode: 797113, min_days: 3, max_days: 4 },
{ pincode: 797115, min_days: 3, max_days: 4 },
{ pincode: 797116, min_days: 4, max_days: 5 },
{ pincode: 797117, min_days: 3, max_days: 4 },
{ pincode: 797121, min_days: 3, max_days: 4 },
{ pincode: 798601, min_days: 4, max_days: 5 },
{ pincode: 798612, min_days: 4, max_days: 5 },
{ pincode: 798618, min_days: 4, max_days: 5 },
{ pincode: 798620, min_days: 4, max_days: 5 },
{ pincode: 798623, min_days: 4, max_days: 5 },
{ pincode: 798627, min_days: 4, max_days: 5 },
{ pincode: 799001, min_days: 4, max_days: 5 },
{ pincode: 799002, min_days: 4, max_days: 5 },
{ pincode: 799003, min_days: 4, max_days: 5 },
{ pincode: 799004, min_days: 4, max_days: 5 },
{ pincode: 799005, min_days: 4, max_days: 5 },
{ pincode: 799006, min_days: 4, max_days: 5 },
{ pincode: 799007, min_days: 4, max_days: 5 },
{ pincode: 799008, min_days: 4, max_days: 5 },
{ pincode: 799009, min_days: 4, max_days: 5 },
{ pincode: 799010, min_days: 4, max_days: 5 },
{ pincode: 799011, min_days: 4, max_days: 5 },
{ pincode: 799012, min_days: 4, max_days: 5 },
{ pincode: 799013, min_days: 4, max_days: 5 },
{ pincode: 799014, min_days: 4, max_days: 5 },
{ pincode: 799015, min_days: 4, max_days: 5 },
{ pincode: 799022, min_days: 4, max_days: 5 },
{ pincode: 799035, min_days: 4, max_days: 5 },
{ pincode: 799046, min_days: 4, max_days: 5 },
{ pincode: 799101, min_days: 4, max_days: 5 },
{ pincode: 799103, min_days: 4, max_days: 5 },
{ pincode: 799104, min_days: 4, max_days: 5 },
{ pincode: 799105, min_days: 4, max_days: 5 },
{ pincode: 799113, min_days: 4, max_days: 5 },
{ pincode: 799114, min_days: 4, max_days: 5 },
{ pincode: 799115, min_days: 4, max_days: 5 },
{ pincode: 799120, min_days: 4, max_days: 5 },
{ pincode: 799125, min_days: 4, max_days: 5 },
{ pincode: 799130, min_days: 4, max_days: 5 },
{ pincode: 799131, min_days: 4, max_days: 5 },
{ pincode: 799132, min_days: 4, max_days: 5 },
{ pincode: 799204, min_days: 4, max_days: 5 },
{ pincode: 799210, min_days: 4, max_days: 5 },
{ pincode: 799211, min_days: 4, max_days: 5 },
{ pincode: 799250, min_days: 5, max_days: 6 },
{ pincode: 799253, min_days: 5, max_days: 6 },
{ pincode: 799254, min_days: 5, max_days: 6 },
{ pincode: 799256, min_days: 5, max_days: 6 },
{ pincode: 799260, min_days: 5, max_days: 6 },
{ pincode: 799261, min_days: 5, max_days: 6 },
{ pincode: 799263, min_days: 5, max_days: 6 },
{ pincode: 799264, min_days: 5, max_days: 6 },
{ pincode: 799270, min_days: 5, max_days: 6 },
{ pincode: 799277, min_days: 5, max_days: 6 },
{ pincode: 799278, min_days: 4, max_days: 5 },
{ pincode: 799279, min_days: 5, max_days: 6 },
{ pincode: 799280, min_days: 5, max_days: 6 },
{ pincode: 799281, min_days: 5, max_days: 6 },
{ pincode: 799282, min_days: 5, max_days: 6 },
{ pincode: 799287, min_days: 4, max_days: 5 },
{ pincode: 799289, min_days: 4, max_days: 5 },
{ pincode: 800001, min_days: 4, max_days: 5 },
{ pincode: 800002, min_days: 4, max_days: 5 },
{ pincode: 800003, min_days: 4, max_days: 5 },
{ pincode: 800004, min_days: 4, max_days: 5 },
{ pincode: 800005, min_days: 4, max_days: 5 },
{ pincode: 800006, min_days: 4, max_days: 5 },
{ pincode: 800007, min_days: 4, max_days: 5 },
{ pincode: 800008, min_days: 4, max_days: 5 },
{ pincode: 800009, min_days: 4, max_days: 5 },
{ pincode: 800010, min_days: 4, max_days: 5 },
{ pincode: 800011, min_days: 4, max_days: 5 },
{ pincode: 800012, min_days: 4, max_days: 5 },
{ pincode: 800013, min_days: 4, max_days: 5 },
{ pincode: 800014, min_days: 4, max_days: 5 },
{ pincode: 800015, min_days: 4, max_days: 5 },
{ pincode: 800016, min_days: 4, max_days: 5 },
{ pincode: 800017, min_days: 4, max_days: 5 },
{ pincode: 800018, min_days: 4, max_days: 5 },
{ pincode: 800019, min_days: 4, max_days: 5 },
{ pincode: 800020, min_days: 4, max_days: 5 },
{ pincode: 800021, min_days: 4, max_days: 5 },
{ pincode: 800022, min_days: 4, max_days: 5 },
{ pincode: 800023, min_days: 4, max_days: 5 },
{ pincode: 800024, min_days: 4, max_days: 5 },
{ pincode: 800025, min_days: 4, max_days: 5 },
{ pincode: 800026, min_days: 4, max_days: 5 },
{ pincode: 800027, min_days: 4, max_days: 5 },
{ pincode: 800028, min_days: 4, max_days: 5 },
{ pincode: 800030, min_days: 4, max_days: 5 },
{ pincode: 800111, min_days: 5, max_days: 6 },
{ pincode: 801102, min_days: 5, max_days: 6 },
{ pincode: 801103, min_days: 5, max_days: 6 },
{ pincode: 801104, min_days: 5, max_days: 6 },
{ pincode: 801105, min_days: 4, max_days: 5 },
{ pincode: 801106, min_days: 5, max_days: 6 },
{ pincode: 801108, min_days: 5, max_days: 6 },
{ pincode: 801109, min_days: 5, max_days: 6 },
{ pincode: 801110, min_days: 5, max_days: 6 },
{ pincode: 801111, min_days: 5, max_days: 6 },
{ pincode: 801112, min_days: 5, max_days: 6 },
{ pincode: 801113, min_days: 5, max_days: 6 },
{ pincode: 801302, min_days: 5, max_days: 6 },
{ pincode: 801304, min_days: 5, max_days: 6 },
{ pincode: 801306, min_days: 5, max_days: 6 },
{ pincode: 801501, min_days: 4, max_days: 5 },
{ pincode: 801503, min_days: 4, max_days: 5 },
{ pincode: 801505, min_days: 4, max_days: 5 },
{ pincode: 801506, min_days: 4, max_days: 5 },
{ pincode: 801507, min_days: 4, max_days: 5 },
{ pincode: 802101, min_days: 6, max_days: 7 },
{ pincode: 802102, min_days: 5, max_days: 6 },
{ pincode: 802103, min_days: 5, max_days: 6 },
{ pincode: 802111, min_days: 5, max_days: 6 },
{ pincode: 802112, min_days: 5, max_days: 6 },
{ pincode: 802113, min_days: 5, max_days: 6 },
{ pincode: 802116, min_days: 5, max_days: 6 },
{ pincode: 802117, min_days: 5, max_days: 6 },
{ pincode: 802118, min_days: 5, max_days: 6 },
{ pincode: 802119, min_days: 6, max_days: 7 },
{ pincode: 802120, min_days: 5, max_days: 6 },
{ pincode: 802122, min_days: 5, max_days: 6 },
{ pincode: 802123, min_days: 5, max_days: 6 },
{ pincode: 802125, min_days: 5, max_days: 6 },
{ pincode: 802126, min_days: 5, max_days: 6 },
{ pincode: 802130, min_days: 5, max_days: 6 },
{ pincode: 802133, min_days: 5, max_days: 6 },
{ pincode: 802134, min_days: 5, max_days: 6 },
{ pincode: 802135, min_days: 5, max_days: 6 },
{ pincode: 802136, min_days: 5, max_days: 6 },
{ pincode: 802151, min_days: 5, max_days: 6 },
{ pincode: 802152, min_days: 5, max_days: 6 },
{ pincode: 802153, min_days: 5, max_days: 6 },
{ pincode: 802154, min_days: 5, max_days: 6 },
{ pincode: 802156, min_days: 5, max_days: 6 },
{ pincode: 802157, min_days: 5, max_days: 6 },
{ pincode: 802158, min_days: 5, max_days: 6 },
{ pincode: 802159, min_days: 5, max_days: 6 },
{ pincode: 802160, min_days: 5, max_days: 6 },
{ pincode: 802161, min_days: 5, max_days: 6 },
{ pincode: 802162, min_days: 5, max_days: 6 },
{ pincode: 802163, min_days: 5, max_days: 6 },
{ pincode: 802165, min_days: 5, max_days: 6 },
{ pincode: 802166, min_days: 5, max_days: 6 },
{ pincode: 802183, min_days: 5, max_days: 6 },
{ pincode: 802201, min_days: 5, max_days: 6 },
{ pincode: 802202, min_days: 5, max_days: 6 },
{ pincode: 802203, min_days: 5, max_days: 6 },
{ pincode: 802204, min_days: 5, max_days: 6 },
{ pincode: 802205, min_days: 5, max_days: 6 },
{ pincode: 802206, min_days: 5, max_days: 6 },
{ pincode: 802207, min_days: 5, max_days: 6 },
{ pincode: 802209, min_days: 5, max_days: 6 },
{ pincode: 802210, min_days: 5, max_days: 6 },
{ pincode: 802211, min_days: 5, max_days: 6 },
{ pincode: 802212, min_days: 5, max_days: 6 },
{ pincode: 802213, min_days: 5, max_days: 6 },
{ pincode: 802214, min_days: 5, max_days: 6 },
{ pincode: 802215, min_days: 5, max_days: 6 },
{ pincode: 802216, min_days: 5, max_days: 6 },
{ pincode: 802217, min_days: 5, max_days: 6 },
{ pincode: 802218, min_days: 5, max_days: 6 },
{ pincode: 802219, min_days: 5, max_days: 6 },
{ pincode: 802220, min_days: 5, max_days: 6 },
{ pincode: 802221, min_days: 5, max_days: 6 },
{ pincode: 802223, min_days: 5, max_days: 6 },
{ pincode: 802226, min_days: 5, max_days: 6 },
{ pincode: 802229, min_days: 5, max_days: 6 },
{ pincode: 802301, min_days: 6, max_days: 7 },
{ pincode: 802302, min_days: 5, max_days: 6 },
{ pincode: 802311, min_days: 5, max_days: 6 },
{ pincode: 802312, min_days: 5, max_days: 6 },
{ pincode: 802314, min_days: 5, max_days: 6 },
{ pincode: 802316, min_days: 5, max_days: 6 },
{ pincode: 802351, min_days: 5, max_days: 6 },
{ pincode: 802352, min_days: 5, max_days: 6 },
{ pincode: 803101, min_days: 5, max_days: 6 },
{ pincode: 803108, min_days: 5, max_days: 6 },
{ pincode: 803110, min_days: 5, max_days: 6 },
{ pincode: 803111, min_days: 5, max_days: 6 },
{ pincode: 803113, min_days: 5, max_days: 6 },
{ pincode: 803114, min_days: 5, max_days: 6 },
{ pincode: 803115, min_days: 5, max_days: 6 },
{ pincode: 803116, min_days: 5, max_days: 6 },
{ pincode: 803117, min_days: 5, max_days: 6 },
{ pincode: 803118, min_days: 5, max_days: 6 },
{ pincode: 803121, min_days: 5, max_days: 6 },
{ pincode: 803201, min_days: 5, max_days: 6 },
{ pincode: 803202, min_days: 5, max_days: 6 },
{ pincode: 803203, min_days: 5, max_days: 6 },
{ pincode: 803211, min_days: 5, max_days: 6 },
{ pincode: 803212, min_days: 5, max_days: 6 },
{ pincode: 803213, min_days: 5, max_days: 6 },
{ pincode: 803214, min_days: 5, max_days: 6 },
{ pincode: 803215, min_days: 5, max_days: 6 },
{ pincode: 803221, min_days: 5, max_days: 6 },
{ pincode: 803301, min_days: 5, max_days: 6 },
{ pincode: 803302, min_days: 5, max_days: 6 },
{ pincode: 803303, min_days: 5, max_days: 6 },
{ pincode: 803306, min_days: 5, max_days: 6 },
{ pincode: 803307, min_days: 5, max_days: 6 },
{ pincode: 804401, min_days: 5, max_days: 6 },
{ pincode: 804402, min_days: 5, max_days: 6 },
{ pincode: 804404, min_days: 5, max_days: 6 },
{ pincode: 804406, min_days: 5, max_days: 6 },
{ pincode: 804408, min_days: 5, max_days: 6 },
{ pincode: 804417, min_days: 5, max_days: 6 },
{ pincode: 804418, min_days: 5, max_days: 6 },
{ pincode: 804419, min_days: 5, max_days: 6 },
{ pincode: 804420, min_days: 5, max_days: 6 },
{ pincode: 804422, min_days: 5, max_days: 6 },
{ pincode: 804423, min_days: 5, max_days: 6 },
{ pincode: 804424, min_days: 5, max_days: 6 },
{ pincode: 804425, min_days: 5, max_days: 6 },
{ pincode: 804426, min_days: 5, max_days: 6 },
{ pincode: 804427, min_days: 5, max_days: 6 },
{ pincode: 804429, min_days: 5, max_days: 6 },
{ pincode: 804430, min_days: 5, max_days: 6 },
{ pincode: 804432, min_days: 5, max_days: 6 },
{ pincode: 804434, min_days: 5, max_days: 6 },
{ pincode: 804451, min_days: 7, max_days: 8 },
{ pincode: 804452, min_days: 7, max_days: 8 },
{ pincode: 804453, min_days: 7, max_days: 8 },
{ pincode: 804454, min_days: 5, max_days: 6 },
{ pincode: 805102, min_days: 5, max_days: 6 },
{ pincode: 805103, min_days: 5, max_days: 6 },
{ pincode: 805104, min_days: 5, max_days: 6 },
{ pincode: 805106, min_days: 5, max_days: 6 },
{ pincode: 805107, min_days: 5, max_days: 6 },
{ pincode: 805108, min_days: 5, max_days: 6 },
{ pincode: 805109, min_days: 5, max_days: 6 },
{ pincode: 805110, min_days: 5, max_days: 6 },
{ pincode: 805111, min_days: 5, max_days: 6 },
{ pincode: 805112, min_days: 5, max_days: 6 },
{ pincode: 805113, min_days: 5, max_days: 6 },
{ pincode: 805121, min_days: 5, max_days: 6 },
{ pincode: 805122, min_days: 5, max_days: 6 },
{ pincode: 805123, min_days: 5, max_days: 6 },
{ pincode: 805124, min_days: 5, max_days: 6 },
{ pincode: 805125, min_days: 5, max_days: 6 },
{ pincode: 805126, min_days: 5, max_days: 6 },
{ pincode: 805127, min_days: 5, max_days: 6 },
{ pincode: 805129, min_days: 5, max_days: 6 },
{ pincode: 805130, min_days: 5, max_days: 6 },
{ pincode: 805131, min_days: 5, max_days: 6 },
{ pincode: 805132, min_days: 5, max_days: 6 },
{ pincode: 805133, min_days: 5, max_days: 6 },
{ pincode: 805141, min_days: 5, max_days: 6 },
{ pincode: 805236, min_days: 5, max_days: 6 },
{ pincode: 811101, min_days: 7, max_days: 8 },
{ pincode: 811102, min_days: 7, max_days: 8 },
{ pincode: 811103, min_days: 7, max_days: 8 },
{ pincode: 811104, min_days: 7, max_days: 8 },
{ pincode: 811105, min_days: 7, max_days: 8 },
{ pincode: 811106, min_days: 5, max_days: 6 },
{ pincode: 811107, min_days: 5, max_days: 6 },
{ pincode: 811112, min_days: 5, max_days: 6 },
{ pincode: 811201, min_days: 7, max_days: 8 },
{ pincode: 811202, min_days: 7, max_days: 8 },
{ pincode: 811211, min_days: 7, max_days: 8 },
{ pincode: 811212, min_days: 7, max_days: 8 },
{ pincode: 811213, min_days: 7, max_days: 8 },
{ pincode: 811214, min_days: 7, max_days: 8 },
{ pincode: 811302, min_days: 5, max_days: 6 },
{ pincode: 811304, min_days: 7, max_days: 8 },
{ pincode: 811305, min_days: 7, max_days: 8 },
{ pincode: 811307, min_days: 7, max_days: 8 },
{ pincode: 811308, min_days: 7, max_days: 8 },
{ pincode: 811309, min_days: 5, max_days: 6 },
{ pincode: 811310, min_days: 5, max_days: 6 },
{ pincode: 811311, min_days: 5, max_days: 6 },
{ pincode: 811312, min_days: 7, max_days: 8 },
{ pincode: 811313, min_days: 7, max_days: 8 },
{ pincode: 811315, min_days: 7, max_days: 8 },
{ pincode: 811317, min_days: 7, max_days: 8 },
{ pincode: 811538, min_days: 5, max_days: 6 },
{ pincode: 812001, min_days: 6, max_days: 7 },
{ pincode: 812002, min_days: 6, max_days: 7 },
{ pincode: 812003, min_days: 6, max_days: 7 },
{ pincode: 812004, min_days: 6, max_days: 7 },
{ pincode: 812005, min_days: 6, max_days: 7 },
{ pincode: 812006, min_days: 6, max_days: 7 },
{ pincode: 812007, min_days: 6, max_days: 7 },
{ pincode: 813101, min_days: 7, max_days: 8 },
{ pincode: 813102, min_days: 7, max_days: 8 },
{ pincode: 813103, min_days: 7, max_days: 8 },
{ pincode: 813104, min_days: 7, max_days: 8 },
{ pincode: 813105, min_days: 5, max_days: 6 },
{ pincode: 813107, min_days: 7, max_days: 8 },
{ pincode: 813108, min_days: 5, max_days: 6 },
{ pincode: 813109, min_days: 7, max_days: 8 },
{ pincode: 813110, min_days: 7, max_days: 8 },
{ pincode: 813113, min_days: 5, max_days: 6 },
{ pincode: 813128, min_days: 7, max_days: 8 },
{ pincode: 813202, min_days: 7, max_days: 8 },
{ pincode: 813203, min_days: 7, max_days: 8 },
{ pincode: 813204, min_days: 7, max_days: 8 },
{ pincode: 813205, min_days: 7, max_days: 8 },
{ pincode: 813206, min_days: 7, max_days: 8 },
{ pincode: 813207, min_days: 7, max_days: 8 },
{ pincode: 813209, min_days: 7, max_days: 8 },
{ pincode: 813210, min_days: 6, max_days: 7 },
{ pincode: 813211, min_days: 7, max_days: 8 },
{ pincode: 813213, min_days: 5, max_days: 6 },
{ pincode: 813214, min_days: 7, max_days: 8 },
{ pincode: 813221, min_days: 7, max_days: 8 },
{ pincode: 813222, min_days: 7, max_days: 8 },
{ pincode: 814101, min_days: 4, max_days: 5 },
{ pincode: 814102, min_days: 4, max_days: 5 },
{ pincode: 814103, min_days: 4, max_days: 5 },
{ pincode: 814110, min_days: 4, max_days: 5 },
{ pincode: 814111, min_days: 4, max_days: 5 },
{ pincode: 814112, min_days: 4, max_days: 5 },
{ pincode: 814113, min_days: 4, max_days: 5 },
{ pincode: 814114, min_days: 4, max_days: 5 },
{ pincode: 814115, min_days: 4, max_days: 5 },
{ pincode: 814116, min_days: 4, max_days: 5 },
{ pincode: 814118, min_days: 4, max_days: 5 },
{ pincode: 814119, min_days: 4, max_days: 5 },
{ pincode: 814120, min_days: 4, max_days: 5 },
{ pincode: 814122, min_days: 4, max_days: 5 },
{ pincode: 814133, min_days: 4, max_days: 5 },
{ pincode: 814141, min_days: 4, max_days: 5 },
{ pincode: 814142, min_days: 4, max_days: 5 },
{ pincode: 814143, min_days: 4, max_days: 5 },
{ pincode: 814144, min_days: 4, max_days: 5 },
{ pincode: 814145, min_days: 4, max_days: 5 },
{ pincode: 814147, min_days: 4, max_days: 5 },
{ pincode: 814148, min_days: 4, max_days: 5 },
{ pincode: 814150, min_days: 4, max_days: 5 },
{ pincode: 814153, min_days: 4, max_days: 5 },
{ pincode: 814154, min_days: 4, max_days: 5 },
{ pincode: 814156, min_days: 4, max_days: 5 },
{ pincode: 814157, min_days: 4, max_days: 5 },
{ pincode: 814158, min_days: 4, max_days: 5 },
{ pincode: 814160, min_days: 7, max_days: 8 },
{ pincode: 814165, min_days: 4, max_days: 5 },
{ pincode: 814166, min_days: 5, max_days: 6 },
{ pincode: 814167, min_days: 4, max_days: 5 },
{ pincode: 815301, min_days: 4, max_days: 5 },
{ pincode: 815302, min_days: 4, max_days: 5 },
{ pincode: 815311, min_days: 4, max_days: 5 },
{ pincode: 815312, min_days: 4, max_days: 5 },
{ pincode: 815351, min_days: 5, max_days: 6 },
{ pincode: 815352, min_days: 5, max_days: 6 },
{ pincode: 815354, min_days: 5, max_days: 6 },
{ pincode: 815355, min_days: 5, max_days: 6 },
{ pincode: 815357, min_days: 5, max_days: 6 },
{ pincode: 816104, min_days: 4, max_days: 5 },
{ pincode: 816107, min_days: 4, max_days: 5 },
{ pincode: 816108, min_days: 7, max_days: 8 },
{ pincode: 816109, min_days: 7, max_days: 8 },
{ pincode: 816115, min_days: 7, max_days: 8 },
{ pincode: 816116, min_days: 7, max_days: 8 },
{ pincode: 816118, min_days: 4, max_days: 5 },
{ pincode: 816120, min_days: 7, max_days: 8 },
{ pincode: 816129, min_days: 7, max_days: 8 },
{ pincode: 821101, min_days: 7, max_days: 8 },
{ pincode: 821102, min_days: 7, max_days: 8 },
{ pincode: 821103, min_days: 7, max_days: 8 },
{ pincode: 821106, min_days: 7, max_days: 8 },
{ pincode: 821107, min_days: 5, max_days: 6 },
{ pincode: 821108, min_days: 7, max_days: 8 },
{ pincode: 821109, min_days: 7, max_days: 8 },
{ pincode: 821111, min_days: 5, max_days: 6 },
{ pincode: 821112, min_days: 5, max_days: 6 },
{ pincode: 821115, min_days: 5, max_days: 6 },
{ pincode: 821307, min_days: 5, max_days: 6 },
{ pincode: 821309, min_days: 5, max_days: 6 },
{ pincode: 821310, min_days: 5, max_days: 6 },
{ pincode: 822101, min_days: 4, max_days: 5 },
{ pincode: 822102, min_days: 4, max_days: 5 },
{ pincode: 822110, min_days: 4, max_days: 5 },
{ pincode: 822111, min_days: 4, max_days: 5 },
{ pincode: 822114, min_days: 4, max_days: 5 },
{ pincode: 822121, min_days: 4, max_days: 5 },
{ pincode: 822124, min_days: 4, max_days: 5 },
{ pincode: 822128, min_days: 4, max_days: 5 },
{ pincode: 822132, min_days: 4, max_days: 5 },
{ pincode: 822133, min_days: 4, max_days: 5 },
{ pincode: 823001, min_days: 6, max_days: 7 },
{ pincode: 823002, min_days: 6, max_days: 7 },
{ pincode: 823003, min_days: 6, max_days: 7 },
{ pincode: 823004, min_days: 5, max_days: 6 },
{ pincode: 823005, min_days: 5, max_days: 6 },
{ pincode: 824101, min_days: 7, max_days: 8 },
{ pincode: 824102, min_days: 7, max_days: 8 },
{ pincode: 824103, min_days: 7, max_days: 8 },
{ pincode: 824111, min_days: 7, max_days: 8 },
{ pincode: 824112, min_days: 7, max_days: 8 },
{ pincode: 824113, min_days: 7, max_days: 8 },
{ pincode: 824114, min_days: 7, max_days: 8 },
{ pincode: 824120, min_days: 5, max_days: 6 },
{ pincode: 824121, min_days: 7, max_days: 8 },
{ pincode: 824123, min_days: 7, max_days: 8 },
{ pincode: 824124, min_days: 7, max_days: 8 },
{ pincode: 824143, min_days: 7, max_days: 8 },
{ pincode: 824202, min_days: 7, max_days: 8 },
{ pincode: 824231, min_days: 5, max_days: 6 },
{ pincode: 824301, min_days: 7, max_days: 8 },
{ pincode: 824302, min_days: 7, max_days: 8 },
{ pincode: 824303, min_days: 7, max_days: 8 },
{ pincode: 825101, min_days: 4, max_days: 5 },
{ pincode: 825102, min_days: 4, max_days: 5 },
{ pincode: 825103, min_days: 4, max_days: 5 },
{ pincode: 825301, min_days: 4, max_days: 5 },
{ pincode: 825302, min_days: 4, max_days: 5 },
{ pincode: 825311, min_days: 5, max_days: 6 },
{ pincode: 825314, min_days: 4, max_days: 5 },
{ pincode: 825316, min_days: 4, max_days: 5 },
{ pincode: 825325, min_days: 4, max_days: 5 },
{ pincode: 825330, min_days: 4, max_days: 5 },
{ pincode: 825336, min_days: 4, max_days: 5 },
{ pincode: 825401, min_days: 4, max_days: 5 },
{ pincode: 825402, min_days: 4, max_days: 5 },
{ pincode: 825403, min_days: 4, max_days: 5 },
{ pincode: 825404, min_days: 4, max_days: 5 },
{ pincode: 825407, min_days: 4, max_days: 5 },
{ pincode: 825408, min_days: 4, max_days: 5 },
{ pincode: 825409, min_days: 4, max_days: 5 },
{ pincode: 825410, min_days: 4, max_days: 5 },
{ pincode: 825413, min_days: 4, max_days: 5 },
{ pincode: 825418, min_days: 4, max_days: 5 },
{ pincode: 825421, min_days: 4, max_days: 5 },
{ pincode: 826001, min_days: 4, max_days: 5 },
{ pincode: 826003, min_days: 4, max_days: 5 },
{ pincode: 826004, min_days: 4, max_days: 5 },
{ pincode: 826005, min_days: 4, max_days: 5 },
{ pincode: 826006, min_days: 4, max_days: 5 },
{ pincode: 826106, min_days: 4, max_days: 5 },
{ pincode: 827001, min_days: 5, max_days: 6 },
{ pincode: 827003, min_days: 5, max_days: 6 },
{ pincode: 827004, min_days: 5, max_days: 6 },
{ pincode: 827006, min_days: 5, max_days: 6 },
{ pincode: 827009, min_days: 4, max_days: 5 },
{ pincode: 827010, min_days: 4, max_days: 5 },
{ pincode: 827011, min_days: 4, max_days: 5 },
{ pincode: 827012, min_days: 4, max_days: 5 },
{ pincode: 827013, min_days: 5, max_days: 6 },
{ pincode: 827014, min_days: 5, max_days: 6 },
{ pincode: 827015, min_days: 4, max_days: 5 },
{ pincode: 827302, min_days: 4, max_days: 5 },
{ pincode: 827611, min_days: 4, max_days: 5 },
{ pincode: 828101, min_days: 4, max_days: 5 },
{ pincode: 828103, min_days: 4, max_days: 5 },
{ pincode: 828104, min_days: 4, max_days: 5 },
{ pincode: 828105, min_days: 4, max_days: 5 },
{ pincode: 828106, min_days: 4, max_days: 5 },
{ pincode: 828107, min_days: 4, max_days: 5 },
{ pincode: 828108, min_days: 4, max_days: 5 },
{ pincode: 828109, min_days: 4, max_days: 5 },
{ pincode: 828110, min_days: 4, max_days: 5 },
{ pincode: 828111, min_days: 4, max_days: 5 },
{ pincode: 828112, min_days: 4, max_days: 5 },
{ pincode: 828113, min_days: 4, max_days: 5 },
{ pincode: 828114, min_days: 4, max_days: 5 },
{ pincode: 828115, min_days: 4, max_days: 5 },
{ pincode: 828116, min_days: 4, max_days: 5 },
{ pincode: 828117, min_days: 4, max_days: 5 },
{ pincode: 828119, min_days: 4, max_days: 5 },
{ pincode: 828120, min_days: 4, max_days: 5 },
{ pincode: 828121, min_days: 4, max_days: 5 },
{ pincode: 828122, min_days: 4, max_days: 5 },
{ pincode: 828123, min_days: 4, max_days: 5 },
{ pincode: 828124, min_days: 4, max_days: 5 },
{ pincode: 828125, min_days: 4, max_days: 5 },
{ pincode: 828126, min_days: 4, max_days: 5 },
{ pincode: 828127, min_days: 4, max_days: 5 },
{ pincode: 828128, min_days: 4, max_days: 5 },
{ pincode: 828129, min_days: 4, max_days: 5 },
{ pincode: 828130, min_days: 4, max_days: 5 },
{ pincode: 828131, min_days: 4, max_days: 5 },
{ pincode: 828132, min_days: 4, max_days: 5 },
{ pincode: 828133, min_days: 4, max_days: 5 },
{ pincode: 828134, min_days: 4, max_days: 5 },
{ pincode: 828135, min_days: 4, max_days: 5 },
{ pincode: 828201, min_days: 4, max_days: 5 },
{ pincode: 828206, min_days: 4, max_days: 5 },
{ pincode: 828301, min_days: 4, max_days: 5 },
{ pincode: 828302, min_days: 4, max_days: 5 },
{ pincode: 828303, min_days: 4, max_days: 5 },
{ pincode: 828304, min_days: 4, max_days: 5 },
{ pincode: 828305, min_days: 4, max_days: 5 },
{ pincode: 828306, min_days: 4, max_days: 5 },
{ pincode: 828307, min_days: 4, max_days: 5 },
{ pincode: 828309, min_days: 4, max_days: 5 },
{ pincode: 828401, min_days: 4, max_days: 5 },
{ pincode: 828402, min_days: 4, max_days: 5 },
{ pincode: 828403, min_days: 4, max_days: 5 },
{ pincode: 828404, min_days: 4, max_days: 5 },
{ pincode: 829101, min_days: 4, max_days: 5 },
{ pincode: 829102, min_days: 4, max_days: 5 },
{ pincode: 829103, min_days: 4, max_days: 5 },
{ pincode: 829104, min_days: 4, max_days: 5 },
{ pincode: 829105, min_days: 4, max_days: 5 },
{ pincode: 829106, min_days: 4, max_days: 5 },
{ pincode: 829107, min_days: 4, max_days: 5 },
{ pincode: 829108, min_days: 4, max_days: 5 },
{ pincode: 829109, min_days: 4, max_days: 5 },
{ pincode: 829110, min_days: 4, max_days: 5 },
{ pincode: 829111, min_days: 4, max_days: 5 },
{ pincode: 829112, min_days: 4, max_days: 5 },
{ pincode: 829113, min_days: 4, max_days: 5 },
{ pincode: 829114, min_days: 4, max_days: 5 },
{ pincode: 829115, min_days: 4, max_days: 5 },
{ pincode: 829116, min_days: 4, max_days: 5 },
{ pincode: 829117, min_days: 4, max_days: 5 },
{ pincode: 829118, min_days: 4, max_days: 5 },
{ pincode: 829119, min_days: 4, max_days: 5 },
{ pincode: 829121, min_days: 4, max_days: 5 },
{ pincode: 829122, min_days: 4, max_days: 5 },
{ pincode: 829123, min_days: 4, max_days: 5 },
{ pincode: 829124, min_days: 4, max_days: 5 },
{ pincode: 829125, min_days: 4, max_days: 5 },
{ pincode: 829126, min_days: 4, max_days: 5 },
{ pincode: 829127, min_days: 4, max_days: 5 },
{ pincode: 829128, min_days: 4, max_days: 5 },
{ pincode: 829129, min_days: 4, max_days: 5 },
{ pincode: 829130, min_days: 4, max_days: 5 },
{ pincode: 829131, min_days: 4, max_days: 5 },
{ pincode: 829132, min_days: 4, max_days: 5 },
{ pincode: 829133, min_days: 4, max_days: 5 },
{ pincode: 829134, min_days: 4, max_days: 5 },
{ pincode: 829135, min_days: 4, max_days: 5 },
{ pincode: 829138, min_days: 4, max_days: 5 },
{ pincode: 829143, min_days: 4, max_days: 5 },
{ pincode: 829144, min_days: 4, max_days: 5 },
{ pincode: 829149, min_days: 4, max_days: 5 },
{ pincode: 829150, min_days: 4, max_days: 5 },
{ pincode: 829203, min_days: 4, max_days: 5 },
{ pincode: 829206, min_days: 4, max_days: 5 },
{ pincode: 829207, min_days: 4, max_days: 5 },
{ pincode: 829301, min_days: 4, max_days: 5 },
{ pincode: 831001, min_days: 3, max_days: 4 },
{ pincode: 831002, min_days: 4, max_days: 5 },
{ pincode: 831003, min_days: 3, max_days: 4 },
{ pincode: 831004, min_days: 3, max_days: 4 },
{ pincode: 831005, min_days: 3, max_days: 4 },
{ pincode: 831006, min_days: 3, max_days: 4 },
{ pincode: 831007, min_days: 3, max_days: 4 },
{ pincode: 831008, min_days: 3, max_days: 4 },
{ pincode: 831009, min_days: 3, max_days: 4 },
{ pincode: 831010, min_days: 3, max_days: 4 },
{ pincode: 831011, min_days: 3, max_days: 4 },
{ pincode: 831012, min_days: 4, max_days: 5 },
{ pincode: 831013, min_days: 3, max_days: 4 },
{ pincode: 831014, min_days: 3, max_days: 4 },
{ pincode: 831015, min_days: 3, max_days: 4 },
{ pincode: 831016, min_days: 3, max_days: 4 },
{ pincode: 831017, min_days: 3, max_days: 4 },
{ pincode: 831018, min_days: 4, max_days: 5 },
{ pincode: 831019, min_days: 3, max_days: 4 },
{ pincode: 831020, min_days: 3, max_days: 4 },
{ pincode: 831021, min_days: 5, max_days: 6 },
{ pincode: 831035, min_days: 3, max_days: 4 },
{ pincode: 832102, min_days: 4, max_days: 5 },
{ pincode: 832103, min_days: 4, max_days: 5 },
{ pincode: 832104, min_days: 4, max_days: 5 },
{ pincode: 832105, min_days: 3, max_days: 4 },
{ pincode: 832106, min_days: 4, max_days: 5 },
{ pincode: 832107, min_days: 3, max_days: 4 },
{ pincode: 832108, min_days: 3, max_days: 4 },
{ pincode: 832109, min_days: 3, max_days: 4 },
{ pincode: 832110, min_days: 3, max_days: 4 },
{ pincode: 832111, min_days: 4, max_days: 5 },
{ pincode: 832302, min_days: 4, max_days: 5 },
{ pincode: 832303, min_days: 4, max_days: 5 },
{ pincode: 832304, min_days: 4, max_days: 5 },
{ pincode: 833102, min_days: 4, max_days: 5 },
{ pincode: 833103, min_days: 4, max_days: 5 },
{ pincode: 833105, min_days: 4, max_days: 5 },
{ pincode: 833201, min_days: 4, max_days: 5 },
{ pincode: 833202, min_days: 4, max_days: 5 },
{ pincode: 833212, min_days: 4, max_days: 5 },
{ pincode: 833215, min_days: 4, max_days: 5 },
{ pincode: 834001, min_days: 3, max_days: 4 },
{ pincode: 834002, min_days: 3, max_days: 4 },
{ pincode: 834003, min_days: 3, max_days: 4 },
{ pincode: 834004, min_days: 3, max_days: 4 },
{ pincode: 834005, min_days: 3, max_days: 4 },
{ pincode: 834006, min_days: 3, max_days: 4 },
{ pincode: 834007, min_days: 3, max_days: 4 },
{ pincode: 834008, min_days: 3, max_days: 4 },
{ pincode: 834009, min_days: 3, max_days: 4 },
{ pincode: 834010, min_days: 3, max_days: 4 },
{ pincode: 834011, min_days: 3, max_days: 4 },
{ pincode: 834012, min_days: 3, max_days: 4 },
{ pincode: 834013, min_days: 3, max_days: 4 },
{ pincode: 835103, min_days: 3, max_days: 4 },
{ pincode: 835207, min_days: 4, max_days: 5 },
{ pincode: 835208, min_days: 4, max_days: 5 },
{ pincode: 835213, min_days: 4, max_days: 5 },
{ pincode: 835215, min_days: 3, max_days: 4 },
{ pincode: 835217, min_days: 4, max_days: 5 },
{ pincode: 835219, min_days: 4, max_days: 5 },
{ pincode: 835222, min_days: 4, max_days: 5 },
{ pincode: 835223, min_days: 4, max_days: 5 },
{ pincode: 835224, min_days: 4, max_days: 5 },
{ pincode: 835226, min_days: 4, max_days: 5 },
{ pincode: 835228, min_days: 4, max_days: 5 },
{ pincode: 835233, min_days: 4, max_days: 5 },
{ pincode: 835235, min_days: 4, max_days: 5 },
{ pincode: 835302, min_days: 4, max_days: 5 },
{ pincode: 835325, min_days: 4, max_days: 5 },
{ pincode: 841101, min_days: 5, max_days: 6 },
{ pincode: 841201, min_days: 5, max_days: 6 },
{ pincode: 841202, min_days: 5, max_days: 6 },
{ pincode: 841203, min_days: 5, max_days: 6 },
{ pincode: 841204, min_days: 5, max_days: 6 },
{ pincode: 841205, min_days: 5, max_days: 6 },
{ pincode: 841206, min_days: 5, max_days: 6 },
{ pincode: 841207, min_days: 5, max_days: 6 },
{ pincode: 841208, min_days: 5, max_days: 6 },
{ pincode: 841209, min_days: 5, max_days: 6 },
{ pincode: 841211, min_days: 5, max_days: 6 },
{ pincode: 841212, min_days: 5, max_days: 6 },
{ pincode: 841213, min_days: 5, max_days: 6 },
{ pincode: 841214, min_days: 5, max_days: 6 },
{ pincode: 841216, min_days: 5, max_days: 6 },
{ pincode: 841217, min_days: 4, max_days: 5 },
{ pincode: 841218, min_days: 5, max_days: 6 },
{ pincode: 841219, min_days: 5, max_days: 6 },
{ pincode: 841220, min_days: 5, max_days: 6 },
{ pincode: 841221, min_days: 4, max_days: 5 },
{ pincode: 841222, min_days: 4, max_days: 5 },
{ pincode: 841223, min_days: 5, max_days: 6 },
{ pincode: 841225, min_days: 5, max_days: 6 },
{ pincode: 841226, min_days: 5, max_days: 6 },
{ pincode: 841227, min_days: 5, max_days: 6 },
{ pincode: 841231, min_days: 5, max_days: 6 },
{ pincode: 841232, min_days: 5, max_days: 6 },
{ pincode: 841233, min_days: 5, max_days: 6 },
{ pincode: 841236, min_days: 5, max_days: 6 },
{ pincode: 841237, min_days: 5, max_days: 6 },
{ pincode: 841238, min_days: 5, max_days: 6 },
{ pincode: 841239, min_days: 5, max_days: 6 },
{ pincode: 841240, min_days: 5, max_days: 6 },
{ pincode: 841241, min_days: 5, max_days: 6 },
{ pincode: 841244, min_days: 5, max_days: 6 },
{ pincode: 841245, min_days: 5, max_days: 6 },
{ pincode: 841286, min_days: 5, max_days: 6 },
{ pincode: 841287, min_days: 5, max_days: 6 },
{ pincode: 841301, min_days: 5, max_days: 6 },
{ pincode: 841302, min_days: 5, max_days: 6 },
{ pincode: 841305, min_days: 5, max_days: 6 },
{ pincode: 841311, min_days: 5, max_days: 6 },
{ pincode: 841313, min_days: 5, max_days: 6 },
{ pincode: 841316, min_days: 5, max_days: 6 },
{ pincode: 841401, min_days: 5, max_days: 6 },
{ pincode: 841402, min_days: 5, max_days: 6 },
{ pincode: 841403, min_days: 5, max_days: 6 },
{ pincode: 841405, min_days: 7, max_days: 8 },
{ pincode: 841411, min_days: 5, max_days: 6 },
{ pincode: 841412, min_days: 5, max_days: 6 },
{ pincode: 841414, min_days: 5, max_days: 6 },
{ pincode: 841415, min_days: 5, max_days: 6 },
{ pincode: 841418, min_days: 5, max_days: 6 },
{ pincode: 841419, min_days: 5, max_days: 6 },
{ pincode: 841421, min_days: 5, max_days: 6 },
{ pincode: 841422, min_days: 5, max_days: 6 },
{ pincode: 841423, min_days: 7, max_days: 8 },
{ pincode: 841424, min_days: 5, max_days: 6 },
{ pincode: 841427, min_days: 7, max_days: 8 },
{ pincode: 841428, min_days: 7, max_days: 8 },
{ pincode: 841436, min_days: 7, max_days: 8 },
{ pincode: 841438, min_days: 7, max_days: 8 },
{ pincode: 841439, min_days: 5, max_days: 6 },
{ pincode: 841440, min_days: 7, max_days: 8 },
{ pincode: 841442, min_days: 5, max_days: 6 },
{ pincode: 841446, min_days: 5, max_days: 6 },
{ pincode: 841501, min_days: 7, max_days: 8 },
{ pincode: 841503, min_days: 7, max_days: 8 },
{ pincode: 841505, min_days: 7, max_days: 8 },
{ pincode: 841506, min_days: 5, max_days: 6 },
{ pincode: 842001, min_days: 5, max_days: 6 },
{ pincode: 842002, min_days: 5, max_days: 6 },
{ pincode: 842003, min_days: 5, max_days: 6 },
{ pincode: 842004, min_days: 5, max_days: 6 },
{ pincode: 842005, min_days: 5, max_days: 6 },
{ pincode: 842008, min_days: 5, max_days: 6 },
{ pincode: 843101, min_days: 5, max_days: 6 },
{ pincode: 843102, min_days: 5, max_days: 6 },
{ pincode: 843103, min_days: 5, max_days: 6 },
{ pincode: 843104, min_days: 5, max_days: 6 },
{ pincode: 843105, min_days: 5, max_days: 6 },
{ pincode: 843106, min_days: 5, max_days: 6 },
{ pincode: 843107, min_days: 5, max_days: 6 },
{ pincode: 843108, min_days: 5, max_days: 6 },
{ pincode: 843109, min_days: 5, max_days: 6 },
{ pincode: 843110, min_days: 5, max_days: 6 },
{ pincode: 843111, min_days: 5, max_days: 6 },
{ pincode: 843112, min_days: 5, max_days: 6 },
{ pincode: 843113, min_days: 5, max_days: 6 },
{ pincode: 843114, min_days: 5, max_days: 6 },
{ pincode: 843115, min_days: 5, max_days: 6 },
{ pincode: 843116, min_days: 5, max_days: 6 },
{ pincode: 843117, min_days: 5, max_days: 6 },
{ pincode: 843118, min_days: 5, max_days: 6 },
{ pincode: 843119, min_days: 5, max_days: 6 },
{ pincode: 843120, min_days: 5, max_days: 6 },
{ pincode: 843121, min_days: 5, max_days: 6 },
{ pincode: 843122, min_days: 5, max_days: 6 },
{ pincode: 843123, min_days: 5, max_days: 6 },
{ pincode: 843124, min_days: 5, max_days: 6 },
{ pincode: 843125, min_days: 5, max_days: 6 },
{ pincode: 843126, min_days: 5, max_days: 6 },
{ pincode: 843127, min_days: 5, max_days: 6 },
{ pincode: 843128, min_days: 5, max_days: 6 },
{ pincode: 843129, min_days: 5, max_days: 6 },
{ pincode: 843130, min_days: 6, max_days: 7 },
{ pincode: 843131, min_days: 5, max_days: 6 },
{ pincode: 843132, min_days: 5, max_days: 6 },
{ pincode: 843141, min_days: 5, max_days: 6 },
{ pincode: 843146, min_days: 5, max_days: 6 },
{ pincode: 843301, min_days: 5, max_days: 6 },
{ pincode: 843302, min_days: 5, max_days: 6 },
{ pincode: 843311, min_days: 5, max_days: 6 },
{ pincode: 843312, min_days: 5, max_days: 6 },
{ pincode: 843314, min_days: 5, max_days: 6 },
{ pincode: 843315, min_days: 5, max_days: 6 },
{ pincode: 843316, min_days: 5, max_days: 6 },
{ pincode: 843317, min_days: 5, max_days: 6 },
{ pincode: 843320, min_days: 5, max_days: 6 },
{ pincode: 843321, min_days: 5, max_days: 6 },
{ pincode: 843322, min_days: 5, max_days: 6 },
{ pincode: 843323, min_days: 5, max_days: 6 },
{ pincode: 843324, min_days: 5, max_days: 6 },
{ pincode: 843325, min_days: 5, max_days: 6 },
{ pincode: 843327, min_days: 5, max_days: 6 },
{ pincode: 843328, min_days: 5, max_days: 6 },
{ pincode: 843329, min_days: 5, max_days: 6 },
{ pincode: 843330, min_days: 5, max_days: 6 },
{ pincode: 843331, min_days: 5, max_days: 6 },
{ pincode: 843332, min_days: 5, max_days: 6 },
{ pincode: 843334, min_days: 5, max_days: 6 },
{ pincode: 843351, min_days: 5, max_days: 6 },
{ pincode: 843360, min_days: 5, max_days: 6 },
{ pincode: 844101, min_days: 5, max_days: 6 },
{ pincode: 844102, min_days: 4, max_days: 5 },
{ pincode: 844103, min_days: 5, max_days: 6 },
{ pincode: 844111, min_days: 5, max_days: 6 },
{ pincode: 844112, min_days: 5, max_days: 6 },
{ pincode: 844113, min_days: 4, max_days: 5 },
{ pincode: 844114, min_days: 5, max_days: 6 },
{ pincode: 844115, min_days: 4, max_days: 5 },
{ pincode: 844116, min_days: 5, max_days: 6 },
{ pincode: 844117, min_days: 5, max_days: 6 },
{ pincode: 844118, min_days: 5, max_days: 6 },
{ pincode: 844119, min_days: 4, max_days: 5 },
{ pincode: 844120, min_days: 5, max_days: 6 },
{ pincode: 844121, min_days: 4, max_days: 5 },
{ pincode: 844122, min_days: 5, max_days: 6 },
{ pincode: 844123, min_days: 5, max_days: 6 },
{ pincode: 844124, min_days: 5, max_days: 6 },
{ pincode: 844125, min_days: 5, max_days: 6 },
{ pincode: 844126, min_days: 5, max_days: 6 },
{ pincode: 844127, min_days: 5, max_days: 6 },
{ pincode: 844128, min_days: 4, max_days: 5 },
{ pincode: 844501, min_days: 5, max_days: 6 },
{ pincode: 844502, min_days: 4, max_days: 5 },
{ pincode: 844503, min_days: 4, max_days: 5 },
{ pincode: 844504, min_days: 4, max_days: 5 },
{ pincode: 844505, min_days: 5, max_days: 6 },
{ pincode: 844507, min_days: 5, max_days: 6 },
{ pincode: 845103, min_days: 7, max_days: 8 },
{ pincode: 845106, min_days: 7, max_days: 8 },
{ pincode: 845301, min_days: 7, max_days: 8 },
{ pincode: 845305, min_days: 7, max_days: 8 },
{ pincode: 845306, min_days: 7, max_days: 8 },
{ pincode: 845307, min_days: 7, max_days: 8 },
{ pincode: 845401, min_days: 5, max_days: 6 },
{ pincode: 845411, min_days: 5, max_days: 6 },
{ pincode: 845412, min_days: 5, max_days: 6 },
{ pincode: 845414, min_days: 5, max_days: 6 },
{ pincode: 845415, min_days: 5, max_days: 6 },
{ pincode: 845416, min_days: 5, max_days: 6 },
{ pincode: 845417, min_days: 5, max_days: 6 },
{ pincode: 845419, min_days: 5, max_days: 6 },
{ pincode: 845420, min_days: 5, max_days: 6 },
{ pincode: 845422, min_days: 5, max_days: 6 },
{ pincode: 845425, min_days: 5, max_days: 6 },
{ pincode: 845426, min_days: 5, max_days: 6 },
{ pincode: 845427, min_days: 5, max_days: 6 },
{ pincode: 845429, min_days: 5, max_days: 6 },
{ pincode: 845430, min_days: 5, max_days: 6 },
{ pincode: 845431, min_days: 5, max_days: 6 },
{ pincode: 845433, min_days: 7, max_days: 8 },
{ pincode: 845434, min_days: 5, max_days: 6 },
{ pincode: 845435, min_days: 5, max_days: 6 },
{ pincode: 845436, min_days: 5, max_days: 6 },
{ pincode: 845437, min_days: 5, max_days: 6 },
{ pincode: 845438, min_days: 7, max_days: 8 },
{ pincode: 845440, min_days: 7, max_days: 8 },
{ pincode: 845449, min_days: 7, max_days: 8 },
{ pincode: 845450, min_days: 7, max_days: 8 },
{ pincode: 845451, min_days: 7, max_days: 8 },
{ pincode: 845452, min_days: 7, max_days: 8 },
{ pincode: 845453, min_days: 7, max_days: 8 },
{ pincode: 845454, min_days: 7, max_days: 8 },
{ pincode: 845455, min_days: 7, max_days: 8 },
{ pincode: 845456, min_days: 7, max_days: 8 },
{ pincode: 845458, min_days: 5, max_days: 6 },
{ pincode: 845459, min_days: 7, max_days: 8 },
{ pincode: 846001, min_days: 6, max_days: 7 },
{ pincode: 846002, min_days: 6, max_days: 7 },
{ pincode: 846003, min_days: 6, max_days: 7 },
{ pincode: 846004, min_days: 6, max_days: 7 },
{ pincode: 846005, min_days: 5, max_days: 6 },
{ pincode: 846006, min_days: 6, max_days: 7 },
{ pincode: 846007, min_days: 6, max_days: 7 },
{ pincode: 846008, min_days: 6, max_days: 7 },
{ pincode: 846009, min_days: 6, max_days: 7 },
{ pincode: 847101, min_days: 5, max_days: 6 },
{ pincode: 847104, min_days: 5, max_days: 6 },
{ pincode: 847106, min_days: 5, max_days: 6 },
{ pincode: 847107, min_days: 5, max_days: 6 },
{ pincode: 847109, min_days: 7, max_days: 8 },
{ pincode: 847115, min_days: 5, max_days: 6 },
{ pincode: 847121, min_days: 7, max_days: 8 },
{ pincode: 847123, min_days: 6, max_days: 7 },
{ pincode: 847211, min_days: 7, max_days: 8 },
{ pincode: 847212, min_days: 7, max_days: 8 },
{ pincode: 847222, min_days: 7, max_days: 8 },
{ pincode: 847225, min_days: 7, max_days: 8 },
{ pincode: 847226, min_days: 7, max_days: 8 },
{ pincode: 847227, min_days: 7, max_days: 8 },
{ pincode: 847229, min_days: 7, max_days: 8 },
{ pincode: 847230, min_days: 7, max_days: 8 },
{ pincode: 847232, min_days: 7, max_days: 8 },
{ pincode: 847234, min_days: 7, max_days: 8 },
{ pincode: 847236, min_days: 7, max_days: 8 },
{ pincode: 847238, min_days: 7, max_days: 8 },
{ pincode: 847240, min_days: 7, max_days: 8 },
{ pincode: 847306, min_days: 5, max_days: 6 },
{ pincode: 847337, min_days: 7, max_days: 8 },
{ pincode: 847401, min_days: 7, max_days: 8 },
{ pincode: 847402, min_days: 7, max_days: 8 },
{ pincode: 847403, min_days: 7, max_days: 8 },
{ pincode: 847404, min_days: 7, max_days: 8 },
{ pincode: 847407, min_days: 7, max_days: 8 },
{ pincode: 847408, min_days: 7, max_days: 8 },
{ pincode: 847409, min_days: 7, max_days: 8 },
{ pincode: 847410, min_days: 7, max_days: 8 },
{ pincode: 847411, min_days: 7, max_days: 8 },
{ pincode: 847428, min_days: 5, max_days: 6 },
{ pincode: 847429, min_days: 6, max_days: 7 },
{ pincode: 848101, min_days: 6, max_days: 7 },
{ pincode: 848102, min_days: 6, max_days: 7 },
{ pincode: 848113, min_days: 5, max_days: 6 },
{ pincode: 848114, min_days: 5, max_days: 6 },
{ pincode: 848115, min_days: 5, max_days: 6 },
{ pincode: 848117, min_days: 5, max_days: 6 },
{ pincode: 848121, min_days: 5, max_days: 6 },
{ pincode: 848122, min_days: 5, max_days: 6 },
{ pincode: 848125, min_days: 5, max_days: 6 },
{ pincode: 848127, min_days: 5, max_days: 6 },
{ pincode: 848129, min_days: 5, max_days: 6 },
{ pincode: 848130, min_days: 5, max_days: 6 },
{ pincode: 848131, min_days: 5, max_days: 6 },
{ pincode: 848132, min_days: 5, max_days: 6 },
{ pincode: 848133, min_days: 5, max_days: 6 },
{ pincode: 848134, min_days: 5, max_days: 6 },
{ pincode: 848160, min_days: 5, max_days: 6 },
{ pincode: 848203, min_days: 7, max_days: 8 },
{ pincode: 848210, min_days: 5, max_days: 6 },
{ pincode: 848211, min_days: 5, max_days: 6 },
{ pincode: 848236, min_days: 5, max_days: 6 },
{ pincode: 848301, min_days: 5, max_days: 6 },
{ pincode: 848302, min_days: 5, max_days: 6 },
{ pincode: 848502, min_days: 5, max_days: 6 },
{ pincode: 848503, min_days: 5, max_days: 6 },
{ pincode: 848505, min_days: 5, max_days: 6 },
{ pincode: 851101, min_days: 6, max_days: 7 },
{ pincode: 851111, min_days: 5, max_days: 6 },
{ pincode: 851112, min_days: 6, max_days: 7 },
{ pincode: 851113, min_days: 6, max_days: 7 },
{ pincode: 851114, min_days: 6, max_days: 7 },
{ pincode: 851115, min_days: 6, max_days: 7 },
{ pincode: 851116, min_days: 5, max_days: 6 },
{ pincode: 851117, min_days: 6, max_days: 7 },
{ pincode: 851118, min_days: 6, max_days: 7 },
{ pincode: 851126, min_days: 6, max_days: 7 },
{ pincode: 851127, min_days: 6, max_days: 7 },
{ pincode: 851128, min_days: 5, max_days: 6 },
{ pincode: 851129, min_days: 6, max_days: 7 },
{ pincode: 851130, min_days: 5, max_days: 6 },
{ pincode: 851131, min_days: 6, max_days: 7 },
{ pincode: 851132, min_days: 5, max_days: 6 },
{ pincode: 851133, min_days: 6, max_days: 7 },
{ pincode: 851134, min_days: 6, max_days: 7 },
{ pincode: 851135, min_days: 6, max_days: 7 },
{ pincode: 851202, min_days: 7, max_days: 8 },
{ pincode: 851203, min_days: 7, max_days: 8 },
{ pincode: 851204, min_days: 7, max_days: 8 },
{ pincode: 851205, min_days: 7, max_days: 8 },
{ pincode: 851210, min_days: 6, max_days: 7 },
{ pincode: 851211, min_days: 6, max_days: 7 },
{ pincode: 851212, min_days: 7, max_days: 8 },
{ pincode: 851213, min_days: 7, max_days: 8 },
{ pincode: 851214, min_days: 7, max_days: 8 },
{ pincode: 851218, min_days: 5, max_days: 6 },
{ pincode: 852105, min_days: 7, max_days: 8 },
{ pincode: 852106, min_days: 7, max_days: 8 },
{ pincode: 852107, min_days: 7, max_days: 8 },
{ pincode: 852108, min_days: 7, max_days: 8 },
{ pincode: 852109, min_days: 7, max_days: 8 },
{ pincode: 852111, min_days: 7, max_days: 8 },
{ pincode: 852113, min_days: 7, max_days: 8 },
{ pincode: 852114, min_days: 7, max_days: 8 },
{ pincode: 852115, min_days: 7, max_days: 8 },
{ pincode: 852121, min_days: 7, max_days: 8 },
{ pincode: 852122, min_days: 7, max_days: 8 },
{ pincode: 852127, min_days: 7, max_days: 8 },
{ pincode: 852128, min_days: 7, max_days: 8 },
{ pincode: 852130, min_days: 7, max_days: 8 },
{ pincode: 852131, min_days: 7, max_days: 8 },
{ pincode: 852132, min_days: 7, max_days: 8 },
{ pincode: 852133, min_days: 7, max_days: 8 },
{ pincode: 852138, min_days: 7, max_days: 8 },
{ pincode: 852139, min_days: 7, max_days: 8 },
{ pincode: 852201, min_days: 7, max_days: 8 },
{ pincode: 852202, min_days: 7, max_days: 8 },
{ pincode: 852212, min_days: 7, max_days: 8 },
{ pincode: 852218, min_days: 7, max_days: 8 },
{ pincode: 852221, min_days: 7, max_days: 8 },
{ pincode: 853201, min_days: 7, max_days: 8 },
{ pincode: 853202, min_days: 7, max_days: 8 },
{ pincode: 853204, min_days: 7, max_days: 8 },
{ pincode: 853205, min_days: 7, max_days: 8 },
{ pincode: 854103, min_days: 7, max_days: 8 },
{ pincode: 854105, min_days: 7, max_days: 8 },
{ pincode: 854106, min_days: 7, max_days: 8 },
{ pincode: 854107, min_days: 7, max_days: 8 },
{ pincode: 854108, min_days: 7, max_days: 8 },
{ pincode: 854109, min_days: 7, max_days: 8 },
{ pincode: 854113, min_days: 7, max_days: 8 },
{ pincode: 854115, min_days: 7, max_days: 8 },
{ pincode: 854202, min_days: 5, max_days: 6 },
{ pincode: 854205, min_days: 5, max_days: 6 },
{ pincode: 854301, min_days: 6, max_days: 7 },
{ pincode: 854302, min_days: 6, max_days: 7 },
{ pincode: 854303, min_days: 6, max_days: 7 },
{ pincode: 854304, min_days: 6, max_days: 7 },
{ pincode: 854305, min_days: 6, max_days: 7 },
{ pincode: 854306, min_days: 5, max_days: 6 },
{ pincode: 854311, min_days: 5, max_days: 6 },
{ pincode: 854312, min_days: 5, max_days: 6 },
{ pincode: 854316, min_days: 5, max_days: 6 },
{ pincode: 854318, min_days: 5, max_days: 6 },
{ pincode: 854325, min_days: 5, max_days: 6 },
{ pincode: 854326, min_days: 6, max_days: 7 },
{ pincode: 854327, min_days: 5, max_days: 6 },
{ pincode: 854328, min_days: 5, max_days: 6 },
{ pincode: 854329, min_days: 5, max_days: 6 },
{ pincode: 854330, min_days: 5, max_days: 6 },
{ pincode: 854332, min_days: 5, max_days: 6 },
{ pincode: 854335, min_days: 5, max_days: 6 },
{ pincode: 854336, min_days: 5, max_days: 6 },
{ pincode: 854337, min_days: 5, max_days: 6 },
{ pincode: 855105, min_days: 7, max_days: 8 },
{ pincode: 855107, min_days: 5, max_days: 6 },
{ pincode: 855108, min_days: 5, max_days: 6 },
{ pincode: 855114, min_days: 7, max_days: 8 },
{ pincode: 855115, min_days: 5, max_days: 6 },
{ pincode: 855117, min_days: 5, max_days: 6 },
]